/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

/** A login credential mapped to a user identity. For password credentials, the username to present for Basic auth is the user's username from the user record */
export interface AccessCredential {
  /** The timestamp of creation of the credential */
  created_at?: string;
  /** The type of credential */
  type: CredentialTypeEnum;
  /** The credential value (e.g. the password) */
  value: string;
}

/** Account information */
export interface Account {
  /**
   * The timestamp when the account was created
   * @format date-time
   */
  created_at?: string;
  /** Optional email address associated with the account */
  email?: string;
  /**
   * The timestamp of the last update to the account metadata itself (not users or creds)
   * @format date-time
   */
  last_updated?: string;
  /** The account identifier, not updatable after creation */
  name: string;
  /** State of the account. Disabled accounts prevent member users from logging in, deleting accounts are disabled and pending deletion and will be removed once all owned resources are garbage collected by the system */
  state?: StateEnum;
  /** The user type (admin vs user). If not specified in a POST request, 'user' is default */
  type?: AccountTypeEnum;
}

/** An account to create/add to the system. If already exists will return 400. */
export interface AccountCreationRequest {
  /**
   * An optional email to associate with the account for contact purposes
   * @pattern [a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?
   */
  email?: string;
  /**
   * The account name to use. This will identify the account and must be globally unique in the system.
   * @pattern ^[a-zA-Z0-9][ a-zA-Z0-9@.!$+=^_`~;-]{1,126}[a-zA-Z0-9_]$
   */
  name: string;
}

/** Account Information. */
export interface AccountInfo {
  /**
   * An optional email to associate with the account for contact purposes
   * @pattern [a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?
   */
  email?: string;
}

/** Information about sent K8s inventory report for an account */
export interface AccountK8SInventoryReportInfo {
  /**
   * Account to which the inventory reports belong
   * @example "development"
   */
  account_name: string;
  /**
   * Number of batches that the inventory report was sent in
   * @min 1
   * @example 3
   */
  batch_size: number;
  /** List of information about inventory report batches */
  batches: {
    /**
     * Index of the batch
     * @min 1
     * @example 1
     */
    batch_index: number;
    /**
     * Error message if the sending was unsuccessful
     * @example "Connection refused"
     */
    error?: string;
    /**
     * Timestamp when the batch was sent
     * @format date-time
     * @example "2024-06-26 14:02:45+00:00"
     */
    send_timestamp: string;
  }[];
  /**
   * true if one or more of the batches coult not be sent, false otherwise
   * @example true
   */
  has_errors: boolean;
  /**
   * Index of last successfully sent batch, -1 if none were successful
   * @min -1
   * @example -1
   */
  last_successful_index: number;
  /**
   * Timestamp for the inventory report
   * @format data-time
   * @example "2024-06-26 14:02:33+00:00"
   */
  report_timestamp: string;
  /**
   * User that the integration instance sent the inventory report as
   * @example "admin"
   */
  sent_as_user: string;
}

export type AccountList = Account[];

/** A summary of account status */
export interface AccountStatus {
  /** The status of the account */
  state?: AccountStatusStateEnum;
}

/** The status of the account */
export const AccountStatusStateEnum = {
  Enabled: 'enabled',
  Disabled: 'disabled',
} as const;
export type AccountStatusStateEnum =
  (typeof AccountStatusStateEnum)[keyof typeof AccountStatusStateEnum];

/** The user type (admin vs user). If not specified in a POST request, 'user' is default */
export const AccountTypeEnum = {
  User: 'user',
  Admin: 'admin',
  Service: 'service',
} as const;
export type AccountTypeEnum =
  (typeof AccountTypeEnum)[keyof typeof AccountTypeEnum];

/** describes a remediation action plan object */
export interface ActionPlan {
  configuration_id?: string;
  /** @format date-time */
  created_at?: string;
  endpoint?: string;
  image_digest?: string;
  image_tag?: string;
  /** @format date-time */
  last_updated?: string;
  message?: string;
  policy_id?: string;
  resolutions?: ActionPlanResolution[];
  subject?: string;
  type?: string;
  uuid?: string;
}

/** defines the trigger IDs and content of a resolution for an action plan */
export interface ActionPlanResolution {
  content?: string;
  trigger_ids?: string[];
}

/** List of Action Plans */
export type ActionPlans = ActionPlan[];

export type AddActionPlanData = ActionPlan;

/** List of analysis archive add results */
export type AddAnalysisArchiveResult = AnalysisArchiveAddResult[];

export type AddApplicationData = Application;

export type AddApplicationVersionData = ApplicationVersion;

export interface AddApplicationVersionParams {
  /** @format path */
  applicationId: string;
}

export type AddArtifactRelationshipData = object;

export type AddArtifactToApplicationVersionData = ArtifactAssociationResponse;

export interface AddArtifactToApplicationVersionParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
}

/**
 * AddContainerImageAssetJobResponse
 * Full response for an add-container-image-asset job.
 */
export interface AddContainerImageAssetJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail for asset-creating jobs. */
  completion_detail?: AssetCompletionDetail | null;
  /** Error details for failed jobs. */
  error?: JobError | null;
  job_spec: ImageJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  /**
   * Resource
   * Human-readable label for the source the job is processing — SBOM filename or image pull reference. Becomes the asset's `reference` after completion.
   */
  resource: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/** AddContainerImageAssetRequest */
export interface AddContainerImageAssetRequest {
  /**
   * Annotations
   * JSON object of string key-value pairs
   * @default "{}"
   */
  annotations?: string;
  /**
   * App Version Id
   * @format uuid
   */
  app_version_id: string;
  /**
   * Asset Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  asset_name: string;
  /** Type of a user-facing Asset attached to an AppVersion. */
  asset_type: AssetType;
  /**
   * Dockerfile
   * @format binary
   */
  dockerfile?: File | null;
  /**
   * Image Reference
   * Fully-qualified image reference in registry/repo:tag format. An @digest suffix is optional (e.g., 'docker.io/library/alpine:latest' or 'docker.io/library/alpine:latest@sha256:...').
   * @minLength 1
   * @maxLength 512
   * @pattern ^[\x21-\x7e]+$
   */
  image_reference: string;
}

export type AddCorrectionData = Correction;

export type AddCredentialData = AccessCredential;

export type AddGithubConfigurationData =
  NotificationGitHubEndpointConfigurationBase;

export type AddGithubSelectorData = NotificationSelector;

export interface AddGithubSelectorParams {
  /** @format path */
  uuid: string;
}

export type AddIdpData = RbacManagerSamlConfiguration;

export type AddIdpUserGroupsData = RbacManagerIdpUserGroups;

export interface AddIdpUserGroupsParams {
  /** @format path */
  name: string;
}

export type AddImageData = AnchoreImage;

export interface AddImageParams {
  /** Indicates if tag will be subscribed for registry updates monitoring */
  auto_subscribe?: boolean;
  /** Override any existing entry in the system */
  force?: boolean;
}

/**
 * AddImportedImageAssetJobResponse
 * Full response for an add-imported-image-asset job.
 */
export interface AddImportedImageAssetJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail for asset-creating jobs. */
  completion_detail?: AssetCompletionDetail | null;
  /** Error details for failed jobs. */
  error?: JobError | null;
  job_spec: AddImportedImageAssetJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  /**
   * Resource
   * Human-readable label for the source the job is processing — SBOM filename or image pull reference. Becomes the asset's `reference` after completion.
   */
  resource: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/** AddImportedImageAssetJobSpec */
export interface AddImportedImageAssetJobSpec {
  /**
   * App Versions
   * Application versions the asset will be attached to.
   */
  app_versions: AppVersionById[];
  asset: NewAssetSpec;
  /**
   * Image Reference
   * Container image pull reference.
   */
  image_reference: string;
}

/**
 * AddImportedImageAssetRequest
 * Multipart form request for POST /add-imported-image-asset.
 */
export interface AddImportedImageAssetRequest {
  /**
   * Analysis Manifest
   * @format binary
   */
  analysis_manifest: File;
  /**
   * Annotations
   * JSON object of string key-value pairs
   * @default "{}"
   */
  annotations?: string;
  /**
   * App Version Id
   * @format uuid
   */
  app_version_id: string;
  /**
   * Asset Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  asset_name: string;
  /** Type of a user-facing Asset attached to an AppVersion. */
  asset_type: AssetType;
  /**
   * Content Searches
   * @format binary
   */
  content_searches?: File | null;
  /**
   * Dockerfile
   * @format binary
   */
  dockerfile?: File | null;
  /**
   * File Contents
   * @format binary
   */
  file_contents?: File | null;
  /**
   * Image Config
   * @format binary
   */
  image_config: File;
  /**
   * Image Reference
   * @minLength 1
   * @maxLength 512
   * @pattern ^[\x21-\x7e]+$
   */
  image_reference: string;
  /**
   * Manifest
   * @format binary
   */
  manifest: File;
  /**
   * Parent Digest
   * Parent image digest (e.g. index digest for multi-arch). Defaults to image digest.
   */
  parent_digest?: string | null;
  /**
   * Parent Manifest
   * @format binary
   */
  parent_manifest?: File | null;
  /**
   * Sbom
   * @format binary
   */
  sbom: File;
  /**
   * Secrets
   * @format binary
   */
  secrets?: File | null;
}

export type AddJiraConfigurationData =
  NotificationJiraEndpointConfigurationBase;

export type AddJiraSelectorData = NotificationSelector;

export interface AddJiraSelectorParams {
  /** @format path */
  uuid: string;
}

export type AddPolicyData = PolicyRecord;

export type AddRepositoryData = SubscriptionList;

export interface AddRepositoryParams {
  /** Flag to enable/disable auto tag_update activation when new images from a repo are added. Default is false. */
  auto_subscribe?: boolean;
  /** Flag to return tags in the repository without actually watching the repository. Default is false. */
  dry_run?: boolean;
  /** Flag that indicates if the watcher will exclude existing tags from the repository during the first run.  When set to 'true', the watcher will only add newly detected tags to the system from this time forward. Default is false. */
  exclude_existing_tags?: boolean;
  /** Full repository to add e.g. docker.io/library/alpine */
  repository: string;
}

export type AddRoleUserData = RbacManagerRoleMember;

export interface AddRoleUserParams {
  /** @format path */
  roleName: string;
}

/**
 * AddSbomAssetJobResponse
 * Full response for an add-sbom-asset job.
 */
export interface AddSbomAssetJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail for asset-creating jobs. */
  completion_detail?: AssetCompletionDetail | null;
  /** Error details for failed jobs. */
  error?: JobError | null;
  job_spec: AddSbomJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  /**
   * Resource
   * Human-readable label for the source the job is processing — SBOM filename or image pull reference. Becomes the asset's `reference` after completion.
   */
  resource: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/** AddSbomAssetRequest */
export interface AddSbomAssetRequest {
  /**
   * Annotations
   * JSON object of string key-value pairs
   * @default "{}"
   */
  annotations?: string;
  /**
   * App Version Id
   * @format uuid
   */
  app_version_id: string;
  /**
   * Asset Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  asset_name: string;
  /** Type of a user-facing Asset attached to an AppVersion. */
  asset_type: AssetType;
  /**
   * Sbom
   * @format binary
   */
  sbom: File;
}

/** AddSbomJobSpec */
export interface AddSbomJobSpec {
  /**
   * App Versions
   * Application versions the asset will be attached to.
   */
  app_versions: AppVersionById[];
  asset: NewAssetSpec;
}

export type AddSlackConfigurationData = NotificationSlackEndpointConfiguration;

export type AddSlackSelectorData = NotificationSelector;

export interface AddSlackSelectorParams {
  /** @format path */
  uuid: string;
}

export type AddSmtpConfigurationData = NotificationSMTPEndpointConfiguration;

export type AddSmtpSelectorData = NotificationSelector;

export interface AddSmtpSelectorParams {
  /** @format path */
  uuid: string;
}

export type AddSubscriptionData = SubscriptionList;

export type AddTeamsConfigurationData = NotificationTeamsEndpointConfiguration;

export type AddTeamsSelectorData = NotificationSelector;

export interface AddTeamsSelectorParams {
  /** @format path */
  uuid: string;
}

export type AddUserGroupRolesData = UserGroupRoles;

export interface AddUserGroupRolesParams {
  /** @format path */
  groupUuid: string;
}

export type AddUserGroupUsersData = UserGroupUsers;

export interface AddUserGroupUsersParams {
  /** @format path */
  groupUuid: string;
}

export type AddWebhookConfigurationData =
  NotificationWebhookEndpointConfiguration;

export type AddWebhookSelectorData = NotificationSelector;

export interface AddWebhookSelectorParams {
  /** @format path */
  uuid: string;
}

/** A summary of the stateful indicator of a specific event in the system */
export interface AlertSummary {
  /**
   * Account that closed the alert
   * @example "system"
   */
  closed_by?: string;
  /**
   * Reason for closing the alert
   * @example "closed by action plan id"
   */
  closed_reason?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the alert was generated
   * @format date-time
   */
  created_at?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the alert was last modified
   * @format date-time
   */
  last_updated?: string;
  resource_labels?: ResourceLabel[];
  /**
   * Current state of the alert
   * @example "open"
   */
  state?: AlertSummaryStateEnum;
  /**
   * Type of the alert
   * @example "compliance_violation"
   */
  type?: AlertSummaryTypeEnum;
  /**
   * Identifier for the alert
   * @example "56c2463b-49e5-49d7-b9a4-0c5c78faec6e"
   */
  uuid?: string;
}

/** Array of alert summaries */
export type AlertSummaryList = AlertSummary[];

/**
 * Current state of the alert
 * @example "open"
 */
export const AlertSummaryStateEnum = {
  Open: 'open',
  Closed: 'closed',
} as const;
export type AlertSummaryStateEnum =
  (typeof AlertSummaryStateEnum)[keyof typeof AlertSummaryStateEnum];

/**
 * Type of the alert
 * @example "compliance_violation"
 */
export const AlertSummaryTypeEnum = {
  ComplianceViolation: 'compliance_violation',
} as const;
export type AlertSummaryTypeEnum =
  (typeof AlertSummaryTypeEnum)[keyof typeof AlertSummaryTypeEnum];

/** A collection of allowlist items to match a policy evaluation against. */
export interface Allowlist {
  /** Description of the Allowlist, human readable */
  description?: string;
  id: string;
  items: AllowlistItem[];
  name: string;
  version: string;
}

/** AllowlistInfo */
export interface AllowlistInfo {
  /**
   * Expires On
   * When the allowlist expires, null if permanent
   * @format date-time
   */
  expires_on?: string | null;
  /**
   * Id
   * ID of the allowlist
   */
  id: string;
  /**
   * Item Id
   * Identifier for allowlist item that matched this finding
   */
  item_id: string;
  /**
   * Name
   * Name of the allowlist
   */
  name: string;
}

/** Identifies a specific gate and trigger match from a policy against an image and indicates it should be ignored in final policy decisions */
export interface AllowlistItem {
  /** Description of the Allowlist item, human readable */
  description?: string;
  /** @format date-time */
  expires_on?: string | null;
  gate: string;
  id: string;
  trigger_id: string;
}

/** The result of adding a single digest to the archive */
export interface AnalysisArchiveAddResult {
  /** Details on the status, e.g. the error message */
  detail?: string;
  /** The image digest requested to be added */
  digest?: string;
  /** The status of the archive add operation. Typically either 'archived' or 'error' */
  status?: AnalysisArchiveAddResultStatusEnum;
}

/** The status of the archive add operation. Typically either 'archived' or 'error' */
export const AnalysisArchiveAddResultStatusEnum = {
  Archived: 'archived',
  Archiving: 'archiving',
  Error: 'error',
} as const;
export type AnalysisArchiveAddResultStatusEnum =
  (typeof AnalysisArchiveAddResultStatusEnum)[keyof typeof AnalysisArchiveAddResultStatusEnum];

/** Rule set for automatic archiving of system objects and flushing of archived objects (permanent delete). */
export type AnalysisArchiveRules = AnalysisArchiveTransitionRule[];

/** Summary of the transition rule set */
export interface AnalysisArchiveRulesSummary {
  /** The number of rules for this account */
  count?: number;
  /**
   * The newest last_updated timestamp from the set of rules
   * @format date-time
   */
  last_updated?: string;
}

/** An image reference in the analysis archive for the purposes of loading analysis from the archive into th working set */
export type AnalysisArchiveSource = {
  /**
   * The image digest identify the analysis. Archived analyses are based on digest, tag records are restored as analysis is restored.
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  digest: string;
} | null;

/** A summarization of the analysis archive, including size, counts, etc. This archive stores image analysis only, never the actual image content or layers. */
export interface AnalysisArchiveSummary {
  /**
   * The timestamp of the most recent archived image
   * @format date-time
   */
  last_updated?: string;
  /** The total sum of all the bytes stored to the backing storage. Accounts for anchore-applied compression, but not compression by the underlying storage system. */
  total_data_bytes?: number;
  /** The number of unique images (digests) in the archive */
  total_image_count?: number;
  /** The number of tag records (registry/repo:tag pull strings) in the archive. This may include repeated tags but will always have a unique tag->digest mapping per record. */
  total_tag_count?: number;
}

/** A rule for auto-archiving image analysis by time and/or tag-history */
export interface AnalysisArchiveTransitionRule {
  /** Matches if the analysis is strictly older than this number of days */
  analysis_age_days?: number;
  /** @format date-time */
  created_at?: string;
  /** Which Images to exclude from auto-archiving logic */
  exclude?: AnalysisArchiveTransitionRuleExclude;
  /** @format date-time */
  last_updated?: string;
  /** This is the maximum number of image analyses an account can have. Can only be set on system_global rules */
  max_images_per_account?: number;
  /** Unique identifier for archive rule */
  rule_id?: string;
  /** A set of selection criteria to match an image by a tagged pull string based on its components, with regex support in each field */
  selector?: ImageSelector;
  /** True if the rule applies to all accounts in the system. This is only available to admin users to update/modify, but all users with permission to list rules can see them */
  system_global?: boolean;
  /** Number of images mapped to the tag that are newer */
  tag_versions_newer?: number;
  /** The type of transition to make. If "archive", then archive an image from the working set and remove it from the working set. If "delete", then match against archived images and delete from the archive if match. */
  transition: AnalysisArchiveTransitionRuleTransitionEnum;
}

/** Which Images to exclude from auto-archiving logic */
export interface AnalysisArchiveTransitionRuleExclude {
  /** How long the image selected will be excluded from the archive transition */
  expiration_days?: number;
  /** Exclude image from archive if last seen in inventory within defined number of days */
  last_seen_in_days?: number;
  /** A set of selection criteria to match an image by a tagged pull string based on its components, with regex support in each field */
  selector?: ImageSelector;
}

/** The type of transition to make. If "archive", then archive an image from the working set and remove it from the working set. If "delete", then match against archived images and delete from the archive if match. */
export const AnalysisArchiveTransitionRuleTransitionEnum = {
  Archive: 'archive',
  Delete: 'delete',
} as const;
export type AnalysisArchiveTransitionRuleTransitionEnum =
  (typeof AnalysisArchiveTransitionRuleTransitionEnum)[keyof typeof AnalysisArchiveTransitionRuleTransitionEnum];

/** The detail of an analysis status change recording which service initiated the state change, when, and which transition */
export interface AnalysisStatusDetail {
  from_status: string;
  /** A reference to a service in the system */
  source: ServiceAnalysisReference;
  /** @format datetime */
  timestamp: string;
  to_status: string;
}

/** Filter by analysis_status value on the record. */
export const AnalysisStatusEnum = {
  NotAnalyzed: 'not_analyzed',
  Analyzed: 'analyzed',
  Analyzing: 'analyzing',
  AnalysisFailed: 'analysis_failed',
} as const;
export type AnalysisStatusEnum =
  (typeof AnalysisStatusEnum)[keyof typeof AnalysisStatusEnum];

export const SummaryImageTagsAnalysisStatus = {
  All: 'all',
  Analyzed: 'analyzed',
  NotAnalyzed: 'not_analyzed',
  AnalysisFailed: 'analysis_failed',
  Analyzing: 'analyzing',
} as const;
export type SummaryImageTagsAnalysisStatus =
  (typeof SummaryImageTagsAnalysisStatus)[keyof typeof SummaryImageTagsAnalysisStatus];

/** A unique image in the engine. May have multiple tags or references. Unique to an image content across registries or repositories. */
export interface AnchoreImage {
  account_name?: string;
  /** A state value for the current status of the analysis progress of the image */
  analysis_status?: AnalysisStatusEnum;
  analysis_status_detail?: AnalysisStatusDetail[] | null;
  annotations?: object;
  /** @format date-time */
  created_at?: string;
  /** A metadata content record for a specific image, containing different content type entries */
  image_content?: ImageContent;
  /** Details specific to an image reference and type such as tag and image source */
  image_detail?: ImageDetail[];
  image_digest?: string;
  /** State of the image */
  image_status?: AnchoreImageImageStatusEnum;
  /** @format date-time */
  last_updated?: string;
  parent_digest?: string;
  /** The version of the record, used for internal schema updates and data migrations. */
  record_version?: string;
}

/** State of the image */
export const AnchoreImageImageStatusEnum = {
  Active: 'active',
  Inactive: 'inactive',
  Disabled: 'disabled',
} as const;
export type AnchoreImageImageStatusEnum =
  (typeof AnchoreImageImageStatusEnum)[keyof typeof AnchoreImageImageStatusEnum];

/** A list of Anchore Images */
export interface AnchoreImageList {
  items?: AnchoreImage[];
}

/** Analysis stats for a repo */
export interface AnchoreImageSummaryCounts {
  analyzed?: number;
  analyzing?: number;
  failed?: number;
  images?: number;
  pending?: number;
  tags?: number;
}

/** A unique image in the engine. */
export interface AnchoreImageTagSummary {
  analysis_status?: string;
  analyzed_at?: number;
  created_at?: number;
  full_tag?: string;
  image_digest?: string;
  image_id?: string;
  image_status?: string;
  parent_digest?: string;
  tag_detected_at?: number;
}

/** a list of AnchoreImageTagSummary objects */
export interface AnchoreImageTagSummaryList {
  items?: AnchoreImageTagSummary[];
  total_rows?: number;
}

/** Generic HTTP API error response */
export interface ApiErrorResponse {
  /** @format int32 */
  code?: number;
  /** Details structure for additional information about the error if available. Content and structure will be error specific. */
  detail?: object;
  error_type?: string;
  message?: string;
}

export interface ApiKeyList {
  items?: UserApiKey[];
}

/** AppCreateRequest */
export interface AppCreateRequest {
  contact: ContactInfo;
  /**
   * Description
   * @maxLength 2000
   * @default ""
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  description?: string;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name: string;
  /**
   * Policy Id
   * The ID of the policy associated with the application. Omit or send null to use the account's default policy. An empty string is rejected.
   * @minLength 1
   */
  policy_id?: string | null;
}

/**
 * AppJobListItemResponse
 * Terse response for application-scoped job listing.
 */
export interface AppJobListItemResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
  target: AppJobTarget;
}

/** AppJobTarget */
export interface AppJobTarget {
  /**
   * Id
   * Target resource id.
   */
  id: string;
  /**
   * Type
   * Target resource type (e.g. `app_version`).
   */
  type: string;
}

/**
 * AppListItemResponse
 * Response model for applications in list view.
 *
 * Same shape as :class:`AppResponse`. Use the search endpoint
 * (`POST /apps-search`) to receive enriched fields such as ``latest_version``
 * in :class:`AppSearchItemResponse`.
 */
export interface AppListItemResponse {
  contact: ContactInfo;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /** Name */
  name: string;
  /** Policy Id */
  policy_id?: string | null;
  system_metadata: SystemMetadata;
  /**
   * Version Count
   * @default 0
   */
  version_count?: number;
}

/**
 * AppResponse
 * Response model for a single application.
 */
export interface AppResponse {
  contact: ContactInfo;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /** Name */
  name: string;
  /** Policy Id */
  policy_id?: string | null;
  system_metadata: SystemMetadata;
  /**
   * Version Count
   * @default 0
   */
  version_count?: number;
}

/** AppUpdateRequest */
export interface AppUpdateRequest {
  contact?: ContactInfoUpdate;
  /**
   * Description
   * @maxLength 2000
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  description?: string | null;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name?: string;
  /**
   * Policy Id
   * The ID of the policy associated with the application. Send null to use the account's default policy; omit to leave it unchanged. An empty string is rejected.
   * @minLength 1
   */
  policy_id?: string | null;
}

/** AppVersionById */
export interface AppVersionById {
  /**
   * App Version Id
   * Application version id.
   * @format uuid
   */
  app_version_id: string;
}

/** AppVersionCreateRequest */
export interface AppVersionCreateRequest {
  /**
   * Description
   * @maxLength 2000
   * @default ""
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  description?: string;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name: string;
  /**
   * Previous Version Id
   * @format uuid
   */
  previous_version_id?: string | null;
  /**
   * Release Date
   * @format date-time
   */
  release_date?: string | null;
  /**
   * Status of the application version
   * @default "in_progress"
   */
  status?: AppVersionStatus;
}

/**
 * AppVersionListItemResponse
 * Response model for app versions in list view.
 */
export interface AppVersionListItemResponse {
  /**
   * Asset Count
   * @default 0
   */
  asset_count?: number;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /** Name */
  name: string;
  /**
   * Previous Version Id
   * @format uuid
   */
  previous_version_id?: string | null;
  /**
   * Release Date
   * @format date-time
   */
  release_date?: string | null;
  /** Status information for an app version. */
  status: AppVersionStatusInfo;
  system_metadata: SystemMetadata;
}

/**
 * AppVersionResponse
 * Response model for individual app version GET.
 */
export interface AppVersionResponse {
  /**
   * Asset Count
   * @default 0
   */
  asset_count?: number;
  /**
   * Description
   * @default ""
   */
  description?: string;
  /** Name */
  name: string;
  /**
   * Previous Version Id
   * @format uuid
   */
  previous_version_id?: string | null;
  /**
   * Release Date
   * @format date-time
   */
  release_date?: string | null;
  /** Status information for an app version. */
  status: AppVersionStatusInfo;
  system_metadata: SystemMetadata;
}

/**
 * AppVersionStatus
 * Status of the application version
 */
export const AppVersionStatus = {
  InProgress: 'in_progress',
  Released: 'released',
  Eol: 'eol',
} as const;
export type AppVersionStatus =
  (typeof AppVersionStatus)[keyof typeof AppVersionStatus];

/**
 * AppVersionStatusInfo
 * Status information for an app version.
 */
export interface AppVersionStatusInfo {
  /** Status of the application version */
  current_value: AppVersionStatus;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

/** AppVersionUpdateRequest */
export interface AppVersionUpdateRequest {
  /**
   * Description
   * @maxLength 2000
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  description?: string | null;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name?: string;
  /**
   * Previous Version Id
   * @format uuid
   */
  previous_version_id?: string | null;
  /**
   * Release Date
   * @format date-time
   */
  release_date?: string | null;
  /** Status of the application version */
  status?: AppVersionStatus;
}

/** AppVersionVulnerabilityAnnotationCreateRequest */
export interface AppVersionVulnerabilityAnnotationCreateRequest {
  /**
   * Action Statement
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  action_statement?: string | null;
  /**
   * Additional Details
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  additional_details?: string | null;
  /**
   * Impact Statement
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  impact_statement?: string | null;
  justification?: VexJustification | null;
  /** Package Name */
  package_name: string;
  /** Package Type */
  package_type: string;
  /** Package Version */
  package_version: string;
  status: VexStatus;
  /**
   * Status Notes
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  status_notes?: string | null;
  /**
   * Vulnerability Id
   * @minLength 1
   * @maxLength 64
   * @pattern ^[A-Za-z0-9][A-Za-z0-9.:\-_/]*$
   */
  vulnerability_id: string;
}

/** AppVersionVulnerabilityAnnotationResponse */
export interface AppVersionVulnerabilityAnnotationResponse {
  /** Action Statement */
  action_statement?: string | null;
  /** Additional Details */
  additional_details?: string | null;
  /**
   * App Version Id
   * @format uuid
   */
  app_version_id: string;
  /**
   * Application Id
   * @format uuid
   */
  application_id: string;
  /** Impact Statement */
  impact_statement?: string | null;
  justification?: VexJustification | null;
  /** Package Name */
  package_name: string;
  /** Package Type */
  package_type: string;
  /** Package Version */
  package_version: string;
  status: VexStatus;
  /** Status Notes */
  status_notes?: string | null;
  system_metadata: SystemMetadata;
  /** Vulnerability Id */
  vulnerability_id: string;
}

/** A representation of an SLDC application */
export interface Application {
  /** The id of the application */
  application_id?: string;
  /** List of application versions */
  application_versions?: ApplicationVersionList;
  /**
   * RFC 3339 formatted UTC timestamp when the application was created
   * @format date-time
   */
  created_at?: string;
  /** The description of the application */
  description?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the application was last updated
   * @format date-time
   */
  last_updated?: string;
  /** The name of the application. This is a unique field per account */
  name?: string;
}

/** List of applications */
export type ApplicationList = Application[];

/** A representation of an SLDC application */
export interface ApplicationVersion {
  /** The id of the application */
  application_id?: string;
  /** The id of the application version */
  application_version_id?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the application was created
   * @format date-time
   */
  created_at?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the application was last updated
   * @format date-time
   */
  last_updated?: string;
  /** The name of the application version. The name must be unique per application */
  version_name: string;
}

/** List of application versions */
export type ApplicationVersionList = ApplicationVersion[];

/** A combined sbom for the artifacts associated with an application version */
export interface ApplicationVersionSbom {
  /** A representation of an SLDC application */
  application?: Application;
  /** A representation of an SLDC application */
  application_version?: ApplicationVersion;
  /**
   * RFC 3339 formatted UTC timestamp when the application version sbom was created
   * @format date-time
   */
  created_at?: string;
  image_sboms?: ImageSBOM[];
  source_sboms?: SourceSBOM[];
}

/** A combined vulnerability report for all artifacts associated with an application version */
export interface ApplicationVersionVulnerabilityReport {
  application?: {
    artifacts?: {
      images?: VersionVulnerabilityReportImage[];
      sources?: VersionVulnerabilityReportSource[];
    };
    id?: string;
    name?: string;
    version_id?: string;
    version_name?: string;
  };
  /** Collection of vulnerabilities and affected packages on a given application version */
  vulnerabilities?: VersionVulnerability[];
}

/** The architecture of the binary to retrieve */
export const ArchitectureEnum = {
  Amd64: 'amd64',
  Arm64: 'arm64',
} as const;
export type ArchitectureEnum =
  (typeof ArchitectureEnum)[keyof typeof ArchitectureEnum];

export type ArchiveImageAnalysisData = AddAnalysisArchiveResult;

/** A summarization of the available archives, a place to for long-term storage of audit, analysis, or other data to remove it from the system's working set but keep it available. */
export interface ArchiveSummary {
  /** A summarization of the analysis archive, including size, counts, etc. This archive stores image analysis only, never the actual image content or layers. */
  images?: AnalysisArchiveSummary;
  /** Summary of the transition rule set */
  rules?: AnalysisArchiveRulesSummary;
}

/** A docker-pullable tag value as well as deconstructed components */
export interface ArchiveTagEntry {
  /**
   * The timestamp at which Anchore Engine archived this image digest.
   * @format date-time
   */
  created_at?: string;
  /**
   * The timestamp at which the Anchore Engine detected this tag was mapped to the image digest. Does not necessarily indicate when the tag was actually pushed to the registry.
   * @format date-time
   */
  detected_at?: string;
  /**
   * The timestamp that the last change was made to this record.
   * @format date-time
   */
  last_updated?: string;
  /** The pullable string for the tag. E.g. "docker.io/library/node:latest" */
  pull_string?: string;
  /** The registry hostname:port section of the pull string */
  registry?: string;
  /** The repository section of the pull string */
  repository?: string;
  /** The tag-only section of the pull string */
  tag?: string;
}

/** List of archived analyses */
export type ArchivedAnalyses = ArchivedAnalysis[];

export interface ArchivedAnalysis {
  /** @format date-time */
  analyzed_at?: string;
  /** User provided annotations as key-value pairs */
  annotations?: object;
  /** The size, in bytes, of the analysis archive file */
  archive_size_bytes?: number;
  /** @format date-time */
  created_at?: string;
  /** List of tags associated with the image digest */
  image_detail?: ArchiveTagEntry[];
  /** The image digest (digest of the manifest describing the image, per docker spec) */
  image_digest?: string;
  /** @format date-time */
  last_updated?: string;
  /** The digest of a parent manifest (for manifest-list images) */
  parent_digest?: string;
  /** The archival status */
  status?: ArchivedAnalysisStatusEnum;
}

/** The archival status */
export const ArchivedAnalysisStatusEnum = {
  Archiving: 'archiving',
  Archived: 'archived',
  Deleting: 'deleting',
  Deleted: 'deleted',
} as const;
export type ArchivedAnalysisStatusEnum =
  (typeof ArchivedAnalysisStatusEnum)[keyof typeof ArchivedAnalysisStatusEnum];

/** ArtifactApiType */
export const ArtifactApiType = {
  Sbom: 'sbom',
  Image: 'image',
} as const;
export type ArtifactApiType =
  (typeof ArtifactApiType)[keyof typeof ArtifactApiType];

/** Metadata for an artifact association to an application version */
export interface ArtifactAssociationMetadata {
  /** The id of the association between the application version and the artifact */
  association_id?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the artifact was associated with the application version
   * @format date-time
   */
  created_at?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the artifact association was last updated
   * @format date-time
   */
  last_updated?: string;
}

/** Request body for an artifact to associate with an application version */
export interface ArtifactAssociationRequest {
  /** A json with key-pair values to query on */
  artifact_keys: object;
  /** The type of the artifact */
  artifact_type: ArtifactType;
}

/** Response body for an artifact to associate with an application version. Only one artifact type (matching the value of the type field) will be populated. */
export interface ArtifactAssociationResponse {
  /** Metadata for an artifact association to an application version */
  artifact_association_metadata?: ArtifactAssociationMetadata;
  /** Model for an image artifact */
  image?: ImageArtifact;
  source?: Source;
}

/** A policy which exists in the system to manage the lifecycle of artifacts */
export interface ArtifactLifecyclePolicy {
  /** The action that should be taken when the rule parameters are met. */
  action: ArtifactLifecyclePolicyActionEnum;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  deleted_at?: string;
  /** A user provided description for the policy. */
  description?: string;
  /** Indicates if the policy should be active or not.  Defaulted to false. */
  enabled?: boolean;
  /** A user provided name for the policy. This name must be unique for an Artifact Lifecycle Policy. */
  name: string;
  policy_conditions: ArtifactLifecyclePolicyConditions;
  /** @format date-time */
  updated_at?: string;
  /** A system defined unique identifier. */
  uuid?: string;
}

/** The action that should be taken when the rule parameters are met. */
export const ArtifactLifecyclePolicyActionEnum = {
  Delete: 'delete',
} as const;
export type ArtifactLifecyclePolicyActionEnum =
  (typeof ArtifactLifecyclePolicyActionEnum)[keyof typeof ArtifactLifecyclePolicyActionEnum];

export type ArtifactLifecyclePolicyConditions = {
  artifact_type: 'image';
} & ImageArtifactLifecyclePolicyConditions;

export interface ArtifactLifecyclePolicyList {
  items?: ArtifactLifecyclePolicyResponse[];
}

export type ArtifactLifecyclePolicyResponse = ArtifactLifecyclePolicy & {
  policy_conditions?: ArtifactLifecyclePolicyConditions[];
};

/** ArtifactListModel */
export interface ArtifactListModel {
  /**
   * Item Count
   * @default 0
   */
  item_count?: number;
  /**
   * Items
   * @default []
   */
  items?: ArtifactResponse[];
}

/** The response provided when querying for the artifacts on an application version */
export interface ArtifactListResponse {
  associated_image_artifacts?: AssociatedImageArtifact[];
  associated_source_artifacts?: AssociatedSourceArtifact[];
}

export interface ArtifactReference {
  artifact_id?: string;
  artifact_type?: ArtifactType;
}

/**
 * A relationship of a specific type between two SDLC artifacts (e.g. container image and source revision). This is
 * and edge in a directed graph where edges are directional from the "source" to the "target". For example, an edge of type "contains"
 * means the source artifact contains the content of the target artifact.
 */
export interface ArtifactRelationship {
  comment?: string;
  /** @format date-time */
  created_at?: string;
  /** The type of relationship between to artifacts */
  relationship_type?: RelationshipType;
  source?: ArtifactReference;
  target?: ArtifactReference;
  /** User-provided metadata about the relationship */
  user_metadata?: object;
}

/** List of artifact relationships */
export type ArtifactRelationships = ArtifactRelationship[];

/** ArtifactResponse */
export interface ArtifactResponse {
  /** Reference */
  reference: SbomArtifactReference | ImageArtifactReference;
  system_metadata: SystemMetadata;
  type: ArtifactApiType;
}

export const ArtifactType = {
  Source: 'source',
  Image: 'image',
} as const;
export type ArtifactType = (typeof ArtifactType)[keyof typeof ArtifactType];

/**
 * AssetCompletionDetail
 * Completion detail for asset-creating jobs.
 */
export interface AssetCompletionDetail {
  /**
   * Asset Id
   * ID of the asset created or updated by this job.
   * @format uuid
   */
  asset_id: string;
}

/**
 * AssetResponse
 * Response model for assets in list view.
 */
export interface AssetResponse {
  /** Annotations */
  annotations: Record<string, string>;
  /** @default {"items":[],"item_count":0} */
  artifacts?: ArtifactListModel;
  /** Name */
  name: string;
  /**
   * Reference
   * A reference to the source of this asset. For container assets, the fully-qualified image reference (e.g., 'docker.io/library/alpine:latest@sha256:...'). For SBOM assets, the uploaded file name.
   */
  reference?: string | null;
  system_metadata: SystemMetadata;
  /** Type of a user-facing Asset attached to an AppVersion. */
  type: AssetType;
}

/**
 * AssetType
 * Type of a user-facing Asset attached to an AppVersion.
 */
export const AssetType = {
  Application: 'application',
  Container: 'container',
  Device: 'device',
  File: 'file',
  Firmware: 'firmware',
  Library: 'library',
  Module: 'module',
  Filesystem: 'filesystem',
  VirtualMachineDisk: 'virtual_machine_disk',
  Unknown: 'unknown',
} as const;
export type AssetType = (typeof AssetType)[keyof typeof AssetType];

/**
 * AssetUpdateRequest
 * Model for asset updates (PATCH).
 *
 * Annotations support merge semantics:
 * - If annotations is not provided, existing annotations are unchanged
 * - If annotations is provided, values are merged with existing
 * - Setting a key's value to None removes that key
 */
export interface AssetUpdateRequest {
  /**
   * Annotations
   * Merge annotations with existing. Set value to null to remove a key. Maximum 10 entries after merge, keys up to 150 chars, values up to 1000 chars.
   */
  annotations?: Record<string, string | null>;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name?: string;
  /** Type of a user-facing Asset attached to an AppVersion. */
  type?: AssetType;
}

/** Model for an associated image artifact. Composites the artifact with the association metadata */
export interface AssociatedImageArtifact {
  /** Metadata for an artifact association to an application version */
  artifact_association_metadata?: ArtifactAssociationMetadata;
  /** Model for an image artifact */
  image?: ImageArtifact;
}

/** Model for an associated source artifact. Composite of the source artifact and its asssociation metadata */
export interface AssociatedSourceArtifact {
  /** Metadata for an artifact association to an application version */
  artifact_association_metadata?: ArtifactAssociationMetadata;
  source?: Source;
}

export interface CVSSV2Scores {
  base_score?: number | null;
  exploitability_score?: number | null;
  impact_score?: number | null;
}

export interface CVSSV3Scores {
  base_score?: number | null;
  exploitability_score?: number | null;
  impact_score?: number | null;
}

export type CancelApplicationJobData = AppJobListItemResponse;

export interface CancelApplicationJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

/** A resource that ties compliance related artifacts - image digest, tag and policy */
export interface ComplianceResource {
  /** @format date-time */
  evaluated_at?: string;
  evaluation_id?: string;
  image_digest?: string;
  image_tag?: string;
  policy_id?: string;
  registry?: string;
  repository?: string;
}

/** Alert raised by the system on a compliance check failure */
export interface ComplianceViolationAlert {
  /**
   * Account that closed the alert
   * @example "system"
   */
  closed_by?: string;
  /**
   * Reason for closing the alert
   * @example "closed by action plan id"
   */
  closed_reason?: string;
  /**
   * Reason for compliance check status. Compliance check could fail due to policy evaluation or denylisting or errors evaluating compliance
   * @example "policy_evaluation"
   */
  compliance_status_reason?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the alert was generated
   * @format date-time
   */
  created_at?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the alert was last modified
   * @format date-time
   */
  last_updated?: string;
  /** A resource that ties compliance related artifacts - image digest, tag and policy */
  resource?: ComplianceResource;
  /**
   * Current state of the alert
   * @example "open"
   */
  state?: AlertSummaryStateEnum;
  /**
   * Type of alert generated
   * @example "compliance_violation"
   */
  type?: AlertSummaryTypeEnum;
  /**
   * Identifier for the alert
   * @example "56c2463b-49e5-49d7-b9a4-0c5c78faec6e"
   */
  uuid?: string;
  /** Number of STOP action results in the compliance check report */
  violations_count?: number;
}

/** Array of compliance violation alerts */
export type ComplianceViolationAlertList = ComplianceViolationAlert[];

/** State change for an existing ComplianceViolationAlert */
export interface ComplianceViolationAlertState {
  /** The new state of the compliance violation alert */
  state: AlertSummaryStateEnum;
}

/** ContactInfo */
export interface ContactInfo {
  /**
   * Email
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name: string;
  /**
   * Phone
   * @maxLength 50
   */
  phone?: string | null;
}

/** ContactInfoUpdate */
export interface ContactInfoUpdate {
  /**
   * Email
   * Contact email. Send null to clear a previously set value; omit to leave it unchanged.
   * @format email
   * @maxLength 254
   */
  email?: string | null;
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   * @pattern ^[^\x00-\x1f\x7f<>]+$
   */
  name?: string;
  /**
   * Phone
   * Contact phone. Send null to clear a previously set value; omit to leave it unchanged.
   * @maxLength 50
   */
  phone?: string | null;
}

/** File content listings from images */
export interface ContentFilesResponse {
  content?: FilesContent[];
  content_type?: string;
  image_digest?: string;
}

/** Java package content listings from images */
export interface ContentJavaPackageResponse {
  content?: JavaPackageContent[];
  content_type?: string;
  image_digest?: string;
}

/** Malware listing response */
export interface ContentMalwareResponse {
  /** List of malware scan results, one per scanner configured to run */
  content?: MalwareScan[];
  content_type?: string;
  image_digest?: string;
}

/** Package content listings from images */
export interface ContentPackageResponse {
  content?: PackageContent[];
  content_type?: string;
  image_digest?: string;
}

export interface ContentSearch {
  findings: {
    content_searches: {
      classification: string;
      length: number;
      line_number: number;
      line_offset: number;
      regex?: string;
      seek_position: number;
      [key: string]: any;
    }[];
    location: {
      layerID: string;
      path: string;
    };
  }[];
  /** The media type of this result */
  media_type: ContentSearchMediaTypeEnum;
  metadata: {
    /**
     * The time the result was analyzed
     * @format date-time
     */
    analyzed_at?: string;
    /** The platform of AnchoreCTL used to generate the result */
    anchorectl_platform: string;
    /** The version of AnchoreCTL used to generate the result */
    anchorectl_version: string;
    /**
     * Deprecated, use anchorectl_platform instead. The platform of AnchoreCTL used to generate the result
     * @deprecated
     */
    platform?: string;
  };
}

/** The media type of this result */
export const ContentSearchMediaTypeEnum = {
  ApplicationAnchoreEnterpriseLocalAnalyzeSecretSearchV1Json:
    'application/anchore.enterprise.local-analyze.secret-search.v1+json',
  ApplicationAnchoreEnterpriseLocalAnalyzeContentSearchV1Json:
    'application/anchore.enterprise.local-analyze.content-search.v1+json',
} as const;
export type ContentSearchMediaTypeEnum =
  (typeof ContentSearchMediaTypeEnum)[keyof typeof ContentSearchMediaTypeEnum];

/** Defines a correction object for false positive management */
export interface Correction {
  /**
   * RFC 3339 formatted UTC timestamp when the correction was generated
   * @format date-time
   */
  created_at?: string;
  description?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the correction was last modified
   * @format date-time
   */
  last_updated?: string;
  /** Defines how a particular correction can match depending on type */
  match: CorrectionMatch;
  replace: CorrectionFieldMatch[];
  /** Type of correction */
  type: CorrectionTypeEnum;
  /**
   * Identifier for the correction
   * @example "56c2463b-49e5-49d7-b9a4-0c5c78faec6e"
   */
  uuid?: string;
}

/** Defines a particular field name and value to match for a Correction */
export interface CorrectionFieldMatch {
  /**
   * The package field name to match
   * @example "name"
   */
  field_name: string;
  /** The package field value for the corresponding field_name above to match. If field_name corresponds to a list value, this will search the list */
  field_value: string;
}

/** Array of Corrections */
export type CorrectionList = Correction[];

/** Defines how a particular correction can match depending on type */
export interface CorrectionMatch {
  /** list of field matches that are required in order for this correction to match */
  field_matches?: CorrectionFieldMatch[];
  /**
   * type of match [supports os, npm, gem, python, java, go]
   * @example "npm"
   */
  type: string;
}

/** Type of correction */
export const CorrectionTypeEnum = {
  Package: 'package',
} as const;
export type CorrectionTypeEnum =
  (typeof CorrectionTypeEnum)[keyof typeof CorrectionTypeEnum];

export type CreateAccountData = Account;

export type CreateAddContainerImageAssetJobData =
  AddContainerImageAssetJobResponse;

export interface CreateAddContainerImageAssetJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateAddImportedImageAssetJobData =
  AddImportedImageAssetJobResponse;

export interface CreateAddImportedImageAssetJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateAddSbomAssetJobData = AddSbomAssetJobResponse;

export interface CreateAddSbomAssetJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateAnalysisArchiveRuleData = AnalysisArchiveTransitionRule;

export type CreateApiKeyData = UserApiKey;

export type CreateAppData = AppResponse;

export type CreateAppVersionData = AppVersionResponse;

export interface CreateAppVersionParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateArtifactLifecyclePolicyData = ArtifactLifecyclePolicyResponse;

export type CreateExportPackagesJobData = ExportPackagesJobResponse;

export interface CreateExportPackagesJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateExportPolicyComplianceJobData =
  ExportPolicyComplianceJobResponse;

export interface CreateExportPolicyComplianceJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateExportSbomCyclonedx1JobData = ExportSbomCycloneDx1JobResponse;

export interface CreateExportSbomCyclonedx1JobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateExportSbomSpdx2JobData = ExportSbomSpdx2JobResponse;

export interface CreateExportSbomSpdx2JobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateExportVdrJobData = ExportVdrJobResponse;

export interface CreateExportVdrJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateExportVexJobData = ExportVexJobResponse;

export interface CreateExportVexJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateExportVulnerabilitiesJobData =
  ExportVulnerabilitiesJobResponse;

export interface CreateExportVulnerabilitiesJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type CreateImageVulnAnnotationData = PackageVulnerabilityAnnotation;

export interface CreateImageVulnAnnotationParams {
  /**
   * The image digest to create a vuln annotation for
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type CreateOperationData = ImageImportOperation;

export type CreateRegistryData = RegistryConfigurationList;

export interface CreateRegistryParams {
  /** flag to determine whether or not to validate registry/credential at registry add time */
  validate?: boolean;
}

export type CreateSourcesOperationData = SourceImportOperation;

export type CreateUserApiKeyData = UserApiKey;

export interface CreateUserApiKeyParams {
  /** @format path */
  accountName: string;
  /** @format path */
  username: string;
}

export type CreateUserCredentialData = AccessCredential;

export interface CreateUserCredentialParams {
  /** @format path */
  accountName: string;
  /** @format path */
  username: string;
}

export type CreateUserData = User;

export type CreateUserGroupData = UserGroup;

export interface CreateUserParams {
  /** @format path */
  accountName: string;
}

export type CreateVulnerabilityAnnotationData =
  AppVersionVulnerabilityAnnotationResponse;

export interface CreateVulnerabilityAnnotationParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type CredentialList = AccessCredential[];

export const CredentialTypeEnum = {
  Password: 'password',
} as const;
export type CredentialTypeEnum =
  (typeof CredentialTypeEnum)[keyof typeof CredentialTypeEnum];

/** Anchore-specific adaptation of RFC6902 to be describeable in swagger/open-api 2.0. Each item is given an ID and the ids are ordered in the array. */
export interface CustomJsonPatch {
  add?: JsonPatchAddList;
  copy?: JsonPatchCopyList;
  move?: JsonPatchMoveList;
  /** Ordered list of the operations in the type-specific lists. This imparts the total ordering of patches to apply such that they can be moved into a single array. */
  operations?: JsonPatchOperationList;
  remove?: JsonPatchRemoveList;
  replace?: JsonPatchReplaceList;
  test?: JsonPatchTestList;
}

/**
 * CvssAssessment
 * A single CVSS assessment from a specific source.
 *
 * Each source provides ONE assessment which may contain scores for
 * multiple CVSS versions (v2, v3, v4) - they are NOT mutually exclusive.
 *
 * Example: NVD may provide both a v2 score (7.6) AND a v3 score (8.8)
 * for the same vulnerability in a single assessment.
 */
export interface CvssAssessment {
  /** V2 Score */
  v2_score?: number | null;
  /** V3 Score */
  v3_score?: number | null;
  /** V4 Score */
  v4_score?: number | null;
  /** Is Primary */
  is_primary: boolean;
  /** Source */
  source: string;
}

/**
 * CvssAssessmentWithCategory
 * CVSS assessment with source category, used in vulnerability search responses.
 */
export interface CvssAssessmentWithCategory {
  /** V2 Score */
  v2_score?: number | null;
  /** V3 Score */
  v3_score?: number | null;
  /** V4 Score */
  v4_score?: number | null;
  /** High-level category for CVSS assessment sources. */
  category?: CvssSourceCategory | null;
  /** Is Primary */
  is_primary: boolean;
  /** Source */
  source: string;
}

/**
 * CvssSourceCategory
 * High-level category for CVSS assessment sources.
 */
export const CvssSourceCategory = {
  Nvd: 'nvd',
  Cisa: 'cisa',
  Github: 'github',
  Other: 'other',
} as const;
export type CvssSourceCategory =
  (typeof CvssSourceCategory)[keyof typeof CvssSourceCategory];

/**
 * CycloneDx1ExportFormat
 * Supported serializations for CycloneDX 1.x exports.
 */
export const CycloneDx1ExportFormat = {
  Json: 'json',
} as const;
export type CycloneDx1ExportFormat =
  (typeof CycloneDx1ExportFormat)[keyof typeof CycloneDx1ExportFormat];

/**
 * CycloneDx1SpecVersion
 * Supported CycloneDX 1.x spec versions.
 *
 * CycloneDX identifies releases as ``MAJOR.MINOR`` — there is no patch
 * component on a CycloneDX spec version.
 */
export const CycloneDx1SpecVersion = {
  Value16: '1.6',
} as const;
export type CycloneDx1SpecVersion =
  (typeof CycloneDx1SpecVersion)[keyof typeof CycloneDx1SpecVersion];

export type DeleteAccountData = any;

export interface DeleteAccountParams {
  /** @format path */
  accountName: string;
}

export type DeleteAnalysisArchiveRuleData = any;

export interface DeleteAnalysisArchiveRuleParams {
  /** @format path */
  ruleId: string;
}

export type DeleteApiKeyData = any;

export interface DeleteApiKeyParams {
  /** @format path */
  keyName: string;
}

export type DeleteAppData = any;

export interface DeleteAppParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Force
   * @default false
   */
  force?: boolean;
}

export type DeleteAppVersionData = any;

export interface DeleteAppVersionParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Force
   * @default false
   */
  force?: boolean;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type DeleteApplicationData = any;

export interface DeleteApplicationParams {
  /** @format path */
  applicationId: string;
}

export type DeleteApplicationVersionData = any;

export interface DeleteApplicationVersionParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
}

export type DeleteArchivedAnalysisData = any;

export interface DeleteArchivedAnalysisParams {
  force?: boolean;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type DeleteArtifactLifecyclePolicyData = any;

export interface DeleteArtifactLifecyclePolicyParams {
  /** @format path */
  policyUuid: string;
}

export type DeleteArtifactRelationshipsData = object;

export interface DeleteArtifactRelationshipsParams {
  /** List of relationship Ids to delete */
  relationship_ids: string[];
}

export type DeleteAssetData = any;

export interface DeleteAssetParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Asset ID
   * The ID of the asset
   * @format uuid
   */
  assetId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type DeleteConfigurationData = any;

export interface DeleteConfigurationParams {
  /** @format path */
  configKey: string;
}

export type DeleteCorrectionByUuidData = any;

export interface DeleteCorrectionByUuidParams {
  /** @format path */
  uuid: string;
}

export type DeleteEventData = any;

export interface DeleteEventParams {
  /**
   * Event ID of the event to be deleted
   * @format path
   */
  eventId: string;
}

export type DeleteEventsData = string[];

export interface DeleteEventsParams {
  /** Delete events that occurred before the timestamp */
  before?: string;
  /** Delete events that match the level - INFO or ERROR */
  level?: string;
  /** Delete events that occurred after the timestamp */
  since?: string;
}

export type DeleteFeedData = any;

export interface DeleteFeedParams {
  /** @format path */
  feed: string;
}

export type DeleteGithubConfigurationData = any;

export interface DeleteGithubConfigurationParams {
  /** @format path */
  uuid: string;
}

export type DeleteGithubSelectorData = any;

export interface DeleteGithubSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type DeleteIdpData = any;

export interface DeleteIdpParams {
  /** @format path */
  name: string;
}

export type DeleteIdpUserGroupData = any;

export interface DeleteIdpUserGroupParams {
  /**
   * The name of the IdP to remove the user group from
   * @format path
   */
  name: string;
  /** The user group uuid to remove from the IdP in the format user_group=uuid1&user_group=uuid2 */
  user_group: string[];
}

export type DeleteImageData = DeleteImageResponse;

export interface DeleteImageParams {
  force?: boolean;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

/** Image deletion response containing status and details */
export interface DeleteImageResponse {
  detail?: string;
  image_digest: string;
  /** Current status of the image deletion */
  status: DeleteImageResponseStatusEnum;
}

/** A list of delete image responses */
export type DeleteImageResponseList = DeleteImageResponse[];

/** Current status of the image deletion */
export const DeleteImageResponseStatusEnum = {
  NotFound: 'not_found',
  Deleting: 'deleting',
  DeleteFailed: 'delete_failed',
} as const;
export type DeleteImageResponseStatusEnum =
  (typeof DeleteImageResponseStatusEnum)[keyof typeof DeleteImageResponseStatusEnum];

export type DeleteImageStigData = any;

export interface DeleteImageStigParams {
  /** The UUID of the STIG evaluation to delete */
  evaluationUuid: UUID;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type DeleteImageVulnAnnotationData = any;

export interface DeleteImageVulnAnnotationParams {
  /**
   * The image digest of the vuln annotation to delete
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  vulnAnnotationUuid: UUID;
}

export type DeleteImagesAsyncData = DeleteImageResponseList;

export interface DeleteImagesAsyncParams {
  force?: boolean;
  image_digests: string[];
}

export type DeleteIntegrationData = any;

export interface DeleteIntegrationParams {
  /**
   * Force deletion of the integration instance regardless of its state
   * @default false
   */
  force?: boolean;
  /**
   * The integration instance's universally unique identifier
   * @example "84993c1f-863f-41f3-9bd8-dfcc821b1c8a"
   */
  integrationUuid: UUID;
}

export type DeleteInventoryData = any;

export interface DeleteInventoryParams {
  context: string;
  image_digest?: string;
  inventory_type: InventoryTypeEnum;
}

export type DeleteJiraConfigurationData = any;

export interface DeleteJiraConfigurationParams {
  /** @format path */
  uuid: string;
}

export type DeleteJiraSelectorData = any;

export interface DeleteJiraSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type DeleteKubernetesNamespacesData = any;

export interface DeleteKubernetesNamespacesParams {
  cluster_name?: string;
}

export type DeletePolicyData = any;

export interface DeletePolicyParams {
  /** @format path */
  policyId: string;
}

export type DeleteRegistryData = any;

export interface DeleteRegistryParams {
  /** @format path */
  registry: string;
}

export type DeleteRoleUserData = any;

export interface DeleteRoleUserParams {
  /** The domain that the user should have the role removed from.  This may be an account name when the domain is an account. */
  domain_name?: string;
  /**
   * Deprecated.  Please use domain_name instead.  The account that the user has the role to be removed
   * @deprecated
   */
  for_account?: string;
  /** @format path */
  roleName: string;
  /** The username to remove the role for */
  username: string;
}

export type DeleteServiceData = any;

export interface DeleteServiceParams {
  /** @format path */
  hostId: string;
  /** @format path */
  serviceName: string;
}

export type DeleteSlackConfigurationData = any;

export interface DeleteSlackConfigurationParams {
  /** @format path */
  uuid: string;
}

export type DeleteSlackSelectorData = any;

export interface DeleteSlackSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type DeleteSmtpConfigurationData = any;

export interface DeleteSmtpConfigurationParams {
  /** @format path */
  uuid: string;
}

export type DeleteSmtpSelectorData = any;

export interface DeleteSmtpSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type DeleteSourceData = any;

export interface DeleteSourceParams {
  /** force delete */
  force?: boolean;
  /**
   * UUID of source to delete
   * @format path
   */
  sourceId: string;
}

export type DeleteSubscriptionData = any;

export interface DeleteSubscriptionParams {
  /** @format path */
  subscriptionId: string;
}

export type DeleteTeamsConfigurationData = any;

export interface DeleteTeamsConfigurationParams {
  /** @format path */
  uuid: string;
}

export type DeleteTeamsSelectorData = any;

export interface DeleteTeamsSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type DeleteUserApiKeyData = any;

export interface DeleteUserApiKeyParams {
  /** @format path */
  accountName: string;
  /** @format path */
  keyName: string;
  /** @format path */
  username: string;
}

export type DeleteUserCredentialData = any;

export interface DeleteUserCredentialParams {
  /** @format path */
  accountName: string;
  credential_type: CredentialTypeEnum;
  /** @format path */
  username: string;
}

export type DeleteUserData = any;

export type DeleteUserGroupData = any;

export interface DeleteUserGroupParams {
  /** @format path */
  groupUuid: string;
}

export type DeleteUserGroupRoleData = any;

export interface DeleteUserGroupRoleParams {
  /** A list of accounts to remove all roles from the user group in the format of all_roles_for_account=account1&all_roles_for_account=account2 */
  all_roles_for_account?: string[];
  /** @format path */
  groupUuid: string;
  /** A list of membership ids to remove from the user group in the format of membership_id=1&membership_id=2 */
  membership_id?: string[];
}

export type DeleteUserGroupUsersData = any;

export interface DeleteUserGroupUsersParams {
  /** @format path */
  groupUuid: string;
  /** A list of usernames to remove from the user group in the format of username=user1&username=user2 */
  username: string[];
}

export interface DeleteUserParams {
  /** @format path */
  accountName: string;
  /** @format path */
  username: string;
}

export type DeleteVulnerabilityAnnotationData = any;

export interface DeleteVulnerabilityAnnotationParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
  /**
   * Vulnerability Annotation ID
   * The ID of the vulnerability annotation
   * @format uuid
   */
  vulnerabilityAnnotationId: string;
}

export type DeleteWebhookConfigurationData = any;

export interface DeleteWebhookConfigurationParams {
  /** @format path */
  uuid: string;
}

export type DeleteWebhookSelectorData = any;

export interface DeleteWebhookSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export interface DeploymentHistory {
  /** @format date-time */
  created_at?: string;
  /** @format float */
  db_upgrade_duration?: number;
  deployment_id?: string;
  from_database_version?: string;
  from_system_version?: string;
  outcome?: string;
  to_database_version?: string;
  to_system_version?: string;
  upgrade_id?: string;
}

export interface DeploymentHistoryList {
  items?: DeploymentHistory[];
}

export type DescribeErrorCodesData = (ErrorCodeSummary | StructuredErrorCode)[];

export interface DescribeErrorCodesParams {
  /**
   * If true, return full error code definitions including description, remediation steps, and other metadata. Default returns only code and message.
   * @default false
   */
  details?: boolean;
  /** Two-letter service prefix to filter by (e.g. AP, PE, CT) */
  service_prefix?: string;
}

export type DescribePolicyData = GateSpecList;

/** @format byte */
export type DownloadExportFileData = Blob;

export interface DownloadExportFileParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Download Id
   * @format uuid
   */
  downloadId: string;
}

export interface ECSContainer {
  account_name: string;
  arn: string;
  context: string;
  image_digest: string;
  image_tag: string;
  task_arn: string;
}

/** Containers defined in ECS */
export interface ECSContainers {
  containers?: ECSContainer[];
}

export interface ECSInventory {
  cluster_arn: string;
  containers?: ECSInventoryContainer[];
  services?: ECSInventoryService[] | null;
  tasks?: ECSInventoryTask[] | null;
  /** @format date-time */
  timestamp: string;
}

export interface ECSInventoryContainer {
  arn: string;
  image_digest?: string;
  image_tag: string;
  task_arn?: string;
}

export interface ECSInventoryService {
  arn: string;
  tags?: Record<string, string>;
}

export interface ECSInventoryTask {
  arn: string;
  service_arn?: string;
  tags?: Record<string, string>;
  task_definition_arn?: string;
}

export interface ECSService {
  account_name: string;
  arn: string;
  cluster_arn: string;
  tags: Record<string, string>;
}

/** Services defined in ECS */
export interface ECSServices {
  services?: ECSService[];
}

export interface ECSTask {
  account_name: string;
  arn: string;
  cluster_arn: string;
  service_arn: string;
  tags: Record<string, string>;
  task_definition_arn: string;
}

/** Tasks defined in ECS */
export interface ECSTasks {
  tasks?: ECSTask[];
}

/** A brief error code entry with just the code and message */
export interface ErrorCodeSummary {
  /**
   * The error code identifier (format: 2 uppercase letters + 3 digits, e.g. AP002)
   * @example "AP002"
   */
  code: string;
  /**
   * Short human-readable error message
   * @example "Invalid Credentials"
   */
  message: string;
}

/** A collection of event subcategories */
export interface EventCategory {
  description?: string;
  name?: string;
  subcategories?: EventSubcategory[];
}

/** A description of an event type */
export interface EventDescription {
  /** The message associated with the event type */
  message?: string;
  /** The event type. The last component of the fully-qualified event_type (category.subcategory.event) */
  name?: string;
  /** The type of resource this event is generated from */
  resource_type?: string;
  /** The fully qualified event type as would be seen in the event payload */
  type?: string;
}

/**
 * A record of occurrence of an asynchronous event triggered either by system or by user activity
 * @example {"event_id":"b4cf3559e6f64077a7e335225f0945fb","event":{"source":{"service_name":"catalog","host_id":"anchore-quickstart","base_url":"http://catalog:8228"},"resource":{"id":"http://policy-engine:8228","type":"service","account_name":"admin"},"type":"system.service.state_transition.orphaned","level":"error","message":"Service orphaned","details":{}}}
 */
export interface EventResponse {
  /** @format date-time */
  created_at?: string;
  event?: {
    category?: string;
    details?: object;
    level?: string;
    message?: string;
    resource?: {
      account_name?: string;
      id?: string;
      type?: string;
    };
    source?: {
      base_url?: string;
      host_id?: string;
      request_id?: string;
      service_name?: string;
    };
    /** @format date-time */
    timestamp?: string;
    type?: string;
  };
  event_id?: string;
}

/** A collection of events related to each other */
export interface EventSubcategory {
  description?: string;
  events?: EventDescription[];
  name?: string;
}

/** Array of EventCategory objects */
export type EventTypesList = EventCategory[];

/** Response envelope for paginated listing of events */
export interface EventsList {
  /** Number of events in this page */
  item_count?: number;
  /** Boolean flag, True indicates there are more events and False otherwise */
  next_page?: boolean;
  /** Page number of this result set */
  page?: number;
  /** List of events */
  results?: EventResponse[];
}

/**
 * ExportCompletionDetail
 * Completion detail populated when an export job finishes.
 */
export interface ExportCompletionDetail {
  /**
   * Download Id
   * Identifier for fetching the export via `/downloads/{download_id}`.
   * @format uuid
   */
  download_id?: string | null;
  /**
   * File Size
   * Export file size in bytes.
   */
  file_size?: number | null;
  /**
   * Record Count
   * Records written to the export.
   */
  record_count?: number | null;
}

/** ExportFormat */
export const ExportFormat = {
  Csv: 'csv',
} as const;
export type ExportFormat = (typeof ExportFormat)[keyof typeof ExportFormat];

/**
 * ExportPackagesJobResponse
 * Full response for an export-packages job.
 */
export interface ExportPackagesJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the Document API response. */
  job_spec: ExportPackagesJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportPackagesJobSpec
 * Mirrors the job_spec shape in the Document API response.
 */
export interface ExportPackagesJobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  format: ExportFormat;
}

/**
 * ExportPackagesRequest
 * POST body for creating an export-packages job.
 */
export interface ExportPackagesRequest {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /** @default "csv" */
  format?: ExportFormat;
}

/**
 * ExportPolicyComplianceJobResponse
 * Full response for an export-policy-compliance job.
 */
export interface ExportPolicyComplianceJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the Document API response. */
  job_spec: ExportPolicyComplianceJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportPolicyComplianceJobSpec
 * Mirrors the job_spec shape in the Document API response.
 */
export interface ExportPolicyComplianceJobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  /**
   * Output format for the policy compliance export.
   *
   * Only ``csv`` is supported in 6.0; the enum is here so we can extend to
   * JSON without breaking the request/response shape.
   */
  format: PolicyComplianceExportFormat;
}

/**
 * ExportPolicyComplianceRequest
 * POST body for creating an export-policy-compliance job.
 *
 * Format is selected via the ``format`` field on this body. Today only CSV
 * is supported; future formats (e.g. JSON) will extend
 * :class:`PolicyComplianceExportFormat` rather than introduce new endpoints.
 */
export interface ExportPolicyComplianceRequest {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /**
   * Output format for the policy compliance export.
   *
   * Only ``csv`` is supported in 6.0; the enum is here so we can extend to
   * JSON without breaking the request/response shape.
   * @default "csv"
   */
  format?: PolicyComplianceExportFormat;
}

/**
 * ExportSbomCycloneDx1JobResponse
 * Response for a CycloneDX 1.x SBOM export job.
 */
export interface ExportSbomCycloneDx1JobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the CycloneDX 1.x response. */
  job_spec: ExportSbomCycloneDx1JobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportSbomCycloneDx1JobSpec
 * Mirrors the job_spec shape in the CycloneDX 1.x response.
 */
export interface ExportSbomCycloneDx1JobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  /** Supported serializations for CycloneDX 1.x exports. */
  format: CycloneDx1ExportFormat;
  /**
   * Supported CycloneDX 1.x spec versions.
   *
   * CycloneDX identifies releases as ``MAJOR.MINOR`` — there is no patch
   * component on a CycloneDX spec version.
   */
  spec_version: CycloneDx1SpecVersion;
}

/**
 * ExportSbomCycloneDx1Request
 * POST body for ``/jobs/export-sbom-cyclonedx-1``.
 */
export interface ExportSbomCycloneDx1Request {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /**
   * Serialization to emit. Defaults to ``json``.
   * @default "json"
   */
  format?: CycloneDx1ExportFormat;
  /**
   * CycloneDX 1.x spec version to emit. Defaults to ``1.6``.
   * @default "1.6"
   */
  spec_version?: CycloneDx1SpecVersion;
}

/**
 * ExportSbomSpdx2JobResponse
 * Response for an SPDX 2.x SBOM export job.
 */
export interface ExportSbomSpdx2JobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the SPDX 2.x response. */
  job_spec: ExportSbomSpdx2JobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportSbomSpdx2JobSpec
 * Mirrors the job_spec shape in the SPDX 2.x response.
 */
export interface ExportSbomSpdx2JobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  /** Supported serializations for SPDX 2.x exports. */
  format: Spdx2ExportFormat;
  /**
   * Supported SPDX 2.x spec versions.
   *
   * The SPDX ``spdxVersion`` field uses ``MAJOR.MINOR`` (e.g. ``SPDX-2.3``);
   * point releases such as 2.2.1 still emit ``SPDX-2.2`` on the document.
   */
  spec_version: Spdx2SpecVersion;
}

/**
 * ExportSbomSpdx2Request
 * POST body for ``/jobs/export-sbom-spdx-2``.
 */
export interface ExportSbomSpdx2Request {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /**
   * Serialization to emit. Defaults to ``json``.
   * @default "json"
   */
  format?: Spdx2ExportFormat;
  /**
   * SPDX 2.x spec version to emit. Defaults to ``2.3``.
   * @default "2.3"
   */
  spec_version?: Spdx2SpecVersion;
}

/**
 * ExportVdrJobResponse
 * Full response for an export-vdr job.
 */
export interface ExportVdrJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the API response. */
  job_spec: ExportVdrJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportVdrJobSpec
 * Mirrors the job_spec shape in the API response.
 */
export interface ExportVdrJobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  format: VdrExportFormat;
  /**
   * Include Annotation Detail
   * Whether VEX narrative fields are included in the export.
   * @default false
   */
  include_annotation_detail?: boolean;
}

/**
 * ExportVdrRequest
 * POST body for creating an export-vdr job.
 *
 * When an app version has VEX annotations on its vulnerabilities, the VDR
 * automatically includes ``analysis.state`` for each annotated vulnerability. Set
 * ``include_annotation_detail`` to also include the narrative fields
 * (status notes, impact, action, additional details) and the CycloneDX
 * ``justification``. Default ``false`` mirrors v5's behaviour.
 */
export interface ExportVdrRequest {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /** @default "cyclonedx-json" */
  format?: VdrExportFormat;
  /**
   * Include Annotation Detail
   * Include VEX narrative fields and CycloneDX `justification` in the export.
   * @default false
   */
  include_annotation_detail?: boolean;
}

/**
 * ExportVexJobResponse
 * Full response for an export-vex job.
 */
export interface ExportVexJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the API response. */
  job_spec: ExportVexJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportVexJobSpec
 * Mirrors the job_spec shape in the API response.
 */
export interface ExportVexJobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  format: VexExportFormat;
}

/**
 * ExportVexRequest
 * POST body for creating a VEX export job.
 *
 * Format is selected via the ``format`` field on this body. Today only
 * CycloneDX JSON is supported; future VEX standards (e.g. OpenVEX) will
 * extend :class:`VexExportFormat` rather than introduce new endpoints.
 */
export interface ExportVexRequest {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /** @default "cyclonedx-json" */
  format?: VexExportFormat;
}

/**
 * ExportVulnerabilitiesJobResponse
 * Full response for an export-vulnerabilities job.
 */
export interface ExportVulnerabilitiesJobResponse {
  /**
   * Completed At
   * RFC3339 timestamp recorded once the job has reached a terminal state and will not be retried. Null while the job is still in flight.
   * @format date-time
   */
  completed_at?: string | null;
  /** Completion detail populated when an export job finishes. */
  completion_detail?: ExportCompletionDetail;
  /** Error details for failed jobs. */
  error?: JobError | null;
  /** Mirrors the job_spec shape in the Document API response. */
  job_spec: ExportVulnerabilitiesJobSpec;
  /**
   * Job Type
   * Job-type identifier (e.g. `add-sbom-asset`).
   */
  job_type: string;
  status: JobStatus;
  system_metadata: SystemMetadata;
}

/**
 * ExportVulnerabilitiesJobSpec
 * Mirrors the job_spec shape in the Document API response.
 */
export interface ExportVulnerabilitiesJobSpec {
  /**
   * App Version Id
   * App version being exported.
   * @format uuid
   */
  app_version_id: string;
  format: ExportFormat;
}

/**
 * ExportVulnerabilitiesRequest
 * POST body for creating an export-vulnerabilities job.
 */
export interface ExportVulnerabilitiesRequest {
  /**
   * App Version Id
   * App version to export.
   * @format uuid
   */
  app_version_id: string;
  /** @default "csv" */
  format?: ExportFormat;
}

export interface Feature {
  /** If the feature is enabled */
  enabled?: boolean;
  /** The name of the feature */
  name?: FeatureNameEnum;
}

export interface FeatureList {
  items?: Feature[];
}

/** The name of the feature */
export const FeatureNameEnum = {
  StaticStig: 'static_stig',
  RuntimeStig: 'runtime_stig',
} as const;
export type FeatureNameEnum =
  (typeof FeatureNameEnum)[keyof typeof FeatureNameEnum];

/** A data record */
export interface FeedDataRecord {
  /**
   * Deprecated - The build timestamp of the data record
   * @deprecated
   * @format date-time
   */
  built_at?: string;
  /** The checksum of the data record */
  checksum?: string;
  /**
   * Deprecated - The creation timestamp of the data record
   * @deprecated
   * @format date-time
   */
  created_at?: string;
  /** The format of the data record */
  data_format?: string;
  /**
   * The time when the Anchore Data Service started to build this feed.
   * @format date-time
   */
  data_service_built_at?: string;
  /** The dataset type of the record */
  dataset?: string;
  /**
   * The time when the Enterprise received this feed either via the data-syncer service or air gapped workflow.
   * @format date-time
   */
  enterprise_received_at?: string;
  /** The unique identifier for the data record */
  id?: string;
  /** The name of the data record */
  name?: string;
  /**
   * Deprecated - The last update timestamp of the data record
   * @deprecated
   * @format date-time
   */
  updated_at?: string;
  /** The version of the data record */
  version?: string;
}

/** @format path */
export const FeedEnum = {
  Packages: 'packages',
  Vulnerabilities: 'vulnerabilities',
} as const;
export type FeedEnum = (typeof FeedEnum)[keyof typeof FeedEnum];

/** The data feed to query */
export const GetSystemFeedFeed = {
  VulnerabilityDb: 'vulnerability_db',
  KevDb: 'kev_db',
  ClamavDb: 'clamav_db',
  EpssDb: 'epss_db',
  VulnerabilityMatchExclusionsDb: 'vulnerability_match_exclusions_db',
  StigProfilesDb: 'stig_profiles_db',
} as const;
export type GetSystemFeedFeed =
  (typeof GetSystemFeedFeed)[keyof typeof GetSystemFeedFeed];

export interface FeedGroupMetadata {
  /**
   * Deprecated - The time when Enterprise uploaded this feed group.
   * @deprecated
   * @format date-time
   */
  created_at?: string;
  /**
   * The time when the Anchore Data Service started to build this feed group.
   * @format date-time
   */
  data_service_built_at?: string;
  /**
   * Deprecated - If group is enabled.
   * @deprecated
   */
  enabled?: boolean;
  /**
   * The time when the Enterprise received this feed group either via the data-syncer service or air gapped workflow.
   * @format date-time
   */
  enterprise_received_at?: string;
  /**
   * Deprecated - The last successful update for this feed group.
   * @deprecated
   * @format date-time
   */
  last_sync?: string;
  /** The name of this feed group. */
  name?: string;
  /** The number of records in this feed group. */
  record_count?: number;
}

/** Metadata on the feeds based on findings from querying the endpoints. */
export interface FeedMetadata {
  /**
   * Deprecated - The time when Enterprise uploaded this feed.
   * @deprecated
   * @format date-time
   */
  created_at?: string;
  /**
   * The time when the Anchore Data Service started to build this feed.
   * @format date-time
   */
  data_service_built_at?: string;
  /** The checksum of the dataset that provides this feed */
  dataset_checksum?: string;
  /** The name of the dataset that provides this feed */
  dataset_name?: string;
  /**
   * Deprecated - If feed is enabled
   * @deprecated
   */
  enabled?: boolean;
  /**
   * The time when the Enterprise received this feed either via the data-syncer service or air gapped workflow.
   * @format date-time
   */
  enterprise_received_at?: string;
  groups?: FeedGroupMetadata[];
  /**
   * Deprecated - The last time that policy-engine service downloaded a new grypedb.
   * @deprecated
   * @format date-time
   */
  last_full_sync?: string;
  /** The name of the feed. */
  name?: string;
  /**
   * Deprecated - The last time the policy-engine service pinged the feed service to see if there was a new grypedb available.
   * @deprecated
   * @format date-time
   */
  updated_at?: string;
  /** The version of the feed. */
  version?: string;
}

/** Simple array of RetrievedFileMetadata objects */
export type FileContentSearchList = FileContentSearchResult[];

/** The retrieved file entry including content (b64 encoded) */
export interface FileContentSearchResult {
  matches?: RegexContentMatch[];
  path?: string;
}

export interface FileContents {
  findings: {
    /** The contents of the file */
    contents: string;
    location: {
      layerID?: string;
      path: string;
    };
  }[];
  /** The media type of this result */
  media_type: FileContentsMediaTypeEnum;
  metadata: {
    /**
     * The time the result was analyzed
     * @format date-time
     */
    analyzed_at?: string;
    /** The platform of AnchoreCTL used to generate the result */
    anchorectl_platform: string;
    /** The version of AnchoreCTL used to generate the result */
    anchorectl_version: string;
    /**
     * The platform of AnchoreCTL used to generate the result
     * @deprecated
     */
    platform?: string;
  };
}

/** The media type of this result */
export const FileContentsMediaTypeEnum = {
  ApplicationAnchoreEnterpriseLocalAnalyzeFileContentsV1Json:
    'application/anchore.enterprise.local-analyze.file-contents.v1+json',
} as const;
export type FileContentsMediaTypeEnum =
  (typeof FileContentsMediaTypeEnum)[keyof typeof FileContentsMediaTypeEnum];

export interface FilesContent {
  sha256?: string | null;
  filename?: string;
  gid?: number;
  linkdest?: string | null;
  mode?: string;
  /** @format int64 */
  size?: number;
  type?: string;
  uid?: number;
}

export type FinalizeOperationData = SourceManifest;

export interface FinalizeOperationParams {
  /** @format path */
  operationId: string;
}

/** FindingResult */
export interface FindingResult {
  /**
   * Action taken for this finding
   * @default "go"
   */
  action?: PolicyAction;
  /** Details of the allowlist if the finding is allowlisted */
  allowlist?: AllowlistInfo | null;
  /**
   * Allowlisted
   * Whether the finding has an active (non-expired) allowlist entry
   */
  allowlisted: boolean;
  /**
   * Message
   * Description of the finding
   */
  message: string;
  /**
   * Trigger Id
   * ID of this policy finding (can be used to allowlist the finding)
   */
  trigger_id: string;
}

/** FindingRule */
export interface FindingRule {
  /**
   * Gate
   * Name of the gate that produced this finding
   */
  gate: string;
  /**
   * Id
   * Unique identifier for the policy rule that triggered this finding
   */
  id: string;
  /**
   * Recommendation
   * User provided details for resolving this finding
   */
  recommendation: string;
  /**
   * Trigger
   * Name of the trigger that produced this finding
   */
  trigger: string;
}

/**
 * FixState
 * Vulnerability fix state.
 *
 * NOTE: Grype returns fix_state with hyphens (``not-fixed``, ``wont-fix``)
 * but we need our enum's NAME.lower() to equal its VALUE so that the
 * conversion to/from PG is just ``FixState(label.lower())``.  Python enum
 * NAMEs cannot include hyphens, so we use underscores instead.
 */
export const FixState = {
  Unknown: 'unknown',
  Fixed: 'fixed',
  NotFixed: 'not_fixed',
  WontFix: 'wont_fix',
} as const;
export type FixState = (typeof FixState)[keyof typeof FixState];

/**
 * FixVersion
 * A fix version with availability metadata.
 *
 * The 'kind' field indicates the type of date:
 * - "advisory": Date when vendor advisory was published
 * - "first-observed": Date when fix first appeared in package repository
 */
export interface FixVersion {
  /** Date */
  date?: string | null;
  kind?: FixVersionKind | null;
  /** Version */
  version: string;
}

/** FixVersionKind */
export const FixVersionKind = {
  Advisory: 'advisory',
  FirstObserved: 'first-observed',
} as const;
export type FixVersionKind =
  (typeof FixVersionKind)[keyof typeof FixVersionKind];

/** A description of the set of gates available in this engine and the triggers and parameters supported */
export interface GateSpec {
  /** Description of the gate */
  description?: string;
  /** Gate name, as it would appear in a policy document */
  name?: string;
  /** State of the gate and transitively all triggers it contains if not 'active' */
  state?: GateSpecStateEnum;
  /** The name of another trigger that supersedes this on functionally if this is deprecated */
  superseded_by?: string | null;
  supported_artifact_type?: RuleSetArtifactTypeEnum;
  /** List of the triggers that can fire for this Gate */
  triggers?: TriggerSpec[];
}

export type GateSpecList = GateSpec[];

/** State of the gate and transitively all triggers it contains if not 'active' */
export const GateSpecStateEnum = {
  Active: 'active',
  Deprecated: 'deprecated',
  Eol: 'eol',
} as const;
export type GateSpecStateEnum =
  (typeof GateSpecStateEnum)[keyof typeof GateSpecStateEnum];

export type GetAccountData = Account;

export interface GetAccountParams {
  /** @format path */
  accountName: string;
}

export type GetAccountUserData = User;

export interface GetAccountUserParams {
  /** @format path */
  accountName: string;
  /** @format path */
  username: string;
}

export type GetActionPlansData = ActionPlans;

export interface GetActionPlansParams {
  /**
   * RFC 3339 formatted UTC timestamp to filter out action plans that were only created after this date
   * @format date-time
   */
  created_after?: string;
  image_digest?: string;
  image_tag?: string;
}

export type GetAddContainerImageAssetJobData =
  AddContainerImageAssetJobResponse;

export interface GetAddContainerImageAssetJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetAddImportedImageAssetJobData = AddImportedImageAssetJobResponse;

export interface GetAddImportedImageAssetJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetAddSbomAssetJobData = AddSbomAssetJobResponse;

export interface GetAddSbomAssetJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetAlertSummariesData = AlertSummaryList;

export interface GetAlertSummariesParams {
  /**
   * Filter for alerts generated after the timestamp
   * @format date-time
   */
  created_after?: string;
  /**
   * Filter for alerts generated before the timestamp
   * @format date-time
   */
  created_before?: string;
  /**
   * @min 1
   * @max 100
   * @default 100
   */
  limit?: number;
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /**
   * Filter for alerts associated with a resource where the label in key=value format such as tag=docker.io/library/alpine:latest or repository=library/alpine
   * @uniqueItems true
   */
  resource_label?: string[];
  /**
   * Filter for alerts by current state, defaults to open alerts unless specified
   * @default "open"
   */
  state?: GetAlertSummariesState;
  /**
   * Filter for alerts based on the type such as compliance violation
   * @default "all"
   */
  type?: TypeEnum;
}

export type GetAnalysisArchiveRuleData = AnalysisArchiveTransitionRule;

export interface GetAnalysisArchiveRuleParams {
  /** @format path */
  ruleId: string;
}

export type GetAnchorectlData = any;

export interface GetAnchorectlParams {
  /** The architecture of the binary to retrieve */
  architecture: ArchitectureEnum;
  /** The operating system (platform) of the binary to retrieve */
  operating_system: OperatingSystemEnum;
}

export type GetApiKeyData = UserApiKey;

export interface GetApiKeyParams {
  /** @format path */
  keyName: string;
}

export type GetAppData = AppResponse;

export interface GetAppParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type GetAppVersionData = AppVersionResponse;

export interface GetAppVersionParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type GetApplicationData = Application;

export type GetApplicationJobData = AppJobListItemResponse;

export interface GetApplicationJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export interface GetApplicationParams {
  /** @format path */
  applicationId: string;
  /** @default false */
  include_versions?: boolean;
}

export type GetApplicationVersionData = ApplicationVersion;

export interface GetApplicationVersionParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
}

export type GetApplicationVersionSbomData = ApplicationVersionSbom;

export interface GetApplicationVersionSbomParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
  artifact_types?: ArtifactType[];
}

export type GetApplicationVersionVulnerabilitiesData =
  ApplicationVersionVulnerabilityReport;

export interface GetApplicationVersionVulnerabilitiesParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
  /** If true, include vulnerabilities that the vendor of an image distribution either disagrees with or does not intend to prioritize for remediation */
  will_not_fix?: boolean;
}

export type GetApplicationVersionsData = ApplicationVersionList;

export interface GetApplicationVersionsParams {
  /** @format path */
  applicationId: string;
}

export type GetApplicationsData = ApplicationList;

export interface GetApplicationsParams {
  /** @default false */
  include_versions?: boolean;
}

export type GetArchivedAnalysisData = ArchivedAnalysis;

export interface GetArchivedAnalysisParams {
  /**
   * The image digest to identify the image analysis
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetArtifactLifecyclePolicyByVersionData =
  ArtifactLifecyclePolicyResponse;

export interface GetArtifactLifecyclePolicyByVersionParams {
  /** Request the latest version */
  latest?: boolean;
  /** @format path */
  policyUuid: string;
  /** Request a specific version number */
  version?: number;
}

export type GetArtifactLifecyclePolicyData = ArtifactLifecyclePolicyResponse;

export interface GetArtifactLifecyclePolicyParams {
  /** @format path */
  policyUuid: string;
}

export type GetArtifactRelationshipData = ArtifactRelationship;

export interface GetArtifactRelationshipParams {
  /** Id of record to retrieve */
  relationshipId: string;
}

export type GetAssetData = AssetResponse;

export interface GetAssetParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Asset ID
   * The ID of the asset
   * @format uuid
   */
  assetId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

/** @format byte */
export type GetAssetSbomData = Blob;

export interface GetAssetSbomParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Asset ID
   * The ID of the asset
   * @format uuid
   */
  assetId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type GetComplianceViolationAlertData = ComplianceViolationAlert;

export interface GetComplianceViolationAlertParams {
  /**
   * Identifier for the alert
   * @format path
   */
  uuid: string;
}

export type GetComplianceViolationAlertsData = ComplianceViolationAlertList;

export interface GetComplianceViolationAlertsParams {
  /**
   * Filter for alerts generated after the timestamp
   * @format date-time
   */
  created_after?: string;
  /**
   * Filter for alerts generated before the timestamp
   * @format date-time
   */
  created_before?: string;
  /**
   * @min 1
   * @max 100
   * @default 100
   */
  limit?: number;
  /**
   * @min 1
   * @default 1
   */
  page?: number;
  /** Filter for alerts associated with image digest */
  resource_image_digest?: string;
  /** Filter for alerts generated for the tag */
  resource_image_tag?: string;
  /** Filter for alerts associated with registry */
  resource_registry?: string;
  /** Filter for alerts associated with repository */
  resource_repository?: string;
  /**
   * Filter for alerts by current state, defaults to open alerts unless specified
   * @default "open"
   */
  state?: GetAlertSummariesState;
}

export type GetConfigurationData = SystemConfiguration;

export interface GetConfigurationParams {
  /** @format path */
  configKey: string;
}

export type GetConfigurationSchemaData = object;

export type GetCorrectionByUuidData = Correction;

export interface GetCorrectionByUuidParams {
  /** @format path */
  uuid: string;
}

export type GetCorrectionsData = CorrectionList;

export interface GetCorrectionsParams {
  correction_type?: CorrectionTypeEnum;
}

export type GetCredentialsData = CredentialList;

export type GetDeploymentHistoryData = DeploymentHistoryList;

export type GetEcsContainersData = ECSContainers;

export interface GetEcsContainersParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetEcsServicesData = ECSServices;

export interface GetEcsServicesParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetEcsTasksData = ECSTasks;

export interface GetEcsTasksParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetErrorCodeDetailsData = StructuredErrorCode;

export interface GetErrorCodeDetailsParams {
  /** The error code to look up (e.g. AP002) */
  code: string;
}

export type GetEventData = EventResponse;

export interface GetEventParams {
  /**
   * Event ID of the event for lookup
   * @format path
   */
  eventId: string;
}

export type GetExportPackagesJobData = ExportPackagesJobResponse;

export interface GetExportPackagesJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetExportPolicyComplianceJobData =
  ExportPolicyComplianceJobResponse;

export interface GetExportPolicyComplianceJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetExportSbomCyclonedx1JobData = ExportSbomCycloneDx1JobResponse;

export interface GetExportSbomCyclonedx1JobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetExportSbomSpdx2JobData = ExportSbomSpdx2JobResponse;

export interface GetExportSbomSpdx2JobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetExportVdrJobData = ExportVdrJobResponse;

export interface GetExportVdrJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetExportVexJobData = ExportVexJobResponse;

export interface GetExportVexJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetExportVulnerabilitiesJobData = ExportVulnerabilitiesJobResponse;

export interface GetExportVulnerabilitiesJobParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Job ID
   * The ID of the job
   * @format uuid
   */
  jobId: string;
}

export type GetGithubConfigurationData =
  NotificationGitHubEndpointConfigurationBase;

export interface GetGithubConfigurationParams {
  /** @format path */
  uuid: string;
}

export type GetGithubConfigurationStatusData = NotificationOperationalStatus;

export interface GetGithubConfigurationStatusParams {
  /** @format path */
  uuid: string;
}

export type GetGithubSelectorData = NotificationSelector;

export interface GetGithubSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type GetGlobalQueryResultData = any;

export interface GetGlobalQueryResultParams {
  /** Page number to fetch. If omitted, '1' is default. Page numbers start at 1 */
  page?: number;
  /**
   * @format path
   * @pattern [0-9a-z-]+
   */
  resultUuid: string;
}

export type GetIdpData = RbacManagerSamlConfigurationGet;

export interface GetIdpParams {
  /** @format path */
  name: string;
}

export type GetIdpUserGroupsData = RbacManagerIdpUserGroups;

export interface GetIdpUserGroupsParams {
  /** @format path */
  name: string;
}

export type GetImageAncestorsData = ImageAncestry;

export interface GetImageAncestorsParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageContentByTypeData = ContentPackageResponse;

export type GetImageContentByTypeFilesData = ContentFilesResponse;

export interface GetImageContentByTypeFilesParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageContentByTypeJavaPackageData = ContentJavaPackageResponse;

export interface GetImageContentByTypeJavaPackageParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageContentByTypeLicenseData = LicenseReviewResponse;

export interface GetImageContentByTypeLicenseParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageContentByTypeMalwareData = ContentMalwareResponse;

export interface GetImageContentByTypeMalwareParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export interface GetImageContentByTypeParams {
  /** @format path */
  contentType: string;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageContentSummaryData = ImageContentSummary;

export interface GetImageContentSummaryParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageCyclonedxJsonData = string;

export interface GetImageCyclonedxJsonParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageCyclonedxXmlData = string;

export interface GetImageCyclonedxXmlParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageData = AnchoreImage;

export type GetImageInventoryData = InventoryItems;

export interface GetImageInventoryParams {
  context?: string;
  image_digest?: string;
  inventory_type?: InventoryTypeEnum;
}

export type GetImageMetadataByTypeData = MetadataResponse;

export interface GetImageMetadataByTypeParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  /** @format path */
  metadataType: string;
}

export type GetImageOpenvexData = string;

export interface GetImageOpenvexParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export interface GetImageParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImagePolicyCheckByDigestData = PolicyEvaluation;

export interface GetImagePolicyCheckByDigestParams {
  /** Digest of a base image. If specified the evaluation will indicate results inherited from the base image. Can specify "auto" to have the base image automatically calculated. */
  base_digest?: string;
  /** @default true */
  detail?: boolean;
  /** @default false */
  history?: boolean;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  /** @default false */
  interactive?: boolean;
  policy_id?: string;
  tag: string;
}

export type GetImageSbomCyclonedxJsonData = string;

export interface GetImageSbomCyclonedxJsonParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageSbomNativeJsonData = string;

export interface GetImageSbomNativeJsonParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageSbomSpdxJsonData = string;

export interface GetImageSbomSpdxJsonParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

/** @format binary */
export type GetImageStigData = File;

export interface GetImageStigParams {
  /** The UUID of the STIG evaluation to retrieve */
  evaluationUuid: UUID;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImageVulnAnnotationData = PackageVulnerabilityAnnotation;

export interface GetImageVulnAnnotationParams {
  /**
   * The image digest of the vuln annotation to retrieve
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  vulnAnnotationUuid: UUID;
}

export type GetImageVulnerabilitiesByDigestCyclonedxJsonData = object;

export interface GetImageVulnerabilitiesByDigestCyclonedxJsonParams {
  /** @default false */
  force_refresh?: boolean;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  /**
   * When true, include detailed vulnerability annotations in the report.
   * @default false
   */
  include_annotation_detail?: boolean;
  /** @default false */
  include_vuln_description?: boolean;
  /**
   * The image distribution vendor assessment of this vulnerability differs from NVD's assessment. The vendor has indicated that they do not intend to provide a fix. Such vulnerabilities will be excluded from results when this is set to True.
   * @default true
   */
  vendor_only?: boolean;
  vulnType: VulnTypeEnum;
}

export type GetImageVulnerabilitiesByDigestCyclonedxXmlData = object;

export interface GetImageVulnerabilitiesByDigestCyclonedxXmlParams {
  /** @default false */
  force_refresh?: boolean;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  /**
   * When true, include detailed vulnerability annotations in the report.
   * @default false
   */
  include_annotation_detail?: boolean;
  /** @default false */
  include_vuln_description?: boolean;
  /**
   * The image distribution vendor assessment of this vulnerability differs from NVD's assessment. The vendor has indicated that they do not intend to provide a fix. Such vulnerabilities will be excluded from results when this is set to True.
   * @default true
   */
  vendor_only?: boolean;
  vulnType: VulnTypeEnum;
}

export type GetImageVulnerabilitiesByDigestData =
  ImagePackageVulnerabilityResponse;

export interface GetImageVulnerabilitiesByDigestParams {
  /** Digest of a base image. If specified the vulnerabilities will indicate inheritance from the base image. Can specify "auto" to have the base image automatically calculated. */
  base_digest?: string;
  /** @default false */
  force_refresh?: boolean;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  /** @default false */
  include_vuln_description?: boolean;
  /**
   * The image distribution vendor assessment of this vulnerability differs from NVD's assessment. The vendor has indicated that they do not intend to provide a fix. Such vulnerabilities will be excluded from results when this is set to True.
   * @default true
   */
  vendor_only?: boolean;
  vulnType: VulnTypeEnum;
}

export type GetImageVulnerabilityTypesData = VulnTypeEnum[];

export interface GetImageVulnerabilityTypesParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type GetImportSourcesSbomData = SourceImportContentResponse;

export interface GetImportSourcesSbomParams {
  /** @format path */
  operationId: string;
}

export type GetIntegrationByIdData = Integration;

export interface GetIntegrationByIdParams {
  /**
   * The integration instance's universally unique identifier
   * @example "84993c1f-863f-41f3-9bd8-dfcc821b1c8a"
   */
  integrationUuid: UUID;
}

export type GetJiraConfigurationData =
  NotificationJiraEndpointConfigurationBase;

export interface GetJiraConfigurationParams {
  /** @format path */
  uuid: string;
}

export type GetJiraConfigurationStatusData = NotificationOperationalStatus;

export interface GetJiraConfigurationStatusParams {
  /** @format path */
  uuid: string;
}

export type GetJiraSelectorData = NotificationSelector;

export interface GetJiraSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type GetKubernetesContainersData = KubernetesContainers;

export interface GetKubernetesContainersParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetKubernetesNamespaceData = KubernetesNamespace;

export interface GetKubernetesNamespaceParams {
  /** @format path */
  namespaceId: string;
}

export type GetKubernetesNamespacesData = KubernetesNamespaces;

export interface GetKubernetesNamespacesParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetKubernetesNodeData = KubernetesNode;

export interface GetKubernetesNodeParams {
  /** @format path */
  nodeId: string;
}

export type GetKubernetesNodesData = KubernetesNodes;

export interface GetKubernetesNodesParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetKubernetesPodData = KubernetesPod;

export interface GetKubernetesPodParams {
  /** @format path */
  podId: string;
}

export type GetKubernetesPodsData = KubernetesPods;

export interface GetKubernetesPodsParams {
  /** @min 1 */
  page: number;
  /**
   * @min 1
   * @default 1000
   */
  page_size?: number;
}

export type GetOauthTokenData = TokenResponse;

export interface GetOauthTokenPayload {
  /**
   * The type of client used for the OAuth token
   * @default "anonymous"
   */
  client_id?: string;
  /**
   * OAuth Grant type for token
   * @default "password"
   */
  grant_type?: string;
  /** Password for corresponding user */
  password?: string;
  /** The refresh token from a previous password grant request, used to get a new access_token */
  refresh_token?: string;
  /** User to assign OAuth token to */
  username?: string;
}

export type GetOperationData = ImageImportOperation;

export interface GetOperationParams {
  /** @format path */
  operationId: string;
}

export type GetPolicyData = PolicyRecord;

export interface GetPolicyParams {
  /** Setting this to false, will return only the policy metadata. Otherwise, this call will always return both the policy metadata and document. */
  detail?: boolean;
  /** @format path */
  policyId: string;
}

export type GetPolicyStatusData = PolicyStatusResponse;

export interface GetPolicyStatusParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type GetQueryResultData = any;

export interface GetQueryResultParams {
  /** Page number to fetch. If omitted, '1' is default. Page numbers start at 1 */
  page?: number;
  /**
   * @format path
   * @pattern [0-9a-z-]+
   */
  resultUuid: string;
}

export type GetRegistryData = RegistryConfigurationList;

export interface GetRegistryParams {
  /** @format path */
  registry: string;
}

export type GetRelationshipSbomDiffData = RelationshipSbomDiff;

export interface GetRelationshipSbomDiffParams {
  relationshipId: string;
}

export type GetResourceLimitsData = SystemResourceLimitsList;

export type GetRoleData = RbacManagerRole;

export interface GetRoleParams {
  /** @format path */
  roleName: string;
}

export type GetServiceDetailData = SystemStatusResponse;

export type GetServicesByNameAndHostData = ServiceList;

export interface GetServicesByNameAndHostParams {
  /** @format path */
  hostId: string;
  /** @format path */
  serviceName: string;
}

export type GetServicesByNameData = ServiceList;

export interface GetServicesByNameParams {
  /** @format path */
  serviceName: string;
}

export type GetSlackConfigurationData = NotificationSlackEndpointConfiguration;

export interface GetSlackConfigurationParams {
  /** @format path */
  uuid: string;
}

export type GetSlackConfigurationStatusData = NotificationOperationalStatus;

export interface GetSlackConfigurationStatusParams {
  /** @format path */
  uuid: string;
}

export type GetSlackSelectorData = NotificationSelector;

export interface GetSlackSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type GetSmtpConfigurationData = NotificationSMTPEndpointConfiguration;

export interface GetSmtpConfigurationParams {
  /** @format path */
  uuid: string;
}

export type GetSmtpConfigurationStatusData = NotificationOperationalStatus;

export interface GetSmtpConfigurationStatusParams {
  /** @format path */
  uuid: string;
}

export type GetSmtpSelectorData = NotificationSelector;

export interface GetSmtpSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type GetSourceContentByTypeData = SourceContentPackageResponse;

export interface GetSourceContentByTypeParams {
  /** @format path */
  contentType: string;
  /** @format path */
  sourceId: string;
}

export type GetSourceContentSummaryData = SourceContentSummary;

export interface GetSourceContentSummaryParams {
  /** @format path */
  sourceId: string;
}

/** Array of available types */
export type GetSourceContentTypesData = string[];

export interface GetSourceContentTypesParams {
  /** @format path */
  sourceId: string;
}

export type GetSourceData = SourceManifest;

export interface GetSourceParams {
  /** @format path */
  sourceId: string;
}

export type GetSourcePolicyCheckData = SourcePolicyEvaluation;

export interface GetSourcePolicyCheckParams {
  policy_id?: string;
  /**
   * UUID of source to get
   * @format path
   */
  sourceId: string;
}

export type GetSourceSbomCyclonedxJsonData = string;

export interface GetSourceSbomCyclonedxJsonParams {
  /** @format path */
  sourceId: string;
}

export type GetSourceSbomNativeJsonData = string;

export interface GetSourceSbomNativeJsonParams {
  /** @format path */
  sourceId: string;
}

export type GetSourceSbomSpdxJsonData = string;

export interface GetSourceSbomSpdxJsonParams {
  /** @format path */
  sourceId: string;
}

export type GetSourceVulnerabilitiesData = SourcePackageVulnerabilityResponse;

export interface GetSourceVulnerabilitiesParams {
  force_refresh?: boolean;
  /** @default false */
  include_vuln_description?: boolean;
  /** @format path */
  sourceId: string;
  vulnType: VulnTypeEnum;
  /** Vulnerability data publishers explicitly won't fix some vulnerabilities. This is captured by will_not_fix attribute of each result. If the query parameter is set, results matching it's value will be filtered. Results are not filtered if the query parameter is unset */
  will_not_fix?: boolean;
}

export type GetSourceVulnerabilityTypesData = VulnTypeEnum[];

export interface GetSourceVulnerabilityTypesParams {
  /** @format path */
  sourceId: string;
}

export type GetSourcesOperationData = SourceImportOperation;

export interface GetSourcesOperationParams {
  /** @format path */
  operationId: string;
}

export type GetStatusData = StatusResponse;

export type GetStigEntitlementData = FeatureList;

/** @format binary */
export type GetStigProfilesData = File;

export type GetSubscriptionData = SubscriptionList;

export interface GetSubscriptionParams {
  /** @format path */
  subscriptionId: string;
}

export type GetSystemFeedData = FeedDataRecord;

export interface GetSystemFeedParams {
  /** The data feed to query */
  feed: GetSystemFeedFeed;
  /** The version of the feed to query */
  version: string;
}

export type GetSystemFeedsData = FeedMetadata[];

export type GetSystemStatisticsData = SystemStatisticsList;

export type GetTeamsConfigurationData = NotificationTeamsEndpointConfiguration;

export interface GetTeamsConfigurationParams {
  /** @format path */
  uuid: string;
}

export type GetTeamsConfigurationStatusData = NotificationOperationalStatus;

export interface GetTeamsConfigurationStatusParams {
  /** @format path */
  uuid: string;
}

export type GetTeamsSelectorData = NotificationSelector;

export interface GetTeamsSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type GetUserApiKeyData = UserApiKey;

export interface GetUserApiKeyParams {
  /** @format path */
  accountName: string;
  /** @format path */
  keyName: string;
  /** @format path */
  username: string;
}

export type GetUserData = User;

export type GetUserGroupData = UserGroup;

export interface GetUserGroupParams {
  /** @format path */
  groupUuid: string;
}

export type GetUsersAccountData = Account;

export type GetVulnerabilityAnnotationData =
  AppVersionVulnerabilityAnnotationResponse;

export interface GetVulnerabilityAnnotationParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
  /**
   * Vulnerability Annotation ID
   * The ID of the vulnerability annotation
   * @format uuid
   */
  vulnerabilityAnnotationId: string;
}

export type GetWebhookConfigurationData =
  NotificationWebhookEndpointConfiguration;

export interface GetWebhookConfigurationParams {
  /** @format path */
  uuid: string;
}

export type GetWebhookConfigurationStatusData = NotificationOperationalStatus;

export interface GetWebhookConfigurationStatusParams {
  /** @format path */
  uuid: string;
}

export type GetWebhookSelectorData = NotificationSelector;

export interface GetWebhookSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

export type HandleHealthReportData = any;

export interface HandleHealthReportParams {
  /**
   * The integration's universally unique identifier
   * @example "84993c1f-863f-41f3-9bd8-dfcc821b1c8a"
   */
  integrationUuid: UUID;
}

export type HealthCheckData = any;

/** Integration instance specific health data */
export interface HealthData {
  /** Information about sent inventory report for accounts */
  account_k8s_inventory_reports?: Record<string, AccountK8SInventoryReportInfo>;
  /** List of errors */
  errors?: string[];
  /** The type of integration */
  type: IntegrationType;
  /**
   * Version of the health data schema
   * @example 1
   */
  version: number;
}

/** Health report for an integration instance */
export interface HealthReport {
  /** Integration instance specific health data */
  health_data: HealthData;
  /** Interval (in seconds) between health reports */
  health_report_interval: HealthReportInterval;
  /**
   * The version of the health report exchange protocol
   * @example 1
   */
  protocol_version: number;
  /**
   * timestamp for this health report
   * @format date-time
   * @example "2024-06-26 14:02:43+00:00"
   */
  timestamp: string;
  /**
   * Running time of integration instance in seconds
   * @example 200.02312
   */
  uptime: number;
  /**
   * Universally unique identifier for this health report
   * @format uuid
   * @example "740c06a3-4c69-4b91-8e85-154cd53e9764"
   */
  uuid: string;
}

/**
 * Interval (in seconds) between health reports
 * @min 30
 * @max 600
 * @example 60
 */
export type HealthReportInterval = number;

/** List of image digests to archive */
export type ImageAnalysisReferences = string[];

/** A request to add an image to be watched and analyzed by the engine. */
export interface ImageAnalysisRequest {
  /** Annotations to be associated with the added image in key/value form */
  annotations?: object;
  /** Optional. The type of image this is adding, defaults to "docker". */
  image_type?: string;
  /** A set of analysis source types. Only one may be set in any given request. */
  source?: ImageSource;
}

/** An summary of an image and it's layers. */
export interface ImageAncestor {
  /** True for the specific ancestor that has been identified as the base image by the system. This image will be used internally for comparisons. */
  chosen_base_image?: boolean;
  /**
   * The digest of the image
   * @example "sha256:55cffbd26dbe2e79252dd3283b1adef4459441e7b4fc2fe5ccd2bd5b52670474"
   */
  image_digest?: string;
  /** The full set of layers for this image */
  layers?: string[];
  /**
   * The digest of the manifest list (if any) that described this image
   * @example "sha256:55cffbd26dbe2e79252dd3283b1adef4459441e7b4fc2fe5ccd2bd5b52670474"
   */
  parent_digest?: string;
  tags?: string[];
  /** True if a specific ancestor has been marked by the user as the chosen base image */
  user_marked_base?: boolean;
}

/** Array of ancestor objects. Sorted by the length of the layers array in each entry, effectively returning them in increasing order of number of common layers. */
export type ImageAncestry = ImageAncestor[];

/** Model for an image artifact */
export interface ImageArtifact {
  /** The account name */
  account_name?: string;
  /** the analysis status of image */
  analysis_status?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the image was analyzed
   * @format date-time
   */
  analyzed_at?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the image was created
   * @format date-time
   */
  created_at?: string;
  /** The distro of the image */
  distro?: string;
  /** The distro version of the image */
  distro_version?: string;
  /** The digest of the image */
  image_digest?: string;
  /** The status of the image */
  image_status?: string;
  /**
   * RFC 3339 formatted UTC timestamp when the image was last updated
   * @format date-time
   */
  last_updated?: string;
}

/** Lifecycle policy conditions specific to image artifacts. */
export interface ImageArtifactLifecyclePolicyConditions {
  /** The type of artifact that will be processed. */
  artifact_type: ImageArtifactLifecyclePolicyConditionsArtifactTypeEnum;
  /** An image analysis must be this many days old before it will be considered for processing. An integer value less than or equal to zero will cause this field to be ignored. */
  days_since_analyzed: number;
  /** Select an image even if it exists in the runtime inventory, otherwise if false do not action anything that exists in runtime inventory. */
  even_if_exists_in_runtime_inventory: boolean;
  /** Include base images in the policy selection criteria. */
  include_base_images?: boolean;
  /** Include images which have failed analysis in the policy selection criteria. */
  include_failed_analysis?: boolean;
  /** The version of these policy conditions. */
  version?: number;
}

/** The type of artifact that will be processed. */
export const ImageArtifactLifecyclePolicyConditionsArtifactTypeEnum = {
  Image: 'image',
} as const;
export type ImageArtifactLifecyclePolicyConditionsArtifactTypeEnum =
  (typeof ImageArtifactLifecyclePolicyConditionsArtifactTypeEnum)[keyof typeof ImageArtifactLifecyclePolicyConditionsArtifactTypeEnum];

/** ImageArtifactReference */
export interface ImageArtifactReference {
  /**
   * Digest
   * Image digest resolved by the catalog (sha256:...).
   */
  digest: string;
  /**
   * Image Id
   * Image ID from the v5 catalog (content-addressable config digest).
   */
  image_id: string;
  /**
   * Index Digest
   * OCI index digest for multi-arch images, if available.
   */
  index_digest?: string | null;
}

/** A metadata content record for a specific image, containing different content type entries */
export interface ImageContent {
  metadata?: {
    /** The CPU architecture of the image */
    arch?: string;
    /** The distro of the image */
    distro?: string;
    /** The distro version of the image */
    distro_version?: string;
    /** The mode of the dockerfile */
    dockerfile_mode?: ImageContentDockerfileModeEnum;
    /** Whether the image has been identified as being of an Extended Update Support (EUS) distro version. A null value indicates that the image was analyzed prior to Enterprise having the ability to detect EUS support. The image may be re-analyzed if this data is required. */
    extended_support?: boolean;
    /**
     * The size of the image in bytes
     * @format int64
     */
    image_size?: number;
    /** The number of layers in the image */
    layer_count?: number;
  };
}

/** The mode of the dockerfile */
export const ImageContentDockerfileModeEnum = {
  Guessed: 'Guessed',
  Actual: 'Actual',
} as const;
export type ImageContentDockerfileModeEnum =
  (typeof ImageContentDockerfileModeEnum)[keyof typeof ImageContentDockerfileModeEnum];

/** A summary of the content types found in an image with counts */
export interface ImageContentSummary {
  items?: {
    content_type?: string;
    count?: number;
    display_name?: string;
  }[];
}

/** A metadata detail record for a specific image. Multiple detail records may map to a single catalog image. For example, an image having multiple tags associated with a single image digest will generate multiple image detail records. */
export interface ImageDetail {
  account_name?: string;
  /** @format date-time */
  created_at?: string;
  dockerfile?: string | null;
  /** Full docker-pullable digest string including the registry url and repository necessary get the image */
  full_digest?: string;
  /** Full docker-pullable tag string referencing the image */
  full_tag?: string;
  /** The parent Anchore Image record to which this detail maps */
  image_digest?: string;
  image_id?: string;
  /** @format date-time */
  last_updated?: string;
  registry?: string;
  repo?: string;
  tag?: string;
  /** @format date-time */
  tag_detected_at?: string;
}

export interface ImageImportContentResponse {
  /** @format date-time */
  created_at?: string;
  digest?: string;
}

export interface ImageImportContentSearch {
  content_searches: ImportContentSearchElement[];
  location: ImportPackageLocation;
}

/** Array of ImageImportContentSearch objects */
export type ImageImportContentSearchList = ImageImportContentSearch[];

export interface ImageImportFileContent {
  contents: string;
  location: ImportPackageLocation;
}

/** Array of ImageImportFileContent objects */
export type ImageImportFileContentList = ImageImportFileContent[];

export interface ImageImportFileCoordinate {
  /** The image layer in which the file was found */
  layerID?: string;
  /** The path on the filesystem of the file within the given layer */
  path?: string;
}

export type ImageImportManifest = {
  /** Digest of content to use in the final import */
  contents: ImportContentDigests;
  digest: string;
  /** An "image_id" as used by Docker if available */
  local_image_id?: string;
  operation_uuid: string;
  /** The digest of the image's manifest-list parent if it was accessed from a multi-arch tag where the tag pointed to a manifest-list. This allows preservation of that relationship in the data */
  parent_digest?: string;
  tags: string[];
} | null;

/** An import record, creating a unique identifier for referencing the operation as well as its state */
export interface ImageImportOperation {
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  expires_at?: string;
  status?: ImageImportOperationStatusEnum;
  uuid?: string;
}

export const ImageImportOperationStatusEnum = {
  Pending: 'pending',
  Queued: 'queued',
  Processing: 'processing',
  Complete: 'complete',
  Failed: 'failed',
  Expired: 'expired',
} as const;
export type ImageImportOperationStatusEnum =
  (typeof ImageImportOperationStatusEnum)[keyof typeof ImageImportOperationStatusEnum];

export type ImageImports = ImageImportOperation[];

/** ImageJobSpec */
export interface ImageJobSpec {
  /**
   * App Versions
   * Application versions the asset will be attached to.
   */
  app_versions: AppVersionById[];
  asset: NewAssetSpec;
  /**
   * Image Reference
   * Container image pull reference.
   */
  image_reference: string;
}

/** The structured components of a normalized image reference. */
export interface ImageNormalizeReference {
  /**
   * The digest component, or null for tag-only references.
   * @example null
   */
  digest?: string | null;
  /**
   * The canonical pullable form of the image reference. Includes the digest component when the input supplied one (e.g. `registry/repo@sha256:...` or `registry/repo:tag@sha256:...`); otherwise takes the `registry/repo:tag` form.
   * @example "docker.io/alpine:latest"
   */
  full_string: string;
  /**
   * The registry host (and port, if present).
   * @example "docker.io"
   */
  registry: string;
  /**
   * The repository name, including any namespace component.
   * @example "alpine"
   */
  repository: string;
  /**
   * The tag component, or null for digest-only references.
   * @example "latest"
   */
  tag?: string | null;
}

/** Request body for normalizing an image reference string. */
export interface ImageNormalizeRequest {
  /**
   * The image reference string to normalize — the same string you would pass to `docker pull`.
   * @example "alpine"
   */
  pull_string: string;
}

/** Response body containing the normalized image reference. */
export interface ImageNormalizeResponse {
  /**
   * The original image reference string supplied by the caller.
   * @example "alpine"
   */
  input: string;
  /** The structured components of a normalized image reference. */
  normalized: ImageNormalizeReference;
}

export interface ImagePackageManifest {
  artifactRelationships?: ImportPackageRelationship[];
  artifacts: ImportPackage[];
  descriptor?: ImportDescriptor;
  distro: ImportDistribution;
  files?: ImportFile[];
  schema?: ImportSchema;
  source: ImportSource;
  [key: string]: any;
}

export type ImagePackageVulnerability = PackageVulnerability & {
  /** True if the vulnerable artifact is found in the base image. False otherwise */
  inherited_from_base?: boolean;
};

/** envelope containing list of vulnerabilities */
export interface ImagePackageVulnerabilityResponse {
  base_digest?: string;
  base_image_problems?: object[];
  /** Whether Extended Update Support (EUS) data was used for the vulnerability scan */
  extended_support?: boolean;
  image_digest?: string;
  /** List of Vulnerability objects */
  vulnerabilities?: ImagePackageVulnerability[];
  vulnerability_type?: string;
}

/** A reference to an image */
export interface ImageRef {
  type: ImageRefTypeEnum;
  value: string;
}

export const ImageRefTypeEnum = {
  Tag: 'tag',
  Digest: 'digest',
  Id: 'id',
} as const;
export type ImageRefTypeEnum =
  (typeof ImageRefTypeEnum)[keyof typeof ImageRefTypeEnum];

/** A summary of an image identity, including digest, id (if available), and any tags known to have ever been mapped to the digest */
export interface ImageReference {
  /** Timestamp, in rfc3339 format, indicating when the image state became 'analyzed' in Anchore Engine. */
  analyzed_at?: string;
  /** The image digest */
  image_digest?: string;
  /** The image id if available */
  image_id?: string;
  tag_history?: TagEntry[];
}

/** An image SBOM Document */
export type ImageSBOM = object;

export interface ImageSelectionRule {
  /** Description of the Allowlist or Denylist image match, human readable */
  description?: string;
  id: string;
  /** A reference to an image */
  image: ImageRef;
  name: string;
  registry: string;
  repository: string;
}

/** A set of selection criteria to match an image by a tagged pull string based on its components, with regex support in each field */
export interface ImageSelector {
  /** The registry section of a pull string. e.g. with "docker.io/anchore/anchore-engine:latest", this is "docker.io" */
  registry?: string;
  /** The repository section of a pull string. e.g. with "docker.io/anchore/anchore-engine:latest", this is "anchore/anchore-engine" */
  repository?: string;
  /** The tag-only section of a pull string. e.g. with "docker.io/anchore/anchore-engine:latest", this is "latest" */
  tag?: string;
}

/** A set of analysis source types. Only one may be set in any given request. */
export interface ImageSource {
  /** An image reference in the analysis archive for the purposes of loading analysis from the archive into th working set */
  archive?: AnalysisArchiveSource;
  /** An image reference using a digest in a registry, includes some extra tag and timestamp info in addition to the pull string to allow proper tag history reconstruction. */
  digest?: RegistryDigestSource;
  import?: ImageImportManifest;
  /** An image reference using a tag in a registry, this is the most common source type. */
  tag?: RegistryTagSource;
}

/**
 * Filter by image_status value on the record. Default if omitted is 'active'.
 * @default "active"
 */
export const ImageStatusEnum = {
  All: 'all',
  Active: 'active',
  Deleting: 'deleting',
} as const;
export type ImageStatusEnum =
  (typeof ImageStatusEnum)[keyof typeof ImageStatusEnum];

/** An image record that contains packages */
export interface ImageWithPackages {
  /** A summary of an image identity, including digest, id (if available), and any tags known to have ever been mapped to the digest */
  image?: ImageReference;
  packages?: PackageReference[];
}

export type ImportContentDigestList = string[];

/** Digest of content to use in the final import */
export interface ImportContentDigests {
  /** Digest for reference content for content search results */
  content_searches?: string;
  /** Digest for reference content for dockerfile */
  dockerfile?: string;
  /** Digest for reference content for file retrieve content */
  file_contents?: string;
  /** Digest for reference content for image config */
  image_config: string;
  /** Digest to reference content for the image manifest */
  manifest: string;
  /** Digest to use for the packages content */
  packages?: string;
  /** Digest for reference content for parent manifest */
  parent_manifest?: string;
  /** Digest to use for the packages content */
  sbom?: string;
  /** Digest for reference content for secret search results */
  secret_searches?: string;
}

export interface ImportContentSearchElement {
  classification: string;
  length: number;
  line_number: number;
  line_offset: number;
  seek_position: number;
}

export type ImportContentSearchesData = ImageImportContentResponse;

export interface ImportContentSearchesParams {
  /** @format path */
  operationId: string;
}

export type ImportContentSearchesPayload =
  | ImageImportContentSearchList
  | ContentSearch;

export interface ImportDescriptor {
  name: string;
  version: string;
  [key: string]: any;
}

export interface ImportDistribution {
  extendedSupport?: boolean | null;
  id?: string | null;
  idLike?: any;
  name?: string | null;
  version?: string | null;
  versionID?: string | null;
  [key: string]: any;
}

export interface ImportFile {
  digests?: ImportFileDigest[];
  /** Unique identifier within the sbom for the file for other elements in the sbom to reference */
  id: string;
  location: ImageImportFileCoordinate;
  /** File metadata such as mode, size, etc. This is populated by anchorectl analysis but is not available in older syft-generated SBOMs */
  metadata?: object;
  [key: string]: any;
}

export type ImportFileContentsData = ImageImportContentResponse;

export interface ImportFileContentsParams {
  /** @format path */
  operationId: string;
}

export type ImportFileContentsPayload =
  | ImageImportFileContentList
  | FileContents;

export interface ImportFileDigest {
  algorithm: string;
  value: string;
}

export type ImportImageAnalysisResultManifestData = ImageImportContentResponse;

export interface ImportImageAnalysisResultManifestParams {
  /** @format path */
  operationId: string;
}

export type ImportImageAnalysisResultManifestPayload = object;

export type ImportImageConfigData = ImageImportContentResponse;

export interface ImportImageConfigParams {
  /** @format path */
  operationId: string;
}

export type ImportImageConfigPayload = object;

export type ImportImageDockerfileData = ImageImportContentResponse;

export interface ImportImageDockerfileParams {
  /** @format path */
  operationId: string;
}

export type ImportImageDockerfilePayload = string;

export type ImportImageManifestData = ImageImportContentResponse;

export interface ImportImageManifestParams {
  /** @format path */
  operationId: string;
}

export type ImportImageManifestPayload = object;

export type ImportImagePackagesData = ImageImportContentResponse;

export interface ImportImagePackagesParams {
  /** @format path */
  operationId: string;
}

export type ImportImageParentManifestData = ImageImportContentResponse;

export interface ImportImageParentManifestParams {
  /** @format path */
  operationId: string;
}

export type ImportImageParentManifestPayload = object;

export type ImportImageSbomData = ImageImportContentResponse;

export interface ImportImageSbomParams {
  /** @format path */
  operationId: string;
}

/** A Syft SBOM document in JSON format. The system supports multiple Syft schema versions and will auto-detect and validate against the appropriate version. */
export type ImportImageSbomPayload = object;

export interface ImportPackage {
  cpes: (string | ImportPackageCPE)[];
  foundBy?: string;
  id?: string;
  language: string;
  licenses: (string | ImportPackageLicense)[];
  locations: ImportPackageLocation[];
  metadata?: object | null;
  metadataType?: string | null;
  name: string;
  purl?: string;
  type: string;
  version: string;
  [key: string]: any;
}

export interface ImportPackageCPE {
  cpe: string;
  source: string;
}

export interface ImportPackageLicense {
  /** The contents of the license file */
  contents?: string;
  locations?: ImportPackageLocation[];
  /** The SPDX expression for the license */
  spdxExpression?: string;
  /** Where the license information came from */
  type?: ImportPackageLicenseTypeEnum;
  /** URLs associated with the license */
  urls?: string[];
  /** The raw license value reported in the packages metadata */
  value?: string;
}

/** Where the license information came from */
export const ImportPackageLicenseTypeEnum = {
  Declared: 'declared',
  Concluded: 'concluded',
} as const;
export type ImportPackageLicenseTypeEnum =
  (typeof ImportPackageLicenseTypeEnum)[keyof typeof ImportPackageLicenseTypeEnum];

export interface ImportPackageLocation {
  layerID?: string;
  path: string;
  [key: string]: any;
}

export interface ImportPackageRelationship {
  child: string;
  metadata?: Record<string, any>;
  parent: string;
  type: string;
  [key: string]: any;
}

export interface ImportSchema {
  url: string;
  version: string;
  [key: string]: any;
}

export type ImportSecretSearchesData = ImageImportContentResponse;

export interface ImportSecretSearchesParams {
  /** @format path */
  operationId: string;
}

export type ImportSecretSearchesPayload =
  | ImageImportContentSearchList
  | ContentSearch;

export interface ImportSource {
  metadata?: any;
  target?: any;
  type: string;
  [key: string]: any;
}

/** Information about an integration instance, e.g., an agent */
export type Integration = UtilRequiredKeys<
  IntegrationSummary,
  'uuid' | 'type' | 'account_name' | 'username'
> &
  IntegrationAdditionalProperties;

export interface IntegrationAdditionalProperties {
  /** Configuration of the integration instance */
  configuration?: object;
  /**
   * Short description of the integration instance
   * @example "This agent has no namespace filtering"
   */
  description?: string;
  /**
   * List of namespaces handled by the integration instance
   * @example ["production","finance"]
   */
  namespaces?: string[];
  /**
   * Timestamp when integration instance was started
   * @format date-time
   * @example "2024-06-25 10:12:53+00:00"
   */
  started_at?: string;
}

/**
 * Health state reported by the client integration.
 * * healthy: All good. No errors.
 * * unhealthy: Not well. Probably errors.
 * @example "healthy"
 */
export const IntegrationHealthState = {
  Healthy: 'healthy',
  Unhealthy: 'unhealthy',
} as const;
export type IntegrationHealthState =
  (typeof IntegrationHealthState)[keyof typeof IntegrationHealthState];

/**
 * Life cycle state of the integration instance
 * * active - Integration operational. Sending health reports.
 * * registered - Integration has registered. Not yet sending health reports.
 * * inactive - Integration has missed its last three health check-ins.
 * @example "active"
 */
export const IntegrationLifecycleState = {
  Active: 'active',
  Registered: 'registered',
  Inactive: 'inactive',
} as const;
export type IntegrationLifecycleState =
  (typeof IntegrationLifecycleState)[keyof typeof IntegrationLifecycleState];

/** Response to list integration */
export interface IntegrationListResponse {
  items?: IntegrationSummaryList;
}

/** Properties of an integration instance, e.g., an agent, to register */
export interface IntegrationRegister {
  /**
   * Name of cluster where the integration instance runs
   * @example "production-east1"
   */
  cluster_name?: string;
  /** Configuration of the integration instance */
  configuration?: object;
  /**
   * Short description of the integration instance
   * @example "This agent has no namespace filtering"
   */
  description?: string;
  /**
   * List of accounts that the integration instance is statically configured to handle
   * @example ["frontend","ci"]
   */
  explicitly_account_bound?: string[];
  /** Interval (in seconds) between health reports */
  health_report_interval: HealthReportInterval;
  /**
   * Name of the integration instance
   * @example "k8s-agent-admin"
   */
  name?: string;
  /**
   * Namespace in which the integration instance runs
   * @example "anchore"
   */
  namespace?: string;
  /**
   * List of namespaces that the integration instance is statically configured to handle
   * @example ["production","finance"]
   */
  namespaces?: string[];
  /**
   * identifier for the integration during registration until it has received its integration_id
   * @example "84993c1f-863f-41f3-9bd8-dfcc821b1c8a"
   */
  registration_id: string;
  /**
   * Unique identifier for the integration instance (among its replicas) during registration
   * @example "67479449b7-zdzlr"
   */
  registration_instance_id: string;
  /**
   * Timestamp when integration instance was started
   * @format date-time
   * @example "2024-06-25 10:12:53+00:00"
   */
  started_at?: string;
  /** The type of integration */
  type: IntegrationType;
  /**
   * Running time of integration instance in seconds
   * @example 200.02312
   */
  uptime?: number;
  /**
   * User that the integration instance authenticates as by default
   * @example "admin"
   */
  username: string;
  /**
   * Version of the integration instance
   * @example "1.6.0"
   */
  version?: string;
}

/** Status of the integration as perceived by the integration instance itself */
export interface IntegrationReportedStatus {
  details?: object;
  reason?: string;
  /**
   * Health state reported by the client integration.
   * * healthy: All good. No errors.
   * * unhealthy: Not well. Probably errors.
   */
  state?: IntegrationHealthState;
}

/** Status of integration instance as perceived by Enterprise */
export interface IntegrationStatus {
  details?: object;
  reason?: string;
  /**
   * Life cycle state of the integration instance
   * * active - Integration operational. Sending health reports.
   * * registered - Integration has registered. Not yet sending health reports.
   * * inactive - Integration has missed its last three health check-ins.
   */
  state?: IntegrationLifecycleState;
  /**
   * Timestamp when status was updated
   * @format date-time
   */
  updated_at?: string;
}

/** Select information about existing integrations */
export interface IntegrationSummary {
  /**
   * Account that the integration instance reports to by default
   * @example "admin"
   */
  account_name?: string;
  /**
   * List of accounts that the integration instance handles
   * @example ["platform","test-team1","customers"]
   */
  accounts?: string[];
  /**
   * Name of cluster where the integration instance runs
   * @example "production-east1"
   */
  cluster_name?: string;
  /**
   * List of accounts that the integration instance is statically configured to handle
   * @example ["frontend","ci"]
   */
  explicitly_account_bound?: string[];
  /** Interval (in seconds) between health reports */
  health_report_interval?: HealthReportInterval;
  /** Status of integration instance as perceived by Enterprise */
  integration_status?: IntegrationStatus;
  /**
   * Timestamp of last received health report from integration instance
   * @format date-time
   * @example "2024-06-25 10:14:20+00:00"
   */
  last_seen?: string;
  /**
   * Name of the integration instance
   * @example "k8s-agent-admin"
   */
  name?: string;
  /**
   * Namespace in which the integration instance runs
   * @example "anchore"
   */
  namespace?: string;
  /**
   * identifier for the integration during registration until it has received its integration_id
   * @example "84993c1f-863f-41f3-9bd8-dfcc821b1c8a"
   */
  registration_id?: string;
  /**
   * Unique identifier for the integration instance (among its replicas) during registration
   * @example "67479449b7-zdzlr"
   */
  registration_instance_id?: string;
  /** Status of the integration as perceived by the integration instance itself */
  reported_status?: IntegrationReportedStatus;
  /** The type of integration */
  type?: IntegrationType;
  /**
   * Running time of integration instance in seconds
   * @example 200.02312
   */
  uptime?: number;
  /**
   * User that the integration instance authenticates as by default
   * @example "admin"
   */
  username?: string;
  /**
   * Globally unique identifier for the integration instance
   * @format uuid
   * @example "84993c1f-863f-41f3-9bd8-dfcc821b1c8a"
   */
  uuid?: string;
  /**
   * Version of the integration instance
   * @example "1.6.0"
   */
  version?: string;
}

export type IntegrationSummaryList = IntegrationSummary[];

/**
 * The type of integration
 * @example "k8s_inventory_agent"
 */
export const IntegrationType = {
  K8SInventoryAgent: 'k8s_inventory_agent',
} as const;
export type IntegrationType =
  (typeof IntegrationType)[keyof typeof IntegrationType];

export type InvalidateOperationData = ImageImportOperation;

export interface InvalidateOperationParams {
  /** @format path */
  operationId: string;
}

export type InvalidateSourcesOperationData = SourceImportOperation;

export interface InvalidateSourcesOperationParams {
  /** @format path */
  operationId: string;
}

/** Inventory result for a specific Namespace */
export interface InventoryItem {
  context?: string;
  /** @format date-time */
  created_at?: string;
  image_digest?: string;
  image_tag?: string;
  inventory_type?: string;
  /** @format date-time */
  last_seen?: string;
  /** @format date-time */
  last_updated?: string;
}

/** Inventory report for Images in Use */
export interface InventoryItems {
  items?: InventoryItem[];
}

export const InventoryTypeEnum = {
  Ecs: 'ecs',
  Kubernetes: 'kubernetes',
} as const;
export type InventoryTypeEnum =
  (typeof InventoryTypeEnum)[keyof typeof InventoryTypeEnum];

export interface JavaPackageContent {
  'implementation-version'?: string;
  'maven-version'?: string;
  'specification-version'?: string;
  /** A list of Common Platform Enumerations that may uniquely identify the package */
  cpes?: string[];
  licenses?: string[];
  location?: string;
  origin?: string;
  package?: string;
  purl?: string;
  type?: string;
  version?: string;
}

/**
 * JobError
 * Error details for failed jobs.
 */
export interface JobError {
  /**
   * Code
   * Structured error code.
   */
  code: string;
  /**
   * Reason
   * Human-readable failure reason.
   */
  reason: string;
}

/** JobStatus */
export const JobStatus = {
  Pending: 'pending',
  Processing: 'processing',
  Cancelled: 'cancelled',
  Complete: 'complete',
  Failed: 'failed',
} as const;
export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus];

/** The 'add' operation per RFC6902 */
export interface JsonPatchAdd {
  /** Operation ID, referenced for ordering in the */
  id?: string;
  op: JsonPatchAddOpEnum;
  /** A JSONPointer per RFC6901 */
  path: JsonPointer;
  /** A valid json value, can be any valid json type */
  value: object;
}

export type JsonPatchAddList = JsonPatchAdd[];

export const JsonPatchAddOpEnum = {
  Add: 'add',
} as const;
export type JsonPatchAddOpEnum =
  (typeof JsonPatchAddOpEnum)[keyof typeof JsonPatchAddOpEnum];

/** The 'copy' operation per RFC6902 */
export interface JsonPatchCopy {
  /** A JSONPointer per RFC6901 */
  from: JsonPointer;
  /** Operation ID, referenced for ordering in the */
  id?: string;
  op: JsonPatchCopyOpEnum;
  /** A JSONPointer per RFC6901 */
  path: JsonPointer;
}

export type JsonPatchCopyList = JsonPatchCopy[];

export const JsonPatchCopyOpEnum = {
  Copy: 'copy',
} as const;
export type JsonPatchCopyOpEnum =
  (typeof JsonPatchCopyOpEnum)[keyof typeof JsonPatchCopyOpEnum];

/** The 'move' operation per RFC6902 */
export interface JsonPatchMove {
  /** A JSONPointer per RFC6901 */
  from: JsonPointer;
  /** Operation ID, referenced for ordering in the */
  id?: string;
  op: JsonPatchMoveOpEnum;
  /** A JSONPointer per RFC6901 */
  path: JsonPointer;
}

export type JsonPatchMoveList = JsonPatchMove[];

export const JsonPatchMoveOpEnum = {
  Move: 'move',
} as const;
export type JsonPatchMoveOpEnum =
  (typeof JsonPatchMoveOpEnum)[keyof typeof JsonPatchMoveOpEnum];

/** Ordered list of the operations in the type-specific lists. This imparts the total ordering of patches to apply such that they can be moved into a single array. */
export type JsonPatchOperationList = string[];

/** The 'remove' operation per RFC6902 */
export interface JsonPatchRemove {
  /** Operation ID, referenced for ordering in the */
  id?: string;
  op: JsonPatchRemoveOpEnum;
  /** A JSONPointer per RFC6901 */
  path: JsonPointer;
}

export type JsonPatchRemoveList = JsonPatchRemove[];

export const JsonPatchRemoveOpEnum = {
  Remove: 'remove',
} as const;
export type JsonPatchRemoveOpEnum =
  (typeof JsonPatchRemoveOpEnum)[keyof typeof JsonPatchRemoveOpEnum];

/** The 'replace' operation per RFC6902 */
export interface JsonPatchReplace {
  /** Operation ID, referenced for ordering in the */
  id?: string;
  op: JsonPatchReplaceOpEnum;
  /** A JSONPointer per RFC6901 */
  path: JsonPointer;
  /** A valid json value, can be any valid json type */
  value: object;
}

export type JsonPatchReplaceList = JsonPatchReplace[];

export const JsonPatchReplaceOpEnum = {
  Replace: 'replace',
} as const;
export type JsonPatchReplaceOpEnum =
  (typeof JsonPatchReplaceOpEnum)[keyof typeof JsonPatchReplaceOpEnum];

/** The 'test' operation per RFC6902 */
export interface JsonPatchTest {
  /** Operation ID, referenced for ordering in the */
  id?: string;
  op: JsonPatchTestOpEnum;
  /** A JSONPointer per RFC6901 */
  path: JsonPointer;
  /** Expected value for test */
  value: object;
}

export type JsonPatchTestList = JsonPatchTest[];

export const JsonPatchTestOpEnum = {
  Test: 'test',
} as const;
export type JsonPatchTestOpEnum =
  (typeof JsonPatchTestOpEnum)[keyof typeof JsonPatchTestOpEnum];

/**
 * A JSONPointer per RFC6901
 * @pattern ^(/[^/~]*(~[01][^/~]*)*)*$
 */
export type JsonPointer = string;

export interface KubernetesContainer {
  account_name: string;
  context: string;
  id: string;
  image_digest: string;
  image_tag: string;
  name: string;
  pod_id: string;
}

/** Containers defined in Kubernetes */
export interface KubernetesContainers {
  containers?: KubernetesContainer[];
}

export interface KubernetesInventory {
  cluster_name: string;
  containers?: KubernetesInventoryContainer[];
  namespaces?: KubernetesInventoryNamespace[];
  nodes?: KubernetesInventoryNode[];
  pods?: KubernetesInventoryPod[];
  /** @format date-time */
  timestamp: string;
}

export interface KubernetesInventoryContainer {
  /** Corresponds to ContainerStatus.containerID in the Kubernetes Spec */
  id: string;
  image_digest?: string;
  /** @pattern ^(?!\s*$).+ */
  image_tag: string;
  name: string;
  pod_uid: UUID;
}

export interface KubernetesInventoryNamespace {
  annotations?: Record<string, string>;
  labels?: Record<string, string>;
  name: string;
  uid: UUID;
}

export interface KubernetesInventoryNode {
  annotations?: Record<string, string>;
  arch?: string;
  container_runtime_version?: string;
  kernel_version?: string;
  kube_proxy_version?: string;
  kubelet_version?: string;
  kubernetes_version?: string;
  labels?: Record<string, string>;
  name: string;
  operating_system?: string;
  uid: UUID;
}

export interface KubernetesInventoryPod {
  annotations?: Record<string, string>;
  labels?: Record<string, string>;
  name: string;
  namespace_uid: UUID;
  node_uid?: UUID;
  uid: UUID;
}

export interface KubernetesNamespace {
  annotations: Record<string, string>;
  labels: Record<string, string>;
  last_seen?: string;
  name: string;
  uid: string;
}

/** Namespaces defined in Kubernetes */
export interface KubernetesNamespaces {
  namespaces?: KubernetesNamespace[];
}

export interface KubernetesNode {
  annotations: Record<string, string>;
  labels: Record<string, string>;
  last_seen?: string;
  name: string;
  uid: string;
}

/** Nodes defined in Kubernetes */
export interface KubernetesNodes {
  namespaces?: KubernetesNode[];
}

export interface KubernetesPod {
  account_name: string;
  annotations: Record<string, string>;
  id: string;
  labels: Record<string, string>;
  last_seen?: string;
  name: string;
  namespace_id?: string;
  node_id?: string;
}

/** Pods defined in Kubernetes */
export interface KubernetesPods {
  namespaces?: KubernetesPod[];
}

/** LicenseResponse */
export interface LicenseResponse {
  /** Name */
  name: string;
}

export interface LicenseReviewItem {
  /** List of licenses for the package */
  licenses?: LicenseReviewPackageLicense[];
  package?: LicenseReviewPackage;
}

export interface LicenseReviewPackage {
  /**
   * The name of the package
   * @example "react"
   */
  name?: string;
  /**
   * The Package URL for the package
   * @example "pkg:npm/react@17.0.2"
   */
  purl?: string;
  /**
   * The type of the package
   * @example "npm"
   */
  type?: string;
  /**
   * The version of the Package
   * @example "17.0.2"
   */
  version?: string;
}

export interface LicenseReviewPackageLicense {
  /**
   * The standard license header for the package’s license
   * @example "Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   * "
   */
  license_header?: string;
  /**
   * The License ID for the license
   * @example "MIT"
   */
  license_id?: string;
  /**
   * The full name of the license
   * @example "MIT License"
   */
  license_name?: string;
  /**
   * The full text of the license
   * @example "MIT License
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   * "
   */
  license_text?: string;
  /**
   * The URL for the license
   * @example "https://github.com/facebook/react/blob/main/LICENSE"
   */
  license_url?: string;
  /** The source of the license information */
  source?: LicenseReviewPackageLicenseSourceEnum;
}

/** The source of the license information */
export const LicenseReviewPackageLicenseSourceEnum = {
  Override: 'override',
  Sbom: 'sbom',
} as const;
export type LicenseReviewPackageLicenseSourceEnum =
  (typeof LicenseReviewPackageLicenseSourceEnum)[keyof typeof LicenseReviewPackageLicenseSourceEnum];

export interface LicenseReviewResponse {
  /** List of packages and their licenses */
  items?: LicenseReviewItem[];
}

export type ListAccountsData = AccountList;

export interface ListAccountsParams {
  /** Filter accounts by state */
  state?: StateEnum;
}

export type ListAddContainerImageAssetJobsData =
  PaginatedAddContainerImageAssetJobListResponse;

export interface ListAddContainerImageAssetJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListAddImportedImageAssetJobsData =
  PaginatedAddImportedImageAssetJobListResponse;

export interface ListAddImportedImageAssetJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListAddSbomAssetJobsData = PaginatedAddSbomAssetJobListResponse;

export interface ListAddSbomAssetJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListAllFindingsData = PaginatedPolicyFindingResponse;

export interface ListAllFindingsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListAllSystemUsersData = Users;

export interface ListAllSystemUsersParams {
  /** Filter by username */
  username?: string;
}

export type ListAnalysisArchiveData = ArchivedAnalyses;

export type ListAnalysisArchiveRulesData = AnalysisArchiveRules;

export interface ListAnalysisArchiveRulesParams {
  /** If true include system global rules (owned by admin) even for non-admin users. Defaults to true if not set. Can be set to false to exclude globals */
  system_global?: boolean;
}

export type ListApiKeysData = ApiKeyList;

export type ListAppJobsData = PaginatedAppJobListResponse;

export interface ListAppJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Created Since
   * Return only jobs whose created_at is at or after this timestamp. Accepts an RFC3339 datetime; if no timezone offset is supplied the value is interpreted as UTC.
   * @format date-time
   */
  created_since?: string | null;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Status
   * Filter jobs by status. Repeat the parameter to filter on multiple statuses (OR semantics, e.g. `?status=pending&status=processing`).
   */
  status?: JobStatus[] | null;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListAppVersionsData = PaginatedAppVersionListResponse;

export interface ListAppVersionsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Name
   * Filter by exact version name
   */
  name?: string | null;
  /**
   * Status
   * Filter by status
   */
  status?: AppVersionStatus | null;
}

export type ListAppsData = PaginatedAppListResponse;

export interface ListAppsParams {
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Name
   * Filter by exact app name
   */
  name?: string | null;
}

export type ListArchivesData = ArchiveSummary;

export type ListArtifactLifecyclePoliciesData = ArtifactLifecyclePolicyList;

export type ListArtifactRelationshipsData = ArtifactRelationships;

export interface ListArtifactRelationshipsParams {
  /** Filter for artifact id as either source or target */
  artifact_id?: string;
  /** Filter for artifact type as either source or target */
  artifact_type?: string;
}

export type ListArtifactsData = ArtifactListResponse;

export interface ListArtifactsParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
  artifact_types?: ArtifactType[];
}

export type ListAssetsByPackageData = PaginatedAssetListResponse;

export interface ListAssetsByPackageParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Name
   * Exact package name
   */
  name: string;
  /**
   * Namespace
   * Package namespace. For OS packages: '{type}:{distro}:{version}' (e.g. 'apk:alpine:3.18'). For language packages: '{type}' (e.g. 'python').
   */
  namespace?: string | null;
  /**
   * Type
   * Package type (e.g. apk, npm, python). Optional when namespace is provided.
   */
  type?: string | null;
  /**
   * Version
   * Exact package version
   */
  version: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListAssetsData = PaginatedAssetListResponse;

export interface ListAssetsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Name
   * Filter by exact asset name
   */
  name?: string | null;
  /**
   * Type
   * Filter by asset type
   */
  type?: AssetType | null;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListConfigurationsData = SystemConfigurationList;

export type ListEndpointsData = NotificationEndpointList;

export type ListEventTypesData = EventTypesList;

export type ListEventsData = EventsList;

export interface ListEventsParams {
  /** Return events that occurred before the timestamp */
  before?: string;
  /**
   * Filter events by a prefix match on the event type (e.g. "user.image.")
   * @pattern ^[a-z0-9-_.*]+$
   */
  event_type?: string;
  /** Filter events by the level - INFO or ERROR */
  level?: string;
  /**
   * Number of events in the result set. Defaults to 100 if left empty
   * @default 100
   */
  limit?: number;
  /**
   * Pagination controls - return the nth page of results. Defaults to first page if left empty
   * @default 1
   */
  page?: number;
  /** Filter events by the id of the resource */
  resource_id?: string;
  /** Filter events by the type of resource - tag, image_digest, repository etc */
  resource_type?: string;
  /** Return events that occurred after the timestamp */
  since?: string;
  /** Filter events by the originating host ID */
  source_host_id?: string;
  /** Filter events by the originating service */
  source_service_name?: string;
}

export type ListExportPackagesJobsData = PaginatedExportPackagesJobListResponse;

export interface ListExportPackagesJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListExportPolicyComplianceJobsData =
  PaginatedExportPolicyComplianceJobListResponse;

export interface ListExportPolicyComplianceJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListExportSbomCyclonedx1JobsData =
  PaginatedExportSbomCycloneDx1JobListResponse;

export interface ListExportSbomCyclonedx1JobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
}

export type ListExportSbomSpdx2JobsData =
  PaginatedExportSbomSpdx2JobListResponse;

export interface ListExportSbomSpdx2JobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
}

export type ListExportVdrJobsData = PaginatedExportVdrJobListResponse;

export interface ListExportVdrJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListExportVexJobsData = PaginatedExportVexJobListResponse;

export interface ListExportVexJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListExportVulnerabilitiesJobsData =
  PaginatedExportVulnerabilitiesJobListResponse;

export interface ListExportVulnerabilitiesJobsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Owned By Me
   * When true, restrict results to jobs created by the requesting user (identified via the `x-anchore-username` header). When false (default), the filter is disabled and all jobs the caller is authorized to read are returned, regardless of who created them.
   * @default false
   */
  owned_by_me?: boolean;
  /**
   * Version Id
   * Filter jobs by app version ID
   * @format uuid
   */
  version_id?: string | null;
}

export type ListFileContentSearchResultsData = FileContentSearchList;

export interface ListFileContentSearchResultsParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type ListGithubConfigurationsData =
  NotificationGitHubEndpointConfigurationList;

export type ListGithubSelectorsData = NotificationSelectorList;

export interface ListGithubSelectorsParams {
  /** @format path */
  uuid: string;
}

export type ListIdpsData = string[];

export type ListImageContentData = string[];

export interface ListImageContentParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type ListImageMetadataData = string[];

export interface ListImageMetadataParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type ListImageStigData = STIGMetadataResponseList;

export interface ListImageStigParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type ListImageVulnAnnotationsData =
  PackageVulnerabilityAnnotationResponseList;

export interface ListImageVulnAnnotationsParams {
  /**
   * The image digest to retrieve vuln annotations for
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  /** Filter vuln annotations that apply to a specific package name */
  package_name?: string;
  /** Filter vuln annotations that apply to a specific package type */
  package_type?: string;
  /** Filter vuln annotations that apply to a specific package version */
  package_version?: string;
  /** Filter vuln annotations that apply to a specific vulnerability ID */
  vulnerability_id?: string;
}

export type ListImagesData = AnchoreImageList;

export interface ListImagesParams {
  /** Filter by analysis_status value on the record. */
  analysis_status?: AnalysisStatusEnum;
  /**
   * Filter by images analyzed on or after the specified datetime
   * @format datetime
   */
  analyzed_since?: string;
  /** Full docker-pull string to filter results by (e.g. docker.io/library/nginx:latest, or myhost.com:5000/testimages:v1.1.1) */
  full_tag?: string;
  /** Include image history in the response */
  history?: boolean;
  /** Filter results matching image ID */
  image_id?: string;
  /**
   * Filter by image_status value on the record. Default if omitted is 'active'.
   * @default "active"
   */
  image_status?: ImageStatusEnum;
}

export type ListImportContentSearchesData = ImportContentDigestList;

export interface ListImportContentSearchesParams {
  /** @format path */
  operationId: string;
}

export type ListImportDockerfilesData = ImportContentDigestList;

export interface ListImportDockerfilesParams {
  /** @format path */
  operationId: string;
}

export type ListImportFileContentsData = ImportContentDigestList;

export interface ListImportFileContentsParams {
  /** @format path */
  operationId: string;
}

export type ListImportImageAnalysisResultManifestsData =
  ImportContentDigestList;

export interface ListImportImageAnalysisResultManifestsParams {
  /** @format path */
  operationId: string;
}

export type ListImportImageConfigsData = ImportContentDigestList;

export interface ListImportImageConfigsParams {
  /** @format path */
  operationId: string;
}

export type ListImportImageManifestsData = ImportContentDigestList;

export interface ListImportImageManifestsParams {
  /** @format path */
  operationId: string;
}

export type ListImportPackagesData = ImportContentDigestList;

export interface ListImportPackagesParams {
  /** @format path */
  operationId: string;
}

export type ListImportParentManifestsData = ImportContentDigestList;

export interface ListImportParentManifestsParams {
  /** @format path */
  operationId: string;
}

export type ListImportSecretSearchesData = ImportContentDigestList;

export interface ListImportSecretSearchesParams {
  /** @format path */
  operationId: string;
}

export type ListIntegrationsData = IntegrationListResponse;

export interface ListIntegrationsParams {
  /**
   * If true, limit listing to unhealthy or inactive integrations
   * @default false
   * @example true
   */
  only_degraded?: boolean;
}

export type ListJiraConfigurationsData =
  NotificationJiraEndpointConfigurationList;

export type ListJiraSelectorsData = NotificationSelectorList;

export interface ListJiraSelectorsParams {
  /** @format path */
  uuid: string;
}

export type ListMyUserGroupsData = UserGroupList;

export type ListOperationsData = ImageImports;

export type ListPackagesByVulnerabilityData =
  PaginatedVulnerabilityPackageListResponse;

export interface ListPackagesByVulnerabilityParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
  /**
   * Vulnerability Id
   * Vulnerability identifier. Accepts either the record's native name (e.g. CVE-2024-1234, GHSA-abcd-1234, RHSA-2024:1234) or any CVE alias from the record's related_cves array. Both forms return the same packages.
   */
  vulnerability_id: string;
}

export type ListPackagesData = PaginatedPackageListResponse;

export interface ListPackagesParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListPoliciesData = PolicyList;

export interface ListPoliciesParams {
  /** Include policy detail in the form of the full policy content for each entry */
  detail?: boolean;
}

export type ListRegistriesData = RegistryConfigurationList;

export type ListRetrievedFilesData = RetrievedFileList;

export interface ListRetrievedFilesParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type ListRoleMembersData = RbacManagerRoleMemberList;

export interface ListRoleMembersParams {
  /** Optional filter parameter to limit the set of returned items to only those that match the specified domain. Will return Access Denied if caller does not have permission to listRoleMembers for that domain. */
  domain_name?: string;
  /**
   * Deprecated.  Please use domain_name instead. Optional filter parameter to limit the set fo returned items to only those with matching account. Will return Access Denied if caller does not have permission to listRoleMembers for that account.
   * @deprecated
   */
  for_account?: string;
  /** @format path */
  roleName: string;
}

export type ListRolesData = RbacManagerRoleSummaryList;

export type ListSecretSearchResultsData = SecretSearchList;

export interface ListSecretSearchResultsParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export type ListSelectorsData = NotificationSelectorList;

export type ListServicesData = ServiceList;

export type ListSlackConfigurationsData =
  NotificationSlackEndpointConfigurationList;

export type ListSlackSelectorsData = NotificationSelectorList;

export interface ListSlackSelectorsParams {
  /** @format path */
  uuid: string;
}

export type ListSmtpConfigurationsData =
  NotificationSMTPEndpointConfigurationList;

export type ListSmtpSelectorsData = NotificationSelectorList;

export interface ListSmtpSelectorsParams {
  /** @format path */
  uuid: string;
}

export type ListSourcesData = SourcesList;

export type ListSourcesOperationsData = SourceImportList;

export type ListSubscriptionsData = SubscriptionList;

export interface ListSubscriptionsParams {
  /** filter only subscriptions matching key */
  subscription_key?: string;
  /** filter only subscriptions matching type */
  subscription_type?: string;
}

export type ListTeamsConfigurationsData =
  NotificationTeamsEndpointConfigurationList;

export type ListTeamsSelectorsData = NotificationSelectorList;

export interface ListTeamsSelectorsParams {
  /** @format path */
  uuid: string;
}

export type ListToolsData = ToolList;

export interface ListToolsParams {
  /** The architecture to filter by */
  architecture?: ArchitectureEnum;
  /** The operating system (platform) to filter by */
  operating_system?: OperatingSystemEnum;
}

export type ListUserApiKeysData = ApiKeyList;

export interface ListUserApiKeysParams {
  /** @format path */
  accountName: string;
  /** @format path */
  username: string;
}

export type ListUserCredentialsData = CredentialList;

export interface ListUserCredentialsParams {
  /** @format path */
  accountName: string;
  /** @format path */
  username: string;
}

export type ListUserGroupRolesData = UserGroupRoles;

export interface ListUserGroupRolesParams {
  /** @format path */
  groupUuid: string;
}

export type ListUserGroupUsersData = UserGroupUsers;

export interface ListUserGroupUsersParams {
  /** @format path */
  groupUuid: string;
}

export type ListUserGroupsData = UserGroupList;

export interface ListUserGroupsParams {
  /** Filter the results to only those that have roles in the specified account */
  contains_account?: string;
  /** Filter the user groups to only those that contain the specified user */
  contains_user?: string;
  /** Filter results to match the specified user group name */
  user_group_name?: string;
}

export type ListUserRolesData = RbacManagerUserRoleMembership;

export interface ListUserRolesParams {
  /** Optional filter parameter to limit the set of returned items to only those that match the specified domain.  This may be an account name when the domain is an account. */
  domain_name?: string;
  /**
   * Deprecated.  Please use domain_name instead. Optional filter parameter to limit the set of returned items to only those with matching account.
   * @deprecated
   */
  for_account?: string;
  role?: string;
  /** @format path */
  username: string;
}

/** List of users in this account and their roles for this account and system roles. */
export type ListUsersData = User[];

export interface ListUsersParams {
  /** @format path */
  accountName: string;
}

export type ListUsersWithRolesData = Users;

export interface ListUsersWithRolesParams {
  /** @format path */
  accountName: string;
}

export type ListVulnerabilitiesData = PaginatedVulnerabilityListResponse;

export interface ListVulnerabilitiesParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Asset Id
   * Optional asset ID to scope results
   * @format uuid
   */
  asset_id?: string | null;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListVulnerabilityAnnotationsData =
  PaginatedAppVersionVulnerabilityAnnotationListResponse;

export interface ListVulnerabilityAnnotationsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListVulnerabilityFindingsData =
  PaginatedVulnerabilityPolicyFindingResponse;

export interface ListVulnerabilityFindingsParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Cursor
   * Pagination cursor from previous response
   */
  cursor?: string | null;
  /**
   * Limit
   * Max items to return
   * @min 1
   * @max 1000
   * @default 1000
   */
  limit?: number;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type ListWebhookConfigurationsData =
  NotificationWebhookEndpointConfigurationList;

export type ListWebhookSelectorsData = NotificationSelectorList;

export interface ListWebhookSelectorsParams {
  /** @format path */
  uuid: string;
}

export interface LoggingLevel {
  logging_level: LoggingLevelLoggingLevelEnum;
  service_name: LoggingLevelServiceNameEnum;
}

export const LoggingLevelLoggingLevelEnum = {
  Default: 'default',
  Trace: 'trace',
  Debug: 'debug',
  Info: 'info',
  Warning: 'warning',
  Error: 'error',
  Critical: 'critical',
} as const;
export type LoggingLevelLoggingLevelEnum =
  (typeof LoggingLevelLoggingLevelEnum)[keyof typeof LoggingLevelLoggingLevelEnum];

export type LoggingLevelResponse = LoggingLevel[];

export const LoggingLevelServiceNameEnum = {
  All: 'all',
  Analyzer: 'analyzer',
  Api: 'api',
  Catalog: 'catalog',
  Notifications: 'notifications',
  Reports: 'reports',
  ReportsWorker: 'reports_worker',
  Simplequeue: 'simplequeue',
  PolicyEngine: 'policy_engine',
} as const;
export type LoggingLevelServiceNameEnum =
  (typeof LoggingLevelServiceNameEnum)[keyof typeof LoggingLevelServiceNameEnum];

export interface MalwareFinding {
  /** A path for a file in the image's rootfs */
  path?: string;
  /** The malware signature found at the path */
  signature?: string;
}

/** A single scan from a scanner */
export interface MalwareScan {
  /** Indicates if the scanner is enabled */
  enabled?: boolean;
  findings?: MalwareFinding[];
  /** Open schema for scanner-specific metadata related to the scan result */
  metadata?: object;
  /** The name of the scanner that produced the finding */
  scanner?: string;
}

export interface MappingRule {
  allowlist_ids: string[];
  /** Description of the image to policy mapping rule, human readable */
  description?: string;
  id: string;
  /** A reference to an image */
  image: ImageRef;
  name: string;
  registry: string;
  repository: string;
  /** List of rule_set_ids to evaluate in order, to completion */
  rule_set_ids: string[];
}

/** Generic wrapper for metadata listings from images */
export interface MetadataResponse {
  image_digest?: string;
  metadata?: any;
  metadata_type?: string;
}

/** A combined modification record showing the source and target packages and the json patch to apply to the relationship-target object to result in the relationship-source package. Source and target are the packages from the respective sides of the relationship. */
export interface ModifiedPackage {
  /** Anchore-specific adaptation of RFC6902 to be describeable in swagger/open-api 2.0. Each item is given an ID and the ids are ordered in the array. */
  patch?: CustomJsonPatch;
  /** A normalized and simplified package that can represent any package type */
  source?: Package;
  /** A normalized and simplified package that can represent any package type */
  target?: Package;
}

export type MyRolesData = RbacManagerUserRoleListing;

/** @format path */
export const NameEnum = {
  Slack: 'slack',
  Jira: 'jira',
  Smtp: 'smtp',
  Github: 'github',
  Teams: 'teams',
  Webhook: 'webhook',
} as const;
export type NameEnum = (typeof NameEnum)[keyof typeof NameEnum];

export interface NativeSBOM {
  artifactRelationships?: NativeSBOMPackageRelationship[];
  artifacts: NativeSBOMPackage[];
  descriptor?: NativeSBOMDescriptor;
  distro: NativeSBOMDistribution;
  files?: ImportFile[] | null;
  schema?: NativeSBOMSchema;
  source: NativeSBOMSource;
  [key: string]: any;
}

export interface NativeSBOMDescriptor {
  name: string;
  version: string;
  [key: string]: any;
}

export interface NativeSBOMDistribution {
  extendedSupport?: boolean | null;
  id?: string | null;
  idLike?: any;
  name?: string | null;
  version?: string | null;
  versionID?: string | null;
  [key: string]: any;
}

export interface NativeSBOMPackage {
  cpes: (string | NativeSBOMPackageCPE)[];
  foundBy?: string;
  id?: string;
  language: string;
  licenses: (string | ImportPackageLicense)[];
  locations: NativeSBOMPackageLocation[];
  metadata?: object | null;
  metadataType?: string | null;
  name: string;
  purl?: string;
  type: string;
  version: string;
  [key: string]: any;
}

export interface NativeSBOMPackageCPE {
  cpe: string;
  source: string;
  [key: string]: any;
}

export interface NativeSBOMPackageLocation {
  layerID?: string;
  path: string;
  [key: string]: any;
}

export interface NativeSBOMPackageRelationship {
  child: string;
  metadata?: Record<string, any>;
  parent: string;
  type: string;
  [key: string]: any;
}

export interface NativeSBOMSchema {
  url: string;
  version: string;
  [key: string]: any;
}

export interface NativeSBOMSource {
  metadata?: any;
  target?: any;
  type: string;
  [key: string]: any;
}

/** NewAssetSpec */
export interface NewAssetSpec {
  /**
   * Annotations
   * User-provided key/value annotations.
   */
  annotations?: Record<string, string>;
  /**
   * Name
   * Asset name.
   */
  name: string;
  /** Type of a user-facing Asset attached to an AppVersion. */
  type: AssetType;
}

export type NormalizeImageData = ImageNormalizeResponse;

export interface NotificationEndpoint {
  /** Is the endpoint enabled for use in the system. Affects all usage, including system-level if set to false. */
  enabled?: boolean;
  /**
   * The timestamp of the last change to the status
   * @format date-time
   */
  last_updated?: string;
  /** the name of the endpoint */
  name?: string;
}

/** Base schema that endpoint configurations extend */
export interface NotificationEndpointConfiguration {
  /**
   * Timestamp for last modification to the record
   * @format date-time
   */
  created_at?: string;
  /** User friendly name or description for the configuration */
  description?: string;
  /**
   * Timestamp for last modification to the record
   * @format date-time
   */
  last_updated?: string;
  /** The instance identifier for the configuration */
  uuid?: string;
  /** Verify the cert if using tls for connecting externally. Defaults to true if not specified */
  verify_tls?: boolean;
}

export interface NotificationEndpointEnabledStatus {
  /** Is the endpoint enabled for use in the system. Affects all usage, including system-level if set to false. */
  enabled?: boolean;
  /**
   * The timestamp of the last change to the status
   * @format date-time
   */
  last_updated?: string;
}

export type NotificationEndpointList = NotificationEndpoint[];

/** A selector of event properties */
export interface NotificationEventSelector {
  /** The level of the event to filter. '*' matches events of all levels. 'info' and 'error' match related events respectively */
  level: NotificationEventSelectorLevelEnum;
  /** The type of resource to filter. '*' matches all resource types. Some examples of resource type are 'image_digest' or 'service' */
  resource_type: string;
  /**
   * The type of event to filter, using wildcards against type field of the event. Event types have a structured format <category>.<subcategory>.<event>. Thus, '*' matches all types of events. 'system.*' matches all system events, 'user.*' matches events that are relevant to individual consumption, and omitting an asterisk will do an exact match. See the GET /event_types route definition in the engine's external API for the list of event types.
   * @pattern ^[a-z0-9-_.*]+$
   */
  type: string;
}

/** The level of the event to filter. '*' matches events of all levels. 'info' and 'error' match related events respectively */
export const NotificationEventSelectorLevelEnum = {
  Value: '*',
  Info: 'info',
  Error: 'error',
} as const;
export type NotificationEventSelectorLevelEnum =
  (typeof NotificationEventSelectorLevelEnum)[keyof typeof NotificationEventSelectorLevelEnum];

/** Configuration for GitHub endpoint (Base model) */
export type NotificationGitHubEndpointConfigurationBase =
  NotificationEndpointConfiguration & {
    /** Personal access token for the GitHub account */
    access_token?: string;
    /** List of user logins to assign to the issue. */
    assignees?: string[];
    /** List of labels to associate with the issue */
    labels?: string[];
    /** Number of the milestone to associate with the issue */
    milestone?: number;
    /** Owner of the repository to create issues against */
    owner?: string;
    /** Name of the repository to create issues against */
    repository?: string;
    /**
     * Github API endpoint, defaults to https://api.github.com if not specified
     * @pattern https?://.*
     */
    url?: string;
    /** GitHub username for creating issues */
    username?: string;
  };

/** List of GitHub endpoint configurations */
export type NotificationGitHubEndpointConfigurationList =
  NotificationGitHubEndpointConfigurationBase[];

/** Configuration for GitHub endpoint (Base model) */
export type NotificationGitHubEndpointConfigurationPost =
  NotificationGitHubEndpointConfigurationBase & object;

/** Configuration for GitHub endpoint (Base model) */
export type NotificationGitHubEndpointConfigurationPut =
  NotificationGitHubEndpointConfigurationBase & object;

export interface NotificationGitHubTestResult {
  response?: string;
  status?: string;
}

/** Configuration for jira endpoint */
export type NotificationJiraEndpointConfigurationBase =
  NotificationEndpointConfiguration & {
    /** Jira user to associate with the issue */
    assignee?: string;
    /** Type associated with the issue */
    issue_type?: string;
    /** List of labels to associate with the issue */
    labels?: string[];
    /** Jira access token for creating issues */
    password?: string;
    /** Priority assigned to the issue */
    priority?: string;
    /** Key of the Jira project for creating issues */
    project_key?: string;
    /**
     * Jira endpoint URL including host and port, should begin with 'http://' or 'https://'
     * @pattern https?://.*
     */
    url?: string;
    /** Jira username for creating issues */
    username?: string;
  };

/** List of jira endpoint configurations */
export type NotificationJiraEndpointConfigurationList =
  NotificationJiraEndpointConfigurationBase[];

/** Configuration for jira endpoint */
export type NotificationJiraEndpointConfigurationPost =
  NotificationJiraEndpointConfigurationBase & object;

/** Configuration for jira endpoint */
export type NotificationJiraEndpointConfigurationPut =
  NotificationJiraEndpointConfigurationBase & object;

export interface NotificationJiraTestResult {
  response?: string;
  status?: string;
}

/** Operational status for a specific notification endpoint configuration */
export interface NotificationOperationalStatus {
  status?: NotificationOperationalStatusStatusEnum;
}

export const NotificationOperationalStatusStatusEnum = {
  Unknown: 'unknown',
  Healthy: 'healthy',
  Unhealthy: 'unhealthy',
} as const;
export type NotificationOperationalStatusStatusEnum =
  (typeof NotificationOperationalStatusStatusEnum)[keyof typeof NotificationOperationalStatusStatusEnum];

/** Configuration for email via smtp endpoint */
export type NotificationSMTPEndpointConfiguration =
  NotificationEndpointConfiguration & {
    /** The from address to use for emails send by this configuration */
    from: string;
    host: string;
    password?: string;
    port: number;
    /** The address to which the emails are sent */
    to: string;
    /** Encrypt the SMTP connection with TLS. Defaults to true */
    use_tls?: boolean;
    username?: string;
  };

/** List of email via smtp endpoint configurations */
export type NotificationSMTPEndpointConfigurationList =
  NotificationSMTPEndpointConfiguration[];

export interface NotificationSMTPTestResult {
  response?: string;
  status?: string;
}

/** A selector for notifications that determines which notifications are passed to a specific endpoint configuration */
export interface NotificationSelector {
  /** UUID of the endpoint configuration bound to this selector */
  configuration_uuid?: string;
  /** A selector of event properties */
  event: NotificationEventSelector;
  /** The scope to filter events. 'global' scope encompasses all the events in the system, only the admin account can request this selector scope. 'account' covers events scoped to a specific account. */
  scope: NotificationSelectorScopeEnum;
  uuid?: string;
}

export type NotificationSelectorList = NotificationSelector[];

/** The scope to filter events. 'global' scope encompasses all the events in the system, only the admin account can request this selector scope. 'account' covers events scoped to a specific account. */
export const NotificationSelectorScopeEnum = {
  Global: 'global',
  Account: 'account',
} as const;
export type NotificationSelectorScopeEnum =
  (typeof NotificationSelectorScopeEnum)[keyof typeof NotificationSelectorScopeEnum];

/** Configuration for slack endpoint */
export type NotificationSlackEndpointConfiguration =
  NotificationEndpointConfiguration & {
    /**
     * url to POST to, including any query parameters, should begin with 'http://' or 'https://'
     * @pattern https?://.*
     */
    url: string;
  };

/** List of slack endpoint configurations */
export type NotificationSlackEndpointConfigurationList =
  NotificationSlackEndpointConfiguration[];

export interface NotificationSlackTestResult {
  response?: string;
  status?: string;
}

/** Configuration for MS Teams endpoint */
export type NotificationTeamsEndpointConfiguration =
  NotificationEndpointConfiguration & {
    /**
     * url to POST to, including any query parameters, should begin with 'http://' or 'https://'
     * @pattern https?://.*
     */
    url: string;
  };

/** List of MS Teams endpoint configurations */
export type NotificationTeamsEndpointConfigurationList =
  NotificationTeamsEndpointConfiguration[];

export interface NotificationTeamsTestResult {
  response?: string;
  status?: string;
}

/** Configuration for Webhook endpoint */
export type NotificationWebhookEndpointConfiguration =
  NotificationEndpointConfiguration & {
    password?: string;
    /**
     * url to POST to, including any query parameters, should begin with 'http://' or 'https://'
     * @pattern https?://.*
     */
    url: string;
    username?: string;
    /** Verify SSL certificates for HTTPS requests, disabled by default */
    verify_ssl?: boolean;
  };

/** List of Webhook endpoint configurations */
export type NotificationWebhookEndpointConfigurationList =
  NotificationWebhookEndpointConfiguration[];

export interface NotificationWebhookTestResult {
  response?: string;
  status?: string;
}

export type NullType = null;

/** List of Nvd Data objects */
export type NvdDataList = NvdDataObject[];

export interface NvdDataObject {
  cvss_v2?: CVSSV2Scores;
  cvss_v3?: CVSSV3Scores;
  /** The full NVD description text for the vulnerability */
  description?: string;
  /** Exploit Prediction Scoring System data for a vulnerability */
  epss?: PackageEPSS;
  /** NVD Vulnerability ID */
  id?: string;
  is_kev?: boolean;
  /** Identifies the organization or entity that generated or provided the CVSS score */
  source?: string;
  /** Indicates the classification of the CVSS */
  type?: NvdDataObjectTypeEnum;
}

/** Indicates the classification of the CVSS */
export const NvdDataObjectTypeEnum = {
  Primary: 'Primary',
  Secondary: 'Secondary',
  None: 'None',
} as const;
export type NvdDataObjectTypeEnum =
  (typeof NvdDataObjectTypeEnum)[keyof typeof NvdDataObjectTypeEnum];

/** The operating system (platform) of the binary to retrieve */
export const OperatingSystemEnum = {
  Linux: 'linux',
  Darwin: 'darwin',
  Windows: 'windows',
} as const;
export type OperatingSystemEnum =
  (typeof OperatingSystemEnum)[keyof typeof OperatingSystemEnum];

export const OrderByEnum = {
  ImageDigest: 'image_digest',
  ParentDigest: 'parent_digest',
  AnalysisStatus: 'analysis_status',
  CreatedAt: 'created_at',
  ImageId: 'image_id',
  AnalyzedAt: 'analyzed_at',
  TagDetectedAt: 'tag_detected_at',
  ImageStatus: 'image_status',
  AnalysisStatus1: 'analysis_status',
  FullTag: 'full_tag',
} as const;
export type OrderByEnum = (typeof OrderByEnum)[keyof typeof OrderByEnum];

/** A normalized and simplified package that can represent any package type */
export interface Package {
  /** List of CPE strings for this package */
  cpes?: string[];
  /** Implementation version for java packages */
  implementation_version?: string;
  licenses?: string[];
  location?: string;
  /** Maven version for java packages */
  maven_version?: string;
  /** Package type specific metadata */
  metadata?: object;
  /** The type of the metadata entry */
  metadata_type?: string;
  name?: string;
  origin?: string;
  purl?: string;
  release?: string;
  size?: number;
  sourcepkg?: string;
  /** Spec version for java packages */
  specification_version?: string;
  version?: string;
}

export interface PackageContent {
  /** A list of Common Platform Enumerations that may uniquely identify the package */
  cpes?: string[];
  licenses?: string[];
  location?: string;
  /** Package type specific metadata */
  metadata?: object;
  /** The type of the metadata entry */
  metadata_type?: string;
  origin?: string;
  package?: string;
  purl?: string;
  size?: string;
  type?: string;
  version?: string;
}

/** Exploit Prediction Scoring System data for a vulnerability */
export interface PackageEPSS {
  /** The EPSS score for the vulnerability */
  epss?: number;
  /** The percentile of the EPSS score for the vulnerability */
  percentile?: number;
}

/** Matching details for the SBOM package scope */
export type PackageIdentifier = {
  /** The name of the package to which this scope applies */
  name: string;
  /** The type of the package to which this scope applies */
  type: string;
  /** The version of the package to which this scope applies */
  version: string;
} | null;

/** A record of a software item which is vulnerable or carries a fix for a vulnerability */
export interface PackageReference {
  /** Package name */
  name?: string;
  /** Package type (e.g. package, rpm, deb, apk, jar, npm, gem, ...) */
  type?: string;
  /** A version for the package. If null, then references all versions */
  version?: string | null;
  /** Whether a vendor will or will not fix a vulnerability */
  will_not_fix?: boolean;
}

/**
 * PackageResponse
 * Package details for a single full-PURL variant within a version.
 */
export interface PackageResponse {
  /**
   * Licenses
   * @default []
   */
  licenses?: LicenseResponse[];
  /** Name */
  name: string;
  /** Purl */
  purl?: string | null;
  /** Type */
  type: string;
  /** Version */
  version: string;
}

export interface PackageVulnerability {
  /** The CPE Version 2.3 string (if applicable) describing the package to vulnerability match */
  package_cpe23?: string;
  annotation_status?: VulnAnnotationStatus;
  /**
   * The UUID of the annotation for this vulnerability, if one exists
   * @format uuid
   */
  annotation_uuid?: string;
  /** The full description text for the vulnerability */
  description?: string;
  /**
   * When the vulnerability was detected
   * @format date-time
   */
  detected_at?: string;
  epss?: PackageEPSS[];
  /** The name of the feed where vulnerability match was made */
  feed?: string;
  /** The name of the feed group where vulnerability match was made */
  feed_group?: string;
  /** The package containing a fix, if available */
  fix?: string;
  /**
   * When the suggested_fix_version was first observed in the vulnerability feed.
   * @format date-time
   */
  fix_observed_at?: string;
  is_kev?: boolean;
  /** The CPE Version 2.3 strings (if applicable) supplied by the vulnerability data provider used to match against the package */
  matched_on_cpes?: string[];
  /** List of Nvd Data objects */
  nvd_data?: NvdDataList;
  /** The package name and version that are vulnerable in the image */
  package?: string;
  /**
   * The CPE string (if applicable) describing the package to vulnerability match
   * @deprecated
   */
  package_cpe?: string;
  /** The name of the vulnerable package artifact */
  package_name?: string;
  /** The location (if applicable) of the vulnerable package in the container filesystem */
  package_path?: string;
  /** The type of vulnerable package */
  package_type?: string;
  /** The version of the vulnerable package artifact */
  package_version?: string;
  /**
   * The Package URL (PURL) for the vulnerable package
   * @example "pkg:deb/debian/libssl3@3.0.17-1~deb12u2?arch=amd64&distro=debian-12&upstream=openssl"
   */
  purl?: string;
  /** The severity of the vulnerability */
  severity?: string;
  /** The recommended version of the package that contains a fix for the vulnerability. This is usually the version that is closest to the current version. */
  suggested_fix_version?: string;
  /** The url for more information about the vulnerability */
  url?: string;
  /** List of Vendor Data objects */
  vendor_data?: VendorDataList;
  /** The vulnerability identifier, such as CVE-2017-100, or RHSA-2017123 */
  vuln?: string;
  /** Whether a vendor will fix or not fix the vulnerability */
  will_not_fix?: boolean;
}

export interface PackageVulnerabilityAnnotation {
  /** A single VEX annotation record */
  annotation: VulnerabilityAnnotation;
  /** Matching details for the SBOM package scope */
  package_identifier?: PackageIdentifier;
}

/** A list of VulnerabilityAnnotation entries for an artifact */
export interface PackageVulnerabilityAnnotationResponseList {
  /** The annotations for the artifact */
  items: PackageVulnerabilityAnnotation[];
}

/** PaginatedAddContainerImageAssetJobListResponse */
export interface PaginatedAddContainerImageAssetJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: AddContainerImageAssetJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedAddImportedImageAssetJobListResponse */
export interface PaginatedAddImportedImageAssetJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: AddImportedImageAssetJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedAddSbomAssetJobListResponse */
export interface PaginatedAddSbomAssetJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: AddSbomAssetJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedAppJobListResponse */
export interface PaginatedAppJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: AppJobListItemResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/**
 * PaginatedAppListResponse
 * Paginated response for application list endpoints.
 */
export interface PaginatedAppListResponse {
  /**
   * Items
   * @default []
   */
  items?: AppListItemResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/**
 * PaginatedAppVersionListResponse
 * Paginated response for app version list endpoints.
 */
export interface PaginatedAppVersionListResponse {
  /**
   * Items
   * @default []
   */
  items?: AppVersionListItemResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/**
 * PaginatedAppVersionVulnerabilityAnnotationListResponse
 * Paginated response for vulnerability annotation list endpoints.
 */
export interface PaginatedAppVersionVulnerabilityAnnotationListResponse {
  /**
   * Items
   * @default []
   */
  items?: AppVersionVulnerabilityAnnotationResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/**
 * PaginatedAssetListResponse
 * Paginated response for asset list endpoints.
 */
export interface PaginatedAssetListResponse {
  /**
   * Items
   * @default []
   */
  items?: AssetResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportPackagesJobListResponse */
export interface PaginatedExportPackagesJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportPackagesJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportPolicyComplianceJobListResponse */
export interface PaginatedExportPolicyComplianceJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportPolicyComplianceJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportSbomCycloneDx1JobListResponse */
export interface PaginatedExportSbomCycloneDx1JobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportSbomCycloneDx1JobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportSbomSpdx2JobListResponse */
export interface PaginatedExportSbomSpdx2JobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportSbomSpdx2JobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportVdrJobListResponse */
export interface PaginatedExportVdrJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportVdrJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportVexJobListResponse */
export interface PaginatedExportVexJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportVexJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedExportVulnerabilitiesJobListResponse */
export interface PaginatedExportVulnerabilitiesJobListResponse {
  /**
   * Items
   * @default []
   */
  items?: ExportVulnerabilitiesJobResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** Pagination wrapped list of images that match some filter */
export type PaginatedImageList = PaginationProperties & {
  images?: ImageWithPackages[];
};

/**
 * PaginatedPackageListResponse
 * Paginated response for package list endpoints.
 */
export interface PaginatedPackageListResponse {
  /**
   * Items
   * @default []
   */
  items?: PackageResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedPolicyFindingResponse */
export interface PaginatedPolicyFindingResponse {
  /**
   * Items
   * @default []
   */
  items?: PolicyFindingResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** A paginated listing of vulnerability records sorted by ID in descending order */
export type PaginatedVulnerabilityList = PaginationProperties & {
  /** The listing of matching vulnerabilities for the query subject to pagination */
  vulnerabilities?: StandaloneVulnerability[];
};

/**
 * PaginatedVulnerabilityListResponse
 * Paginated response for vulnerability list endpoints.
 */
export interface PaginatedVulnerabilityListResponse {
  /**
   * Items
   * @default []
   */
  items?: VulnerabilityMatch[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/**
 * PaginatedVulnerabilityPackageListResponse
 * Paginated response for packages-by-vulnerability endpoint.
 */
export interface PaginatedVulnerabilityPackageListResponse {
  /**
   * Items
   * @default []
   */
  items?: VulnerabilityPackageResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/** PaginatedVulnerabilityPolicyFindingResponse */
export interface PaginatedVulnerabilityPolicyFindingResponse {
  /**
   * Items
   * @default []
   */
  items?: VulnerabilityPolicyFindingResponse[];
  /**
   * Pagination metadata for collection responses.
   *
   * Attributes:
   *     cursor: The cursor used for this request. None for the first page.
   *     next_cursor: Cursor for the next page. None when no more results.
   *     item_count: Number of items in the current response.
   */
  pagination: PaginationInfo;
}

/**
 * PaginationInfo
 * Pagination metadata for collection responses.
 *
 * Attributes:
 *     cursor: The cursor used for this request. None for the first page.
 *     next_cursor: Cursor for the next page. None when no more results.
 *     item_count: Number of items in the current response.
 */
export interface PaginationInfo {
  /** Cursor */
  cursor?: string | null;
  /** Item Count */
  item_count: number;
  /** Next Cursor */
  next_cursor?: string | null;
}

/** Properties for common pagination handling to be included in any wrapping object that needs pagination elements */
export interface PaginationProperties {
  /** True if additional pages exist (page + 1) or False if this is the last page */
  next_page?: string;
  /** The page number returned (should match the requested page query string param) */
  page?: string;
  /** The number of items sent in this response */
  returned_count?: number;
}

export type PatchApiKeyData = UserApiKey;

export interface PatchApiKeyParams {
  /** @format path */
  keyName: string;
}

export type PatchApiKeyPayload = {
  description?: string;
  name?: string;
  status?: PatchApiKeyStatusEnum;
};

export const PatchApiKeyStatusEnum = {
  Revoked: 'revoked',
} as const;
export type PatchApiKeyStatusEnum =
  (typeof PatchApiKeyStatusEnum)[keyof typeof PatchApiKeyStatusEnum];

export type PatchConfigurationData = SystemConfigurationList;

export type PatchUserApiKeyData = UserApiKey;

export interface PatchUserApiKeyParams {
  /** @format path */
  accountName: string;
  /** @format path */
  keyName: string;
  /** @format path */
  username: string;
}

export type PatchUserApiKeyPayload = {
  description?: string;
  name?: string;
  status?: PatchApiKeyStatusEnum;
};

export type PingData = string;

/** A policy containing a rule-set, allowlists, and rules for mapping them to specific images */
export interface Policy {
  /** List of mapping rules that define which images should always be passed (unless also on the denylist), regardless of policy result. */
  allowlisted_images?: ImageSelectionRule[];
  /** Allowlists which define which policy matches to disregard explicitly in the final policy decision */
  allowlists?: Allowlist[];
  /** List of mapping rules that define which images should always result in a STOP/FAIL policy result regardless of policy content or presence in allowlisted_images */
  denylisted_images?: ImageSelectionRule[];
  /** Description of the policy, human readable */
  description?: string;
  /** Id of the policy */
  id: string;
  /** The time at which the policy was last updated, informational only */
  last_updated?: number;
  /** Mapping rules for defining which policy and allowlist(s) to apply to an image based on a match of the image tag or id. Evaluated in order. */
  mappings: MappingRule[];
  /**
   * Human readable name for the policy
   * @minLength 1
   */
  name: string;
  /** Collections of policy rules which define the go/stop/warn status of an image using rule matches on image properties */
  rule_sets: RuleSet[];
  /** Mapping rules for defining which policy and allowlist(s) to apply to a source based on a match of the sbom name and version. Evaluated in order. */
  sbom_mappings?: SBOMMappingRule[];
  /** Mapping rules for defining which policy and allowlist(s) to apply to a source based on a match of the host and repo name. Evaluated in order. */
  source_mappings?: SourceMappingRule[];
  /** Version id for this policy format */
  version: string;
}

/**
 * PolicyAction
 * Action a policy rule produces for a finding.
 */
export const PolicyAction = {
  Go: 'go',
  Warn: 'warn',
  Stop: 'stop',
} as const;
export type PolicyAction = (typeof PolicyAction)[keyof typeof PolicyAction];

/**
 * PolicyComplianceExportFormat
 * Output format for the policy compliance export.
 *
 * Only ``csv`` is supported in 6.0; the enum is here so we can extend to
 * JSON without breaking the request/response shape.
 */
export const PolicyComplianceExportFormat = {
  Csv: 'csv',
} as const;
export type PolicyComplianceExportFormat =
  (typeof PolicyComplianceExportFormat)[keyof typeof PolicyComplianceExportFormat];

/** Evaluation response object */
export interface PolicyEvaluation {
  /** Image tag used to evaluate policy for the given image */
  evaluated_tag?: string;
  /** List of policy evaluations. Always has at least one result, may contain multiple when the evaluation history is requested. */
  evaluations?: PolicyEvaluationResult[];
  /** Image digest of the image being evaluated */
  image_digest?: string;
  /** The ID of the policy used to evaluate the image */
  policy_id?: string;
}

export interface PolicyEvaluationFinding {
  /** The action associated with this finding */
  action: PolicyAction;
  allowlist_match?: NullType | PolicyFindingAllowlistMatch;
  /** Indicates if this finding was allowlisted or not */
  allowlisted: boolean;
  /** Name of the gate that generated this finding */
  gate: string;
  /** Indicates if this finding was found in the base image */
  inherited_from_base?: boolean | null;
  /** Description of the finding */
  message: string;
  /** ID of the policy that this gate and trigger are a part of */
  policy_id: string;
  /** User provided details for resolving this finding */
  recommendation: string;
  /** ID of the policy rule that that generated this finding */
  rule_id: string;
  /** Name of the trigger that generated this finding */
  trigger: string;
  /** ID of this policy trigger finding (can be used to allowlist this finding) */
  trigger_id: string;
}

/** Details for an error or warning indicating a problem during policy evaluation */
export interface PolicyEvaluationProblem {
  /** Details about the problem itself and how to fix it */
  details: string;
  /** the type of problem encountered, such as a misconfiguration or unavailable data */
  problem_type: string;
  /** Severity of the policy evaluation problem. Problems with a severity of "error" prevent the policy from being evaluated, while severity "warn" indicates the policy was evaluated but the result may require additional attention. */
  severity: PolicyEvaluationProblemSeverityEnum;
}

/** Severity of the policy evaluation problem. Problems with a severity of "error" prevent the policy from being evaluated, while severity "warn" indicates the policy was evaluated but the result may require additional attention. */
export const PolicyEvaluationProblemSeverityEnum = {
  Error: 'error',
  Warn: 'warn',
} as const;
export type PolicyEvaluationProblemSeverityEnum =
  (typeof PolicyEvaluationProblemSeverityEnum)[keyof typeof PolicyEvaluationProblemSeverityEnum];

export interface PolicyEvaluationRemediation {
  /** Anchore generated options for resolving a finding */
  suggestions: PolicyEvaluationRemediationSuggestion[];
  /** List of trigger IDs that these remediation suggestions apply to */
  trigger_ids: string[];
}

export interface PolicyEvaluationRemediationSuggestion {
  /** The suggestion for resolving a finding */
  message: string;
  /** Indicates whether this suggestion is recommended */
  preferred: boolean;
}

export interface PolicyEvaluationResult {
  /** Image digest of the base image used during policy evaluation */
  comparison_image_digest?: string | null;
  /** Contains additional details about the policy evaluation */
  details?: {
    /** The detailed policy findings */
    findings: PolicyEvaluationFinding[];
    /** A policy containing a rule-set, allowlists, and rules for mapping them to specific images */
    policy: Policy;
    /** The outcome of the policy evaluation, before allowlist/denylist evaluation. */
    policy_action: PolicyAction;
    /** List of remediations for the findings */
    remediations?: PolicyEvaluationRemediation[] | null;
  } | null;
  /** list of error objects indicating errors encountered during evaluation execution */
  evaluation_problems: PolicyEvaluationProblem[];
  /**
   * The date and time this policy evaluation was performed at
   * @format date-time
   */
  evaluation_time: string;
  /** The overall outcome of the evaluation. */
  final_action: PolicyAction;
  /** The reason for the final result */
  final_action_reason: PolicyEvaluationResultFinalActionReasonEnum;
  /** Whether the evaluated image matched an allowlist rule */
  image_allowlisted: boolean;
  /** Whether the evaluated image matched a denylist rule */
  image_denylisted: boolean;
  /** Whether the evaluated image matched a policy rule */
  image_mapped_to_rule: boolean;
  matched_allowlisted_images_rule?: NullType | ImageSelectionRule;
  matched_denylisted_images_rule?: NullType | ImageSelectionRule;
  matched_mapping_rule?: NullType | MappingRule;
  /** Number of policy findings in the response */
  number_of_findings: number;
  /** The overall status of the policy evaluation */
  status: PolicyStatus;
}

/** The reason for the final result */
export const PolicyEvaluationResultFinalActionReasonEnum = {
  PolicyEvaluation: 'policy_evaluation',
  Allowlisted: 'allowlisted',
  Denylisted: 'denylisted',
} as const;
export type PolicyEvaluationResultFinalActionReasonEnum =
  (typeof PolicyEvaluationResultFinalActionReasonEnum)[keyof typeof PolicyEvaluationResultFinalActionReasonEnum];

/** Details about (possible) allowlist match */
export interface PolicyFindingAllowlistMatch {
  /** ID of the allowlist that matched this finding */
  id?: string;
  /** ID of the rule within the allowlist that matched this finding */
  matched_rule_id?: string;
  /** Name of the allowlist that matched this finding */
  name?: string;
}

/** PolicyFindingResponse */
export interface PolicyFindingResponse {
  /**
   * Assets Affected
   * Number of assets affected by this finding
   * @default 0
   */
  assets_affected?: number;
  /** The evaluation result for this finding */
  result: FindingResult;
  /** The policy rule that produced this finding */
  rule: FindingRule;
}

/** List of PolicyRecord objects */
export type PolicyList = PolicyRecord[];

/** A policy plus some metadata */
export interface PolicyRecord {
  /** UserId of the user that owns the policy */
  account_name: string;
  /** True if the policy is currently defined to be used automatically */
  active: boolean;
  /** @format date-time */
  created_at?: string;
  /** Description of the policy, human readable */
  description?: string;
  /** SHA256 digest of the policy document content */
  digest?: string | null;
  /** @format date-time */
  last_updated?: string;
  /** Name of the policy */
  name: string;
  policy?: NullType | Policy;
  /** The policy's identifier */
  policy_id: string;
  /** Source location of where the policy originated */
  policy_source: string;
}

/** A rule that defines and decision value if the match is found true for a given image. */
export interface PolicyRule {
  action: PolicyRuleActionEnum;
  /** Description of the policy rule, human readable */
  description?: string;
  gate: string;
  id: string;
  params: PolicyRuleParam[];
  recommendation?: string;
  trigger: string;
}

export const PolicyRuleActionEnum = {
  GO: 'GO',
  STOP: 'STOP',
  WARN: 'WARN',
} as const;
export type PolicyRuleActionEnum =
  (typeof PolicyRuleActionEnum)[keyof typeof PolicyRuleActionEnum];

export interface PolicyRuleParam {
  name: string;
  value: string;
}

/** PolicyStatus */
export const PolicyStatus = {
  Pass: 'pass',
  Fail: 'fail',
} as const;
export type PolicyStatus = (typeof PolicyStatus)[keyof typeof PolicyStatus];

/** PolicyStatusResponse */
export interface PolicyStatusResponse {
  /**
   * Evaluated At
   * When the policy evaluation was completed
   * @format date-time
   */
  evaluated_at: string;
  /**
   * Policy Id
   * ID of the policy
   */
  policy_id: string;
  /**
   * Policy Name
   * Name of the policy
   */
  policy_name: string;
  /**
   * Statistics for the policy
   * @default {"total_findings":0}
   */
  stats?: PolicyStatusStats;
  /**
   * Overall status of the policy evaluation
   * @default "pass"
   */
  status?: PolicyStatus;
}

/** PolicyStatusStats */
export interface PolicyStatusStats {
  /**
   * Total Findings
   * Total number of findings across all gates
   * @default 0
   */
  total_findings?: number;
}

export type PostEcsInventoryData = any;

export type PostImageStigData = STIGMetadataResponse;

export interface PostImageStigParams {
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export interface PostImageStigPayload {
  /**
   * A valid STIG evaluation file in HDF JSON format
   * @format binary
   */
  file?: File;
  /** The name of the STIG profile that produced this result */
  stig_profile?: string;
}

export type PostKubernetesInventoryData = any;

export interface PostSystemFeedsData {
  /**
   * Message from the operation
   * @example "Datasets sync successful"
   */
  message?: string;
}

export interface PostSystemFeedsParams {
  /** If set this will cause the data-syncer to ignore checksum matches and force a resync */
  force_sync?: boolean;
}

export type PutConfigurationData = SystemConfiguration;

export interface PutConfigurationParams {
  /** @format path */
  configKey: string;
}

export type PutImageStigData = STIGMetadataResponse;

export interface PutImageStigParams {
  /** The UUID of the STIG evaluation to update */
  evaluationUuid: UUID;
  /**
   * @format path
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
}

export interface PutImageStigPayload {
  /**
   * A valid STIG evaluation file in HDF JSON format
   * @format binary
   */
  file?: File;
  /** The name of the STIG profile that produced this evaluation */
  stig_profile?: string;
}

export type QueryImagesByPackageData = PaginatedImageList;

export interface QueryImagesByPackageParams {
  /** Limit the number of records for the requested page. If omitted or set to 0, return all results in a single page */
  limit?: number;
  /** Name of package to search for (e.g. sed) */
  name: string;
  /** Type of package to filter on (e.g. dpkg) */
  package_type?: string;
  /** The page of results to fetch. Pages start at 1 */
  page?: string;
  /** Version of named package to filter on (e.g. 4.4-1) */
  version?: string;
}

export type QueryVulnerabilitiesData = PaginatedVulnerabilityList;

export interface QueryVulnerabilitiesParams {
  /** Filter results by specified package name (e.g. sed) */
  affected_package?: string;
  /**
   * Filter results by specified package version (e.g. 4.4-1) (This options is deprecated and will be removed in a future release)
   * @deprecated
   */
  affected_package_version?: string;
  /** The ID of the vulnerability (e.g. CVE-1999-0001) */
  id: string[];
  /** Limit the number of records for the requested page. If omitted or set to 0, return all results in a single page */
  limit?: number;
  /** Namespace(s) to filter vulnerability records by */
  namespace?: string[];
  /**
   * The page of results to fetch. Pages start at 1
   * @default "1"
   */
  page?: string;
}

/** An account identifier and roles a user has within that account */
export interface RbacManagerAccountRole {
  /** When the domain is an account, this will be the account object. */
  account?: Account;
  /** The domain scope that applies to the set of roles */
  domain_name?: string;
  /**
   * Deprecated. Please use `domain_name' instead.  The account scope that applies to the set of roles
   * @deprecated
   */
  for_account?: string;
  /** Role definition */
  roles?: RbacManagerRole;
}

/** Generic HTTP API error response */
export interface RbacManagerApiErrorResponse {
  /** @format int32 */
  code?: number;
  /** Details structure for additional information about the error if available. Content and structure will be error specific. */
  detail?: object;
  error_type?: string;
  message?: string;
}

/** A user group associated with an IdP */
export interface RbacManagerIdpUserGroup {
  /**
   * The timestamp when the user group was mapped to the IdP
   * @format date-time
   */
  mapped_on?: string;
  /** The name of the user group */
  user_group_name?: string;
  /** The UUID of the user group */
  user_group_uuid: string;
}

export interface RbacManagerIdpUserGroupPost {
  user_group_uuids?: string[];
}

export type RbacManagerIdpUserGroups = RbacManagerIdpUserGroup[];

/** A grant of specific action against a specific scope and target */
export interface RbacManagerPermission {
  /** The allowed action. e.g. getImage */
  action?: string;
  /** The target to which the action may be applied. Either a '*' for all or a specific target id */
  target?: string;
}

export type RbacManagerPermissionList = RbacManagerPermission[];

/** Role definition */
export interface RbacManagerRole {
  /**
   * The timestamp when the role was created
   * @format date-time
   */
  created_at?: string;
  /** A role description for humans */
  description?: string;
  /** Are the permissions of this role modifiable by users (including admin users) */
  immutable?: boolean;
  /**
   * The timestamp of the last update to the role metadata itself
   * @format date-time
   */
  last_updated?: string;
  /** The name of the role */
  name: string;
  permissions?: RbacManagerPermissionList;
}

/** A mapping between a username and a role within a domain */
export type RbacManagerRoleMember = {
  /** @format date-time */
  created_at?: string;
  /** The domain scope that applies to the set of roles. This will be the account name if the domain scope is an account. */
  domain_name?: string;
  /**
   * Deprecated. Please use domain_name instead.
   * @deprecated
   */
  for_account?: string;
  username: string;
};

/** List of members of the role, may be filtered by the calling user's access level (e.g. will not display members for which the caller doesn't have listRoleMembers account access) */
export type RbacManagerRoleMemberList = RbacManagerRoleMember[];

/** Membership for a role in an account */
export interface RbacManagerRoleMembership {
  /** @format date-time */
  created_at?: string;
  /** The domain scope that applies for this roles. This will be the account name if the domain scope is an account. */
  domain_name?: string;
  /**
   * Deprecated. Please use domain_name instead. The account for which the user has the role permission
   * @deprecated
   */
  for_account?: string;
  /** The name of the role the user has permissions for */
  role?: string;
}

export interface RbacManagerRoleSummary {
  /** @format date-time */
  created_at?: string;
  description?: string;
  name?: string;
}

export type RbacManagerRoleSummaryList = RbacManagerRoleSummary[];

/** A named configuration for interaction with an Identity Provider that supports SAML 2.0 */
export interface RbacManagerSamlConfiguration {
  /** The port number to use for https if not 443. If omitted or -1, 443 is assumed and used as a default */
  acs_https_port?: number;
  /** The URL the IDP can use to access the Assertion Consumer Service to provide the token for sso. This is the way to reach the rbac manager services /service/sso/auth/{IDP_name} route externally */
  acs_url: string;
  /** @format date-time */
  created_at?: string;
  /** The anchore account to assign all users to from this IDP if no account attribute is mapped or present. */
  default_account?: string;
  /** The default role to apply to new users from this IDP if no attribute is mapped or found in the SAML assertions. */
  default_role?: string;
  /** If this IDP configuration should be enabled for user logins */
  enabled: boolean;
  /** The SAML attribute to use from the response assertions to determine the anchore account to use. If unset, the default is used. */
  idp_account_attribute?: string;
  /** The default value is `memberOf`. This field is available to overwrite the SAML attribute if your IDP is using a different SSO group value during the response assertions. */
  idp_groups_attribute?: string;
  /** The url where the SP (anchore) can retrieve the metadata about the Identity Provider. Only one of this or metadata_xml should be set. This is typically provided by the IDP. */
  idp_metadata_url?: string;
  /** The direct metadata xml payload, if a url is not available. Only one of this or metadata_url should be set. */
  idp_metadata_xml?: string;
  /** The SAML attribute to use from the response assertions to determine the anchore role(s) to assign a new user in the specified account. If unset, the default is used. */
  idp_role_attribute?: string;
  /** The SAML attribute to use from the response assertions to determine the anchore username. If unset, the subject is used. */
  idp_username_attribute?: string;
  /** @format date-time */
  last_updated?: string;
  /**
   * The name to use for referencing this IDP configuration. This will configured as part of the url string the Idp must have the client POST the saml assertion to.
   * @pattern ^[a-zA-Z0-9_-]+$
   */
  name: string;
  /**
   * Indicates if Anchore will require an authenticating SSO user to already exist.  This field is ignored on POST/PUT Operations.
   * @default false
   */
  require_existing_users?: boolean;
  /**
   * Require assertions in to be signed from the IDP
   * @default true
   */
  require_signed_assertions?: boolean;
  /**
   * Require the authn response to be signed by the IDP
   * @default true
   */
  require_signed_response?: boolean;
  /** The entity ID for this SP. Can be the same for all IDP configurations in this installation or unique to each. This is typically a URL, but you can use any value as long as you also configure the IDP to expect this value. */
  sp_entity_id: string;
}

export type RbacManagerSamlConfigurationGet = RbacManagerSamlConfiguration & {
  /** List of user groups associated with this IDP (Only for GET operations) */
  user_groups?: {
    /**
     * The date and time the user group was associated with the IDP
     * @format date-time
     */
    added_on?: string;
    /** The name of the user group */
    user_group?: string;
  }[];
};

/** An auth token for use in future requests as an Authorization header value of type 'bearer' */
export interface RbacManagerTokenResponse {
  /** The token content */
  token: string;
}

/** List of role mappings for a user */
export type RbacManagerUserRoleListing = RbacManagerAccountRole[];

/** List of role mappings for a user */
export type RbacManagerUserRoleMembership = RbacManagerRoleMembership[];

/** Match of a named regex on a file */
export interface RegexContentMatch {
  /** A list of line numbers in the file that matched the regex */
  lines?: number[];
  /** The name associated with the regular expression */
  name?: string;
  /** The regular expression used for the match */
  regex?: string;
}

export type RegisterIntegrationData = Integration;

/** A registry entry describing the endpoint and credentials for a registry to pull images from */
export interface RegistryConfiguration {
  /** Anchore account that owns this registry entry */
  account_name?: string;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  last_updated?: string;
  /** hostname:port string for accessing the registry, as would be used in a docker pull operation */
  registry?: string;
  /** human readable name associated with registry record */
  registry_name?: string;
  /** Type of registry */
  registry_type?: string;
  /** Username portion of credential to use for this registry */
  registry_user?: string;
  /** Use TLS/SSL verification for the registry URL */
  registry_verify?: boolean;
}

/** List of registry configurations */
export type RegistryConfigurationList = RegistryConfiguration[];

/** A registry record describing the endpoint and credentials for a registry */
export interface RegistryConfigurationRequest {
  /** hostname:port string for accessing the registry, as would be used in a docker pull operation. May include some or all of a repository and wildcards (e.g. docker.io/library/* or gcr.io/myproject/myrepository) */
  registry?: string;
  /** human readable name associated with registry record */
  registry_name?: string;
  /** Password portion of credential to use for this registry */
  registry_pass?: string;
  /** Type of registry */
  registry_type?: string;
  /** Username portion of credential to use for this registry */
  registry_user?: string;
  /** Use TLS/SSL verification for the registry URL */
  registry_verify?: boolean;
}

/** An image reference using a digest in a registry, includes some extra tag and timestamp info in addition to the pull string to allow proper tag history reconstruction. */
export type RegistryDigestSource = {
  /**
   * Optional override of the image creation time to support proper tag history construction in cases of out-of-order analysis compared to registry history for the tag
   * @format date-time
   */
  creation_timestamp_override?: string;
  /**
   * Base64 encoded content of the dockerfile used to build the image, if available.
   * @pattern ^[a-zA-Z0-9+/=]+$
   */
  dockerfile?: string;
  /** A digest-based pull string (e.g. docker.io/nginx@sha256:123abc) */
  pull_string: string;
  /** A valid docker tag reference (e.g. docker.io/nginx:latest) that will be associated with the image but not used to pull the image. */
  tag: string;
} | null;

/** An image reference using a tag in a registry, this is the most common source type. */
export type RegistryTagSource = {
  /**
   * Base64 encoded content of the dockerfile used to build the image, if available.
   * @pattern ^[a-zA-Z0-9+/=]+$
   */
  dockerfile?: string;
  /** A docker pull string (e.g. docker.io/nginx:latest, or docker.io/nginx@sha256:abd) to retrieve the image */
  pull_string: string;
} | null;

/**
 * The diff of two sboms with context applied in each difference. The "added" and "removed" directions depend on the relationship to which this diff applies.
 * A relationship defines a source, a target, and a type. For example, a relationship of type "contains" with a source of an image and a target of a source revision will
 * indicate that the diff is between the source repo sbom and the image sbom. Added packages are present in the image but not in the source, removed are present in the source revision
 * but not in the image, etc.
 */
export interface RelationshipSbomDiff {
  both_unmodified?: Package[];
  source_modified?: ModifiedPackage[];
  /** Packages added based on the type of relationship. A "contains" relationship means packages present in the source artifact (image) not present in the target (source repo) of the relationship. */
  source_only?: Package[];
  /** Packages removed based on the type of relationship. A "contains" relationship means packages not present in the source artifact (image) present in the target (source repo) of the relationship. */
  target_only?: Package[];
}

/** The type of relationship between to artifacts */
export const RelationshipType = {
  Contains: 'contains',
  ContainedBy: 'contained_by',
} as const;
export type RelationshipType =
  (typeof RelationshipType)[keyof typeof RelationshipType];

export type RemoveArtifactFromApplicationVersionData = any;

export interface RemoveArtifactFromApplicationVersionParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
  /** @format path */
  associationId: string;
}

/** Label on the resource in the key value format */
export interface ResourceLabel {
  /** @example "tag" */
  key?: string;
  /** @example "docker.io/library/alpine:latest" */
  value?: string;
}

/** The retrieved file entry including content (b64 encoded) */
export interface RetrievedFile {
  b64_content?: string;
  path?: string;
}

/** Simple array of RetrievedFileMetadata objects */
export type RetrievedFileList = RetrievedFile[];

export type RevokeOauthTokenData = any;

export interface RevokeOauthTokenPayload {
  /** The token to be revoked */
  token?: string;
  /** A hint about the type of token to be revoked */
  token_type_hint?: RevokeOauthTokenTokenTypeHintEnum;
}

/** A hint about the type of token to be revoked */
export const RevokeOauthTokenTokenTypeHintEnum = {
  RefreshToken: 'refresh_token',
} as const;
export type RevokeOauthTokenTokenTypeHintEnum =
  (typeof RevokeOauthTokenTokenTypeHintEnum)[keyof typeof RevokeOauthTokenTokenTypeHintEnum];

export interface RuleSet {
  artifact_type?: RuleSetArtifactTypeEnum;
  /** Description of the Policy, human readable */
  description?: string;
  id: string;
  name: string;
  rules: PolicyRule[];
  version: string;
}

export const RuleSetArtifactTypeEnum = {
  Image: 'image',
  Source: 'source',
  Sbom: 'sbom',
} as const;
export type RuleSetArtifactTypeEnum =
  (typeof RuleSetArtifactTypeEnum)[keyof typeof RuleSetArtifactTypeEnum];

export interface SBOMMappingRule {
  allowlist_ids: string[];
  /** Description of the source to policy rule, human readable */
  description?: string;
  id: string;
  name: string;
  /** List of rule_set_ids to evaluate in order, to completion */
  rule_set_ids: string[];
  sbom_name: string;
  sbom_version: string;
}

/** Envelope containing list of vulnerabilities for a source repo */
export interface SBOMVulnerabilitiesResponse {
  /** Whether Extended Update Support (EUS) data was used for the vulnerability scan */
  extended_support?: boolean;
  sbom_id?: string;
  vulnerabilities?: PackageVulnerability[];
}

export interface STIGMetadataResponse {
  /** The format of the STIG content */
  evaluation_format?: StigMetadataResponseEvaluationFormatEnum;
  evaluation_uuid?: UUID;
  /** The name of the STIG profile that produced this result */
  stig_profile?: string;
  /** @format date-time */
  uploaded_at?: string;
}

export interface STIGMetadataResponseList {
  items?: STIGMetadataResponse[];
}

export type SamlLoginData = RbacManagerTokenResponse;

export interface SamlLoginParams {
  /** @format path */
  idpName: string;
}

export type SamlSsoData = RbacManagerTokenResponse;

export interface SamlSsoParams {
  /** @format path */
  idpName: string;
}

/** SbomArtifactReference */
export interface SbomArtifactReference {
  /** File Hash */
  file_hash: string;
  /** File Size */
  file_size: number;
  /** Format */
  format: string;
  /** Schema Version */
  schema_version: string;
}

export interface ScanRequest {
  content_search?: ContentSearch;
  /**
   * Base64 encoded content of the dockerfile used to build the image, if available.
   * @pattern ^[a-zA-Z0-9+/=]+$
   */
  dockerfile?: string | null;
  retrieved_files?: FileContents;
  sbom?: NativeSBOM;
  secret_scan?: ContentSearch;
}

export interface ScanResponse {
  /** Evaluation response object */
  policy_scan?: PolicyEvaluation;
  /** Envelope containing list of vulnerabilities for a source repo */
  vuln_scan?: SBOMVulnerabilitiesResponse;
}

/** Simple array of RetrievedFileMetadata objects */
export type SecretSearchList = SecretSearchResult[];

/** The retrieved file entry including content (b64 encoded) */
export interface SecretSearchResult {
  matches?: RegexContentMatch[];
  path?: string;
}

/** A service status record */
export interface Service {
  /** The url to reach the service, including port as needed */
  base_url?: string;
  /** The unique id of the host on which the service is executing */
  host_id?: string;
  /** System status response */
  service_detail?: StatusResponse;
  /** Registered service name */
  service_name?: string;
  status?: boolean;
  /** A state indicating the condition of the service. Normal operation is 'registered' */
  status_message?: string;
  /** The version of the service as reported by the service implementation on registration */
  version?: string;
}

/** A reference to a service in the system */
export interface ServiceAnalysisReference {
  /** The generation of analysis engine that was used for the analysis */
  analysis_engine?: ServiceAnalysisReferenceAnalysisEngineEnum;
  /** The version of the Anchore Enterprise service that performed the analysis */
  enterprise_version?: string;
  /** The unique id of the host on which the service is executing */
  host_id?: string;
  /** Registered service name */
  service_name?: string;
}

/** The generation of analysis engine that was used for the analysis */
export const ServiceAnalysisReferenceAnalysisEngineEnum = {
  AnchoreEnginePipeline: 'anchore-engine-pipeline',
  SyftNativePipeline: 'syft-native-pipeline',
} as const;
export type ServiceAnalysisReferenceAnalysisEngineEnum =
  (typeof ServiceAnalysisReferenceAnalysisEngineEnum)[keyof typeof ServiceAnalysisReferenceAnalysisEngineEnum];

/** A list of service objects */
export type ServiceList = Service[];

/** Version information for a service */
export interface ServiceVersion {
  /** Api Version string */
  api?: {
    /** Semantic version of the api */
    version?: string;
  };
  db?: {
    /** Semantic version of the db schema */
    schema_version?: string;
  };
  service?: {
    /** Semantic Version string of the service implementation */
    version?: string;
  };
}

export type SetNewLogLevelData = LoggingLevelResponse;

/**
 * Severity
 * Vulnerability severity levels.
 */
export const Severity = {
  Unknown: 'unknown',
  Negligible: 'negligible',
  Low: 'low',
  Medium: 'medium',
  High: 'high',
  Critical: 'critical',
} as const;
export type Severity = (typeof Severity)[keyof typeof Severity];

export interface Source {
  /** The anchore account name that owns this resource */
  account_name?: string;
  /** The analysis state of the source */
  analysis_status?: AnalysisStatusEnum;
  /** @format date-time */
  created_at?: string;
  /** Host name for the repository location (e.g. github.com) */
  host?: string;
  /** @format date-time */
  last_updated?: string;
  /** The name of the repository on the host (e.g. 'anchore/anchore-engine') */
  repository_name?: string;
  /** The commit ID for a git repository */
  revision?: string;
  /** The state of the source */
  source_status?: SourceSourceStatusEnum;
  /** A system-assigned identifier unique for each source analysis */
  uuid?: string;
}

/** Package content listings from analysis sbom */
export interface SourceContentPackageResponse {
  content?: SourceContentPackageResponseContent[];
  content_type?: string;
  source_id?: string;
}

/** Package content listings from a source */
export interface SourceContentPackageResponseContent {
  /** A list of Common Platform Enumerations that may uniquely identify the package */
  cpes?: string[];
  licenses?: string[];
  location?: string;
  /** Package type specific metadata */
  metadata?: object;
  /** The type of the metadata entry */
  metadata_type?: string;
  origin?: string;
  package?: string;
  purl?: string;
  size?: string;
  type?: string;
  version?: string;
}

/** A summary of the content types found in a source with counts */
export interface SourceContentSummary {
  items?: {
    content_type?: string;
    count?: number;
    display_name?: string;
  }[];
}

export interface SourceImportContentResponse {
  /** @format date-time */
  created_at?: string;
  digest?: string;
}

export type SourceImportList = SourceImportOperation[];

export interface SourceImportMetadata {
  branch_name?: string | null;
  change_author?: string | null;
  /** @format date-time */
  ci_workflow_execution_time?: string | null;
  ci_workflow_name?: string | null;
  /** Digest of content to use in the final import */
  contents: {
    /** Digest to use for the sbom */
    sbom: string;
  };
  host: string;
  repository_name: string;
  revision: string;
}

/** An import record, creating a unique identifier for referencing the operation as well as its state */
export interface SourceImportOperation {
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  expires_at?: string;
  /** @format date-time */
  last_updated?: string;
  status?: ImageImportOperationStatusEnum;
  uuid?: string;
}

export interface SourceManifest {
  account_name?: string;
  analysis_status?: AnalysisStatusEnum;
  /** @format date-time */
  created_at?: string;
  host?: string;
  /** @format date-time */
  last_updated?: string;
  /** Array of metadata available */
  metadata_records?: SourceManifestMetadataRecord[];
  repository_name?: string;
  revision?: string;
  source_status?: SourceSourceStatusEnum;
  uuid?: string;
  vcs_type?: string;
}

/** Metadata associated with a source upload */
export interface SourceManifestMetadataRecord {
  branch_name?: string | null;
  change_author?: string | null;
  /** @format date-time */
  ci_workflow_execution_time?: string | null;
  ci_workflow_name?: string | null;
  uuid?: string;
}

export interface SourceMappingRule {
  allowlist_ids: string[];
  /** Description of the source to policy rule, human readable */
  description?: string;
  host: string;
  id: string;
  name: string;
  repository: string;
  /** List of rule_set_ids to evaluate in order, to completion */
  rule_set_ids: string[];
}

/** Envelope containing list of vulnerabilities for a source repo */
export interface SourcePackageVulnerabilityResponse {
  source_id?: string;
  vulnerabilities?: PackageVulnerability[];
  vulnerability_type?: string;
}

/** A policy bundle evaluation result for a specific image, tag, policy tuple */
export interface SourcePolicyEvaluation {
  /** The name of the account containing the source to evaluate */
  account_name: string;
  /** The ID of this policy evaluation */
  evaluation_id: string;
  /** list of error objects indicating errors encountered during evaluation execution */
  evaluation_problems: PolicyEvaluationProblem[];
  /**
   * The date and time this policy evaluation was performed at
   * @format date-time
   */
  evaluation_time: string;
  /** The overall outcome of the evaluation. */
  final_action: PolicyAction;
  /** The reason for the final result */
  final_action_reason: PolicyEvaluationResultFinalActionReasonEnum;
  /** The detailed policy findings */
  findings: SourcePolicyEvaluationFinding[];
  /** Host name for the repository location (e.g. github.com) */
  host: string;
  /** The policy mapping rule that the source repository being evaluated matched against. */
  matched_mapping_rule?: object;
  /** Number of policy findings in the response */
  number_of_findings: number;
  /** A policy containing a rule-set, allowlists, and rules for mapping them to specific images */
  policy: Policy;
  /** The name of the repository on the host (e.g. 'anchore/anchore-engine') */
  repository_name: string;
  /** The commit ID for a git repository */
  revision: string;
  /** The ID of the source repository that was evaluated */
  source_id: string;
  /** Whether the evaluated source repository matched a policy rule */
  source_mapped_to_rule: boolean;
  /** The overall status of the policy evaluation */
  status: PolicyStatus;
}

export interface SourcePolicyEvaluationFinding {
  /** The action associated with this finding */
  action?: PolicyAction;
  allowlist_match?: NullType | PolicyFindingAllowlistMatch;
  /** Indicates if this finding was allowlisted or not */
  allowlisted?: boolean;
  /** Name of the gate that generated this finding */
  gate?: string;
  /** Description of the finding */
  message?: string;
  /** ID of the policy that this gate and trigger are a part of */
  policy_id?: string;
  /** User provided details for resolving this finding */
  recommendation?: string;
  /** ID of the policy rule that that generated this finding */
  rule_id?: string;
  /** Name of the trigger that generated this finding */
  trigger?: string;
  /** ID of this policy trigger finding (can be used to allowlist this finding) */
  trigger_id?: string;
}

/** A Source SBOM Document */
export type SourceSBOM = object;

/** The state of the source */
export const SourceSourceStatusEnum = {
  Active: 'active',
  Inactive: 'inactive',
  Deleting: 'deleting',
} as const;
export type SourceSourceStatusEnum =
  (typeof SourceSourceStatusEnum)[keyof typeof SourceSourceStatusEnum];

export interface SourcesList {
  items?: Source[];
}

/**
 * Spdx2ExportFormat
 * Supported serializations for SPDX 2.x exports.
 */
export const Spdx2ExportFormat = {
  Json: 'json',
} as const;
export type Spdx2ExportFormat =
  (typeof Spdx2ExportFormat)[keyof typeof Spdx2ExportFormat];

/**
 * Spdx2SpecVersion
 * Supported SPDX 2.x spec versions.
 *
 * The SPDX ``spdxVersion`` field uses ``MAJOR.MINOR`` (e.g. ``SPDX-2.3``);
 * point releases such as 2.2.1 still emit ``SPDX-2.2`` on the document.
 */
export const Spdx2SpecVersion = {
  Value23: '2.3',
} as const;
export type Spdx2SpecVersion =
  (typeof Spdx2SpecVersion)[keyof typeof Spdx2SpecVersion];

/** A single vulnerability record in a single namespace, the unique key is the combination of the id and namespace */
export interface StandaloneVulnerability {
  /** The array of packages (typically packages) that are vulnerable-to or provide fixes-for this vulnerability */
  affected_packages?: PackageReference[];
  /** Description of the vulnerability if available */
  description?: string;
  /** Vulnerability identifier. May be CVE-X, RHSA-X, etc. Not necessarily unique across namespaces */
  id?: string;
  /** URL for the upstream CVE record in the reporting source (e.g. ubuntu security tracker) */
  link?: string;
  /** The namespace for the vulnerability record to avoid conflicts for the same id in different distros or sources (e.g. deb vs ubuntu for same CVE) */
  namespace?: string;
  /** List of Nvd Data objects */
  nvd_data?: NvdDataList;
  /** List of references including */
  references?: VulnerabilityReference[];
  /** Severity label specific to the namespace */
  severity?: StandaloneVulnerabilitySeverityEnum;
  /** List of Vendor Data objects */
  vendor_data?: VendorDataList;
}

/** Severity label specific to the namespace */
export const StandaloneVulnerabilitySeverityEnum = {
  Unknown: 'Unknown',
  Negligible: 'Negligible',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
  Critical: 'Critical',
} as const;
export type StandaloneVulnerabilitySeverityEnum =
  (typeof StandaloneVulnerabilitySeverityEnum)[keyof typeof StandaloneVulnerabilitySeverityEnum];

/** Filter accounts by state */
export const StateEnum = {
  Enabled: 'enabled',
  Disabled: 'disabled',
  Deleting: 'deleting',
} as const;
export type StateEnum = (typeof StateEnum)[keyof typeof StateEnum];

/**
 * Filter for alerts by current state, defaults to open alerts unless specified
 * @default "open"
 */
export const GetAlertSummariesState = {
  All: 'all',
  Open: 'open',
  Closed: 'closed',
} as const;
export type GetAlertSummariesState =
  (typeof GetAlertSummariesState)[keyof typeof GetAlertSummariesState];

export type StatelessScanData = ScanResponse;

export interface StatelessScanParams {
  /** Whether to use Extended Update Support (EUS) data during the vulnerability scan for relevant SBOMs. Will use the system configured behaviour if not provided. */
  extended_support?: boolean;
  /** The ID of the policy used to evaluate the image */
  policy_id?: string;
  /** A valid docker tag reference (e.g. docker.io/nginx:latest) that will be used as part of the policy evaluation. */
  tag: string;
}

/** System status response */
export interface StatusResponse {
  available?: boolean;
  busy?: boolean;
  db_version?: string;
  detail?: object;
  message?: string;
  up?: boolean;
  version?: string;
}

/** The format of the STIG content */
export const StigMetadataResponseEvaluationFormatEnum = {
  Hdfjson: 'hdfjson',
} as const;
export type StigMetadataResponseEvaluationFormatEnum =
  (typeof StigMetadataResponseEvaluationFormatEnum)[keyof typeof StigMetadataResponseEvaluationFormatEnum];

/** A structured error code definition with full metadata */
export interface StructuredErrorCode {
  /**
   * The error code identifier (format: 2 uppercase letters + 3 digits, e.g. AP002)
   * @example "AP002"
   */
  code: string;
  /**
   * Whether this error code is deprecated
   * @default false
   */
  deprecated: boolean;
  /** Detailed description of the error condition */
  description: string;
  /**
   * URL to detailed documentation for this error code
   * @format uri
   */
  documentation_url: string;
  /**
   * The HTTP status code typically associated with this error
   * @example 401
   */
  http_code: number;
  /**
   * Short human-readable error message
   * @example "Invalid Credentials"
   */
  message: string;
  /** Suggested steps to resolve the error */
  remediation_steps?: string[];
  /**
   * The service that produces this error code
   * @example "apiext"
   */
  service: string;
  /** The error code that supersedes this one, if deprecated */
  superseded_by?: string;
}

/** Subscription entry */
export interface Subscription {
  /** The account_name of the subscribed user */
  account_name?: string;
  /** Is the subscription currently active */
  active?: boolean;
  /** @format date-time */
  created_at?: string;
  /** @format date-time */
  last_updated?: string;
  /** the unique id for this subscription record */
  subscription_id?: string;
  /** The key value that the subscription references. E.g. a tag value or a repo name. */
  subscription_key?: string;
  /** The type of the subscription */
  subscription_type?: string;
  /** The value of the subscription target */
  subscription_value?: string | null;
}

/** List of subscriptions */
export type SubscriptionList = Subscription[];

/** A subscription entry to add to the system */
export interface SubscriptionRequest {
  subscription_key?: string;
  subscription_type?: string;
  subscription_value?: string | null;
}

/** A modification to a subscription entry to change its status or value */
export interface SubscriptionUpdate {
  /** Toggle the subscription processing on or off */
  active?: boolean;
  /** The new subscription value, e.g. the new tag to be subscribed to */
  subscription_value?: string | null;
}

export type SummaryImageCountsData = AnchoreImageSummaryCounts;

export interface SummaryImageCountsParams {
  /**
   * Filter images in one or more states such as active, deleting. Defaults to active images only if unspecified
   * @default ["active"]
   */
  image_status?: ImageStatusEnum[];
  /** Filter by registry */
  registry?: string;
  /** Filter by repo */
  repo?: string;
}

export type SummaryImageTagsData = AnchoreImageTagSummaryList;

export interface SummaryImageTagsParams {
  /**
   * Filter images in one or more analysis_status such as analyzed, not_analyzed, analysis_failed. Defaults to unfiltered if unspecified
   * @default ["all"]
   */
  analysis_status?: SummaryImageTagsAnalysisStatus[];
  /**
   * Filter images analyzed on or after the specified datetime
   * @format datetime
   */
  analyzed_since?: string;
  /** Filter by 'image_digest' or 'full_tag' fields, using partial or full string match */
  filter?: string;
  /**
   * Filter images in one or more states such as active, deleting. Defaults to active images only if unspecified
   * @default ["active"]
   */
  image_status?: ImageStatusEnum[];
  /** Maximum number of rows to return */
  limit?: number;
  /** List of field name(s) to order by, ascending by default */
  order_by?: OrderByEnum[];
  /** Configures the sort order of each specified order_by column to be descending (true) instead of ascending (false) */
  order_by_descending?: boolean[];
  /**
   * Page number to return, one's based
   * @default 1
   */
  page?: number;
  /** A registry name to filter result by (e.g. "docker.io") */
  registry?: string;
  /** A repository name to filter results by (e.g. "jboss/keycloak") */
  repository?: string;
  /** Filter by images with runtime inventory */
  runtime?: boolean;
  /** A tag value to filter results by (e.g. "latest", or "v1.2.0") */
  tag?: string;
}

export interface SystemConfiguration {
  category?: string;
  config_schema?: SystemConfigurationSchema;
  /** @format date-time */
  created_at?: string;
  default_value?: SystemConfigurationValue;
  deprecated_reason?: string;
  description?: string;
  editable_reason?: string;
  is_deprecated?: boolean;
  is_editable?: boolean;
  is_secret?: boolean;
  is_system_internal?: boolean;
  key: string;
  requires_system_restart?: boolean;
  source?: SystemConfigurationSourceEnum;
  title?: string;
  /** @format date-time */
  updated_at?: string;
  uuid?: string;
  value: SystemConfigurationValue;
}

export interface SystemConfigurationList {
  items?: SystemConfiguration[];
}

export type SystemConfigurationPatch = {
  key: string;
  value: SystemConfigurationValue;
}[];

export interface SystemConfigurationPut {
  key: string;
  value: SystemConfigurationValue;
}

export interface SystemConfigurationSchema {
  allow_inf_nan?: boolean | null;
  data_type?: SystemConfigurationSchemaDataTypeEnum;
  decimal_places?: number | null;
  default_value?: SystemConfigurationValue;
  enum?: string[] | null;
  ge?: number | null;
  gt?: number | null;
  is_array?: boolean | null;
  le?: number | null;
  lt?: number | null;
  max_digits?: number | null;
  max_items?: number | null;
  max_length?: number | null;
  min_items?: number | null;
  min_length?: number | null;
  multiple_of?: number | null;
  regex?: string | null;
  unique_items?: boolean | null;
}

export const SystemConfigurationSchemaDataTypeEnum = {
  String: 'string',
  Integer: 'integer',
  Number: 'number',
  Boolean: 'boolean',
  StringEnum: 'string_enum',
} as const;
export type SystemConfigurationSchemaDataTypeEnum =
  (typeof SystemConfigurationSchemaDataTypeEnum)[keyof typeof SystemConfigurationSchemaDataTypeEnum];

export const SystemConfigurationSourceEnum = {
  Default: 'default',
  InheritedDefault: 'inherited_default',
  Api: 'api',
  ConfigFile: 'config_file',
} as const;
export type SystemConfigurationSourceEnum =
  (typeof SystemConfigurationSourceEnum)[keyof typeof SystemConfigurationSourceEnum];

export type SystemConfigurationValue =
  | NullType
  | string
  | number
  | SystemConfigurationValueEnum
  | (string | number | object)[];

export const SystemConfigurationValueEnum = {
  True: true,
  False: false,
} as const;
export type SystemConfigurationValueEnum =
  (typeof SystemConfigurationValueEnum)[keyof typeof SystemConfigurationValueEnum];

/** SystemMetadata */
export interface SystemMetadata {
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /**
   * Id
   * @format uuid
   */
  id: string;
  /**
   * Updated At
   * @format date-time
   */
  updated_at: string;
}

export interface SystemResourceLimit {
  /** The current value of the resource */
  current_value?: number;
  /** Whether the limit has been exceeded and is being enforced */
  limit_exceeded?: boolean;
  /** The value at which a limit will be enforced */
  limit_value?: number | null;
  /** The resource being limited */
  name?: SystemResourceLimitNameEnum;
  /** The value at which a warning will be generated */
  warning_value?: number | null;
}

/** The resource being limited */
export const SystemResourceLimitNameEnum = {
  SbomInventory: 'sbom_inventory',
  ReportInventory: 'report_inventory',
  ReportExecutionInventory: 'report_execution_inventory',
  AccountInventory: 'account_inventory',
  UserInventory: 'user_inventory',
} as const;
export type SystemResourceLimitNameEnum =
  (typeof SystemResourceLimitNameEnum)[keyof typeof SystemResourceLimitNameEnum];

export interface SystemResourceLimitsList {
  items?: SystemResourceLimit[];
}

export interface SystemStatistics {
  description?: string;
  name?: SystemStatisticsNameEnum;
  value?: number;
  value_type?: string;
}

export interface SystemStatisticsList {
  items?: SystemStatistics[];
}

export const SystemStatisticsNameEnum = {
  AccountCreation: 'account_creation',
  AccountInventory: 'account_inventory',
  ApplicationCreation: 'application_creation',
  ApplicationInventory: 'application_inventory',
  ApplicationVersionCreation: 'application_version_creation',
  ApplicationVersionInventory: 'application_version_inventory',
  ArtifactContainerImageCreation: 'artifact_container_image_creation',
  ArtifactContainerImageInventory: 'artifact_container_image_inventory',
  ArtifactSbomCreation: 'artifact_sbom_creation',
  ArtifactSbomInventory: 'artifact_sbom_inventory',
  AssetCreation: 'asset_creation',
  AssetInventory: 'asset_inventory',
  EcsContainerCreation: 'ecs_container_creation',
  EcsContainerInventory: 'ecs_container_inventory',
  EcsImageCreation: 'ecs_image_creation',
  EcsImageInventory: 'ecs_image_inventory',
  EcsServiceCreation: 'ecs_service_creation',
  EcsServiceInventory: 'ecs_service_inventory',
  EcsTaskCreation: 'ecs_task_creation',
  EcsTaskInventory: 'ecs_task_inventory',
  ImageAnalysis: 'image_analysis',
  ImageInventory: 'image_inventory',
  ImageReanalysis: 'image_reanalysis',
  KubernetesContainerCreation: 'kubernetes_container_creation',
  KubernetesContainerInventory: 'kubernetes_container_inventory',
  KubernetesImageCreation: 'kubernetes_image_creation',
  KubernetesImageInventory: 'kubernetes_image_inventory',
  KubernetesNamespaceCreation: 'kubernetes_namespace_creation',
  KubernetesNamespaceInventory: 'kubernetes_namespace_inventory',
  KubernetesNodeCreation: 'kubernetes_node_creation',
  KubernetesNodeInventory: 'kubernetes_node_inventory',
  KubernetesPodCreation: 'kubernetes_pod_creation',
  KubernetesPodInventory: 'kubernetes_pod_inventory',
  PolicyCreation: 'policy_creation',
  PolicyEvaluation: 'policy_evaluation',
  PolicyInventory: 'policy_inventory',
  ReportExecutionInventory: 'report_execution_inventory',
  ReportGeneration: 'report_generation',
  ReportInventory: 'report_inventory',
  SourceAnalysis: 'source_analysis',
  SourceInventory: 'source_inventory',
  StatelessSbomAnalysis: 'stateless_sbom_analysis',
  StatelessSbomEvaluation: 'stateless_sbom_evaluation',
  StigEvaluationInventory: 'stig_evaluation_inventory',
  UserCreation: 'user_creation',
  UserInventory: 'user_inventory',
} as const;
export type SystemStatisticsNameEnum =
  (typeof SystemStatisticsNameEnum)[keyof typeof SystemStatisticsNameEnum];

/** System status response */
export interface SystemStatusResponse {
  /** A list of service objects */
  service_states?: ServiceList;
}

/** A docker-pullable tag value as well as deconstructed components */
export interface TagEntry {
  /** The pullable string for the tag. E.g. "docker.io/library/node:latest" */
  full_tag?: string;
  /** The registry hostname:port section of the pull string */
  registry?: string;
  /** The repository section of the pull string */
  repo?: string;
  /** The tag-only section of the pull string */
  tag?: string;
  /**
   * The timestamp at which the Anchore Engine detected this tag was mapped to the image digest. Does not necessarily indicate when the tag was actually pushed to the registry.
   * @format date-time
   */
  tag_detected_at?: string;
}

export type TestGithubConfigurationData = NotificationGitHubTestResult;

export type TestJiraConfigurationData = NotificationJiraTestResult;

export type TestSlackConfigurationData = NotificationSlackTestResult;

export type TestSmtpConfigurationData = NotificationSMTPTestResult;

export type TestStoredGithubConfigurationData = NotificationGitHubTestResult;

export interface TestStoredGithubConfigurationParams {
  /** @format path */
  uuid: string;
}

export type TestStoredJiraConfigurationData = NotificationJiraTestResult;

export interface TestStoredJiraConfigurationParams {
  /** @format path */
  uuid: string;
}

export type TestStoredSlackConfigurationData = NotificationSlackTestResult;

export interface TestStoredSlackConfigurationParams {
  /** @format path */
  uuid: string;
}

export type TestStoredSmtpConfigurationData = NotificationSMTPTestResult;

export interface TestStoredSmtpConfigurationParams {
  /** @format path */
  uuid: string;
}

export type TestStoredTeamsConfigurationData = NotificationTeamsTestResult;

export interface TestStoredTeamsConfigurationParams {
  /** @format path */
  uuid: string;
}

export type TestStoredWebhookConfigurationData = NotificationWebhookTestResult;

export interface TestStoredWebhookConfigurationParams {
  /** @format path */
  uuid: string;
}

export type TestTeamsConfigurationData = NotificationTeamsTestResult;

export type TestWebhookConfigurationData = NotificationWebhookTestResult;

export type ToggleFeedEnabledData = FeedMetadata;

export interface ToggleFeedEnabledParams {
  enabled: boolean;
  /** @format path */
  feed: FeedEnum;
}

export interface TokenResponse {
  /** The token content */
  access_token: string;
  /** The lifetime of the access token in seconds */
  expires_in?: number;
  /** The refresh token content */
  refresh_token?: string;
  /** The type of the token returned */
  token_type?: string;
}

/** A downloadable tool available from the API */
export interface Tool {
  architecture?: string;
  name?: string;
  operating_system?: string;
  version?: string;
}

export interface ToolList {
  items?: Tool[];
}

export interface TriggerParamSpec {
  description?: string;
  /** An example value for the parameter (encoded as a string if the parameter is an object or list type) */
  example?: string | null;
  /** Parameter name as it appears in policy document */
  name?: string;
  /** Is this a required parameter or optional */
  required?: boolean;
  /** State of the trigger parameter */
  state?: GateSpecStateEnum;
  /** The name of another trigger that supersedes this on functionally if this is deprecated */
  superseded_by?: string | null;
  /** If present, a definition for validation of input. Typically a jsonschema object that can be used to validate an input against. */
  validator?: object;
}

/** Definition of a trigger and its parameters */
export interface TriggerSpec {
  /** Trigger description for what it tests and when it will fire during evaluation */
  description?: string;
  /** Name of the trigger as it would appear in a policy document */
  name?: string;
  /** The list of parameters that are valid for this trigger */
  parameters?: TriggerParamSpec[];
  /** State of the trigger */
  state?: GateSpecStateEnum;
  /** The name of another trigger that supersedes this on functionally if this is deprecated */
  superseded_by?: string | null;
}

/**
 * Filter for alerts based on the type such as compliance violation
 * @default "all"
 */
export const TypeEnum = {
  All: 'all',
  ComplianceViolation: 'compliance_violation',
} as const;
export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];

/**
 * @minLength 36
 * @maxLength 36
 * @pattern ^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$
 */
export type UUID = string;

export interface UnifiedRoles {
  /** The domain (or account) name that provides the scope of the role */
  domain_name?: string;
  /** The type of grant that was made */
  grant_type?: UnifiedRolesGrantTypeEnum;
  /**
   * The timestamp of when the role was granted
   * @format date-time
   */
  granted_at?: string;
  /** The name of the user group that granted the role.  Will be null if the role was granted directly to the user. */
  granter?: string;
  /** The name of the RBAC Role */
  role_name?: string;
}

/** The type of grant that was made */
export const UnifiedRolesGrantTypeEnum = {
  Direct: 'direct',
  GroupMembership: 'group_membership',
  SsoGroupMembership: 'sso_group_membership',
} as const;
export type UnifiedRolesGrantTypeEnum =
  (typeof UnifiedRolesGrantTypeEnum)[keyof typeof UnifiedRolesGrantTypeEnum];

export type UpdateAccountData = Account;

export interface UpdateAccountParams {
  /** @format path */
  accountName: string;
}

export type UpdateAccountStateData = AccountStatus;

export interface UpdateAccountStateParams {
  /** @format path */
  accountName: string;
}

export type UpdateAppData = AppResponse;

export interface UpdateAppParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
}

export type UpdateAppVersionData = AppVersionResponse;

export interface UpdateAppVersionParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type UpdateApplicationData = Application;

export interface UpdateApplicationParams {
  /** @format path */
  applicationId: string;
}

export type UpdateApplicationVersionData = ApplicationVersion;

export interface UpdateApplicationVersionParams {
  /** @format path */
  applicationId: string;
  /** @format path */
  applicationVersionId: string;
}

export type UpdateArtifactLifecyclePolicyData = ArtifactLifecyclePolicyResponse;

export interface UpdateArtifactLifecyclePolicyParams {
  /** @format path */
  policyUuid: string;
}

export type UpdateAssetData = AssetResponse;

export interface UpdateAssetParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Asset ID
   * The ID of the asset
   * @format uuid
   */
  assetId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
}

export type UpdateComplianceViolationAlertStateData = ComplianceViolationAlert;

export interface UpdateComplianceViolationAlertStateParams {
  /**
   * Identifier for the alert
   * @format path
   */
  uuid: string;
}

export type UpdateCorrectionByUuidData = Correction;

export interface UpdateCorrectionByUuidParams {
  /** @format path */
  uuid: string;
}

export type UpdateEndpointStatusData = NotificationEndpointEnabledStatus;

export interface UpdateEndpointStatusParams {
  /** @format path */
  name: NameEnum;
}

export type UpdateGithubConfigurationData =
  NotificationGitHubEndpointConfigurationBase;

export interface UpdateGithubConfigurationParams {
  /** @format path */
  uuid: string;
}

export type UpdateGithubSelectorData = NotificationSelector;

export interface UpdateGithubSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type UpdateIdpData = RbacManagerSamlConfiguration;

export interface UpdateIdpParams {
  /** @format path */
  name: string;
}

export type UpdateImageVulnAnnotationData = PackageVulnerabilityAnnotation;

export interface UpdateImageVulnAnnotationParams {
  /**
   * The image digest of the vuln annotation to update
   * @pattern ^sha256:[a-fA-F0-9]{64}$
   */
  imageDigest: string;
  vulnAnnotationUuid: UUID;
}

export type UpdateJiraConfigurationData =
  NotificationJiraEndpointConfigurationBase;

export interface UpdateJiraConfigurationParams {
  /** @format path */
  uuid: string;
}

export type UpdateJiraSelectorData = NotificationSelector;

export interface UpdateJiraSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type UpdatePolicyData = PolicyRecord;

export interface UpdatePolicyParams {
  /** Mark policy as active */
  active?: boolean;
  /** @format path */
  policyId: string;
}

export type UpdateRegistryData = RegistryConfigurationList;

export interface UpdateRegistryParams {
  /** @format path */
  registry: string;
  /** flag to determine whether or not to validate registry/credential at registry update time */
  validate?: boolean;
}

export type UpdateSlackConfigurationData =
  NotificationSlackEndpointConfiguration;

export interface UpdateSlackConfigurationParams {
  /** @format path */
  uuid: string;
}

export type UpdateSlackSelectorData = NotificationSelector;

export interface UpdateSlackSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type UpdateSmtpConfigurationData = NotificationSMTPEndpointConfiguration;

export interface UpdateSmtpConfigurationParams {
  /** @format path */
  uuid: string;
}

export type UpdateSmtpSelectorData = NotificationSelector;

export interface UpdateSmtpSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type UpdateSubscriptionData = SubscriptionList;

export interface UpdateSubscriptionParams {
  /** @format path */
  subscriptionId: string;
}

export type UpdateTeamsConfigurationData =
  NotificationTeamsEndpointConfiguration;

export interface UpdateTeamsConfigurationParams {
  /** @format path */
  uuid: string;
}

export type UpdateTeamsSelectorData = NotificationSelector;

export interface UpdateTeamsSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type UpdateUserGroupData = UserGroup;

export interface UpdateUserGroupParams {
  /** @format path */
  groupUuid: string;
}

export type UpdateVulnerabilityAnnotationData =
  AppVersionVulnerabilityAnnotationResponse;

export interface UpdateVulnerabilityAnnotationParams {
  /**
   * Application ID
   * The ID of the application
   * @format uuid
   */
  appId: string;
  /**
   * Version ID
   * The ID of the application version
   * @format uuid
   */
  versionId: string;
  /**
   * Vulnerability Annotation ID
   * The ID of the vulnerability annotation
   * @format uuid
   */
  vulnerabilityAnnotationId: string;
}

export type UpdateWebhookConfigurationData =
  NotificationWebhookEndpointConfiguration;

export interface UpdateWebhookConfigurationParams {
  /** @format path */
  uuid: string;
}

export type UpdateWebhookSelectorData = NotificationSelector;

export interface UpdateWebhookSelectorParams {
  /** @format path */
  configurationUuid: string;
  /** @format path */
  selectorUuid: string;
}

export type UploadImportSourcesSbomData = SourceImportContentResponse;

export interface UploadImportSourcesSbomParams {
  /** @format path */
  operationId: string;
}

export type UploadSystemFeedData = any;

export interface UploadSystemFeedParams {
  /**
   * Build timestsamp
   * @format datetime
   */
  built: string;
  /** Digest of the data record */
  checksum: string;
  /** The data feed to upload */
  feed: string;
  /** The version of the data set to upload */
  version: string;
}

export interface UploadSystemFeedPayload {
  /** @format binary */
  file?: File;
}

/** A username for authenticating with one or more types of credentials. User type defines the expected credentials allowed for the user. Native users have passwords, other users have no credential internally. Internal users are service/system users for inter-service communication. */
export interface User {
  /** The account name that this user is primary in */
  account_name?: string;
  /**
   * The timestamp of when the user record was created
   * @format date-time
   */
  created_at?: string;
  /** When the user 'type' is 'saml', this will be the configured name of the IDP that they are authenticating from.  Otherwise, this will be set to null. */
  idp_name?: string | null;
  /**
   * The timestamp of the last update to this record
   * @format date-time
   */
  last_updated?: string;
  /**
   * When the user 'type' is 'native', this will be the timestamp of the last time this user's credentials were updated.
   * @format date-time
   */
  password_last_updated?: string | null;
  /** When the user 'type' is 'saml', this will be the EntityId of the IDP that they are authenticating from. Otherwise, this will be set to null. */
  source?: string | null;
  /** The user's type */
  type?: UserTypeEnum;
  /** The unified list of RBAC roles this user currently has. */
  unified_roles?: UnifiedRoles[];
  /** The username to authenticate with */
  username: string;
}

export interface UserApiKey {
  /** @format date-time */
  created_at?: string;
  /** API key description */
  description?: string;
  /**
   * API key expiration date in the RFC3339 format
   * @format date-time
   * @pattern ^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}Z$
   */
  expires_at: string;
  /** API key name */
  name: string;
  status?: UserApiKeyStatusEnum;
  /** @format date-time */
  updated_at?: string;
  /** API key value */
  value?: string;
  /** API key format version */
  version?: string;
}

export const UserApiKeyStatusEnum = {
  Active: 'active',
  Expired: 'expired',
  Revoked: 'revoked',
} as const;
export type UserApiKeyStatusEnum =
  (typeof UserApiKeyStatusEnum)[keyof typeof UserApiKeyStatusEnum];

/** A payload for creating a new user, includes the username and password in a single request */
export interface UserCreationRequest {
  /** If the user is authenticating via an IDP, this is the name of the IDP. A 'native' user should have this set to null. */
  idp_name?: string;
  /**
   * The initial password for the user, must be at least 6 characters, up to 128. This must be null when the user_type is not 'native'.
   * @pattern .{6,128}$
   */
  password?: string;
  /** The user's type. A Native user authenticates using user/password log on. All other users will authenticate with an IDP. */
  user_type?: UserTypeEnum;
  /**
   * The username for authentication. If the user_type is 'native', this name must not contain a colon character as per RFC 2617 (HTTP Basic and Digest Authentication). If the user_type is 'saml', then colons are allowed in the name since HTTP Basic auth is not used for that user type.
   * @pattern ^[a-zA-Z0-9][ a-zA-Z0-9@.!#$+=^_`~;:-]{1,126}[a-zA-Z0-9_]$
   */
  username: string;
}

export interface UserGroup {
  account_roles?: UserGroupRoles;
  /**
   * The timestamp of when the user group was created
   * @format date-time
   */
  created_at?: string;
  /** The description of the user group */
  description?: string;
  /** The unique identifier for the user group */
  group_uuid: string;
  /**
   * The timestamp of the last update to this user group
   * @format date-time
   */
  last_updated?: string;
  /**
   * The name of the user group
   * @pattern ^[a-zA-Z0-9][ a-zA-Z0-9@.!#$+=^_`~;-]{1,126}[a-zA-Z0-9_]$
   */
  name: string;
}

export type UserGroupList = UserGroup[];

export interface UserGroupPatch {
  /** The description of the user group */
  description: string;
}

export interface UserGroupPost {
  /** The description of the user group */
  description?: string;
  /**
   * The name of the user group
   * @pattern ^[a-zA-Z0-9][ a-zA-Z0-9@.!#$+=^_`~;-]{1,126}[a-zA-Z0-9_]$
   */
  name: string;
}

export interface UserGroupRole {
  /** The domain scope for this role. This may be an account name when the domain is an account. */
  domain_name?: string;
  /**
   * Deprecated. Please use domain_name instead. The account for this role
   * @deprecated
   */
  for_account: string;
  roles: {
    /**
     * The timestamp of when the role membership was created
     * @format date-time
     */
    created_at?: string;
    /** The unique identifier for the role membership */
    membership_id?: string;
    /** The role name */
    role?: string;
  }[];
}

export interface UserGroupRolePost {
  /** The domain scope for this role. This may be an account name when the domain is an account. */
  domain_name?: string;
  /**
   * Deprecated. Please use domain_name instead. The account
   * @deprecated
   */
  for_account?: string;
  roles: {
    /** The name of the rbac role */
    role?: string;
  }[];
}

export interface UserGroupRoles {
  /** The list of accounts and all its roles which are configured in the user group */
  items?: UserGroupRole[];
}

export interface UserGroupUser {
  /**
   * The timestamp of when the user was added to the group
   * @format date-time
   */
  added_on?: string;
  /** The username of the user */
  username: string;
}

export interface UserGroupUsers {
  items?: UserGroupUser[];
}

export interface UserGroupUsersPost {
  /** The list of usernames to add to the user group */
  usernames: {
    /** A username */
    username?: string;
  }[];
}

/** The user's type */
export const UserTypeEnum = {
  Native: 'native',
  Saml: 'saml',
} as const;
export type UserTypeEnum = (typeof UserTypeEnum)[keyof typeof UserTypeEnum];

/** a list of User objects */
export interface Users {
  items?: User[];
  total_rows?: number;
}

/** ValidationError */
export interface ValidationError {
  /** Context */
  ctx?: object;
  /** Input */
  input?: any;
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VdrExportFormat */
export const VdrExportFormat = {
  CyclonedxJson: 'cyclonedx-json',
} as const;
export type VdrExportFormat =
  (typeof VdrExportFormat)[keyof typeof VdrExportFormat];

/** List of Vendor Data objects */
export type VendorDataList = VendorDataObject[];

export interface VendorDataObject {
  cvss_v2?: CVSSV2Scores;
  cvss_v3?: CVSSV3Scores;
  /** Vendor Vulnerability ID */
  id?: string;
  /** Identifies the organization or entity that generated or provided the CVSS score */
  source?: string;
  /** Indicates the classification of the CVSS */
  type?: NvdDataObjectTypeEnum;
}

export type VersionCheckData = ServiceVersion;

/** A vulnerability in an application version vulnerability report with vulnerability data, affected artifacts, and packages */
export interface VersionVulnerability {
  /** The vulnerability id for the match */
  id?: string;
  matches?: VersionVulnerabilityMatch[];
  nvd?: VersionVulnerabilityNVD[];
  /** The vendor information of the vulnerability */
  vendor_data?: VersionVulnerabilityVendor;
}

/** The details of a match for a single matche for a vulnerability in an application version vulnerability report */
export interface VersionVulnerabilityMatch {
  fix?: string;
  /** The location of the match, which includes both the package and the artifact it belongs to */
  location?: {
    artifact?: {
      id?: string;
      type?: string;
    };
    package?: {
      location?: string;
      name?: string;
      type?: string;
      version?: string;
    };
  };
}

/** NVD entry for application version vulnerability */
export type VersionVulnerabilityNVD = VersionVulnerabilityVendorNVDCommon & {
  id?: string;
};

/** The definition of the image artifacts in the application version vulnerability report */
export interface VersionVulnerabilityReportImage {
  image_digest?: string;
}

/** The definition of the source artifacts in the application version vulnerability report */
export interface VersionVulnerabilityReportSource {
  host?: string;
  repository_name?: string;
  revision?: string;
  uuid?: string;
}

/** The vendor information of the vulnerability */
export type VersionVulnerabilityVendor = VersionVulnerabilityVendorNVDCommon & {
  feed?: string;
  group?: string;
  will_not_fix?: boolean;
};

/** Values common to vendor and nvd entries in application version vulnerability report */
export interface VersionVulnerabilityVendorNVDCommon {
  cvss?: {
    cvss_v2?: CVSSV2Scores;
    cvss_v3?: CVSSV3Scores;
  };
  description?: string;
  severity?: string;
  url?: string;
}

/** VexExportFormat */
export const VexExportFormat = {
  CyclonedxJson: 'cyclonedx-json',
} as const;
export type VexExportFormat =
  (typeof VexExportFormat)[keyof typeof VexExportFormat];

/** VexJustification */
export const VexJustification = {
  ComponentNotPresent: 'component_not_present',
  VulnerableCodeNotPresent: 'vulnerable_code_not_present',
  VulnerableCodeNotInExecutePath: 'vulnerable_code_not_in_execute_path',
  VulnerableCodeCannotBeControlledByAdversary:
    'vulnerable_code_cannot_be_controlled_by_adversary',
  InlineMitigationsAlreadyExist: 'inline_mitigations_already_exist',
  FixNotPlanned: 'fix_not_planned',
} as const;
export type VexJustification =
  (typeof VexJustification)[keyof typeof VexJustification];

/** VexStatus */
export const VexStatus = {
  NotAffected: 'not_affected',
  Affected: 'affected',
  Fixed: 'fixed',
  UnderInvestigation: 'under_investigation',
} as const;
export type VexStatus = (typeof VexStatus)[keyof typeof VexStatus];

export const VulnAnnotationStatus = {
  NotAffected: 'not_affected',
  Affected: 'affected',
  Fixed: 'fixed',
  UnderInvestigation: 'under_investigation',
} as const;
export type VulnAnnotationStatus =
  (typeof VulnAnnotationStatus)[keyof typeof VulnAnnotationStatus];

export const VulnTypeEnum = {
  Os: 'os',
  NonOs: 'non-os',
  All: 'all',
} as const;
export type VulnTypeEnum = (typeof VulnTypeEnum)[keyof typeof VulnTypeEnum];

/** A single VEX annotation record */
export interface VulnerabilityAnnotation {
  /** A statement of the action taken in response to the vulnerability */
  action_statement?: string | null;
  /** Detailed description of the impact including methods used during annotation. If a vulnerability is not exploitable, this field should include specific details on why the component or service is not impacted by this vulnerability. */
  additional_details?: string | null;
  /** The name of the user that created/updated this annotation */
  author?: string;
  /**
   * The date that the annotation was created at
   * @format date-time
   */
  created_at?: string;
  /** A statement of the impact of the vulnerability on the component or service */
  impact_statement?: string | null;
  justification?: VexJustification | null;
  status: VulnAnnotationStatus;
  /** Notes on the status of the annotation */
  status_notes?: string | null;
  /**
   * The date that the annotation was last updated at
   * @format date-time
   */
  updated_at?: string;
  uuid?: UUID;
  /** The version number of this annotation */
  version?: number;
  /**
   * The CVE identifier that this annotation refers to
   * @example "CVE-2023-1234"
   */
  vulnerability_id: string;
}

/** VulnerabilityAnnotationUpdateRequest */
export interface VulnerabilityAnnotationUpdateRequest {
  /**
   * Action Statement
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  action_statement?: string | null;
  /**
   * Additional Details
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  additional_details?: string | null;
  /**
   * Impact Statement
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  impact_statement?: string | null;
  justification?: VexJustification | null;
  status?: VexStatus;
  /**
   * Status Notes
   * @maxLength 8192
   * @pattern ^[^\x00-\x08\x0b\x0c\x0e-\x1f\x7f]*$
   */
  status_notes?: string | null;
}

/** VulnerabilityFindingDetails */
export interface VulnerabilityFindingDetails {
  /** Fix availability information */
  fix?: VulnerabilityFindingFix | null;
  /** Affected package information */
  package: VulnerabilityFindingPackage;
  /** Vulnerability metadata */
  vulnerability: VulnerabilityFindingVulnerability;
}

/** VulnerabilityFindingFix */
export interface VulnerabilityFindingFix {
  /**
   * Fix Observed At
   * Timestamp when the fix was first observed
   * @format date-time
   */
  fix_observed_at?: string | null;
  /** Current fix availability state */
  state: VulnerabilityFindingFixState;
  /**
   * Version
   * Best fixed version closest to the vulnerable version
   */
  version?: string | null;
}

/** VulnerabilityFindingFixState */
export const VulnerabilityFindingFixState = {
  Unknown: 'unknown',
  Fixed: 'fixed',
  NotFixed: 'not_fixed',
  WontFix: 'wont_fix',
} as const;
export type VulnerabilityFindingFixState =
  (typeof VulnerabilityFindingFixState)[keyof typeof VulnerabilityFindingFixState];

/** VulnerabilityFindingPackage */
export interface VulnerabilityFindingPackage {
  /**
   * Name
   * Package name
   */
  name: string;
  /**
   * Purl
   * Package URL identifier
   */
  purl: string;
  /**
   * Type
   * Package type (e.g. rpm, deb, npm, gem)
   */
  type: string;
  /**
   * Version
   * Installed version of the package
   */
  version: string;
}

/** VulnerabilityFindingVulnerability */
export interface VulnerabilityFindingVulnerability {
  /**
   * Anchore Score
   * Weighted 0.0-100.0 Anchore Score combining CVSS, severity, EPSS and KEV signals, returned with one decimal place. Computed on demand from canonical inputs at evaluation time. Null when the underlying canonical CVSS row is unavailable.
   * @min 0
   * @max 100
   */
  anchore_score?: number | null;
  /**
   * Detected At
   * Timestamp when the vulnerability was first detected in the asset
   * @format date-time
   */
  detected_at: string;
  /**
   * Epss Percentile
   * EPSS percentile rank relative to all scored vulnerabilities
   */
  epss_percentile?: number | null;
  /**
   * Epss Score
   * EPSS probability score indicating likelihood of exploitation
   */
  epss_score?: number | null;
  /**
   * Id
   * Vulnerability identifier (e.g. CVE-2024-1234)
   */
  id: string;
  /**
   * Is Kev
   * Whether the vulnerability is in the CISA Known Exploited Vulnerabilities list
   */
  is_kev: boolean;
  /** CVSS assessment from the National Vulnerability Database */
  nvd_cvss?: CvssAssessment | null;
  /** Severity of the vulnerability */
  severity: Severity;
  /** CVSS assessment from the vendor-specific feed */
  vendor_cvss?: CvssAssessment | null;
}

/**
 * VulnerabilityMatch
 * A single vulnerability match.
 */
export interface VulnerabilityMatch {
  /**
   * Cvss Assessments
   * @default []
   */
  cvss_assessments?: CvssAssessment[];
  /** Epss Percentile */
  epss_percentile?: number | null;
  /** Epss Score */
  epss_score?: number | null;
  /**
   * Vulnerability fix state.
   *
   * NOTE: Grype returns fix_state with hyphens (``not-fixed``, ``wont-fix``)
   * but we need our enum's NAME.lower() to equal its VALUE so that the
   * conversion to/from PG is just ``FixState(label.lower())``.  Python enum
   * NAMEs cannot include hyphens, so we use underscores instead.
   */
  fix_state?: FixState | null;
  /**
   * Fix Versions
   * @default []
   */
  fix_versions?: FixVersion[];
  /**
   * Kev
   * @default false
   */
  kev?: boolean;
  /** Package Name */
  package_name: string;
  /** Package Type */
  package_type: string;
  /** Package Version */
  package_version: string;
  /** Purl */
  purl?: string | null;
  /** Vulnerability severity levels. */
  severity?: Severity | null;
  /** VEX annotation status for this (vulnerability, package) pair in the app version, or null if no annotation exists. Version-specific annotations take precedence over app-scoped annotations. */
  vex_status?: VexStatus | null;
  /** Vulnerability Id */
  vulnerability_id: string;
}

/**
 * VulnerabilityPackageResponse
 * Package affected by a specific vulnerability.
 */
export interface VulnerabilityPackageResponse {
  /**
   * Asset Count
   * @default 0
   */
  asset_count?: number;
  /**
   * Cvss Assessments
   * @default []
   */
  cvss_assessments?: CvssAssessmentWithCategory[];
  /** Epss Percentile */
  epss_percentile?: number | null;
  /** Epss Score */
  epss_score?: number | null;
  /**
   * Vulnerability fix state.
   *
   * NOTE: Grype returns fix_state with hyphens (``not-fixed``, ``wont-fix``)
   * but we need our enum's NAME.lower() to equal its VALUE so that the
   * conversion to/from PG is just ``FixState(label.lower())``.  Python enum
   * NAMEs cannot include hyphens, so we use underscores instead.
   */
  fix_state?: FixState | null;
  /**
   * Fix Versions
   * @default []
   */
  fix_versions?: FixVersion[];
  /**
   * Kev
   * @default false
   */
  kev?: boolean;
  /** Name */
  name: string;
  /** Namespace */
  namespace: string;
  /** Purl */
  purl?: string | null;
  /**
   * Reference Urls
   * Additional reference URLs for this vulnerability.
   */
  reference_urls?: string[];
  /** Vulnerability severity levels. */
  severity?: Severity | null;
  /**
   * Source Url
   * Primary provider advisory URL for this vulnerability.
   */
  source_url?: string | null;
  /** Type */
  type: string;
  /** Version */
  version: string;
  vex_status?: VexStatus | null;
  /**
   * Vulnerability Annotation Id
   * @format uuid
   */
  vulnerability_annotation_id?: string | null;
}

/** VulnerabilityPolicyFindingResponse */
export interface VulnerabilityPolicyFindingResponse {
  /**
   * Assets Affected
   * Number of assets affected by this finding
   * @default 0
   */
  assets_affected?: number;
  /** Vulnerability, package, and fix details for this finding */
  details: VulnerabilityFindingDetails;
  /** The evaluation result for this finding */
  result: FindingResult;
  /** The policy rule that produced this finding */
  rule: FindingRule;
}

/** An external link/reference */
export interface VulnerabilityReference {
  /** The reference source */
  source?: string;
  tags?: string[];
  /** The reference url */
  url?: string;
}

export type VulnerabilityScanSbomData = SBOMVulnerabilitiesResponse;

export interface VulnerabilityScanSbomParams {
  /** Whether to use Extended Update Support (EUS) data during the vulnerability scan for relevant SBOMs. Will use the system configured behaviour if not provided. */
  extended_support?: boolean;
  /** @default false */
  include_vuln_description?: boolean;
}

export type VulnerabilityScanSbomPayload = object;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  JsonApi = 'application/vnd.api+json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '/v2';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      key => 'undefined' !== typeof query[key],
    );
    return keys
      .map(key =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string')
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== 'string'
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { 'Content-Type': type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === 'undefined' || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async response => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch(e => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data.data;
    });
  };
}

/**
 * @title Anchore API
 * @version 2.17.0
 * @license Apache 2.0 (http://www.apache.org/licenses/LICENSE-2.0.html)
 * @baseUrl /v2
 * @contact <dev@anchore.com>
 *
 * This is the Anchore API. Provides the external API for users of Anchore Enterprise.
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Simple status check
   *
   * @tags System
   * @name Ping
   * @request GET:/
   * @response `200` `PingData` Version check response, returns the api version prefix (e.g. 'v2')
   */
  ping = (params: RequestParams = {}) =>
    this.request<PingData, any>({
      path: `/`,
      method: 'GET',
      format: 'json',
      ...params,
    });

  account = {
    /**
     * No description
     *
     * @tags Identity
     * @name GetUsersAccount
     * @summary List the account for the authenticated user
     * @request GET:/account
     * @response `200` `GetUsersAccountData` User details for caller's user
     * @response `500` `ApiErrorResponse` Internal error
     */
    getUsersAccount: (params: RequestParams = {}) =>
      this.request<GetUsersAccountData, ApiErrorResponse>({
        path: `/account`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  accounts = {
    /**
     * No description
     *
     * @tags User Management
     * @name ListAccounts
     * @summary List account summaries. Only available to the system admin user.
     * @request GET:/accounts
     * @response `200` `ListAccountsData` Account summary listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listAccounts: (
      query: ListAccountsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListAccountsData, ApiErrorResponse>({
        path: `/accounts`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name CreateAccount
     * @summary Create a new account. Only available to admin user.
     * @request POST:/accounts
     * @response `200` `CreateAccountData` Account Record
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `409` `ApiErrorResponse` Conflicting account information. Account already exists.
     * @response `500` `ApiErrorResponse` Internal error
     */
    createAccount: (data: AccountCreationRequest, params: RequestParams = {}) =>
      this.request<CreateAccountData, ApiErrorResponse>({
        path: `/accounts`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListAllSystemUsers
     * @summary List all system account users. Only available to `admin` users.
     * @request GET:/accounts/users
     * @response `200` `ListAllSystemUsersData` List of all Users
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listAllSystemUsers: (
      query: ListAllSystemUsersParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListAllSystemUsersData, ApiErrorResponse>({
        path: `/accounts/users`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UpdateAccountState
     * @summary Update the state of an account to either enabled or disabled. For deletion use the DELETE route
     * @request PUT:/accounts/{account_name}/state
     * @response `200` `UpdateAccountStateData` Updated state of the account
     * @response `400` `ApiErrorResponse` State requested is invalid based on current state of the account
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateAccountState: (
      { accountName }: UpdateAccountStateParams,
      data: AccountStatus,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAccountStateData, ApiErrorResponse>({
        path: `/accounts/${accountName}/state`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUsers
     * @summary List of users that are primary within this account. The response object will only contain roles for this account as well as any system roles.
     * @request GET:/accounts/{account_name}/users
     * @response `200` `ListUsersData` User listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listUsers: ({ accountName }: ListUsersParams, params: RequestParams = {}) =>
      this.request<ListUsersData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name CreateUser
     * @summary Create a new user within the specified account.
     * @request POST:/accounts/{account_name}/users
     * @response `200` `CreateUserData` Credential summary
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    createUser: (
      { accountName }: CreateUserParams,
      data: UserCreationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateUserData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUsersWithRoles
     * @summary List of users who have rbac roles in this account.
     * @request GET:/accounts/{account_name}/users-with-roles
     * @response `200` `ListUsersWithRolesData` List of all Users with roles in this account.
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listUsersWithRoles: (
      { accountName }: ListUsersWithRolesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListUsersWithRolesData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users-with-roles`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUserApiKeys
     * @summary Get a list of API keys
     * @request GET:/accounts/{account_name}/users/{username}/api-keys
     * @response `200` `ListUserApiKeysData` User API key listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listUserApiKeys: (
      { accountName, username }: ListUserApiKeysParams,
      params: RequestParams = {},
    ) =>
      this.request<ListUserApiKeysData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/api-keys`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name CreateUserApiKey
     * @summary Add a new API key
     * @request POST:/accounts/{account_name}/users/{username}/api-keys
     * @response `201` `CreateUserApiKeyData` Add a new API key
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    createUserApiKey: (
      { accountName, username }: CreateUserApiKeyParams,
      data: UserApiKey,
      params: RequestParams = {},
    ) =>
      this.request<CreateUserApiKeyData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/api-keys`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name GetUserApiKey
     * @summary Get a user API key
     * @request GET:/accounts/{account_name}/users/{username}/api-keys/{key_name}
     * @response `200` `GetUserApiKeyData` User API key listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account, user, or API key not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getUserApiKey: (
      { accountName, username, keyName }: GetUserApiKeyParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserApiKeyData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/api-keys/${keyName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name PatchUserApiKey
     * @summary Patch a user API key
     * @request PATCH:/accounts/{account_name}/users/{username}/api-keys/{key_name}
     * @response `200` `PatchUserApiKeyData` Patched information in a user API key
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account, user, or API key not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    patchUserApiKey: (
      { accountName, username, keyName }: PatchUserApiKeyParams,
      data: PatchUserApiKeyPayload,
      params: RequestParams = {},
    ) =>
      this.request<PatchUserApiKeyData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/api-keys/${keyName}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteUserApiKey
     * @summary Delete a user API key
     * @request DELETE:/accounts/{account_name}/users/{username}/api-keys/{key_name}
     * @response `204` `DeleteUserApiKeyData` Successful deletion of a user API key
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account, user, or API key not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteUserApiKey: (
      { accountName, username, keyName }: DeleteUserApiKeyParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserApiKeyData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/api-keys/${keyName}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUserCredentials
     * @summary Get current credential summary
     * @request GET:/accounts/{account_name}/users/{username}/credentials
     * @response `200` `ListUserCredentialsData` User credential listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listUserCredentials: (
      { accountName, username }: ListUserCredentialsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListUserCredentialsData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/credentials`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name CreateUserCredential
     * @summary add/replace credential
     * @request POST:/accounts/{account_name}/users/{username}/credentials
     * @response `200` `CreateUserCredentialData` Add a credential, overwriting if already exists
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    createUserCredential: (
      { accountName, username }: CreateUserCredentialParams,
      data: AccessCredential,
      params: RequestParams = {},
    ) =>
      this.request<CreateUserCredentialData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/credentials`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteUserCredential
     * @summary Delete a credential by type
     * @request DELETE:/accounts/{account_name}/users/{username}/credentials
     * @response `204` `DeleteUserCredentialData` Successful deletion
     * @response `400` `void` Conflict, cannot delete the credential used to authenticate this request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteUserCredential: (
      { accountName, username, ...query }: DeleteUserCredentialParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserCredentialData, void | ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}/credentials`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name GetAccountUser
     * @summary Get a specific user in the specified account
     * @request GET:/accounts/{account_name}/users/{username}
     * @response `200` `GetAccountUserData` User record
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getAccountUser: (
      { accountName, username }: GetAccountUserParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAccountUserData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteUser
     * @summary Delete a specific user by username.
     * @request DELETE:/accounts/{account_name}/users/{username}
     * @response `204` `DeleteUserData` Deleted user
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account or user not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteUser: (
      { accountName, username }: DeleteUserParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserData, ApiErrorResponse>({
        path: `/accounts/${accountName}/users/${username}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name GetAccount
     * @summary Get account info about this specific account.
     * @request GET:/accounts/{account_name}
     * @response `200` `GetAccountData` Get user information
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getAccount: (
      { accountName }: GetAccountParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAccountData, ApiErrorResponse>({
        path: `/accounts/${accountName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UpdateAccount
     * @summary Update the info for this specific account.
     * @request PUT:/accounts/{account_name}
     * @response `200` `UpdateAccountData` Returns the account information
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateAccount: (
      { accountName }: UpdateAccountParams,
      data: AccountInfo,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAccountData, ApiErrorResponse>({
        path: `/accounts/${accountName}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteAccount
     * @summary Delete the specified account, only allowed if the account is in the disabled state. All users will be deleted along with the account and all resources will be garbage collected. The deleted account name will not be available for reuse immediately until all resources are garbage collected async.
     * @request DELETE:/accounts/{account_name}
     * @response `204` `DeleteAccountData` Successful deletion
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Account not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteAccount: (
      { accountName }: DeleteAccountParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAccountData, ApiErrorResponse>({
        path: `/accounts/${accountName}`,
        method: 'DELETE',
        ...params,
      }),
  };
  actions = {
    /**
     * @description Retrieves a list of action plans that have been completed
     *
     * @tags Actions
     * @name GetActionPlans
     * @summary Gets a list of submitted action (remediation) plans
     * @request GET:/actions
     * @response `200` `GetActionPlansData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getActionPlans: (
      query: GetActionPlansParams = {},
      params: RequestParams = {},
    ) =>
      this.request<GetActionPlansData, ApiErrorResponse>({
        path: `/actions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Submits an Action Plan and saves upon completion
     *
     * @tags Actions
     * @name AddActionPlan
     * @summary Submits an Action Plan
     * @request POST:/actions
     * @response `200` `AddActionPlanData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addActionPlan: (data: ActionPlan, params: RequestParams = {}) =>
      this.request<AddActionPlanData, ApiErrorResponse>({
        path: `/actions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  alerts = {
    /**
     * @description Returns a paginated list of compliance violation alerts in chronological order from the most to least recently generated alerts. Return alerts in the open state by default. Use query parameters for filtering
     *
     * @tags Alerts
     * @name GetComplianceViolationAlerts
     * @summary List all compliance violation alerts scoped to the account
     * @request GET:/alerts/compliance-violations
     * @response `200` `GetComplianceViolationAlertsData` List of compliance violation alerts
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getComplianceViolationAlerts: (
      query: GetComplianceViolationAlertsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<GetComplianceViolationAlertsData, ApiErrorResponse>({
        path: `/alerts/compliance-violations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single compliance violation alert object
     *
     * @tags Alerts
     * @name GetComplianceViolationAlert
     * @summary Get compliance violation alert by id
     * @request GET:/alerts/compliance-violations/{uuid}
     * @response `200` `GetComplianceViolationAlertData` Compliance violation alert
     */
    getComplianceViolationAlert: (
      { uuid }: GetComplianceViolationAlertParams,
      params: RequestParams = {},
    ) =>
      this.request<GetComplianceViolationAlertData, any>({
        path: `/alerts/compliance-violations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Idempotent op for changing the alert state to open or closed
     *
     * @tags Alerts
     * @name UpdateComplianceViolationAlertState
     * @summary Open or close a compliance violation alert
     * @request PATCH:/alerts/compliance-violations/{uuid}
     * @response `200` `UpdateComplianceViolationAlertStateData` Alert state updated successfully
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Compliance Violation Alert not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    updateComplianceViolationAlertState: (
      { uuid }: UpdateComplianceViolationAlertStateParams,
      data: ComplianceViolationAlertState,
      params: RequestParams = {},
    ) =>
      this.request<UpdateComplianceViolationAlertStateData, ApiErrorResponse>({
        path: `/alerts/compliance-violations/${uuid}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a paginated list of alert summaries in chronological order from the most to least recently generated alerts. Return alerts in the open state by default. Use query parameters for filtering
     *
     * @tags Alerts
     * @name GetAlertSummaries
     * @summary List all alert summaries scoped to the account
     * @request GET:/alerts/summaries
     * @response `200` `GetAlertSummariesData` List of alert summaries
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getAlertSummaries: (
      query: GetAlertSummariesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<GetAlertSummariesData, ApiErrorResponse>({
        path: `/alerts/summaries`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  applications = {
    /**
     * @description Deprecated. Please use App Versions. List all applications
     *
     * @tags Applications
     * @name GetApplications
     * @summary Deprecated. Please use App Versions. List all applications
     * @request GET:/applications
     * @deprecated
     * @response `200` `GetApplicationsData` Applications retrieved successfully
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApplications: (
      query: GetApplicationsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationsData, ApiErrorResponse>({
        path: `/applications`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Create an application
     *
     * @tags Applications
     * @name AddApplication
     * @summary Deprecated. Please use App Versions. Create an application
     * @request POST:/applications
     * @deprecated
     * @response `200` `AddApplicationData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `409` `ApiErrorResponse` Application with name already exists
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addApplication: (data: Application, params: RequestParams = {}) =>
      this.request<AddApplicationData, ApiErrorResponse>({
        path: `/applications`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. List all application versions
     *
     * @tags Applications
     * @name GetApplicationVersions
     * @summary Deprecated. Please use App Versions. List all application versions
     * @request GET:/applications/{application_id}/versions
     * @deprecated
     * @response `200` `GetApplicationVersionsData` Successfully retrieved application versions
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApplicationVersions: (
      { applicationId }: GetApplicationVersionsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationVersionsData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Create an application version
     *
     * @tags Applications
     * @name AddApplicationVersion
     * @summary Deprecated. Please use App Versions. Create an application version
     * @request POST:/applications/{application_id}/versions
     * @deprecated
     * @response `200` `AddApplicationVersionData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application not found
     * @response `409` `ApiErrorResponse` Application version with version_name already exists on the specified application
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addApplicationVersion: (
      { applicationId }: AddApplicationVersionParams,
      data: ApplicationVersion,
      params: RequestParams = {},
    ) =>
      this.request<AddApplicationVersionData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. List artifacts present on a given application version
     *
     * @tags Applications
     * @name ListArtifacts
     * @summary Deprecated. Please use App Versions. List artifacts present on a given application version
     * @request GET:/applications/{application_id}/versions/{application_version_id}/artifacts
     * @deprecated
     * @response `200` `ListArtifactsData` Successfully retrieved artifacts
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listArtifacts: (
      { applicationId, applicationVersionId, ...query }: ListArtifactsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListArtifactsData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}/artifacts`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Add artifact to given application_id and application_version_id
     *
     * @tags Applications
     * @name AddArtifactToApplicationVersion
     * @summary Deprecated. Please use App Versions. Add an artifact to an application version
     * @request POST:/applications/{application_id}/versions/{application_version_id}/artifacts
     * @deprecated
     * @response `200` `AddArtifactToApplicationVersionData` Artifact successfully added to application version
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addArtifactToApplicationVersion: (
      {
        applicationId,
        applicationVersionId,
      }: AddArtifactToApplicationVersionParams,
      data: ArtifactAssociationRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddArtifactToApplicationVersionData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}/artifacts`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Delete an artifact from specified application version
     *
     * @tags Applications
     * @name RemoveArtifactFromApplicationVersion
     * @summary Deprecated. Please use App Versions. Delete an artifact from specified application version
     * @request DELETE:/applications/{application_id}/versions/{application_version_id}/artifacts/{association_id}
     * @deprecated
     * @response `204` `RemoveArtifactFromApplicationVersionData` Artifact successfully removed from application version
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version or artifact not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    removeArtifactFromApplicationVersion: (
      {
        applicationId,
        applicationVersionId,
        associationId,
      }: RemoveArtifactFromApplicationVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<RemoveArtifactFromApplicationVersionData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}/artifacts/${associationId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Get the combined sbom for the given application version, optionally filtered by artifact type
     *
     * @tags Applications
     * @name GetApplicationVersionSbom
     * @summary Deprecated. Please use App Versions. Get the combined sbom for the given application version, optionally filtered by artifact type
     * @request GET:/applications/{application_id}/versions/{application_version_id}/sboms/native-json
     * @deprecated
     * @response `200` `GetApplicationVersionSbomData` Successfully retrieved combined sbom
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApplicationVersionSbom: (
      {
        applicationId,
        applicationVersionId,
        ...query
      }: GetApplicationVersionSbomParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationVersionSbomData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}/sboms/native-json`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Get the vulnerabilities for a given application version
     *
     * @tags Applications
     * @name GetApplicationVersionVulnerabilities
     * @summary Deprecated. Please use App Versions. Get the vulnerabilities for a given application version
     * @request GET:/applications/{application_id}/versions/{application_version_id}/vulnerabilities
     * @deprecated
     * @response `200` `GetApplicationVersionVulnerabilitiesData` Successfully retrieved vulnerability data
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApplicationVersionVulnerabilities: (
      {
        applicationId,
        applicationVersionId,
        ...query
      }: GetApplicationVersionVulnerabilitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationVersionVulnerabilitiesData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}/vulnerabilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Get an application version by application_id and application_version_id
     *
     * @tags Applications
     * @name GetApplicationVersion
     * @summary Deprecated. Please use App Versions. Get an application version
     * @request GET:/applications/{application_id}/versions/{application_version_id}
     * @deprecated
     * @response `200` `GetApplicationVersionData` Successfully retrieved application version
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApplicationVersion: (
      { applicationId, applicationVersionId }: GetApplicationVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationVersionData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Updates application version details for given application_id and application_version_id
     *
     * @tags Applications
     * @name UpdateApplicationVersion
     * @summary Deprecated. Please use App Versions. Update application version details
     * @request PUT:/applications/{application_id}/versions/{application_version_id}
     * @deprecated
     * @response `200` `UpdateApplicationVersionData` Application updated successfully
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `409` `ApiErrorResponse` Application version with version_name already exists on the specified application
     * @response `500` `ApiErrorResponse` Internal Error
     */
    updateApplicationVersion: (
      { applicationId, applicationVersionId }: UpdateApplicationVersionParams,
      data: ApplicationVersion,
      params: RequestParams = {},
    ) =>
      this.request<UpdateApplicationVersionData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Delete an application version by application_id and application_version_id
     *
     * @tags Applications
     * @name DeleteApplicationVersion
     * @summary Deprecated. Please use App Versions. Delete an application version by application_id and application_version_id
     * @request DELETE:/applications/{application_id}/versions/{application_version_id}
     * @deprecated
     * @response `204` `DeleteApplicationVersionData` Application version deleted successfully
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application version not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteApplicationVersion: (
      { applicationId, applicationVersionId }: DeleteApplicationVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteApplicationVersionData, ApiErrorResponse>({
        path: `/applications/${applicationId}/versions/${applicationVersionId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Get an application by application_id
     *
     * @tags Applications
     * @name GetApplication
     * @summary Deprecated. Please use App Versions. Get an application by application_id
     * @request GET:/applications/{application_id}
     * @deprecated
     * @response `200` `GetApplicationData` Successfully retrieved application
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApplication: (
      { applicationId, ...query }: GetApplicationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationData, ApiErrorResponse>({
        path: `/applications/${applicationId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Updates application details for given application_id
     *
     * @tags Applications
     * @name UpdateApplication
     * @summary Deprecated. Please use App Versions. Update application details
     * @request PUT:/applications/{application_id}
     * @deprecated
     * @response `200` `UpdateApplicationData` Application updated successfully
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application not found
     * @response `409` `ApiErrorResponse` Application with name already exists
     * @response `500` `ApiErrorResponse` Internal Error
     */
    updateApplication: (
      { applicationId }: UpdateApplicationParams,
      data: Application,
      params: RequestParams = {},
    ) =>
      this.request<UpdateApplicationData, ApiErrorResponse>({
        path: `/applications/${applicationId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated. Please use App Versions. Delete an application by application_id
     *
     * @tags Applications
     * @name DeleteApplication
     * @summary Deprecated. Please use App Versions. Delete an application by application_id
     * @request DELETE:/applications/{application_id}
     * @deprecated
     * @response `204` `DeleteApplicationData` Application deleted successfully
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Application not found
     */
    deleteApplication: (
      { applicationId }: DeleteApplicationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteApplicationData, ApiErrorResponse>({
        path: `/applications/${applicationId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  archives = {
    /**
     * No description
     *
     * @tags Archives
     * @name ListArchives
     * @request GET:/archives
     * @response `200` `ListArchivesData` Archive summary listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listArchives: (params: RequestParams = {}) =>
      this.request<ListArchivesData, ApiErrorResponse>({
        path: `/archives`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Archives
     * @name ListAnalysisArchive
     * @request GET:/archives/images
     * @response `200` `ListAnalysisArchiveData` Image analysis archive listing for the requesting account (not the whole system)
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listAnalysisArchive: (params: RequestParams = {}) =>
      this.request<ListAnalysisArchiveData, ApiErrorResponse>({
        path: `/archives/images`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Archives
     * @name ArchiveImageAnalysis
     * @request POST:/archives/images
     * @response `200` `ArchiveImageAnalysisData` Archive statuses
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    archiveImageAnalysis: (
      data: ImageAnalysisReferences,
      params: RequestParams = {},
    ) =>
      this.request<ArchiveImageAnalysisData, ApiErrorResponse>({
        path: `/archives/images`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the archive metadata record identifying the image and tags for the analysis in the archive.
     *
     * @tags Archives
     * @name GetArchivedAnalysis
     * @request GET:/archives/images/{image_digest}
     * @response `200` `GetArchivedAnalysisData` Archived Image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getArchivedAnalysis: (
      { imageDigest }: GetArchivedAnalysisParams,
      params: RequestParams = {},
    ) =>
      this.request<GetArchivedAnalysisData, ApiErrorResponse>({
        path: `/archives/images/${imageDigest}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Performs a synchronous archive deletion
     *
     * @tags Archives
     * @name DeleteArchivedAnalysis
     * @request DELETE:/archives/images/{image_digest}
     * @response `200` `DeleteArchivedAnalysisData` Archived Image Analysis was successfully deleted
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteArchivedAnalysis: (
      { imageDigest, ...query }: DeleteArchivedAnalysisParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteArchivedAnalysisData, ApiErrorResponse>({
        path: `/archives/images/${imageDigest}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Archives
     * @name ListAnalysisArchiveRules
     * @request GET:/archives/rules
     * @response `200` `ListAnalysisArchiveRulesData` Archive transition rules
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listAnalysisArchiveRules: (
      query: ListAnalysisArchiveRulesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListAnalysisArchiveRulesData, ApiErrorResponse>({
        path: `/archives/rules`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Archives
     * @name CreateAnalysisArchiveRule
     * @request POST:/archives/rules
     * @response `200` `CreateAnalysisArchiveRuleData` Archive transition rule
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    createAnalysisArchiveRule: (
      data: AnalysisArchiveTransitionRule,
      params: RequestParams = {},
    ) =>
      this.request<CreateAnalysisArchiveRuleData, ApiErrorResponse>({
        path: `/archives/rules`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Archives
     * @name GetAnalysisArchiveRule
     * @request GET:/archives/rules/{rule_id}
     * @response `200` `GetAnalysisArchiveRuleData` Archive transition rule
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Rule not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getAnalysisArchiveRule: (
      { ruleId }: GetAnalysisArchiveRuleParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAnalysisArchiveRuleData, ApiErrorResponse>({
        path: `/archives/rules/${ruleId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Archives
     * @name DeleteAnalysisArchiveRule
     * @request DELETE:/archives/rules/{rule_id}
     * @response `200` `DeleteAnalysisArchiveRuleData` Analysis archive rule successfully deleted
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Rule not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteAnalysisArchiveRule: (
      { ruleId }: DeleteAnalysisArchiveRuleParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAnalysisArchiveRuleData, ApiErrorResponse>({
        path: `/archives/rules/${ruleId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  artifactRelationships = {
    /**
     * @description List the relationships between software supply chain artifacts (images, source revisions, etc)
     *
     * @tags Relationships
     * @name ListArtifactRelationships
     * @request GET:/artifact-relationships
     * @response `200` `ListArtifactRelationshipsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listArtifactRelationships: (
      query: ListArtifactRelationshipsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListArtifactRelationshipsData, ApiErrorResponse>({
        path: `/artifact-relationships`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add a new relationship for this image to another artifact (source or image)
     *
     * @tags Relationships
     * @name AddArtifactRelationship
     * @request POST:/artifact-relationships
     * @response `200` `AddArtifactRelationshipData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    addArtifactRelationship: (
      data: ArtifactRelationship,
      params: RequestParams = {},
    ) =>
      this.request<AddArtifactRelationshipData, ApiErrorResponse>({
        path: `/artifact-relationships`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete one or more relationships
     *
     * @tags Relationships
     * @name DeleteArtifactRelationships
     * @request DELETE:/artifact-relationships
     * @response `200` `DeleteArtifactRelationshipsData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteArtifactRelationships: (
      query: DeleteArtifactRelationshipsParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteArtifactRelationshipsData, ApiErrorResponse>({
        path: `/artifact-relationships`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return the context-aware diff of the sboms for the relationship
     *
     * @tags Relationships
     * @name GetRelationshipSbomDiff
     * @request GET:/artifact-relationships/{relationship_id}/diffs/sbom
     * @response `200` `GetRelationshipSbomDiffData` SBoM Diff for the related artifacts
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getRelationshipSbomDiff: (
      { relationshipId }: GetRelationshipSbomDiffParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRelationshipSbomDiffData, ApiErrorResponse>({
        path: `/artifact-relationships/${relationshipId}/diffs/sbom`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the relationship between software supply chain artifacts (images, source revisions, etc)
     *
     * @tags Relationships
     * @name GetArtifactRelationship
     * @request GET:/artifact-relationships/{relationship_id}
     * @response `200` `GetArtifactRelationshipData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getArtifactRelationship: (
      { relationshipId }: GetArtifactRelationshipParams,
      params: RequestParams = {},
    ) =>
      this.request<GetArtifactRelationshipData, ApiErrorResponse>({
        path: `/artifact-relationships/${relationshipId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  corrections = {
    /**
     * @description Returns a list of corrections
     *
     * @tags Corrections
     * @name GetCorrections
     * @summary Retrieve a list of corrections
     * @request GET:/corrections
     * @response `200` `GetCorrectionsData` Corrections retrieved successfully
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getCorrections: (
      query: GetCorrectionsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<GetCorrectionsData, ApiErrorResponse>({
        path: `/corrections`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Add a correction record that will be used to fix false positive matches
     *
     * @tags Corrections
     * @name AddCorrection
     * @summary Create a correction record
     * @request POST:/corrections
     * @response `200` `AddCorrectionData` Corrections saved successfully
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    addCorrection: (data: Correction, params: RequestParams = {}) =>
      this.request<AddCorrectionData, ApiErrorResponse>({
        path: `/corrections`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns a single correction, looked up via it's uuid
     *
     * @tags Corrections
     * @name GetCorrectionByUuid
     * @summary Retrieve a correction by UUID
     * @request GET:/corrections/{uuid}
     * @response `200` `GetCorrectionByUuidData` Correction retrieved successfully
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getCorrectionByUuid: (
      { uuid }: GetCorrectionByUuidParams,
      params: RequestParams = {},
    ) =>
      this.request<GetCorrectionByUuidData, ApiErrorResponse>({
        path: `/corrections/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a single correction, looked up via it's uuid
     *
     * @tags Corrections
     * @name UpdateCorrectionByUuid
     * @summary Update a correction by UUID
     * @request PUT:/corrections/{uuid}
     * @response `200` `UpdateCorrectionByUuidData` Correction updated successfully
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateCorrectionByUuid: (
      { uuid }: UpdateCorrectionByUuidParams,
      data: Correction,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCorrectionByUuidData, ApiErrorResponse>({
        path: `/corrections/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a single correction, looked up via it's uuid
     *
     * @tags Corrections
     * @name DeleteCorrectionByUuid
     * @summary Delete a correction by UUID
     * @request DELETE:/corrections/{uuid}
     * @response `204` `DeleteCorrectionByUuidData` Correction deleted successfully
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteCorrectionByUuid: (
      { uuid }: DeleteCorrectionByUuidParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteCorrectionByUuidData, ApiErrorResponse>({
        path: `/corrections/${uuid}`,
        method: 'DELETE',
        ...params,
      }),
  };
  ecsContainers = {
    /**
     * @description Return a list of ECS containers that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetEcsContainers
     * @summary Return a list of ECS containers that have been inventoried for this account
     * @request GET:/ecs-containers
     * @response `200` `GetEcsContainersData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getEcsContainers: (
      query: GetEcsContainersParams,
      params: RequestParams = {},
    ) =>
      this.request<GetEcsContainersData, ApiErrorResponse>({
        path: `/ecs-containers`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  ecsInventory = {
    /**
     * @description Add container metadata from Amazon ECS
     *
     * @tags Inventories
     * @name PostEcsInventory
     * @summary Add container metadata from Amazon ECS
     * @request POST:/ecs-inventory
     * @response `204` `PostEcsInventoryData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    postEcsInventory: (data: ECSInventory, params: RequestParams = {}) =>
      this.request<PostEcsInventoryData, ApiErrorResponse>({
        path: `/ecs-inventory`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  ecsServices = {
    /**
     * @description Return a list of ECS services that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetEcsServices
     * @summary Return a list of ECS services that have been inventoried for this account
     * @request GET:/ecs-services
     * @response `200` `GetEcsServicesData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getEcsServices: (query: GetEcsServicesParams, params: RequestParams = {}) =>
      this.request<GetEcsServicesData, ApiErrorResponse>({
        path: `/ecs-services`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  ecsTasks = {
    /**
     * @description Return a list of ECS tasks that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetEcsTasks
     * @summary Return a list of ECS tasks that have been inventoried for this account
     * @request GET:/ecs-tasks
     * @response `200` `GetEcsTasksData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getEcsTasks: (query: GetEcsTasksParams, params: RequestParams = {}) =>
      this.request<GetEcsTasksData, ApiErrorResponse>({
        path: `/ecs-tasks`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  eventTypes = {
    /**
     * @description Returns list of event types in the category hierarchy
     *
     * @tags Events
     * @name ListEventTypes
     * @summary List Event Types
     * @request GET:/event-types
     * @response `200` `ListEventTypesData` List of event types
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listEventTypes: (params: RequestParams = {}) =>
      this.request<ListEventTypesData, ApiErrorResponse>({
        path: `/event-types`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  events = {
    /**
     * @description Returns a paginated list of events in the descending order of their occurrence. Optional query parameters may be used for filtering results
     *
     * @tags Events
     * @name ListEvents
     * @summary List Events
     * @request GET:/events
     * @response `200` `ListEventsData` Paginated list of event records and the next token
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listEvents: (query: ListEventsParams = {}, params: RequestParams = {}) =>
      this.request<ListEventsData, ApiErrorResponse>({
        path: `/events`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all or a subset of events filtered using the optional query parameters
     *
     * @tags Events
     * @name DeleteEvents
     * @summary Delete Events
     * @request DELETE:/events
     * @response `200` `DeleteEventsData` List of deleted event IDs
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteEvents: (
      query: DeleteEventsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<DeleteEventsData, ApiErrorResponse>({
        path: `/events`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lookup an event by its event ID
     *
     * @tags Events
     * @name GetEvent
     * @summary Get Event
     * @request GET:/events/{event_id}
     * @response `200` `GetEventData` Single event record
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Event not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getEvent: ({ eventId }: GetEventParams, params: RequestParams = {}) =>
      this.request<GetEventData, ApiErrorResponse>({
        path: `/events/${eventId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an event by its event ID
     *
     * @tags Events
     * @name DeleteEvent
     * @summary Delete Event
     * @request DELETE:/events/{event_id}
     * @response `200` `DeleteEventData` Delete success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Event not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteEvent: ({ eventId }: DeleteEventParams, params: RequestParams = {}) =>
      this.request<DeleteEventData, ApiErrorResponse>({
        path: `/events/${eventId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  health = {
    /**
     * @description Health check, returns 200 and no body if service is running
     *
     * @tags System
     * @name HealthCheck
     * @request GET:/health
     * @response `200` `HealthCheckData` Empty body on success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    healthCheck: (params: RequestParams = {}) =>
      this.request<HealthCheckData, ApiErrorResponse>({
        path: `/health`,
        method: 'GET',
        ...params,
      }),
  };
  images = {
    /**
     * @description List all images visible to the user
     *
     * @tags Images
     * @name ListImages
     * @summary List all visible images
     * @request GET:/images
     * @response `200` `ListImagesData` successful operation
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImages: (query: ListImagesParams = {}, params: RequestParams = {}) =>
      this.request<ListImagesData, ApiErrorResponse>({
        path: `/images`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a new analysis task that is executed asynchronously
     *
     * @tags Images
     * @name AddImage
     * @summary Submit a new image for analysis by the engine
     * @request POST:/images
     * @response `200` `AddImageData` Successfully added image to analysis queue
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    addImage: (
      data: ImageAnalysisRequest,
      query: AddImageParams = {},
      params: RequestParams = {},
    ) =>
      this.request<AddImageData, ApiErrorResponse>({
        path: `/images`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete analysis for image digests in the list asynchronously
     *
     * @tags Images
     * @name DeleteImagesAsync
     * @summary Bulk mark images for deletion
     * @request DELETE:/images
     * @response `200` `DeleteImagesAsyncData` successful operation
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteImagesAsync: (
      query: DeleteImagesAsyncParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteImagesAsyncData, ApiErrorResponse>({
        path: `/images`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Parses a pull-style image reference and returns its canonical pullable form along with the structured registry, repository, tag, and digest components. When the input omits a registry, docker.io is assumed; when it omits a tag and has no digest, `latest` is assumed. The first path segment is only treated as a registry host when it contains a `.` or `:` or matches one of `localhost`, `localhost.localdomain`, `localbuild`. As a result, an input like `harbor/proj/img` is normalized as `docker.io/harbor/proj/img:latest`, not as the repository `proj/img` on an internal Harbor registry — callers referencing an internal registry must supply a dotted host (e.g. `harbor.internal/proj/img`) or an explicit port (e.g. `harbor:443/proj/img`).
     *
     * @tags Images
     * @name NormalizeImage
     * @summary Normalize an image reference string
     * @request POST:/images/normalize
     * @response `200` `NormalizeImageData` Normalized image reference
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    normalizeImage: (data: ImageNormalizeRequest, params: RequestParams = {}) =>
      this.request<NormalizeImageData, ApiErrorResponse>({
        path: `/images/normalize`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns list of ancestor images, which are the images that form the base layers of the image
     *
     * @tags Images
     * @name GetImageAncestors
     * @summary Return the list of ancestor images for the given image
     * @request GET:/images/{image_digest}/ancestors
     * @response `200` `GetImageAncestorsData` Ancestor list
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageAncestors: (
      { imageDigest }: GetImageAncestorsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageAncestorsData, ApiErrorResponse>({
        path: `/images/${imageDigest}/ancestors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListFileContentSearchResults
     * @summary Return a list of analyzer artifacts of the specified type
     * @request GET:/images/{image_digest}/artifacts/file-content-search
     * @response `200` `ListFileContentSearchResultsData` List of file metadata objects
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listFileContentSearchResults: (
      { imageDigest }: ListFileContentSearchResultsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListFileContentSearchResultsData, ApiErrorResponse>({
        path: `/images/${imageDigest}/artifacts/file-content-search`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListRetrievedFiles
     * @summary Return a list of analyzer artifacts of the specified type
     * @request GET:/images/{image_digest}/artifacts/retrieved-files
     * @response `200` `ListRetrievedFilesData` List of file metadata objects
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listRetrievedFiles: (
      { imageDigest }: ListRetrievedFilesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListRetrievedFilesData, ApiErrorResponse>({
        path: `/images/${imageDigest}/artifacts/retrieved-files`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListSecretSearchResults
     * @summary Return a list of analyzer artifacts of the specified type
     * @request GET:/images/{image_digest}/artifacts/secret-search
     * @response `200` `ListSecretSearchResultsData` List of file metadata objects
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSecretSearchResults: (
      { imageDigest }: ListSecretSearchResultsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListSecretSearchResultsData, ApiErrorResponse>({
        path: `/images/${imageDigest}/artifacts/secret-search`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListImageVulnAnnotations
     * @summary List the vuln annotations for this image
     * @request GET:/images/{image_digest}/vuln-annotations
     * @response `200` `ListImageVulnAnnotationsData` Vulnerability annotation list
     * @response `500` `void` Internal Error
     */
    listImageVulnAnnotations: (
      { imageDigest, ...query }: ListImageVulnAnnotationsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImageVulnAnnotationsData, void>({
        path: `/images/${imageDigest}/vuln-annotations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name CreateImageVulnAnnotation
     * @summary Add a vuln annotation for this image
     * @request POST:/images/{image_digest}/vuln-annotations
     * @response `201` `CreateImageVulnAnnotationData` Vulnerability annotation post successful
     * @response `500` `ApiErrorResponse` Internal Error
     */
    createImageVulnAnnotation: (
      { imageDigest }: CreateImageVulnAnnotationParams,
      data: PackageVulnerabilityAnnotation,
      params: RequestParams = {},
    ) =>
      this.request<CreateImageVulnAnnotationData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vuln-annotations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageVulnAnnotation
     * @summary Get a vuln annotation
     * @request GET:/images/{image_digest}/vuln-annotations/{vuln_annotation_uuid}
     * @response `200` `GetImageVulnAnnotationData` Vulnerability annotation details
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getImageVulnAnnotation: (
      { imageDigest, vulnAnnotationUuid }: GetImageVulnAnnotationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageVulnAnnotationData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vuln-annotations/${vulnAnnotationUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name UpdateImageVulnAnnotation
     * @summary Update a vuln annotation
     * @request PUT:/images/{image_digest}/vuln-annotations/{vuln_annotation_uuid}
     * @response `200` `UpdateImageVulnAnnotationData` Vulnerability annotation update successful
     * @response `500` `ApiErrorResponse` Internal Error
     */
    updateImageVulnAnnotation: (
      { imageDigest, vulnAnnotationUuid }: UpdateImageVulnAnnotationParams,
      data: VulnerabilityAnnotation,
      params: RequestParams = {},
    ) =>
      this.request<UpdateImageVulnAnnotationData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vuln-annotations/${vulnAnnotationUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name DeleteImageVulnAnnotation
     * @summary Delete a vuln annotation
     * @request DELETE:/images/{image_digest}/vuln-annotations/{vuln_annotation_uuid}
     * @response `204` `DeleteImageVulnAnnotationData` Vulnerability annotation delete successful
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteImageVulnAnnotation: (
      { imageDigest, vulnAnnotationUuid }: DeleteImageVulnAnnotationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteImageVulnAnnotationData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vuln-annotations/${vulnAnnotationUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Get the policy evaluation for the given image
     *
     * @tags Images
     * @name GetImagePolicyCheckByDigest
     * @summary Check policy evaluation status for image
     * @request GET:/images/{image_digest}/check
     * @response `200` `GetImagePolicyCheckByDigestData` Policy evaluation success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImagePolicyCheckByDigest: (
      { imageDigest, ...query }: GetImagePolicyCheckByDigestParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImagePolicyCheckByDigestData, ApiErrorResponse>({
        path: `/images/${imageDigest}/check`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListImageContent
     * @summary List image content types
     * @request GET:/images/{image_digest}/content
     * @response `200` `ListImageContentData` Content listing for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImageContent: (
      { imageDigest }: ListImageContentParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImageContentData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageContentSummary
     * @summary Get image content summary
     * @request GET:/images/{image_digest}/content-summary
     * @response `200` `GetImageContentSummaryData` Content listing for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageContentSummary: (
      { imageDigest }: GetImageContentSummaryParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageContentSummaryData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content-summary`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageContentByTypeFiles
     * @summary Get the content of an image by type files
     * @request GET:/images/{image_digest}/content/files
     * @response `200` `GetImageContentByTypeFilesData` Content of specified type from the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageContentByTypeFiles: (
      { imageDigest }: GetImageContentByTypeFilesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageContentByTypeFilesData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content/files`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageContentByTypeMalware
     * @summary Get the content of an image by type malware
     * @request GET:/images/{image_digest}/content/malware
     * @response `200` `GetImageContentByTypeMalwareData` Content of specified type from the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageContentByTypeMalware: (
      { imageDigest }: GetImageContentByTypeMalwareParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageContentByTypeMalwareData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content/malware`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageContentByTypeJavaPackage
     * @summary Get the content of an image by type java
     * @request GET:/images/{image_digest}/content/java
     * @response `200` `GetImageContentByTypeJavaPackageData` Content of specified type from the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageContentByTypeJavaPackage: (
      { imageDigest }: GetImageContentByTypeJavaPackageParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageContentByTypeJavaPackageData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content/java`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get detailed information about the software licenses for each package contained within an image
     *
     * @tags Images
     * @name GetImageContentByTypeLicense
     * @summary Get package licenses for an image
     * @request GET:/images/{image_digest}/content/licenses
     * @response `200` `GetImageContentByTypeLicenseData` OK
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageContentByTypeLicense: (
      { imageDigest }: GetImageContentByTypeLicenseParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageContentByTypeLicenseData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content/licenses`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageContentByType
     * @summary Get the content of an image by type
     * @request GET:/images/{image_digest}/content/{content_type}
     * @response `200` `GetImageContentByTypeData` Content of specified type from the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageContentByType: (
      { imageDigest, contentType }: GetImageContentByTypeParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageContentByTypeData, ApiErrorResponse>({
        path: `/images/${imageDigest}/content/${contentType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListImageMetadata
     * @summary List image metadata types
     * @request GET:/images/{image_digest}/metadata
     * @response `200` `ListImageMetadataData` Metadata listing for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImageMetadata: (
      { imageDigest }: ListImageMetadataParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImageMetadataData, ApiErrorResponse>({
        path: `/images/${imageDigest}/metadata`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageMetadataByType
     * @summary Get the metadata of an image by type
     * @request GET:/images/{image_digest}/metadata/{metadata_type}
     * @response `200` `GetImageMetadataByTypeData` Metadata of specified type from the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageMetadataByType: (
      { imageDigest, metadataType }: GetImageMetadataByTypeParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageMetadataByTypeData, ApiErrorResponse>({
        path: `/images/${imageDigest}/metadata/${metadataType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageStig
     * @summary Get a specific STIG evaluation for an image
     * @request GET:/images/{image_digest}/stig/{evaluation_uuid}/file
     * @response `200` `GetImageStigData` The STIG evaluation retrieved
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image or STIG evaluation not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageStig: (
      { imageDigest, evaluationUuid }: GetImageStigParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageStigData, ApiErrorResponse>({
        path: `/images/${imageDigest}/stig/${evaluationUuid}/file`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name PutImageStig
     * @summary Update a STIG evaluation for an image
     * @request PUT:/images/{image_digest}/stig/{evaluation_uuid}
     * @response `201` `PutImageStigData` Metadata of the STIG evaluation for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image or STIG evaluation not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    putImageStig: (
      { imageDigest, evaluationUuid }: PutImageStigParams,
      data: PutImageStigPayload,
      params: RequestParams = {},
    ) =>
      this.request<PutImageStigData, ApiErrorResponse>({
        path: `/images/${imageDigest}/stig/${evaluationUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name DeleteImageStig
     * @summary Delete a specific STIG evaluation for an image
     * @request DELETE:/images/{image_digest}/stig/{evaluation_uuid}
     * @response `204` `DeleteImageStigData` STIG evaluation deleted
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image or STIG evaluation not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteImageStig: (
      { imageDigest, evaluationUuid }: DeleteImageStigParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteImageStigData, ApiErrorResponse>({
        path: `/images/${imageDigest}/stig/${evaluationUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name ListImageStig
     * @summary List STIG evaluation metadata for an image
     * @request GET:/images/{image_digest}/stig
     * @response `200` `ListImageStigData` List of STIG evaluation metadata for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImageStig: (
      { imageDigest }: ListImageStigParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImageStigData, ApiErrorResponse>({
        path: `/images/${imageDigest}/stig`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name PostImageStig
     * @summary Upload a STIG evaluation for an image
     * @request POST:/images/{image_digest}/stig
     * @response `201` `PostImageStigData` Metadata of the STIG evaluation for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    postImageStig: (
      { imageDigest }: PostImageStigParams,
      data: PostImageStigPayload,
      params: RequestParams = {},
    ) =>
      this.request<PostImageStigData, ApiErrorResponse>({
        path: `/images/${imageDigest}/stig`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageSbomCyclonedxJson
     * @summary Get image sbom in the CycloneDX format
     * @request GET:/images/{image_digest}/sboms/cyclonedx-json
     * @response `200` `GetImageSbomCyclonedxJsonData` Image lookup success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageSbomCyclonedxJson: (
      { imageDigest }: GetImageSbomCyclonedxJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageSbomCyclonedxJsonData, ApiErrorResponse>({
        path: `/images/${imageDigest}/sboms/cyclonedx-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageSbomNativeJson
     * @summary Get image sbom in the native Anchore format
     * @request GET:/images/{image_digest}/sboms/native-json
     * @response `200` `GetImageSbomNativeJsonData` Image lookup success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageSbomNativeJson: (
      { imageDigest }: GetImageSbomNativeJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageSbomNativeJsonData, ApiErrorResponse>({
        path: `/images/${imageDigest}/sboms/native-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageSbomSpdxJson
     * @summary Get image sbom in the SPDX format
     * @request GET:/images/{image_digest}/sboms/spdx-json
     * @response `200` `GetImageSbomSpdxJsonData` Image lookup success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageSbomSpdxJson: (
      { imageDigest }: GetImageSbomSpdxJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageSbomSpdxJsonData, ApiErrorResponse>({
        path: `/images/${imageDigest}/sboms/spdx-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageVulnerabilityTypes
     * @summary Get vulnerability types
     * @request GET:/images/{image_digest}/vuln
     * @response `200` `GetImageVulnerabilityTypesData` Vulnerability listing for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageVulnerabilityTypes: (
      { imageDigest }: GetImageVulnerabilityTypesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageVulnerabilityTypesData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vuln`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageVulnerabilitiesByDigestCyclonedxJson
     * @summary Get vulnerabilities by type in CycloneDX JSON format
     * @request GET:/images/{image_digest}/vuln/{vuln_type}/cyclonedx-json
     * @response `200` `GetImageVulnerabilitiesByDigestCyclonedxJsonData` A CycloneDX v1.6 Vulnerability Disclosure Report
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageVulnerabilitiesByDigestCyclonedxJson: (
      {
        imageDigest,
        vulnType,
        ...query
      }: GetImageVulnerabilitiesByDigestCyclonedxJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetImageVulnerabilitiesByDigestCyclonedxJsonData,
        ApiErrorResponse
      >({
        path: `/images/${imageDigest}/vuln/${vulnType}/cyclonedx-json`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageVulnerabilitiesByDigestCyclonedxXml
     * @summary Get vulnerabilities by type in CycloneDX XML format
     * @request GET:/images/{image_digest}/vuln/{vuln_type}/cyclonedx-xml
     * @response `200` `GetImageVulnerabilitiesByDigestCyclonedxXmlData` A CycloneDX v1.6 Vulnerability Disclosure Report
     * @response `400` `void` Bad request
     * @response `403` `void` Not permitted
     * @response `404` `void` Image not found
     * @response `500` `void` Internal error
     */
    getImageVulnerabilitiesByDigestCyclonedxXml: (
      {
        imageDigest,
        vulnType,
        ...query
      }: GetImageVulnerabilitiesByDigestCyclonedxXmlParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageVulnerabilitiesByDigestCyclonedxXmlData, void>({
        path: `/images/${imageDigest}/vuln/${vulnType}/cyclonedx-xml`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageVulnerabilitiesByDigest
     * @summary Get vulnerabilities by type
     * @request GET:/images/{image_digest}/vuln/{vuln_type}
     * @response `200` `GetImageVulnerabilitiesByDigestData` Vulnerability listing for the image
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageVulnerabilitiesByDigest: (
      {
        imageDigest,
        vulnType,
        ...query
      }: GetImageVulnerabilitiesByDigestParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageVulnerabilitiesByDigestData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vuln/${vulnType}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageOpenvex
     * @summary Get image VEX document in the OpenVEX format
     * @request GET:/images/{image_digest}/vex/openvex
     * @response `200` `GetImageOpenvexData` Image lookup success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageOpenvex: (
      { imageDigest }: GetImageOpenvexParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageOpenvexData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vex/openvex`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageCyclonedxJson
     * @summary Get image VEX document in the CycloneDX JSON format
     * @request GET:/images/{image_digest}/vex/cyclonedx-json
     * @response `200` `GetImageCyclonedxJsonData` Image lookup success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageCyclonedxJson: (
      { imageDigest }: GetImageCyclonedxJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageCyclonedxJsonData, ApiErrorResponse>({
        path: `/images/${imageDigest}/vex/cyclonedx-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImageCyclonedxXml
     * @summary Get image VEX document in the CycloneDX XML format
     * @request GET:/images/{image_digest}/vex/cyclonedx-xml
     * @response `200` `GetImageCyclonedxXmlData` Image lookup success
     * @response `400` `void` Bad request
     * @response `403` `void` Not permitted
     * @response `404` `void` Image not found
     * @response `500` `void` Internal error
     */
    getImageCyclonedxXml: (
      { imageDigest }: GetImageCyclonedxXmlParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImageCyclonedxXmlData, void>({
        path: `/images/${imageDigest}/vex/cyclonedx-xml`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name GetImage
     * @summary Get image metadata
     * @request GET:/images/{image_digest}
     * @response `200` `GetImageData` Image lookup success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImage: ({ imageDigest }: GetImageParams, params: RequestParams = {}) =>
      this.request<GetImageData, ApiErrorResponse>({
        path: `/images/${imageDigest}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Images
     * @name DeleteImage
     * @summary Delete an image analysis
     * @request DELETE:/images/{image_digest}
     * @response `200` `DeleteImageData` Image deletion success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Image not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteImage: (
      { imageDigest, ...query }: DeleteImageParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteImageData, ApiErrorResponse>({
        path: `/images/${imageDigest}`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  imports = {
    /**
     * No description
     *
     * @tags Imports
     * @name ListOperations
     * @summary Lists in-progress imports
     * @request GET:/imports/images
     * @response `200` `ListOperationsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listOperations: (params: RequestParams = {}) =>
      this.request<ListOperationsData, ApiErrorResponse>({
        path: `/imports/images`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name CreateOperation
     * @summary Begin the import of an image SBOM into the system
     * @request POST:/imports/images
     * @response `200` `CreateOperationData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    createOperation: (params: RequestParams = {}) =>
      this.request<CreateOperationData, ApiErrorResponse>({
        path: `/imports/images`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportContentSearches
     * @summary List uploaded content search results
     * @request GET:/imports/images/{operation_id}/content-searches
     * @response `200` `ListImportContentSearchesData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportContentSearches: (
      { operationId }: ListImportContentSearchesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportContentSearchesData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/content-searches`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportContentSearches
     * @summary Import a content search analysis catalog
     * @request POST:/imports/images/{operation_id}/content-searches
     * @response `200` `ImportContentSearchesData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    importContentSearches: (
      { operationId }: ImportContentSearchesParams,
      data: ImportContentSearchesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportContentSearchesData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/content-searches`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportDockerfiles
     * @summary List uploaded dockerfiles
     * @request GET:/imports/images/{operation_id}/dockerfile
     * @response `200` `ListImportDockerfilesData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportDockerfiles: (
      { operationId }: ListImportDockerfilesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportDockerfilesData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/dockerfile`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImageDockerfile
     * @summary Begin the import of an image analyzed by Syft into the system
     * @request POST:/imports/images/{operation_id}/dockerfile
     * @response `200` `ImportImageDockerfileData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImageDockerfile: (
      { operationId }: ImportImageDockerfileParams,
      data: ImportImageDockerfilePayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportImageDockerfileData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/dockerfile`,
        method: 'POST',
        body: data,
        type: ContentType.Text,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportFileContents
     * @summary List uploaded file contents
     * @request GET:/imports/images/{operation_id}/file-contents
     * @response `200` `ListImportFileContentsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportFileContents: (
      { operationId }: ListImportFileContentsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportFileContentsData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/file-contents`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportFileContents
     * @summary Import a file contents analysis catalog
     * @request POST:/imports/images/{operation_id}/file-contents
     * @response `200` `ImportFileContentsData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importFileContents: (
      { operationId }: ImportFileContentsParams,
      data: ImportFileContentsPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportFileContentsData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/file-contents`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportImageConfigs
     * @summary List uploaded image configs
     * @request GET:/imports/images/{operation_id}/image-config
     * @response `200` `ListImportImageConfigsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportImageConfigs: (
      { operationId }: ListImportImageConfigsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportImageConfigsData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/image-config`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImageConfig
     * @summary Import a docker or OCI image config to associate with the image
     * @request POST:/imports/images/{operation_id}/image-config
     * @response `200` `ImportImageConfigData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImageConfig: (
      { operationId }: ImportImageConfigParams,
      data: ImportImageConfigPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportImageConfigData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/image-config`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportImageManifests
     * @summary List uploaded image manifests
     * @request GET:/imports/images/{operation_id}/manifest
     * @response `200` `ListImportImageManifestsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportImageManifests: (
      { operationId }: ListImportImageManifestsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportImageManifestsData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/manifest`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImageManifest
     * @summary Import a docker or OCI distribution manifest to associate with the image
     * @request POST:/imports/images/{operation_id}/manifest
     * @response `200` `ImportImageManifestData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImageManifest: (
      { operationId }: ImportImageManifestParams,
      data: ImportImageManifestPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportImageManifestData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/manifest`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportImageAnalysisResultManifests
     * @summary List uploaded image analysis metadata manifests
     * @request GET:/imports/images/{operation_id}/analysis_result_manifest
     * @response `200` `ListImportImageAnalysisResultManifestsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportImageAnalysisResultManifests: (
      { operationId }: ListImportImageAnalysisResultManifestsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListImportImageAnalysisResultManifestsData,
        ApiErrorResponse
      >({
        path: `/imports/images/${operationId}/analysis_result_manifest`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImageAnalysisResultManifest
     * @summary Import a image analysis manifest to associate with the image
     * @request POST:/imports/images/{operation_id}/analysis_result_manifest
     * @response `200` `ImportImageAnalysisResultManifestData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImageAnalysisResultManifest: (
      { operationId }: ImportImageAnalysisResultManifestParams,
      data: ImportImageAnalysisResultManifestPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportImageAnalysisResultManifestData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/analysis_result_manifest`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportPackages
     * @summary List uploaded package manifests
     * @request GET:/imports/images/{operation_id}/packages
     * @response `200` `ListImportPackagesData` success
     * @response `500` `void` Internal Error
     */
    listImportPackages: (
      { operationId }: ListImportPackagesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportPackagesData, void>({
        path: `/imports/images/${operationId}/packages`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImagePackages
     * @summary Begin the import of an image analyzed by Syft into the system
     * @request POST:/imports/images/{operation_id}/packages
     * @response `200` `ImportImagePackagesData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImagePackages: (
      { operationId }: ImportImagePackagesParams,
      data: ImagePackageManifest,
      params: RequestParams = {},
    ) =>
      this.request<ImportImagePackagesData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/packages`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportParentManifests
     * @summary List uploaded parent manifests (manifest lists for a tag)
     * @request GET:/imports/images/{operation_id}/parent-manifest
     * @response `200` `ListImportParentManifestsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportParentManifests: (
      { operationId }: ListImportParentManifestsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportParentManifestsData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/parent-manifest`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImageParentManifest
     * @summary Import a docker or OCI distribution manifest list to associate with the image
     * @request POST:/imports/images/{operation_id}/parent-manifest
     * @response `200` `ImportImageParentManifestData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImageParentManifest: (
      { operationId }: ImportImageParentManifestParams,
      data: ImportImageParentManifestPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportImageParentManifestData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/parent-manifest`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ListImportSecretSearches
     * @summary List uploaded secret search results
     * @request GET:/imports/images/{operation_id}/secret-searches
     * @response `200` `ListImportSecretSearchesData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listImportSecretSearches: (
      { operationId }: ListImportSecretSearchesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListImportSecretSearchesData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/secret-searches`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportSecretSearches
     * @summary Import a secret search analysis catalog
     * @request POST:/imports/images/{operation_id}/secret-searches
     * @response `200` `ImportSecretSearchesData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    importSecretSearches: (
      { operationId }: ImportSecretSearchesParams,
      data: ImportSecretSearchesPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportSecretSearchesData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/secret-searches`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name ImportImageSbom
     * @summary Import a Syft native SBOM for an image into the system
     * @request POST:/imports/images/{operation_id}/sbom
     * @response `200` `ImportImageSbomData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    importImageSbom: (
      { operationId }: ImportImageSbomParams,
      data: ImportImageSbomPayload,
      params: RequestParams = {},
    ) =>
      this.request<ImportImageSbomData, ApiErrorResponse>({
        path: `/imports/images/${operationId}/sbom`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name GetOperation
     * @summary Get detail on a single import
     * @request GET:/imports/images/{operation_id}
     * @response `200` `GetOperationData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getOperation: (
      { operationId }: GetOperationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetOperationData, ApiErrorResponse>({
        path: `/imports/images/${operationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Imports
     * @name InvalidateOperation
     * @summary Invalidate operation ID so it can be garbage collected
     * @request DELETE:/imports/images/{operation_id}
     * @response `200` `InvalidateOperationData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    invalidateOperation: (
      { operationId }: InvalidateOperationParams,
      params: RequestParams = {},
    ) =>
      this.request<InvalidateOperationData, ApiErrorResponse>({
        path: `/imports/images/${operationId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Lists in-progress imports
     *
     * @tags Imports
     * @name ListSourcesOperations
     * @summary Lists in-progress imports
     * @request GET:/imports/sources
     * @deprecated
     * @response `200` `ListSourcesOperationsData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSourcesOperations: (params: RequestParams = {}) =>
      this.request<ListSourcesOperationsData, ApiErrorResponse>({
        path: `/imports/sources`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Begin the import of a source code repository analyzed by Syft into the system
     *
     * @tags Imports
     * @name CreateSourcesOperation
     * @summary Begin the import of a source code repository analyzed by Syft into the system
     * @request POST:/imports/sources
     * @deprecated
     * @response `200` `CreateSourcesOperationData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    createSourcesOperation: (params: RequestParams = {}) =>
      this.request<CreateSourcesOperationData, ApiErrorResponse>({
        path: `/imports/sources`,
        method: 'POST',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Add source records to catalog db
     *
     * @tags Imports
     * @name FinalizeOperation
     * @summary Add source records to catalog db
     * @request POST:/imports/sources/{operation_id}/finalize
     * @deprecated
     * @response `200` `FinalizeOperationData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    finalizeOperation: (
      { operationId }: FinalizeOperationParams,
      data: SourceImportMetadata,
      params: RequestParams = {},
    ) =>
      this.request<FinalizeOperationData, ApiErrorResponse>({
        path: `/imports/sources/${operationId}/finalize`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. list the packages of an imported source code repository
     *
     * @tags Imports
     * @name GetImportSourcesSbom
     * @summary list the packages of an imported source code repository
     * @request GET:/imports/sources/{operation_id}/sbom
     * @deprecated
     * @response `200` `GetImportSourcesSbomData` success
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImportSourcesSbom: (
      { operationId }: GetImportSourcesSbomParams,
      params: RequestParams = {},
    ) =>
      this.request<GetImportSourcesSbomData, ApiErrorResponse>({
        path: `/imports/sources/${operationId}/sbom`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Begin the import of a source code repository analyzed by Syft into the system
     *
     * @tags Imports
     * @name UploadImportSourcesSbom
     * @summary Begin the import of a source code repository analyzed by Syft into the system
     * @request POST:/imports/sources/{operation_id}/sbom
     * @deprecated
     * @response `200` `UploadImportSourcesSbomData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    uploadImportSourcesSbom: (
      { operationId }: UploadImportSourcesSbomParams,
      data: NativeSBOM,
      params: RequestParams = {},
    ) =>
      this.request<UploadImportSourcesSbomData, ApiErrorResponse>({
        path: `/imports/sources/${operationId}/sbom`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get detail on a single import
     *
     * @tags Imports
     * @name GetSourcesOperation
     * @summary Get detail on a single import
     * @request GET:/imports/sources/{operation_id}
     * @deprecated
     * @response `200` `GetSourcesOperationData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourcesOperation: (
      { operationId }: GetSourcesOperationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourcesOperationData, ApiErrorResponse>({
        path: `/imports/sources/${operationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Invalidate operation ID so it can be garbage collected
     *
     * @tags Imports
     * @name InvalidateSourcesOperation
     * @summary Invalidate operation ID so it can be garbage collected
     * @request DELETE:/imports/sources/{operation_id}
     * @deprecated
     * @response `200` `InvalidateSourcesOperationData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    invalidateSourcesOperation: (
      { operationId }: InvalidateSourcesOperationParams,
      params: RequestParams = {},
    ) =>
      this.request<InvalidateSourcesOperationData, ApiErrorResponse>({
        path: `/imports/sources/${operationId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  inventories = {
    /**
     * @description Returns a list of the images that are in use
     *
     * @tags Inventories
     * @name GetImageInventory
     * @summary Return a list of the images in inventories for this account
     * @request GET:/inventories
     * @response `200` `GetImageInventoryData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getImageInventory: (
      query: GetImageInventoryParams = {},
      params: RequestParams = {},
    ) =>
      this.request<GetImageInventoryData, ApiErrorResponse>({
        path: `/inventories`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete runtime inventory by type and context
     *
     * @tags Inventories
     * @name DeleteInventory
     * @summary Delete runtime inventory by type and context
     * @request DELETE:/inventories
     * @response `204` `DeleteInventoryData` Successfully deleted runtime inventory
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Inventory not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteInventory: (
      query: DeleteInventoryParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteInventoryData, ApiErrorResponse>({
        path: `/inventories`,
        method: 'DELETE',
        query: query,
        ...params,
      }),
  };
  kubernetesContainers = {
    /**
     * @description Return a list of Kubernetes containers that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesContainers
     * @summary Return a list of Kubernetes containers that have been inventoried for this account
     * @request GET:/kubernetes-containers
     * @response `200` `GetKubernetesContainersData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesContainers: (
      query: GetKubernetesContainersParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesContainersData, ApiErrorResponse>({
        path: `/kubernetes-containers`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  kubernetesInventory = {
    /**
     * @description Add container metadata from a Kubernetes deployment
     *
     * @tags Inventories
     * @name PostKubernetesInventory
     * @summary Add container metadata from a Kubernetes deployment
     * @request POST:/kubernetes-inventory
     * @response `201` `PostKubernetesInventoryData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    postKubernetesInventory: (
      data: KubernetesInventory,
      params: RequestParams = {},
    ) =>
      this.request<PostKubernetesInventoryData, ApiErrorResponse>({
        path: `/kubernetes-inventory`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  kubernetesNamespaces = {
    /**
     * @description Return a list of Kubernetes namespaces that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesNamespaces
     * @summary Return a list of Kubernetes namespaces that have been inventoried for this account
     * @request GET:/kubernetes-namespaces
     * @response `200` `GetKubernetesNamespacesData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesNamespaces: (
      query: GetKubernetesNamespacesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesNamespacesData, ApiErrorResponse>({
        path: `/kubernetes-namespaces`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Kubernetes namespaces for a given criteria
     *
     * @tags Inventories
     * @name DeleteKubernetesNamespaces
     * @summary Delete Kubernetes namespaces for a given criteria
     * @request DELETE:/kubernetes-namespaces
     * @response `204` `DeleteKubernetesNamespacesData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteKubernetesNamespaces: (
      query: DeleteKubernetesNamespacesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<DeleteKubernetesNamespacesData, ApiErrorResponse>({
        path: `/kubernetes-namespaces`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Return Kubernetes namespace that has been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesNamespace
     * @summary Return a Kubernetes namespace that has been inventoried for this account
     * @request GET:/kubernetes-namespaces/{namespace_id}
     * @response `200` `GetKubernetesNamespaceData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesNamespace: (
      { namespaceId }: GetKubernetesNamespaceParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesNamespaceData, ApiErrorResponse>({
        path: `/kubernetes-namespaces/${namespaceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  kubernetesNodes = {
    /**
     * @description Return a list of Kubernetes nodes that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesNodes
     * @summary Return a list of Kubernetes nodes that have been inventoried for this account
     * @request GET:/kubernetes-nodes
     * @response `200` `GetKubernetesNodesData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesNodes: (
      query: GetKubernetesNodesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesNodesData, ApiErrorResponse>({
        path: `/kubernetes-nodes`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return Kubernetes node that has been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesNode
     * @summary Return a Kubernetes node that has been inventoried for this account
     * @request GET:/kubernetes-nodes/{node_id}
     * @response `200` `GetKubernetesNodeData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesNode: (
      { nodeId }: GetKubernetesNodeParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesNodeData, ApiErrorResponse>({
        path: `/kubernetes-nodes/${nodeId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  kubernetesPods = {
    /**
     * @description Return a list of Kubernetes pods that have been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesPods
     * @summary Return a list of Kubernetes pods that have been inventoried for this account
     * @request GET:/kubernetes-pods
     * @response `200` `GetKubernetesPodsData` success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesPods: (
      query: GetKubernetesPodsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesPodsData, ApiErrorResponse>({
        path: `/kubernetes-pods`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return a Kubernetes pod that has been inventoried for this account
     *
     * @tags Inventories
     * @name GetKubernetesPod
     * @summary Return a Kubernetes pod that has been inventoried for this account
     * @request GET:/kubernetes-pods/{pod_id}
     * @response `200` `GetKubernetesPodData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getKubernetesPod: (
      { podId }: GetKubernetesPodParams,
      params: RequestParams = {},
    ) =>
      this.request<GetKubernetesPodData, ApiErrorResponse>({
        path: `/kubernetes-pods/${podId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  myUserGroups = {
    /**
     * No description
     *
     * @tags Identity
     * @name ListMyUserGroups
     * @summary List user groups for the authenticated user
     * @request GET:/my-user-groups
     * @response `200` `ListMyUserGroupsData` User group list
     * @response `500` `ApiErrorResponse` Internal error
     */
    listMyUserGroups: (params: RequestParams = {}) =>
      this.request<ListMyUserGroupsData, ApiErrorResponse>({
        path: `/my-user-groups`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  notifications = {
    /**
     * @description List the system installed notification endpoints
     *
     * @tags Notifications
     * @name ListEndpoints
     * @request GET:/notifications/endpoints
     * @response `200` `ListEndpointsData` Listing of endpoint status objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listEndpoints: (params: RequestParams = {}) =>
      this.request<ListEndpointsData, ApiErrorResponse>({
        path: `/notifications/endpoints`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description List GitHub endpoint configurations
     *
     * @tags Notifications
     * @name ListGithubConfigurations
     * @request GET:/notifications/endpoints/github/configurations
     * @response `200` `ListGithubConfigurationsData` List of GitHub endpoint configuration objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listGithubConfigurations: (params: RequestParams = {}) =>
      this.request<ListGithubConfigurationsData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new GitHub endpoint configuration
     *
     * @tags Notifications
     * @name AddGithubConfiguration
     * @request POST:/notifications/endpoints/github/configurations
     * @response `200` `AddGithubConfigurationData` Newly created GitHub endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addGithubConfiguration: (
      data: NotificationGitHubEndpointConfigurationPost,
      params: RequestParams = {},
    ) =>
      this.request<AddGithubConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a selector mapped to a GitHub endpoint configuration
     *
     * @tags Notifications
     * @name GetGithubSelector
     * @request GET:/notifications/endpoints/github/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `GetGithubSelectorData` Selector object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getGithubSelector: (
      { configurationUuid, selectorUuid }: GetGithubSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<GetGithubSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a selector mapped to a GitHub endpoint configuration
     *
     * @tags Notifications
     * @name UpdateGithubSelector
     * @request PUT:/notifications/endpoints/github/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `UpdateGithubSelectorData` Updated selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateGithubSelector: (
      { configurationUuid, selectorUuid }: UpdateGithubSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<UpdateGithubSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a selector mapped to a GitHub endpoint configuration
     *
     * @tags Notifications
     * @name DeleteGithubSelector
     * @request DELETE:/notifications/endpoints/github/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `DeleteGithubSelectorData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteGithubSelector: (
      { configurationUuid, selectorUuid }: DeleteGithubSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteGithubSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List selectors mapping events for delivery to a GitHub endpoint configuration
     *
     * @tags Notifications
     * @name ListGithubSelectors
     * @request GET:/notifications/endpoints/github/configurations/{uuid}/selectors
     * @response `200` `ListGithubSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listGithubSelectors: (
      { uuid }: ListGithubSelectorsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListGithubSelectorsData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${uuid}/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add selector for mapping events for delivery to a GitHub endpoint configuration
     *
     * @tags Notifications
     * @name AddGithubSelector
     * @request POST:/notifications/endpoints/github/configurations/{uuid}/selectors
     * @response `200` `AddGithubSelectorData` Newly created selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addGithubSelector: (
      { uuid }: AddGithubSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<AddGithubSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${uuid}/selectors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get operational status for a GitHub endpoint configuration
     *
     * @tags Notifications
     * @name GetGithubConfigurationStatus
     * @request GET:/notifications/endpoints/github/configurations/{uuid}/status
     * @response `200` `GetGithubConfigurationStatusData` Status object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getGithubConfigurationStatus: (
      { uuid }: GetGithubConfigurationStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetGithubConfigurationStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${uuid}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test stored GitHub endpoint configuration
     *
     * @tags Notifications
     * @name TestStoredGithubConfiguration
     * @request GET:/notifications/endpoints/github/configurations/{uuid}/test
     * @response `200` `TestStoredGithubConfigurationData` Test result
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    testStoredGithubConfiguration: (
      { uuid }: TestStoredGithubConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<TestStoredGithubConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${uuid}/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a GitHub endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name GetGithubConfiguration
     * @request GET:/notifications/endpoints/github/configurations/{uuid}
     * @response `200` `GetGithubConfigurationData` GitHub endpoint configuration object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getGithubConfiguration: (
      { uuid }: GetGithubConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetGithubConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a GitHub endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name UpdateGithubConfiguration
     * @request PUT:/notifications/endpoints/github/configurations/{uuid}
     * @response `200` `UpdateGithubConfigurationData` Updated GitHub endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateGithubConfiguration: (
      { uuid }: UpdateGithubConfigurationParams,
      data: NotificationGitHubEndpointConfigurationPut,
      params: RequestParams = {},
    ) =>
      this.request<UpdateGithubConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/configurations/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a GitHub endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name DeleteGithubConfiguration
     * @request DELETE:/notifications/endpoints/github/configurations/{uuid}
     * @response `200` `DeleteGithubConfigurationData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` The provided notification configuration UUID was not found
     */
    deleteGithubConfiguration: (
      { uuid }: DeleteGithubConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteGithubConfigurationData, ApiErrorResponse | void>({
        path: `/notifications/endpoints/github/configurations/${uuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Test GitHub endpoint configuration
     *
     * @tags Notifications
     * @name TestGithubConfiguration
     * @request POST:/notifications/endpoints/github/test
     * @response `200` `TestGithubConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    testGithubConfiguration: (
      data: NotificationGitHubEndpointConfigurationPost,
      params: RequestParams = {},
    ) =>
      this.request<TestGithubConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/github/test`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Jira endpoint configurations
     *
     * @tags Notifications
     * @name ListJiraConfigurations
     * @request GET:/notifications/endpoints/jira/configurations
     * @response `200` `ListJiraConfigurationsData` List of Jira endpoint configuration objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listJiraConfigurations: (params: RequestParams = {}) =>
      this.request<ListJiraConfigurationsData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new Jira endpoint configuration
     *
     * @tags Notifications
     * @name AddJiraConfiguration
     * @request POST:/notifications/endpoints/jira/configurations
     * @response `200` `AddJiraConfigurationData` Newly created Jira endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addJiraConfiguration: (
      data: NotificationJiraEndpointConfigurationPost,
      params: RequestParams = {},
    ) =>
      this.request<AddJiraConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a selector mapped to a Jira endpoint configuration
     *
     * @tags Notifications
     * @name GetJiraSelector
     * @request GET:/notifications/endpoints/jira/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `GetJiraSelectorData` Selector object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getJiraSelector: (
      { configurationUuid, selectorUuid }: GetJiraSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<GetJiraSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a selector mapped to a Jira endpoint configuration
     *
     * @tags Notifications
     * @name UpdateJiraSelector
     * @request PUT:/notifications/endpoints/jira/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `UpdateJiraSelectorData` Updated selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateJiraSelector: (
      { configurationUuid, selectorUuid }: UpdateJiraSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<UpdateJiraSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a selector mapped to a Jira endpoint configuration
     *
     * @tags Notifications
     * @name DeleteJiraSelector
     * @request DELETE:/notifications/endpoints/jira/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `DeleteJiraSelectorData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteJiraSelector: (
      { configurationUuid, selectorUuid }: DeleteJiraSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteJiraSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List selectors mapping events for delivery to a Jira endpoint configuration
     *
     * @tags Notifications
     * @name ListJiraSelectors
     * @request GET:/notifications/endpoints/jira/configurations/{uuid}/selectors
     * @response `200` `ListJiraSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listJiraSelectors: (
      { uuid }: ListJiraSelectorsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListJiraSelectorsData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${uuid}/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add selector for mapping events for delivery to a Jira endpoint configuration
     *
     * @tags Notifications
     * @name AddJiraSelector
     * @request POST:/notifications/endpoints/jira/configurations/{uuid}/selectors
     * @response `200` `AddJiraSelectorData` Newly created selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addJiraSelector: (
      { uuid }: AddJiraSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<AddJiraSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${uuid}/selectors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get operational status for a Jira endpoint configuration
     *
     * @tags Notifications
     * @name GetJiraConfigurationStatus
     * @request GET:/notifications/endpoints/jira/configurations/{uuid}/status
     * @response `200` `GetJiraConfigurationStatusData` Status object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getJiraConfigurationStatus: (
      { uuid }: GetJiraConfigurationStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetJiraConfigurationStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${uuid}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test stored Jira endpoint configuration
     *
     * @tags Notifications
     * @name TestStoredJiraConfiguration
     * @request GET:/notifications/endpoints/jira/configurations/{uuid}/test
     * @response `200` `TestStoredJiraConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    testStoredJiraConfiguration: (
      { uuid }: TestStoredJiraConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<TestStoredJiraConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${uuid}/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Jira endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name GetJiraConfiguration
     * @request GET:/notifications/endpoints/jira/configurations/{uuid}
     * @response `200` `GetJiraConfigurationData` Jira endpoint configuration object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getJiraConfiguration: (
      { uuid }: GetJiraConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetJiraConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Jira endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name UpdateJiraConfiguration
     * @request PUT:/notifications/endpoints/jira/configurations/{uuid}
     * @response `200` `UpdateJiraConfigurationData` Updated Jira endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateJiraConfiguration: (
      { uuid }: UpdateJiraConfigurationParams,
      data: NotificationJiraEndpointConfigurationPut,
      params: RequestParams = {},
    ) =>
      this.request<UpdateJiraConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/configurations/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Jira endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name DeleteJiraConfiguration
     * @request DELETE:/notifications/endpoints/jira/configurations/{uuid}
     * @response `200` `DeleteJiraConfigurationData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` The provided notification configuration UUID was not found
     */
    deleteJiraConfiguration: (
      { uuid }: DeleteJiraConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteJiraConfigurationData, ApiErrorResponse | void>({
        path: `/notifications/endpoints/jira/configurations/${uuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Test Jira endpoint configuration
     *
     * @tags Notifications
     * @name TestJiraConfiguration
     * @request POST:/notifications/endpoints/jira/test
     * @response `200` `TestJiraConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    testJiraConfiguration: (
      data: NotificationJiraEndpointConfigurationPost,
      params: RequestParams = {},
    ) =>
      this.request<TestJiraConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/jira/test`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Slack endpoint configurations
     *
     * @tags Notifications
     * @name ListSlackConfigurations
     * @request GET:/notifications/endpoints/slack/configurations
     * @response `200` `ListSlackConfigurationsData` List of Slack endpoint configuration objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSlackConfigurations: (params: RequestParams = {}) =>
      this.request<ListSlackConfigurationsData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new Slack endpoint configuration
     *
     * @tags Notifications
     * @name AddSlackConfiguration
     * @request POST:/notifications/endpoints/slack/configurations
     * @response `200` `AddSlackConfigurationData` Newly created Slack endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addSlackConfiguration: (
      data: NotificationSlackEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<AddSlackConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a selector mapped to a Slack endpoint configuration
     *
     * @tags Notifications
     * @name GetSlackSelector
     * @request GET:/notifications/endpoints/slack/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `GetSlackSelectorData` Selector object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSlackSelector: (
      { configurationUuid, selectorUuid }: GetSlackSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSlackSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a selector mapped to a Slack endpoint configuration
     *
     * @tags Notifications
     * @name UpdateSlackSelector
     * @request PUT:/notifications/endpoints/slack/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `UpdateSlackSelectorData` Updated selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateSlackSelector: (
      { configurationUuid, selectorUuid }: UpdateSlackSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSlackSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a selector mapped to a Slack endpoint configuration
     *
     * @tags Notifications
     * @name DeleteSlackSelector
     * @request DELETE:/notifications/endpoints/slack/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `DeleteSlackSelectorData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteSlackSelector: (
      { configurationUuid, selectorUuid }: DeleteSlackSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSlackSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List selectors mapping events for delivery to a Slack endpoint configuration
     *
     * @tags Notifications
     * @name ListSlackSelectors
     * @request GET:/notifications/endpoints/slack/configurations/{uuid}/selectors
     * @response `200` `ListSlackSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSlackSelectors: (
      { uuid }: ListSlackSelectorsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListSlackSelectorsData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${uuid}/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add selector for mapping events for delivery to a Slack endpoint configuration
     *
     * @tags Notifications
     * @name AddSlackSelector
     * @request POST:/notifications/endpoints/slack/configurations/{uuid}/selectors
     * @response `200` `AddSlackSelectorData` Newly created selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addSlackSelector: (
      { uuid }: AddSlackSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<AddSlackSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${uuid}/selectors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get operational status for a Slack endpoint configuration
     *
     * @tags Notifications
     * @name GetSlackConfigurationStatus
     * @request GET:/notifications/endpoints/slack/configurations/{uuid}/status
     * @response `200` `GetSlackConfigurationStatusData` Status object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSlackConfigurationStatus: (
      { uuid }: GetSlackConfigurationStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSlackConfigurationStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${uuid}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test stored Slack endpoint configuration
     *
     * @tags Notifications
     * @name TestStoredSlackConfiguration
     * @request GET:/notifications/endpoints/slack/configurations/{uuid}/test
     * @response `200` `TestStoredSlackConfigurationData` Test result
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    testStoredSlackConfiguration: (
      { uuid }: TestStoredSlackConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<TestStoredSlackConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${uuid}/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Slack endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name GetSlackConfiguration
     * @request GET:/notifications/endpoints/slack/configurations/{uuid}
     * @response `200` `GetSlackConfigurationData` Slack endpoint configuration object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSlackConfiguration: (
      { uuid }: GetSlackConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSlackConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Slack endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name UpdateSlackConfiguration
     * @request PUT:/notifications/endpoints/slack/configurations/{uuid}
     * @response `200` `UpdateSlackConfigurationData` Updated Slack endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateSlackConfiguration: (
      { uuid }: UpdateSlackConfigurationParams,
      data: NotificationSlackEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSlackConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/configurations/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Slack endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name DeleteSlackConfiguration
     * @request DELETE:/notifications/endpoints/slack/configurations/{uuid}
     * @response `200` `DeleteSlackConfigurationData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` The provided notification configuration UUID was not found
     */
    deleteSlackConfiguration: (
      { uuid }: DeleteSlackConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSlackConfigurationData, ApiErrorResponse | void>({
        path: `/notifications/endpoints/slack/configurations/${uuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Test Slack endpoint configuration
     *
     * @tags Notifications
     * @name TestSlackConfiguration
     * @request POST:/notifications/endpoints/slack/test
     * @response `200` `TestSlackConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    testSlackConfiguration: (
      data: NotificationSlackEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<TestSlackConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/slack/test`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List SMTP endpoint configurations
     *
     * @tags Notifications
     * @name ListSmtpConfigurations
     * @request GET:/notifications/endpoints/smtp/configurations
     * @response `200` `ListSmtpConfigurationsData` List of SMTP endpoint configuration objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSmtpConfigurations: (params: RequestParams = {}) =>
      this.request<ListSmtpConfigurationsData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new SMTP endpoint configuration
     *
     * @tags Notifications
     * @name AddSmtpConfiguration
     * @request POST:/notifications/endpoints/smtp/configurations
     * @response `200` `AddSmtpConfigurationData` Newly created SMTP endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addSmtpConfiguration: (
      data: NotificationSMTPEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<AddSmtpConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a selector mapped to a SMTP endpoint configuration
     *
     * @tags Notifications
     * @name GetSmtpSelector
     * @request GET:/notifications/endpoints/smtp/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `GetSmtpSelectorData` Selector object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSmtpSelector: (
      { configurationUuid, selectorUuid }: GetSmtpSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSmtpSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a selector mapped to a SMTP endpoint configuration
     *
     * @tags Notifications
     * @name UpdateSmtpSelector
     * @request PUT:/notifications/endpoints/smtp/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `UpdateSmtpSelectorData` Updated selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateSmtpSelector: (
      { configurationUuid, selectorUuid }: UpdateSmtpSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSmtpSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a selector mapped to a SMTP endpoint configuration
     *
     * @tags Notifications
     * @name DeleteSmtpSelector
     * @request DELETE:/notifications/endpoints/smtp/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `DeleteSmtpSelectorData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteSmtpSelector: (
      { configurationUuid, selectorUuid }: DeleteSmtpSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSmtpSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List selectors mapping events for delivery to a SMTP endpoint configuration
     *
     * @tags Notifications
     * @name ListSmtpSelectors
     * @request GET:/notifications/endpoints/smtp/configurations/{uuid}/selectors
     * @response `200` `ListSmtpSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSmtpSelectors: (
      { uuid }: ListSmtpSelectorsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListSmtpSelectorsData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add selector for mapping events for delivery to a SMTP endpoint configuration
     *
     * @tags Notifications
     * @name AddSmtpSelector
     * @request POST:/notifications/endpoints/smtp/configurations/{uuid}/selectors
     * @response `200` `AddSmtpSelectorData` Newly created selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addSmtpSelector: (
      { uuid }: AddSmtpSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<AddSmtpSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}/selectors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get operational status for a SMTP endpoint configuration
     *
     * @tags Notifications
     * @name GetSmtpConfigurationStatus
     * @request GET:/notifications/endpoints/smtp/configurations/{uuid}/status
     * @response `200` `GetSmtpConfigurationStatusData` Status object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSmtpConfigurationStatus: (
      { uuid }: GetSmtpConfigurationStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSmtpConfigurationStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test stored SMTP endpoint configuration
     *
     * @tags Notifications
     * @name TestStoredSmtpConfiguration
     * @request GET:/notifications/endpoints/smtp/configurations/{uuid}/test
     * @response `200` `TestStoredSmtpConfigurationData` Test result
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    testStoredSmtpConfiguration: (
      { uuid }: TestStoredSmtpConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<TestStoredSmtpConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a SMTP endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name GetSmtpConfiguration
     * @request GET:/notifications/endpoints/smtp/configurations/{uuid}
     * @response `200` `GetSmtpConfigurationData` SMTP endpoint configuration object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSmtpConfiguration: (
      { uuid }: GetSmtpConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSmtpConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a SMTP endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name UpdateSmtpConfiguration
     * @request PUT:/notifications/endpoints/smtp/configurations/{uuid}
     * @response `200` `UpdateSmtpConfigurationData` Updated SMTP endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateSmtpConfiguration: (
      { uuid }: UpdateSmtpConfigurationParams,
      data: NotificationSMTPEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSmtpConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a SMTP endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name DeleteSmtpConfiguration
     * @request DELETE:/notifications/endpoints/smtp/configurations/{uuid}
     * @response `200` `DeleteSmtpConfigurationData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` The provided notification configuration UUID was not found
     */
    deleteSmtpConfiguration: (
      { uuid }: DeleteSmtpConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSmtpConfigurationData, ApiErrorResponse | void>({
        path: `/notifications/endpoints/smtp/configurations/${uuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Test SMTP endpoint configuration
     *
     * @tags Notifications
     * @name TestSmtpConfiguration
     * @request POST:/notifications/endpoints/smtp/test
     * @response `200` `TestSmtpConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    testSmtpConfiguration: (
      data: NotificationSMTPEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<TestSmtpConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/smtp/test`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Teams endpoint configurations
     *
     * @tags Notifications
     * @name ListTeamsConfigurations
     * @request GET:/notifications/endpoints/teams/configurations
     * @response `200` `ListTeamsConfigurationsData` List of Teams endpoint configuration objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listTeamsConfigurations: (params: RequestParams = {}) =>
      this.request<ListTeamsConfigurationsData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new Teams endpoint configuration
     *
     * @tags Notifications
     * @name AddTeamsConfiguration
     * @request POST:/notifications/endpoints/teams/configurations
     * @response `200` `AddTeamsConfigurationData` Newly created Teams endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addTeamsConfiguration: (
      data: NotificationTeamsEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<AddTeamsConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a selector mapped to a Teams endpoint configuration
     *
     * @tags Notifications
     * @name GetTeamsSelector
     * @request GET:/notifications/endpoints/teams/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `GetTeamsSelectorData` Selector object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getTeamsSelector: (
      { configurationUuid, selectorUuid }: GetTeamsSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTeamsSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a selector mapped to a Teams endpoint configuration
     *
     * @tags Notifications
     * @name UpdateTeamsSelector
     * @request PUT:/notifications/endpoints/teams/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `UpdateTeamsSelectorData` Updated selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateTeamsSelector: (
      { configurationUuid, selectorUuid }: UpdateTeamsSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTeamsSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a selector mapped to a Teams endpoint configuration
     *
     * @tags Notifications
     * @name DeleteTeamsSelector
     * @request DELETE:/notifications/endpoints/teams/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `DeleteTeamsSelectorData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteTeamsSelector: (
      { configurationUuid, selectorUuid }: DeleteTeamsSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTeamsSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List selectors mapping events for delivery to a Teams endpoint configuration
     *
     * @tags Notifications
     * @name ListTeamsSelectors
     * @request GET:/notifications/endpoints/teams/configurations/{uuid}/selectors
     * @response `200` `ListTeamsSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listTeamsSelectors: (
      { uuid }: ListTeamsSelectorsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListTeamsSelectorsData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${uuid}/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add selector for mapping events for delivery to a Teams endpoint configuration
     *
     * @tags Notifications
     * @name AddTeamsSelector
     * @request POST:/notifications/endpoints/teams/configurations/{uuid}/selectors
     * @response `200` `AddTeamsSelectorData` Newly created selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addTeamsSelector: (
      { uuid }: AddTeamsSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<AddTeamsSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${uuid}/selectors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get operational status for a Teams endpoint configuration
     *
     * @tags Notifications
     * @name GetTeamsConfigurationStatus
     * @request GET:/notifications/endpoints/teams/configurations/{uuid}/status
     * @response `200` `GetTeamsConfigurationStatusData` Status object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getTeamsConfigurationStatus: (
      { uuid }: GetTeamsConfigurationStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTeamsConfigurationStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${uuid}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test stored Teams endpoint configuration
     *
     * @tags Notifications
     * @name TestStoredTeamsConfiguration
     * @request GET:/notifications/endpoints/teams/configurations/{uuid}/test
     * @response `200` `TestStoredTeamsConfigurationData` Test result
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    testStoredTeamsConfiguration: (
      { uuid }: TestStoredTeamsConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<TestStoredTeamsConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${uuid}/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test Teams endpoint configuration
     *
     * @tags Notifications
     * @name TestTeamsConfiguration
     * @request POST:/notifications/endpoints/teams/test
     * @response `200` `TestTeamsConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    testTeamsConfiguration: (
      data: NotificationTeamsEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<TestTeamsConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/test`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Teams endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name GetTeamsConfiguration
     * @request GET:/notifications/endpoints/teams/configurations/{uuid}
     * @response `200` `GetTeamsConfigurationData` Teams endpoint configuration object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getTeamsConfiguration: (
      { uuid }: GetTeamsConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetTeamsConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Teams endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name UpdateTeamsConfiguration
     * @request PUT:/notifications/endpoints/teams/configurations/{uuid}
     * @response `200` `UpdateTeamsConfigurationData` Updated Teams endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateTeamsConfiguration: (
      { uuid }: UpdateTeamsConfigurationParams,
      data: NotificationTeamsEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<UpdateTeamsConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/teams/configurations/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Teams endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name DeleteTeamsConfiguration
     * @request DELETE:/notifications/endpoints/teams/configurations/{uuid}
     * @response `200` `DeleteTeamsConfigurationData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` The provided notification configuration UUID was not found
     */
    deleteTeamsConfiguration: (
      { uuid }: DeleteTeamsConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteTeamsConfigurationData, ApiErrorResponse | void>({
        path: `/notifications/endpoints/teams/configurations/${uuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List Webhook endpoint configurations
     *
     * @tags Notifications
     * @name ListWebhookConfigurations
     * @request GET:/notifications/endpoints/webhook/configurations
     * @response `200` `ListWebhookConfigurationsData` List of Webhook endpoint configuration objects
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listWebhookConfigurations: (params: RequestParams = {}) =>
      this.request<ListWebhookConfigurationsData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new Webhook endpoint configuration
     *
     * @tags Notifications
     * @name AddWebhookConfiguration
     * @request POST:/notifications/endpoints/webhook/configurations
     * @response `200` `AddWebhookConfigurationData` Newly created Webhook endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addWebhookConfiguration: (
      data: NotificationWebhookEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<AddWebhookConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a selector mapped to a Webhook endpoint configuration
     *
     * @tags Notifications
     * @name GetWebhookSelector
     * @request GET:/notifications/endpoints/webhook/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `GetWebhookSelectorData` Selector object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getWebhookSelector: (
      { configurationUuid, selectorUuid }: GetWebhookSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<GetWebhookSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a selector mapped to a Webhook endpoint configuration
     *
     * @tags Notifications
     * @name UpdateWebhookSelector
     * @request PUT:/notifications/endpoints/webhook/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `UpdateWebhookSelectorData` Updated selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateWebhookSelector: (
      { configurationUuid, selectorUuid }: UpdateWebhookSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<UpdateWebhookSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a selector mapped to a Webhook endpoint configuration
     *
     * @tags Notifications
     * @name DeleteWebhookSelector
     * @request DELETE:/notifications/endpoints/webhook/configurations/{configuration_uuid}/selectors/{selector_uuid}
     * @response `200` `DeleteWebhookSelectorData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteWebhookSelector: (
      { configurationUuid, selectorUuid }: DeleteWebhookSelectorParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteWebhookSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${configurationUuid}/selectors/${selectorUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description List selectors mapping events for delivery to a Webhook endpoint configuration
     *
     * @tags Notifications
     * @name ListWebhookSelectors
     * @request GET:/notifications/endpoints/webhook/configurations/{uuid}/selectors
     * @response `200` `ListWebhookSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listWebhookSelectors: (
      { uuid }: ListWebhookSelectorsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListWebhookSelectorsData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add selector for mapping events for delivery to a Webhook endpoint configuration
     *
     * @tags Notifications
     * @name AddWebhookSelector
     * @request POST:/notifications/endpoints/webhook/configurations/{uuid}/selectors
     * @response `200` `AddWebhookSelectorData` Newly created selector object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addWebhookSelector: (
      { uuid }: AddWebhookSelectorParams,
      data: NotificationSelector,
      params: RequestParams = {},
    ) =>
      this.request<AddWebhookSelectorData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}/selectors`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get operational status for a Webhook endpoint configuration
     *
     * @tags Notifications
     * @name GetWebhookConfigurationStatus
     * @request GET:/notifications/endpoints/webhook/configurations/{uuid}/status
     * @response `200` `GetWebhookConfigurationStatusData` Status object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getWebhookConfigurationStatus: (
      { uuid }: GetWebhookConfigurationStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetWebhookConfigurationStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Test stored Webhook endpoint configuration
     *
     * @tags Notifications
     * @name TestStoredWebhookConfiguration
     * @request GET:/notifications/endpoints/webhook/configurations/{uuid}/test
     * @response `200` `TestStoredWebhookConfigurationData` Test result
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    testStoredWebhookConfiguration: (
      { uuid }: TestStoredWebhookConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<TestStoredWebhookConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}/test`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Webhook endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name GetWebhookConfiguration
     * @request GET:/notifications/endpoints/webhook/configurations/{uuid}
     * @response `200` `GetWebhookConfigurationData` Webhook endpoint configuration object
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getWebhookConfiguration: (
      { uuid }: GetWebhookConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetWebhookConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Webhook endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name UpdateWebhookConfiguration
     * @request PUT:/notifications/endpoints/webhook/configurations/{uuid}
     * @response `200` `UpdateWebhookConfigurationData` Updated Webhook endpoint configuration object
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateWebhookConfiguration: (
      { uuid }: UpdateWebhookConfigurationParams,
      data: NotificationWebhookEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<UpdateWebhookConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Webhook endpoint configuration by it's UUID
     *
     * @tags Notifications
     * @name DeleteWebhookConfiguration
     * @request DELETE:/notifications/endpoints/webhook/configurations/{uuid}
     * @response `200` `DeleteWebhookConfigurationData` Successful delete
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` The provided notification configuration UUID was not found
     */
    deleteWebhookConfiguration: (
      { uuid }: DeleteWebhookConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteWebhookConfigurationData, ApiErrorResponse | void>({
        path: `/notifications/endpoints/webhook/configurations/${uuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Test Webhook endpoint configuration
     *
     * @tags Notifications
     * @name TestWebhookConfiguration
     * @request POST:/notifications/endpoints/webhook/test
     * @response `200` `TestWebhookConfigurationData` Test result
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    testWebhookConfiguration: (
      data: NotificationWebhookEndpointConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<TestWebhookConfigurationData, ApiErrorResponse>({
        path: `/notifications/endpoints/webhook/test`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update enabled status of an endpoint
     *
     * @tags Notifications
     * @name UpdateEndpointStatus
     * @request PUT:/notifications/endpoints/{name}
     * @response `200` `UpdateEndpointStatusData` Updated status record for an endpoint
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateEndpointStatus: (
      { name }: UpdateEndpointStatusParams,
      data: NotificationEndpointEnabledStatus,
      params: RequestParams = {},
    ) =>
      this.request<UpdateEndpointStatusData, ApiErrorResponse>({
        path: `/notifications/endpoints/${name}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all selectors mapped to endpoint configurations for the account
     *
     * @tags Notifications
     * @name ListSelectors
     * @request GET:/notifications/selectors
     * @response `200` `ListSelectorsData` List of selectors
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSelectors: (params: RequestParams = {}) =>
      this.request<ListSelectorsData, ApiErrorResponse>({
        path: `/notifications/selectors`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  oauth = {
    /**
 * @description Revoke a refresh token previously requested from /oauth/token
 *
 * @tags User Management
 * @name RevokeOauthToken
 * @request POST:/oauth/revoke
 * @response `200` `RevokeOauthTokenData` The token has been successfully revoked
 * @response `400` `{
  /** ASCII error code from RFC6749 *\/
    error?: string,

}` Error response
 * @response `401` `void` Revocation of the provided token type is not supported
 * @response `403` `ApiErrorResponse` Not permitted
 * @response `415` `ApiErrorResponse` Unsupported Media Type
 * @response `500` `ApiErrorResponse` Internal error
 */
    revokeOauthToken: (
      data: RevokeOauthTokenPayload,
      params: RequestParams = {},
    ) =>
      this.request<
        RevokeOauthTokenData,
        | {
            /** ASCII error code from RFC6749 */
            error?: string;
          }
        | void
        | ApiErrorResponse
      >({
        path: `/oauth/revoke`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * @description Request a jwt token for subsequent operations, this request is authenticated with normal HTTP auth
     *
     * @tags User Management
     * @name GetOauthToken
     * @request POST:/oauth/token
     * @response `200` `GetOauthTokenData` Resulting JWT token
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    getOauthToken: (data: GetOauthTokenPayload, params: RequestParams = {}) =>
      this.request<GetOauthTokenData, ApiErrorResponse>({
        path: `/oauth/token`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        format: 'json',
        ...params,
      }),
  };
  policies = {
    /**
     * @description List all saved policies
     *
     * @tags Policies
     * @name ListPolicies
     * @summary List policies
     * @request GET:/policies
     * @response `200` `ListPoliciesData` Policy listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listPolicies: (
      query: ListPoliciesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListPoliciesData, ApiErrorResponse>({
        path: `/policies`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Adds a new policy to the system
     *
     * @tags Policies
     * @name AddPolicy
     * @summary Add a new policy
     * @request POST:/policies
     * @response `200` `AddPolicyData` Saved policy
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `409` `ApiErrorResponse` Policy already exists
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addPolicy: (data: Policy, params: RequestParams = {}) =>
      this.request<AddPolicyData, ApiErrorResponse>({
        path: `/policies`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the policy metadata and document for a specific policy
     *
     * @tags Policies
     * @name GetPolicy
     * @summary Get specific policy
     * @request GET:/policies/{policy_id}
     * @response `200` `GetPolicyData` A single fetched policy record
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getPolicy: (
      { policyId, ...query }: GetPolicyParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPolicyData, ApiErrorResponse>({
        path: `/policies/${policyId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update/replace and existing policy
     *
     * @tags Policies
     * @name UpdatePolicy
     * @summary Update policy
     * @request PUT:/policies/{policy_id}
     * @response `200` `UpdatePolicyData` A single updated policy record
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updatePolicy: (
      { policyId, ...query }: UpdatePolicyParams,
      data: PolicyRecord,
      params: RequestParams = {},
    ) =>
      this.request<UpdatePolicyData, ApiErrorResponse>({
        path: `/policies/${policyId}`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete the specified policy
     *
     * @tags Policies
     * @name DeletePolicy
     * @summary Delete policy
     * @request DELETE:/policies/{policy_id}
     * @response `204` `DeletePolicyData` Delete success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Policy not found to delete
     * @response `409` `ApiErrorResponse` Policy cannot be deleted in its current state (e.g. in use by one or more applications)
     * @response `500` `ApiErrorResponse` Internal Error
     * @response `503` `ApiErrorResponse` Service temporarily unavailable
     */
    deletePolicy: (
      { policyId }: DeletePolicyParams,
      params: RequestParams = {},
    ) =>
      this.request<DeletePolicyData, ApiErrorResponse>({
        path: `/policies/${policyId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  query = {
    /**
     * @description Filterable query interface to search for images containing specified package
     *
     * @tags Query
     * @name QueryImagesByPackage
     * @summary List of images containing given package
     * @request GET:/query/images/by-package
     * @response `200` `QueryImagesByPackageData` Image listing
     * @response `400` `ApiErrorResponse` Bad filter parameters
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    queryImagesByPackage: (
      query: QueryImagesByPackageParams,
      params: RequestParams = {},
    ) =>
      this.request<QueryImagesByPackageData, ApiErrorResponse>({
        path: `/query/images/by-package`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List (w/filters) vulnerability records known by the system, with affected packages information if present
     *
     * @tags Query
     * @name QueryVulnerabilities
     * @summary Listing information about given vulnerability
     * @request GET:/query/vulnerabilities
     * @response `200` `QueryVulnerabilitiesData` Vulnerability listing paginated
     * @response `400` `ApiErrorResponse` Invalid filter parameters
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    queryVulnerabilities: (
      query: QueryVulnerabilitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<QueryVulnerabilitiesData, ApiErrorResponse>({
        path: `/query/vulnerabilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  rbacManager = {
    /**
     * No description
     *
     * @tags RBAC
     * @name MyRoles
     * @summary List the roles for which the authenticated user is a member
     * @request GET:/rbac-manager/my-roles
     * @response `200` `MyRolesData` Role summary listing
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    myRoles: (params: RequestParams = {}) =>
      this.request<MyRolesData, RbacManagerApiErrorResponse>({
        path: `/rbac-manager/my-roles`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RBAC
     * @name ListRoles
     * @summary List roles available in the system
     * @request GET:/rbac-manager/roles
     * @response `200` `ListRolesData` Role summary listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    listRoles: (params: RequestParams = {}) =>
      this.request<
        ListRolesData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/roles`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RBAC
     * @name ListRoleMembers
     * @summary Returns a list of objects that have members in the role. The list is filtered by 'listRoleMembers' access for the 'account' element of each entry.
     * @request GET:/rbac-manager/roles/{role_name}/members
     * @response `200` `ListRoleMembersData` List of users assigned the role
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    listRoleMembers: (
      { roleName, ...query }: ListRoleMembersParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListRoleMembersData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/roles/${roleName}/members`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RBAC
     * @name AddRoleUser
     * @summary Add a user to the role
     * @request POST:/rbac-manager/roles/{role_name}/members
     * @response `200` `AddRoleUserData` Added user mapping
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    addRoleUser: (
      { roleName }: AddRoleUserParams,
      data: RbacManagerRoleMember,
      params: RequestParams = {},
    ) =>
      this.request<
        AddRoleUserData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/roles/${roleName}/members`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags RBAC
     * @name DeleteRoleUser
     * @summary Remove a user from the role
     * @request DELETE:/rbac-manager/roles/{role_name}/members
     * @response `204` `DeleteRoleUserData` Success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    deleteRoleUser: (
      { roleName, ...query }: DeleteRoleUserParams,
      params: RequestParams = {},
    ) =>
      this.request<
        DeleteRoleUserData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/roles/${roleName}/members`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags RBAC
     * @name GetRole
     * @summary Get detailed information about a specific role
     * @request GET:/rbac-manager/roles/{role_name}
     * @response `200` `GetRoleData` Role details
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    getRole: ({ roleName }: GetRoleParams, params: RequestParams = {}) =>
      this.request<GetRoleData, ApiErrorResponse | RbacManagerApiErrorResponse>(
        {
          path: `/rbac-manager/roles/${roleName}`,
          method: 'GET',
          format: 'json',
          ...params,
        },
      ),

    /**
     * @description List the names of configured Identity Providers for this anchore installation
     *
     * @tags RBAC
     * @name ListIdps
     * @request GET:/rbac-manager/saml/idps
     * @response `200` `ListIdpsData` List of idp names
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    listIdps: (params: RequestParams = {}) =>
      this.request<ListIdpsData, RbacManagerApiErrorResponse>({
        path: `/rbac-manager/saml/idps`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Add a new Identity Provider to the system, with a specific name
     *
     * @tags RBAC
     * @name AddIdp
     * @request POST:/rbac-manager/saml/idps
     * @response `200` `AddIdpData` Entry created
     * @response `400` `ApiErrorResponse` Bad request
     * @response `409` `RbacManagerApiErrorResponse` Conflict, entry already exists
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    addIdp: (data: RbacManagerSamlConfiguration, params: RequestParams = {}) =>
      this.request<AddIdpData, ApiErrorResponse | RbacManagerApiErrorResponse>({
        path: `/rbac-manager/saml/idps`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Return the list of user groups associated with an IdP
     *
     * @tags RBAC
     * @name GetIdpUserGroups
     * @request GET:/rbac-manager/saml/idps/{name}/user-group-mappings
     * @response `200` `GetIdpUserGroupsData` Successfully retrieved configuration
     * @response `404` `RbacManagerApiErrorResponse` Not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    getIdpUserGroups: (
      { name }: GetIdpUserGroupsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIdpUserGroupsData, RbacManagerApiErrorResponse>({
        path: `/rbac-manager/saml/idps/${name}/user-group-mappings`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Associate a user group with an IdP.
     *
     * @tags RBAC
     * @name AddIdpUserGroups
     * @request POST:/rbac-manager/saml/idps/{name}/user-group-mappings
     * @response `200` `AddIdpUserGroupsData` Successfully associated user group with IdP
     * @response `400` `RbacManagerApiErrorResponse` Bad request
     * @response `404` `RbacManagerApiErrorResponse` Not found
     * @response `409` `RbacManagerApiErrorResponse` Conflict, entry already exists
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    addIdpUserGroups: (
      { name }: AddIdpUserGroupsParams,
      data: RbacManagerIdpUserGroupPost,
      params: RequestParams = {},
    ) =>
      this.request<AddIdpUserGroupsData, RbacManagerApiErrorResponse>({
        path: `/rbac-manager/saml/idps/${name}/user-group-mappings`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove user group association(s) from an IdP
     *
     * @tags RBAC
     * @name DeleteIdpUserGroup
     * @request DELETE:/rbac-manager/saml/idps/{name}/user-group-mappings
     * @response `204` `DeleteIdpUserGroupData` Successfully removed user group association from IdP
     * @response `400` `RbacManagerApiErrorResponse` Bad request
     * @response `404` `RbacManagerApiErrorResponse` Not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    deleteIdpUserGroup: (
      { name, ...query }: DeleteIdpUserGroupParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteIdpUserGroupData, RbacManagerApiErrorResponse>({
        path: `/rbac-manager/saml/idps/${name}/user-group-mappings`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Return the configuration for a named Identity Provider
     *
     * @tags RBAC
     * @name GetIdp
     * @request GET:/rbac-manager/saml/idps/{name}
     * @response `200` `GetIdpData` Successfully retrieved configuration
     * @response `404` `RbacManagerApiErrorResponse` Not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    getIdp: ({ name }: GetIdpParams, params: RequestParams = {}) =>
      this.request<GetIdpData, RbacManagerApiErrorResponse>({
        path: `/rbac-manager/saml/idps/${name}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update an existing Identity Provider configuration
     *
     * @tags RBAC
     * @name UpdateIdp
     * @request PUT:/rbac-manager/saml/idps/{name}
     * @response `200` `UpdateIdpData` Successfully updated configuration
     * @response `400` `RbacManagerApiErrorResponse` Not found
     * @response `404` `RbacManagerApiErrorResponse` Not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    updateIdp: (
      { name }: UpdateIdpParams,
      data: RbacManagerSamlConfiguration,
      params: RequestParams = {},
    ) =>
      this.request<
        UpdateIdpData,
        RbacManagerApiErrorResponse | ApiErrorResponse
      >({
        path: `/rbac-manager/saml/idps/${name}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete an idp configuration. Users will not longer be able to login from this idp. In addition, any users that have been configured explicitly or JIT Provisioned on this IDP will be deleted.
     *
     * @tags RBAC
     * @name DeleteIdp
     * @request DELETE:/rbac-manager/saml/idps/{name}
     * @response `204` `DeleteIdpData` Successfully deleted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    deleteIdp: ({ name }: DeleteIdpParams, params: RequestParams = {}) =>
      this.request<
        DeleteIdpData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/saml/idps/${name}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Initiate an SP-initiated login sequence for the Idp. The SP will respond with the SAML AuthN Request the client must send to the Idp URL
     *
     * @tags RBAC
     * @name SamlLogin
     * @request GET:/rbac-manager/saml/login/{idp_name}
     * @response `200` `SamlLoginData` Resulting JWT token
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    samlLogin: ({ idpName }: SamlLoginParams, params: RequestParams = {}) =>
      this.request<
        SamlLoginData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/saml/login/${idpName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Perform a login using a SAML assertion, no HTTP auth is required as the SAML assertion is considered the authenticating token
     *
     * @tags RBAC
     * @name SamlSso
     * @request POST:/rbac-manager/saml/sso/{idp_name}
     * @response `200` `SamlSsoData` Resulting JWT token
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    samlSso: ({ idpName }: SamlSsoParams, params: RequestParams = {}) =>
      this.request<SamlSsoData, ApiErrorResponse | RbacManagerApiErrorResponse>(
        {
          path: `/rbac-manager/saml/sso/${idpName}`,
          method: 'POST',
          format: 'json',
          ...params,
        },
      ),

    /**
     * No description
     *
     * @tags RBAC
     * @name ListUserRoles
     * @summary List the roles for which the requested user is a member
     * @request GET:/rbac-manager/users/{username}/roles
     * @response `200` `ListUserRolesData` Role summary listing
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `RbacManagerApiErrorResponse` Internal error
     */
    listUserRoles: (
      { username, ...query }: ListUserRolesParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListUserRolesData,
        ApiErrorResponse | RbacManagerApiErrorResponse
      >({
        path: `/rbac-manager/users/${username}/roles`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  registries = {
    /**
     * @description List all configured registries the system can/will watch
     *
     * @tags Registries
     * @name ListRegistries
     * @summary List configured registries
     * @request GET:/registries
     * @response `200` `ListRegistriesData` Registry listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listRegistries: (params: RequestParams = {}) =>
      this.request<ListRegistriesData, ApiErrorResponse>({
        path: `/registries`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Adds a new registry to the system
     *
     * @tags Registries
     * @name CreateRegistry
     * @summary Add a new registry
     * @request POST:/registries
     * @response `200` `CreateRegistryData` Saved registry configuration
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    createRegistry: (
      data: RegistryConfigurationRequest,
      query: CreateRegistryParams = {},
      params: RequestParams = {},
    ) =>
      this.request<CreateRegistryData, ApiErrorResponse>({
        path: `/registries`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get information on a specific registry
     *
     * @tags Registries
     * @name GetRegistry
     * @summary Get a specific registry configuration
     * @request GET:/registries/{registry}
     * @response `200` `GetRegistryData` Registry configuration
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getRegistry: (
      { registry }: GetRegistryParams,
      params: RequestParams = {},
    ) =>
      this.request<GetRegistryData, ApiErrorResponse>({
        path: `/registries/${registry}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Replaces an existing registry record with the given record
     *
     * @tags Registries
     * @name UpdateRegistry
     * @summary Update/replace a registry configuration
     * @request PUT:/registries/{registry}
     * @response `200` `UpdateRegistryData` Updated registry configuration
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateRegistry: (
      { registry, ...query }: UpdateRegistryParams,
      data: RegistryConfigurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateRegistryData, ApiErrorResponse>({
        path: `/registries/${registry}`,
        method: 'PUT',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a registry configuration record from the system. Does not remove any images.
     *
     * @tags Registries
     * @name DeleteRegistry
     * @summary Delete a registry configuration
     * @request DELETE:/registries/{registry}
     * @response `204` `DeleteRegistryData` Delete success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteRegistry: (
      { registry }: DeleteRegistryParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteRegistryData, ApiErrorResponse>({
        path: `/registries/${registry}`,
        method: 'DELETE',
        ...params,
      }),
  };
  reporting = {
    /**
     * @description Get a single saved global query result
     *
     * @tags Reports
     * @name GetGlobalQueryResult
     * @request GET:/reporting/reports/global/scheduled-query-results/{result_uuid}
     * @response `200` `GetGlobalQueryResultData` Saved Query result page
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getGlobalQueryResult: (
      { resultUuid, ...query }: GetGlobalQueryResultParams,
      params: RequestParams = {},
    ) =>
      this.request<GetGlobalQueryResultData, ApiErrorResponse>({
        path: `/reporting/reports/global/scheduled-query-results/${resultUuid}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Get a single saved query result
     *
     * @tags Reports
     * @name GetQueryResult
     * @request GET:/reporting/scheduled-query-results/{result_uuid}
     * @response `200` `GetQueryResultData` Saved Query result page
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getQueryResult: (
      { resultUuid, ...query }: GetQueryResultParams,
      params: RequestParams = {},
    ) =>
      this.request<GetQueryResultData, ApiErrorResponse>({
        path: `/reporting/scheduled-query-results/${resultUuid}`,
        method: 'GET',
        query: query,
        ...params,
      }),
  };
  repositories = {
    /**
     * No description
     *
     * @tags Repository
     * @name AddRepository
     * @summary Add repository to watch
     * @request POST:/repositories
     * @response `200` `AddRepositoryData` Repository Subscription
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    addRepository: (query: AddRepositoryParams, params: RequestParams = {}) =>
      this.request<AddRepositoryData, ApiErrorResponse>({
        path: `/repositories`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  scan = {
    /**
     * @description Use this operation for checking sboms for vulnerabilities and policy evaluations in cases where the sbom does not need to be stored for later re-scans or added to the managed set of SBOMs in Anchore. If you need to upload and save an SBOM use the "/import/*" API set instead.
     *
     * @tags Onetime
     * @name StatelessScan
     * @summary Return a onetime evaluation of the provided data.
     * @request POST:/scan
     * @response `200` `StatelessScanData` Successful response with onetime scan status
     * @response `400` `ApiErrorResponse` Unable to evaluate the provided data
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    statelessScan: (
      query: StatelessScanParams,
      data: ScanRequest,
      params: RequestParams = {},
    ) =>
      this.request<StatelessScanData, ApiErrorResponse>({
        path: `/scan`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  sources = {
    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. List the source repository analysis records
     *
     * @tags Sources
     * @name ListSources
     * @summary List the source repository analysis records
     * @request GET:/sources
     * @deprecated
     * @response `200` `ListSourcesData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listSources: (params: RequestParams = {}) =>
      this.request<ListSourcesData, ApiErrorResponse>({
        path: `/sources`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Fetch or calculate policy evaluation for a source
     *
     * @tags Sources
     * @name GetSourcePolicyCheck
     * @summary Fetch or calculate policy evaluation for a source
     * @request GET:/sources/{source_id}/check
     * @deprecated
     * @response `200` `GetSourcePolicyCheckData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourcePolicyCheck: (
      { sourceId, ...query }: GetSourcePolicyCheckParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourcePolicyCheckData, ApiErrorResponse>({
        path: `/sources/${sourceId}/check`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get a detailed source repository analysis metadata record
     *
     * @tags Sources
     * @name GetSourceContentTypes
     * @summary Get a detailed source repository analysis metadata record
     * @request GET:/sources/{source_id}/content
     * @deprecated
     * @response `200` `GetSourceContentTypesData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceContentTypes: (
      { sourceId }: GetSourceContentTypesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceContentTypesData, ApiErrorResponse>({
        path: `/sources/${sourceId}/content`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get sources content summary
     *
     * @tags Sources
     * @name GetSourceContentSummary
     * @summary Get sources content summary
     * @request GET:/sources/{source_id}/content-summary
     * @deprecated
     * @response `200` `GetSourceContentSummaryData` Content summary listing for the source
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceContentSummary: (
      { sourceId }: GetSourceContentSummaryParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceContentSummaryData, ApiErrorResponse>({
        path: `/sources/${sourceId}/content-summary`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get the content of an analyzed source repository
     *
     * @tags Sources
     * @name GetSourceContentByType
     * @summary Get the content of an analyzed source repository
     * @request GET:/sources/{source_id}/content/{content_type}
     * @deprecated
     * @response `200` `GetSourceContentByTypeData` Content of specified type from the image
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceContentByType: (
      { sourceId, contentType }: GetSourceContentByTypeParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceContentByTypeData, ApiErrorResponse>({
        path: `/sources/${sourceId}/content/${contentType}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Return the source SBOM in the CycloneDX format
     *
     * @tags Sources
     * @name GetSourceSbomCyclonedxJson
     * @summary Return the source SBOM in the CycloneDX format
     * @request GET:/sources/{source_id}/sbom/cyclonedx-json
     * @deprecated
     * @response `200` `GetSourceSbomCyclonedxJsonData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceSbomCyclonedxJson: (
      { sourceId }: GetSourceSbomCyclonedxJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceSbomCyclonedxJsonData, ApiErrorResponse>({
        path: `/sources/${sourceId}/sbom/cyclonedx-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Return the source SBOM in the native Anchore format
     *
     * @tags Sources
     * @name GetSourceSbomNativeJson
     * @summary Return the source SBOM in the native Anchore format
     * @request GET:/sources/{source_id}/sbom/native-json
     * @deprecated
     * @response `200` `GetSourceSbomNativeJsonData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceSbomNativeJson: (
      { sourceId }: GetSourceSbomNativeJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceSbomNativeJsonData, ApiErrorResponse>({
        path: `/sources/${sourceId}/sbom/native-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Return the source SBOM in the SPDX format
     *
     * @tags Sources
     * @name GetSourceSbomSpdxJson
     * @summary Return the source SBOM in the SPDX format
     * @request GET:/sources/{source_id}/sbom/spdx-json
     * @deprecated
     * @response `200` `GetSourceSbomSpdxJsonData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceSbomSpdxJson: (
      { sourceId }: GetSourceSbomSpdxJsonParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceSbomSpdxJsonData, ApiErrorResponse>({
        path: `/sources/${sourceId}/sbom/spdx-json`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get the available vulnerability types for source
     *
     * @tags Sources
     * @name GetSourceVulnerabilityTypes
     * @summary Get the available vulnerability types for source
     * @request GET:/sources/{source_id}/vuln
     * @deprecated
     * @response `200` `GetSourceVulnerabilityTypesData` List of vulnerability types for the source
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceVulnerabilityTypes: (
      { sourceId }: GetSourceVulnerabilityTypesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceVulnerabilityTypesData, ApiErrorResponse>({
        path: `/sources/${sourceId}/vuln`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get vulnerabilities for the source by type
     *
     * @tags Sources
     * @name GetSourceVulnerabilities
     * @summary Get vulnerabilities for the source by type
     * @request GET:/sources/{source_id}/vuln/{vuln_type}
     * @deprecated
     * @response `200` `GetSourceVulnerabilitiesData` Vulnerability listing for the source
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSourceVulnerabilities: (
      { sourceId, vulnType, ...query }: GetSourceVulnerabilitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSourceVulnerabilitiesData, ApiErrorResponse>({
        path: `/sources/${sourceId}/vuln/${vulnType}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Get a detailed source repository analysis metadata record
     *
     * @tags Sources
     * @name GetSource
     * @summary Get a detailed source repository analysis metadata record
     * @request GET:/sources/{source_id}
     * @deprecated
     * @response `200` `GetSourceData` success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSource: ({ sourceId }: GetSourceParams, params: RequestParams = {}) =>
      this.request<GetSourceData, ApiErrorResponse>({
        path: `/sources/${sourceId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated: use the App SBOM Assets APIs instead. Delete source record from DB
     *
     * @tags Sources
     * @name DeleteSource
     * @summary Delete source record from DB
     * @request DELETE:/sources/{source_id}
     * @deprecated
     * @response `204` `DeleteSourceData` Delete success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteSource: (
      { sourceId, ...query }: DeleteSourceParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSourceData, ApiErrorResponse>({
        path: `/sources/${sourceId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),
  };
  status = {
    /**
     * @description Get the API service status
     *
     * @tags System
     * @name GetStatus
     * @summary Service status
     * @request GET:/status
     * @response `200` `GetStatusData` Status listing
     * @response `500` `ApiErrorResponse` Internal error
     */
    getStatus: (params: RequestParams = {}) =>
      this.request<GetStatusData, ApiErrorResponse>({
        path: `/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  stigProfiles = {
    /**
     * @description Retrieve the latest STIG profiles database for airgap environments
     *
     * @tags System
     * @name GetStigProfiles
     * @summary Download STIG profiles database
     * @request GET:/stig-profiles
     * @response `200` `GetStigProfilesData` STIG profiles database file
     * @response `404` `ApiErrorResponse` STIG profiles database not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getStigProfiles: (params: RequestParams = {}) =>
      this.request<GetStigProfilesData, ApiErrorResponse>({
        path: `/stig-profiles`,
        method: 'GET',
        ...params,
      }),
  };
  subscriptions = {
    /**
     * No description
     *
     * @tags Subscriptions
     * @name ListSubscriptions
     * @summary List all subscriptions
     * @request GET:/subscriptions
     * @response `200` `ListSubscriptionsData` Subscription listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listSubscriptions: (
      query: ListSubscriptionsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListSubscriptionsData, ApiErrorResponse>({
        path: `/subscriptions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new subscription
     *
     * @tags Subscriptions
     * @name AddSubscription
     * @summary Add a subscription of a specific type
     * @request POST:/subscriptions
     * @response `200` `AddSubscriptionData` Subscription add success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    addSubscription: (data: SubscriptionRequest, params: RequestParams = {}) =>
      this.request<AddSubscriptionData, ApiErrorResponse>({
        path: `/subscriptions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name GetSubscription
     * @summary Get a specific subscription set
     * @request GET:/subscriptions/{subscription_id}
     * @response `200` `GetSubscriptionData` Filtered subscription list by type
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getSubscription: (
      { subscriptionId }: GetSubscriptionParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSubscriptionData, ApiErrorResponse>({
        path: `/subscriptions/${subscriptionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name UpdateSubscription
     * @summary Update an existing and specific subscription
     * @request PUT:/subscriptions/{subscription_id}
     * @response `200` `UpdateSubscriptionData` Subscription update success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateSubscription: (
      { subscriptionId }: UpdateSubscriptionParams,
      data: SubscriptionUpdate,
      params: RequestParams = {},
    ) =>
      this.request<UpdateSubscriptionData, ApiErrorResponse>({
        path: `/subscriptions/${subscriptionId}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name DeleteSubscription
     * @summary Delete specific subscription
     * @request DELETE:/subscriptions/{subscription_id}
     * @response `204` `DeleteSubscriptionData` Delete success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteSubscription: (
      { subscriptionId }: DeleteSubscriptionParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteSubscriptionData, ApiErrorResponse>({
        path: `/subscriptions/${subscriptionId}`,
        method: 'DELETE',
        ...params,
      }),
  };
  summaries = {
    /**
     * @description List all image tags visible to the user
     *
     * @tags Images
     * @name SummaryImageTags
     * @summary Summarize image tags
     * @request GET:/summaries/image-tags
     * @response `200` `SummaryImageTagsData` successful operation
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    summaryImageTags: (
      query: SummaryImageTagsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SummaryImageTagsData, ApiErrorResponse>({
        path: `/summaries/image-tags`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Count tags and images by analysis status
     *
     * @tags Images
     * @name SummaryImageCounts
     * @summary Image summary counts
     * @request GET:/summaries/image-counts
     * @response `200` `SummaryImageCountsData` successful operation
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    summaryImageCounts: (
      query: SummaryImageCountsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<SummaryImageCountsData, ApiErrorResponse>({
        path: `/summaries/image-counts`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  system = {
    /**
     * @description Get the system status including queue lengths
     *
     * @tags System
     * @name GetServiceDetail
     * @summary System status
     * @request GET:/system
     * @response `200` `GetServiceDetailData` Status listing
     * @response `500` `ApiErrorResponse` Internal error
     */
    getServiceDetail: (params: RequestParams = {}) =>
      this.request<GetServiceDetailData, ApiErrorResponse>({
        path: `/system`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetAnchorectl
     * @summary Get an anchorectl binary compatible with this version of Anchore Enterprise
     * @request GET:/system/anchorectl
     * @response `200` `GetAnchorectlData` The binary requested
     * @response `400` `ApiErrorResponse` Bad request
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getAnchorectl: (query: GetAnchorectlParams, params: RequestParams = {}) =>
      this.request<GetAnchorectlData, ApiErrorResponse>({
        path: `/system/anchorectl`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name ListTools
     * @summary Get a listing of the tools and versions available from the system for download and use
     * @request GET:/system/tools
     * @response `200` `ListToolsData` The tool listing
     * @response `400` `ApiErrorResponse` Bad request
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    listTools: (query: ListToolsParams = {}, params: RequestParams = {}) =>
      this.request<ListToolsData, ApiErrorResponse>({
        path: `/system/tools`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Artifact Lifecycle
     * @name ListArtifactLifecyclePolicies
     * @summary List all artifact lifecycle policies
     * @request GET:/system/artifact-lifecycle-policies
     * @response `200` `ListArtifactLifecyclePoliciesData` A list of artifact lifecycle policies in the system
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listArtifactLifecyclePolicies: (params: RequestParams = {}) =>
      this.request<ListArtifactLifecyclePoliciesData, ApiErrorResponse>({
        path: `/system/artifact-lifecycle-policies`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Artifact Lifecycle
     * @name CreateArtifactLifecyclePolicy
     * @summary Create new artifact lifecycle policy
     * @request POST:/system/artifact-lifecycle-policies
     * @response `201` `CreateArtifactLifecyclePolicyData` The newly created artifact lifecycle policy
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    createArtifactLifecyclePolicy: (
      data: ArtifactLifecyclePolicy,
      params: RequestParams = {},
    ) =>
      this.request<CreateArtifactLifecyclePolicyData, ApiErrorResponse>({
        path: `/system/artifact-lifecycle-policies`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Artifact Lifecycle
     * @name GetArtifactLifecyclePolicyByVersion
     * @summary Get single artifact lifecycle policy by its version
     * @request GET:/system/artifact-lifecycle-policies/{policy_uuid}/versions
     * @response `200` `GetArtifactLifecyclePolicyByVersionData` The requested version(s) of the artifact lifecycle policy
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getArtifactLifecyclePolicyByVersion: (
      { policyUuid, ...query }: GetArtifactLifecyclePolicyByVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<GetArtifactLifecyclePolicyByVersionData, ApiErrorResponse>({
        path: `/system/artifact-lifecycle-policies/${policyUuid}/versions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Artifact Lifecycle
     * @name GetArtifactLifecyclePolicy
     * @summary Get single artifact lifecycle policy
     * @request GET:/system/artifact-lifecycle-policies/{policy_uuid}
     * @response `200` `GetArtifactLifecyclePolicyData` A single artifact lifecycle policy
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getArtifactLifecyclePolicy: (
      { policyUuid }: GetArtifactLifecyclePolicyParams,
      params: RequestParams = {},
    ) =>
      this.request<GetArtifactLifecyclePolicyData, ApiErrorResponse>({
        path: `/system/artifact-lifecycle-policies/${policyUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Artifact Lifecycle
     * @name UpdateArtifactLifecyclePolicy
     * @summary Update a single artifact lifecycle policy
     * @request PUT:/system/artifact-lifecycle-policies/{policy_uuid}
     * @response `200` `UpdateArtifactLifecyclePolicyData` The updated artifact lifecycle policy
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    updateArtifactLifecyclePolicy: (
      { policyUuid }: UpdateArtifactLifecyclePolicyParams,
      data: ArtifactLifecyclePolicy,
      params: RequestParams = {},
    ) =>
      this.request<UpdateArtifactLifecyclePolicyData, ApiErrorResponse>({
        path: `/system/artifact-lifecycle-policies/${policyUuid}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Artifact Lifecycle
     * @name DeleteArtifactLifecyclePolicy
     * @summary Delete lifecycle policy
     * @request DELETE:/system/artifact-lifecycle-policies/{policy_uuid}
     * @response `204` `DeleteArtifactLifecyclePolicyData` Returns an empty response
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteArtifactLifecyclePolicy: (
      { policyUuid }: DeleteArtifactLifecyclePolicyParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteArtifactLifecyclePolicyData, ApiErrorResponse>({
        path: `/system/artifact-lifecycle-policies/${policyUuid}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description A full schema definition for the API exposed configurations
     *
     * @tags System Configuration
     * @name GetConfigurationSchema
     * @summary Get the system configuration schema for API exposed settings
     * @request GET:/system/configurations/schema
     * @response `200` `GetConfigurationSchemaData` The configuration schema
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    getConfigurationSchema: (params: RequestParams = {}) =>
      this.request<GetConfigurationSchemaData, ApiErrorResponse>({
        path: `/system/configurations/schema`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description List all API exposed configurations and their values
     *
     * @tags System Configuration
     * @name ListConfigurations
     * @summary List all API exposed configurations and their values
     * @request GET:/system/configurations
     * @response `200` `ListConfigurationsData` The list of configurations
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    listConfigurations: (params: RequestParams = {}) =>
      this.request<ListConfigurationsData, ApiErrorResponse>({
        path: `/system/configurations`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Enables the user to update more than one configuration key at a time with partials Note; this operation is atomic so if any key fails validation none will be set.
     *
     * @tags System Configuration
     * @name PatchConfiguration
     * @summary Apply a patch to the system configuration
     * @request PATCH:/system/configurations
     * @response `200` `PatchConfigurationData` The list of impacted keys
     * @response `400` `ApiErrorResponse` Validation error
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `409` `ApiErrorResponse` Conflict
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    patchConfiguration: (
      data: SystemConfigurationPatch,
      params: RequestParams = {},
    ) =>
      this.request<PatchConfigurationData, ApiErrorResponse>({
        path: `/system/configurations`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description The value of a single configuration key
     *
     * @tags System Configuration
     * @name GetConfiguration
     * @summary Get an individual configuration
     * @request GET:/system/configurations/{config_key}
     * @response `200` `GetConfigurationData` The configuration
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getConfiguration: (
      { configKey }: GetConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetConfigurationData, ApiErrorResponse>({
        path: `/system/configurations/${configKey}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the value of a single configuration key
     *
     * @tags System Configuration
     * @name PutConfiguration
     * @summary Put a single configuration value
     * @request PUT:/system/configurations/{config_key}
     * @response `200` `PutConfigurationData` The updated configuration
     * @response `400` `ApiErrorResponse` Validation error
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `409` `ApiErrorResponse` Conflict
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal error
     */
    putConfiguration: (
      { configKey }: PutConfigurationParams,
      data: SystemConfigurationPut,
      params: RequestParams = {},
    ) =>
      this.request<PutConfigurationData, ApiErrorResponse>({
        path: `/system/configurations/${configKey}`,
        method: 'PUT',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Unset a configuration key - this will return it to the system default
     *
     * @tags System Configuration
     * @name DeleteConfiguration
     * @summary Unset a configuration key
     * @request DELETE:/system/configurations/{config_key}
     * @response `204` `DeleteConfigurationData` Success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    deleteConfiguration: (
      { configKey }: DeleteConfigurationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteConfigurationData, ApiErrorResponse>({
        path: `/system/configurations/${configKey}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Returns list of deployment history entries
     *
     * @tags catalog
     * @name GetDeploymentHistory
     * @summary List Deployment History
     * @request GET:/system/deployment-history
     * @response `200` `GetDeploymentHistoryData` List of deployment history entries
     * @response `500` `ApiErrorResponse` Internal error
     */
    getDeploymentHistory: (params: RequestParams = {}) =>
      this.request<GetDeploymentHistoryData, ApiErrorResponse>({
        path: `/system/deployment-history`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns all structured error code definitions, optionally filtered by service prefix.
     *
     * @tags System
     * @name DescribeErrorCodes
     * @summary List all structured error codes.
     * @request GET:/system/error-codes
     * @response `200` `DescribeErrorCodesData` List of error codes. By default returns only code and message; use ?details=true for full definitions.
     * @response `500` `ApiErrorResponse` Internal error
     */
    describeErrorCodes: (
      query: DescribeErrorCodesParams = {},
      params: RequestParams = {},
    ) =>
      this.request<DescribeErrorCodesData, ApiErrorResponse>({
        path: `/system/error-codes`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns the full definition for a single structured error code.
     *
     * @tags System
     * @name GetErrorCodeDetails
     * @summary Look up a single structured error code.
     * @request GET:/system/error-codes/{code}
     * @response `200` `GetErrorCodeDetailsData` Structured error code definition
     * @response `404` `ApiErrorResponse` Error code not found
     * @response `500` `ApiErrorResponse` Internal error
     */
    getErrorCodeDetails: (
      { code }: GetErrorCodeDetailsParams,
      params: RequestParams = {},
    ) =>
      this.request<GetErrorCodeDetailsData, ApiErrorResponse>({
        path: `/system/error-codes/${code}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Return a list of feed and their groups along with update and record count information. This data reflects the state of the policy engine, not the upstream feed service itself.
     *
     * @tags System
     * @name GetSystemFeeds
     * @summary list feeds operations and information
     * @request GET:/system/feeds
     * @response `200` `GetSystemFeedsData` success
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getSystemFeeds: (params: RequestParams = {}) =>
      this.request<GetSystemFeedsData, ApiErrorResponse>({
        path: `/system/feeds`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a synchronous fetch and sync of all datasets by the data_syncer, this is a synchronous operation and may take some time to complete.
     *
     * @tags System
     * @name PostSystemFeeds
     * @summary trigger feeds operations
     * @request POST:/system/feeds
     * @response `200` `PostSystemFeedsData` Datasets sync successful
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal error
     */
    postSystemFeeds: (
      query: PostSystemFeedsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<PostSystemFeedsData, ApiErrorResponse>({
        path: `/system/feeds`,
        method: 'POST',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deprecated - Disable the feed so that it does not sync on subsequent sync operations
     *
     * @tags System
     * @name ToggleFeedEnabled
     * @request PUT:/system/feeds/{feed}
     * @deprecated
     * @response `200` `ToggleFeedEnabledData` FeedInfo
     * @response `400` `void` Bad request, fix and resend
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `void` Internal server error processing the request. Retry expected
     * @response `501` `void` Not implemented
     */
    toggleFeedEnabled: (
      { feed, ...query }: ToggleFeedEnabledParams,
      params: RequestParams = {},
    ) =>
      this.request<ToggleFeedEnabledData, void | ApiErrorResponse>({
        path: `/system/feeds/${feed}`,
        method: 'PUT',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get feed metadata
     *
     * @tags System
     * @name GetSystemFeed
     * @request GET:/system/feeds/{feed}
     * @response `200` `GetSystemFeedData` Feed data record
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getSystemFeed: (
      { feed, ...query }: GetSystemFeedParams,
      params: RequestParams = {},
    ) =>
      this.request<GetSystemFeedData, ApiErrorResponse>({
        path: `/system/feeds/${feed}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Upload a new feed
     *
     * @tags System
     * @name UploadSystemFeed
     * @request POST:/system/feeds/{feed}
     * @response `202` `UploadSystemFeedData` Feed uploaded successfully
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    uploadSystemFeed: (
      { feed, ...query }: UploadSystemFeedParams,
      data: UploadSystemFeedPayload,
      params: RequestParams = {},
    ) =>
      this.request<UploadSystemFeedData, ApiErrorResponse>({
        path: `/system/feeds/${feed}`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * @description Deprecated - Delete the groups and data for the feed and disable the feed itself
     *
     * @tags System
     * @name DeleteFeed
     * @request DELETE:/system/feeds/{feed}
     * @deprecated
     * @response `200` `DeleteFeedData` Successfully deleted
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `void` Not found
     * @response `500` `void` Internal server error processing the request. Retry expected
     * @response `501` `void` Not implemented
     */
    deleteFeed: ({ feed }: DeleteFeedParams, params: RequestParams = {}) =>
      this.request<DeleteFeedData, ApiErrorResponse | void>({
        path: `/system/feeds/${feed}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description An integration, such as an agent, will use this API to report its current health status. Such calls will typically be done on an interval, e.g., every 60 seconds.
     *
     * @tags Integrations
     * @name HandleHealthReport
     * @summary Report health status for an integration
     * @request POST:/system/integrations/{integration_uuid}/health-report
     * @response `201` `HandleHealthReportData` Health report accepted. Empty response.
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    handleHealthReport: (
      { integrationUuid }: HandleHealthReportParams,
      data: HealthReport,
      params: RequestParams = {},
    ) =>
      this.request<HandleHealthReportData, ApiErrorResponse>({
        path: `/system/integrations/${integrationUuid}/health-report`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name GetIntegrationById
     * @summary Get information about an integration instance
     * @request GET:/system/integrations/{integration_uuid}
     * @response `200` `GetIntegrationByIdData` Get integration response
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getIntegrationById: (
      { integrationUuid }: GetIntegrationByIdParams,
      params: RequestParams = {},
    ) =>
      this.request<GetIntegrationByIdData, ApiErrorResponse>({
        path: `/system/integrations/${integrationUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integrations
     * @name DeleteIntegration
     * @summary Delete an integration instance
     * @request DELETE:/system/integrations/{integration_uuid}
     * @response `204` `DeleteIntegrationData` Successfully deleted
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteIntegration: (
      { integrationUuid, ...query }: DeleteIntegrationParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteIntegrationData, ApiErrorResponse>({
        path: `/system/integrations/${integrationUuid}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description An integration instance, such as an agent, will use this API to register itself with Anchore. The integration registers using registration_id and registration_instance_id as temporary identifiers and is assigned its integration uuid upon successful registration. This method is idempotent in the sense that if an integration instance call it multiple time and uses the same registration_id and registration_instance_id, it will be assigned the same integration uuid.
     *
     * @tags Integrations
     * @name RegisterIntegration
     * @summary Register an integration instance
     * @request POST:/system/integrations/registration
     * @response `200` `RegisterIntegrationData` Integration successfully (re-)registered response
     * @response `201` `Integration` Integration successfully registered and created response
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `409` `ImageSBOM` Integration registration failure
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    registerIntegration: (
      data: IntegrationRegister,
      params: RequestParams = {},
    ) =>
      this.request<RegisterIntegrationData, ApiErrorResponse | ImageSBOM>({
        path: `/system/integrations/registration`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Lists all integrations that have been created (explicitly or indirectly via registration).
     *
     * @tags Integrations
     * @name ListIntegrations
     * @summary List known integration instances
     * @request GET:/system/integrations
     * @response `200` `ListIntegrationsData` Summary list of integrations response
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listIntegrations: (
      query: ListIntegrationsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListIntegrationsData, ApiErrorResponse>({
        path: `/system/integrations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Enables override of localconfig logging level for one or all services until they are next rebooted. If multiple instances of a service exist this call may need to be repeated depending on the container orchestration system in use. This API is in preview and may change in the future.
     *
     * @tags System
     * @name SetNewLogLevel
     * @summary Change logging level for a running service
     * @request POST:/system/logging
     * @response `200` `SetNewLogLevelData` Logging level successfully changed
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    setNewLogLevel: (data: LoggingLevel, params: RequestParams = {}) =>
      this.request<SetNewLogLevelData, ApiErrorResponse>({
        path: `/system/logging`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the policy language spec for this service
     *
     * @tags System
     * @name DescribePolicy
     * @summary Describe the policy language spec implemented by this service.
     * @request GET:/system/policy-spec
     * @response `200` `DescribePolicyData` Policy Language Description
     * @response `500` `ApiErrorResponse` Internal Error
     */
    describePolicy: (params: RequestParams = {}) =>
      this.request<DescribePolicyData, ApiErrorResponse>({
        path: `/system/policy-spec`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetResourceLimits
     * @summary Get resource limits
     * @request GET:/system/resource-limits
     * @response `200` `GetResourceLimitsData` Resource limits
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getResourceLimits: (params: RequestParams = {}) =>
      this.request<GetResourceLimitsData, ApiErrorResponse>({
        path: `/system/resource-limits`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name ListServices
     * @summary List system services
     * @request GET:/system/services
     * @response `200` `ListServicesData` Service listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listServices: (params: RequestParams = {}) =>
      this.request<ListServicesData, ApiErrorResponse>({
        path: `/system/services`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetServicesByNameAndHost
     * @summary Get service config for a specific host
     * @request GET:/system/services/{service_name}/{host_id}
     * @response `200` `GetServicesByNameAndHostData` Listing of registered services
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getServicesByNameAndHost: (
      { serviceName, hostId }: GetServicesByNameAndHostParams,
      params: RequestParams = {},
    ) =>
      this.request<GetServicesByNameAndHostData, ApiErrorResponse>({
        path: `/system/services/${serviceName}/${hostId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name DeleteService
     * @summary Delete the service config
     * @request DELETE:/system/services/{service_name}/{host_id}
     * @response `200` `DeleteServiceData` Delete success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteService: (
      { serviceName, hostId }: DeleteServiceParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteServiceData, ApiErrorResponse>({
        path: `/system/services/${serviceName}/${hostId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetServicesByName
     * @summary Get a service configuration and state
     * @request GET:/system/services/{service_name}
     * @response `200` `GetServicesByNameData` Service Info
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getServicesByName: (
      { serviceName }: GetServicesByNameParams,
      params: RequestParams = {},
    ) =>
      this.request<GetServicesByNameData, ApiErrorResponse>({
        path: `/system/services/${serviceName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns list of system statistics with total all-time counts.
     *
     * @tags Statistics
     * @name GetSystemStatistics
     * @summary List System Statistics
     * @request GET:/system/statistics
     * @response `200` `GetSystemStatisticsData` List of system statistics
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getSystemStatistics: (params: RequestParams = {}) =>
      this.request<GetSystemStatisticsData, ApiErrorResponse>({
        path: `/system/statistics`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags System
     * @name GetStigEntitlement
     * @summary Check STIG entitlement status
     * @request GET:/system/stig-entitlement
     * @response `200` `GetStigEntitlementData` STIG entitlement status
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getStigEntitlement: (params: RequestParams = {}) =>
      this.request<GetStigEntitlementData, ApiErrorResponse>({
        path: `/system/stig-entitlement`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUserGroups
     * @summary List user groups
     * @request GET:/system/user-groups
     * @response `200` `ListUserGroupsData` User group list
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listUserGroups: (
      query: ListUserGroupsParams = {},
      params: RequestParams = {},
    ) =>
      this.request<ListUserGroupsData, ApiErrorResponse>({
        path: `/system/user-groups`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name CreateUserGroup
     * @summary Create a new user group
     * @request POST:/system/user-groups
     * @response `201` `CreateUserGroupData` User group record
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `409` `ApiErrorResponse` Conflict
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    createUserGroup: (data: UserGroupPost, params: RequestParams = {}) =>
      this.request<CreateUserGroupData, ApiErrorResponse>({
        path: `/system/user-groups`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUserGroupRoles
     * @summary Get a list of all user group roles
     * @request GET:/system/user-groups/{group_uuid}/roles
     * @response `200` `ListUserGroupRolesData` User group roles
     * @response `404` `ApiErrorResponse` Not found
     */
    listUserGroupRoles: (
      { groupUuid }: ListUserGroupRolesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListUserGroupRolesData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}/roles`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name AddUserGroupRoles
     * @summary Add account role(s) to this user group
     * @request POST:/system/user-groups/{group_uuid}/roles
     * @response `201` `AddUserGroupRolesData` User group role
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addUserGroupRoles: (
      { groupUuid }: AddUserGroupRolesParams,
      data: UserGroupRolePost,
      params: RequestParams = {},
    ) =>
      this.request<AddUserGroupRolesData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}/roles`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteUserGroupRole
     * @summary Remove account role(s) from this user group
     * @request DELETE:/system/user-groups/{group_uuid}/roles
     * @response `204` `DeleteUserGroupRoleData` Success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteUserGroupRole: (
      { groupUuid, ...query }: DeleteUserGroupRoleParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserGroupRoleData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}/roles`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name ListUserGroupUsers
     * @summary Get a list of user group users
     * @request GET:/system/user-groups/{group_uuid}/users
     * @response `200` `ListUserGroupUsersData` User group users
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listUserGroupUsers: (
      { groupUuid }: ListUserGroupUsersParams,
      params: RequestParams = {},
    ) =>
      this.request<ListUserGroupUsersData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}/users`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name AddUserGroupUsers
     * @summary Add user(s) to a user group
     * @request POST:/system/user-groups/{group_uuid}/users
     * @response `201` `AddUserGroupUsersData` User group user
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addUserGroupUsers: (
      { groupUuid }: AddUserGroupUsersParams,
      data: UserGroupUsersPost,
      params: RequestParams = {},
    ) =>
      this.request<AddUserGroupUsersData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}/users`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteUserGroupUsers
     * @summary Remove a user from a user group
     * @request DELETE:/system/user-groups/{group_uuid}/users
     * @response `204` `DeleteUserGroupUsersData` Success
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteUserGroupUsers: (
      { groupUuid, ...query }: DeleteUserGroupUsersParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserGroupUsersData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}/users`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name GetUserGroup
     * @summary Get a user group
     * @request GET:/system/user-groups/{group_uuid}
     * @response `200` `GetUserGroupData` User group record
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getUserGroup: (
      { groupUuid }: GetUserGroupParams,
      params: RequestParams = {},
    ) =>
      this.request<GetUserGroupData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name UpdateUserGroup
     * @summary Update a user group
     * @request PATCH:/system/user-groups/{group_uuid}
     * @response `200` `UpdateUserGroupData` User group record
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    updateUserGroup: (
      { groupUuid }: UpdateUserGroupParams,
      data: UserGroupPatch,
      params: RequestParams = {},
    ) =>
      this.request<UpdateUserGroupData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Management
     * @name DeleteUserGroup
     * @summary Delete a user group
     * @request DELETE:/system/user-groups/{group_uuid}
     * @response `204` `DeleteUserGroupData` Success
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteUserGroup: (
      { groupUuid }: DeleteUserGroupParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteUserGroupData, ApiErrorResponse>({
        path: `/system/user-groups/${groupUuid}`,
        method: 'DELETE',
        ...params,
      }),
  };
  user = {
    /**
     * No description
     *
     * @tags Identity
     * @name GetUser
     * @summary List authenticated user info
     * @request GET:/user
     * @response `200` `GetUserData` User details for caller's user
     * @response `500` `ApiErrorResponse` Internal error
     */
    getUser: (params: RequestParams = {}) =>
      this.request<GetUserData, ApiErrorResponse>({
        path: `/user`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name ListApiKeys
     * @summary Get a list of API keys
     * @request GET:/user/api-keys
     * @response `200` `ListApiKeysData` User API key listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `500` `ApiErrorResponse` Internal Error
     */
    listApiKeys: (params: RequestParams = {}) =>
      this.request<ListApiKeysData, ApiErrorResponse>({
        path: `/user/api-keys`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name CreateApiKey
     * @summary Add a new API key
     * @request POST:/user/api-keys
     * @response `201` `CreateApiKeyData` Add a new API key
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    createApiKey: (data: UserApiKey, params: RequestParams = {}) =>
      this.request<CreateApiKeyData, ApiErrorResponse>({
        path: `/user/api-keys`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name GetApiKey
     * @summary Get a user API key
     * @request GET:/user/api-keys/{key_name}
     * @response `200` `GetApiKeyData` User API key listing
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    getApiKey: ({ keyName }: GetApiKeyParams, params: RequestParams = {}) =>
      this.request<GetApiKeyData, ApiErrorResponse>({
        path: `/user/api-keys/${keyName}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name PatchApiKey
     * @summary Patch a user API key
     * @request PATCH:/user/api-keys/{key_name}
     * @response `200` `PatchApiKeyData` Patches information in a user API key
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    patchApiKey: (
      { keyName }: PatchApiKeyParams,
      data: PatchApiKeyPayload,
      params: RequestParams = {},
    ) =>
      this.request<PatchApiKeyData, ApiErrorResponse>({
        path: `/user/api-keys/${keyName}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name DeleteApiKey
     * @summary Delete a user API key
     * @request DELETE:/user/api-keys/{key_name}
     * @response `204` `DeleteApiKeyData` Successful deletion
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `404` `ApiErrorResponse` Resource not found
     * @response `500` `ApiErrorResponse` Internal Error
     */
    deleteApiKey: (
      { keyName }: DeleteApiKeyParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteApiKeyData, ApiErrorResponse>({
        path: `/user/api-keys/${keyName}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name GetCredentials
     * @summary Get current credential summary
     * @request GET:/user/credentials
     * @response `200` `GetCredentialsData` User credential listing
     * @response `500` `ApiErrorResponse` Internal error
     */
    getCredentials: (params: RequestParams = {}) =>
      this.request<GetCredentialsData, ApiErrorResponse>({
        path: `/user/credentials`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Identity
     * @name AddCredential
     * @summary add/replace credential
     * @request POST:/user/credentials
     * @response `200` `AddCredentialData` Add a credential, over-writing if already exists
     * @response `400` `ApiErrorResponse` Bad request
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    addCredential: (data: AccessCredential, params: RequestParams = {}) =>
      this.request<AddCredentialData, ApiErrorResponse>({
        path: `/user/credentials`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  version = {
    /**
     * @description Returns the version object for the service, including db schema version info
     *
     * @tags System
     * @name VersionCheck
     * @request GET:/version
     * @response `200` `VersionCheckData` Version object describing version state
     * @response `500` `ApiErrorResponse` Internal Error
     */
    versionCheck: (params: RequestParams = {}) =>
      this.request<VersionCheckData, ApiErrorResponse>({
        path: `/version`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  vulnerabilityScan = {
    /**
     * @description Use this operation for checking sboms for vulnerabilities in cases where the sbom does not need to be stored for later re-scans or added to the managed set of SBOMs in Anchore. If you need to upload and save an SBOM use the "/import/*" API set instead.
     *
     * @tags Vulnerabilities
     * @name VulnerabilityScanSbom
     * @summary Return a vulnerability scan for the uploaded SBOM without storing the SBOM and without any side-effects in the system.
     * @request POST:/vulnerability-scan
     * @response `200` `VulnerabilityScanSbomData` Vulnerability listing for the sbom
     * @response `400` `ApiErrorResponse` Bad request
     * @response `403` `ApiErrorResponse` Not permitted
     * @response `415` `ApiErrorResponse` Unsupported Media Type
     * @response `500` `ApiErrorResponse` Internal Error
     */
    vulnerabilityScanSbom: (
      data: VulnerabilityScanSbomPayload,
      query: VulnerabilityScanSbomParams = {},
      params: RequestParams = {},
    ) =>
      this.request<VulnerabilityScanSbomData, ApiErrorResponse>({
        path: `/vulnerability-scan`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  apps = {
    /**
     * No description
     *
     * @tags Apps
     * @name ListApps
     * @summary List Apps
     * @request GET:/apps
     * @response `200` `ListAppsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listApps: (query: ListAppsParams = {}, params: RequestParams = {}) =>
      this.request<ListAppsData, void | HTTPValidationError>({
        path: `/apps`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Apps
     * @name CreateApp
     * @summary Create App
     * @request POST:/apps
     * @response `201` `CreateAppData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `409` `void` An application with the given name already exists.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createApp: (data: AppCreateRequest, params: RequestParams = {}) =>
      this.request<CreateAppData, void | HTTPValidationError>({
        path: `/apps`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Apps
     * @name GetApp
     * @summary Get App
     * @request GET:/apps/{app_id}
     * @response `200` `GetAppData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getApp: ({ appId }: GetAppParams, params: RequestParams = {}) =>
      this.request<GetAppData, void | HTTPValidationError>({
        path: `/apps/${appId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a specific application. This will fail if there are any app-versions associated with the application, unless the `force` query parameter is set to `true`. When `force=true`, all associated app-versions and their assets will be deleted along with the application.
     *
     * @tags Apps
     * @name DeleteApp
     * @summary Delete App
     * @request DELETE:/apps/{app_id}
     * @response `204` `DeleteAppData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `409` `void` Cannot delete: the application still has versions and force=false.
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteApp: (
      { appId, ...query }: DeleteAppParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAppData, void | HTTPValidationError>({
        path: `/apps/${appId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Apps
     * @name UpdateApp
     * @summary Update App
     * @request PATCH:/apps/{app_id}
     * @response `200` `UpdateAppData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateApp: (
      { appId }: UpdateAppParams,
      data: AppUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAppData, void | HTTPValidationError>({
        path: `/apps/${appId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all versions for a specific application.
     *
     * @tags App Versions
     * @name ListAppVersions
     * @summary List Application Versions
     * @request GET:/apps/{app_id}/versions
     * @response `200` `ListAppVersionsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAppVersions: (
      { appId, ...query }: ListAppVersionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAppVersionsData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new version for an application.
     *
     * @tags App Versions
     * @name CreateAppVersion
     * @summary Create Application Version
     * @request POST:/apps/{app_id}/versions
     * @response `201` `CreateAppVersionData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `409` `void` A version with the given name already exists for this application.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createAppVersion: (
      { appId }: CreateAppVersionParams,
      data: AppVersionCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAppVersionData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve details of a specific application version.
     *
     * @tags App Versions
     * @name GetAppVersion
     * @summary Get Application Version
     * @request GET:/apps/{app_id}/versions/{version_id}
     * @response `200` `GetAppVersionData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAppVersion: (
      { appId, versionId }: GetAppVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAppVersionData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the metadata for an existing application version.
     *
     * @tags App Versions
     * @name UpdateAppVersion
     * @summary Update Application Version
     * @request PATCH:/apps/{app_id}/versions/{version_id}
     * @response `200` `UpdateAppVersionData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateAppVersion: (
      { appId, versionId }: UpdateAppVersionParams,
      data: AppVersionUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAppVersionData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a specific application version. This will fail if there are any assets associated with the application version, unless the `force` query parameter is set to `true`. When `force=true`, all associated assets will be deleted along with the application version.
     *
     * @tags App Versions
     * @name DeleteAppVersion
     * @summary Delete Application Version
     * @request DELETE:/apps/{app_id}/versions/{version_id}
     * @response `204` `DeleteAppVersionData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `409` `void` Cannot delete: the version still has assets and force=false.
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteAppVersion: (
      { appId, versionId, ...query }: DeleteAppVersionParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAppVersionData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Assets
     * @name ListAssets
     * @summary List Assets
     * @request GET:/apps/{app_id}/versions/{version_id}/assets
     * @response `200` `ListAssetsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAssets: (
      { appId, versionId, ...query }: ListAssetsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAssetsData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/assets`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Assets
     * @name GetAsset
     * @summary Get Asset
     * @request GET:/apps/{app_id}/versions/{version_id}/assets/{asset_id}
     * @response `200` `GetAssetData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAsset: (
      { appId, versionId, assetId }: GetAssetParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAssetData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/assets/${assetId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Assets
     * @name UpdateAsset
     * @summary Update Asset
     * @request PATCH:/apps/{app_id}/versions/{version_id}/assets/{asset_id}
     * @response `200` `UpdateAssetData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateAsset: (
      { appId, versionId, assetId }: UpdateAssetParams,
      data: AssetUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAssetData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/assets/${assetId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Assets
     * @name DeleteAsset
     * @summary Delete Asset
     * @request DELETE:/apps/{app_id}/versions/{version_id}/assets/{asset_id}
     * @response `204` `DeleteAssetData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteAsset: (
      { appId, versionId, assetId }: DeleteAssetParams,
      params: RequestParams = {},
    ) =>
      this.request<DeleteAssetData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/assets/${assetId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Retrieve the original SBOM file for an asset.
     *
     * @tags App Version Assets
     * @name GetAssetSbom
     * @summary Get Asset SBOM
     * @request GET:/apps/{app_id}/versions/{version_id}/assets/{asset_id}/sbom
     * @response `200` `Blob` The raw SBOM file content. The body is the original uploaded or generated SBOM document (CycloneDX/SPDX/Syft, JSON or XML). Use the Content-Disposition filename to determine the format.
     * @response `404` `void` Asset or SBOM not found
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAssetSbom: (
      { appId, versionId, assetId }: GetAssetSbomParams,
      params: RequestParams = {},
    ) =>
      this.request<Blob, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/assets/${assetId}/sbom`,
        method: 'GET',
        ...params,
      }),

    /**
     * @description Get a list of packages for the specified application version.
     *
     * @tags App Version Packages
     * @name ListPackages
     * @summary List Packages
     * @request GET:/apps/{app_id}/versions/{version_id}/packages
     * @response `200` `ListPackagesData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listPackages: (
      { appId, versionId, ...query }: ListPackagesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPackagesData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/packages`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List assets that contain packages within this application version. Filter by package name and version (required), optionally narrowing by type or namespace. Namespace encodes the package type and, for OS packages, the distro context (e.g. 'apk:alpine:3.18'). For language packages, namespace equals the type (e.g. 'python'). If both type and namespace are provided, they must agree on the package type; namespace takes precedence for filtering.
     *
     * @tags App Version Packages
     * @name ListAssetsByPackage
     * @summary List Assets By Package
     * @request GET:/apps/{app_id}/versions/{version_id}/assets-by-package
     * @response `200` `ListAssetsByPackageData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAssetsByPackage: (
      { appId, versionId, ...query }: ListAssetsByPackageParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAssetsByPackageData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/assets-by-package`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List packages affected by a specific vulnerability within this application version.
     *
     * @tags App Version Packages
     * @name ListPackagesByVulnerability
     * @summary List Packages By Vulnerability
     * @request GET:/apps/{app_id}/versions/{version_id}/packages-by-vulnerability
     * @response `200` `ListPackagesByVulnerabilityData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listPackagesByVulnerability: (
      { appId, versionId, ...query }: ListPackagesByVulnerabilityParams,
      params: RequestParams = {},
    ) =>
      this.request<ListPackagesByVulnerabilityData, void | HTTPValidationError>(
        {
          path: `/apps/${appId}/versions/${versionId}/packages-by-vulnerability`,
          method: 'GET',
          query: query,
          format: 'json',
          ...params,
        },
      ),

    /**
     * @description Get vulnerabilities for an app version. By default, aggregates and deduplicates vulnerabilities across all artifacts/assets in the version. If asset_id is provided, returns only vulnerabilities for that asset. Each artifact's distro context is respected for filtering. Deduplication follows the same logic as Anchore Enterprise: related CVEs are used for identity matching, and higher priority sources (distro advisories) win over lower (NVD).
     *
     * @tags App Version Vulnerabilities
     * @name ListVulnerabilities
     * @summary List Vulnerabilities
     * @request GET:/apps/{app_id}/versions/{version_id}/vulnerabilities
     * @response `200` `ListVulnerabilitiesData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listVulnerabilities: (
      { versionId, appId, ...query }: ListVulnerabilitiesParams,
      params: RequestParams = {},
    ) =>
      this.request<ListVulnerabilitiesData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/vulnerabilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Vulnerability Annotations
     * @name CreateVulnerabilityAnnotation
     * @summary Create Vulnerability Annotation
     * @request POST:/apps/{app_id}/versions/{version_id}/vulnerability-annotations
     * @response `201` `CreateVulnerabilityAnnotationData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `409` `void` An annotation with the same vulnerability/package already exists.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createVulnerabilityAnnotation: (
      { appId, versionId }: CreateVulnerabilityAnnotationParams,
      data: AppVersionVulnerabilityAnnotationCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateVulnerabilityAnnotationData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/versions/${versionId}/vulnerability-annotations`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Vulnerability Annotations
     * @name ListVulnerabilityAnnotations
     * @summary List Vulnerability Annotations
     * @request GET:/apps/{app_id}/versions/{version_id}/vulnerability-annotations
     * @response `200` `ListVulnerabilityAnnotationsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listVulnerabilityAnnotations: (
      { appId, versionId, ...query }: ListVulnerabilityAnnotationsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListVulnerabilityAnnotationsData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/versions/${versionId}/vulnerability-annotations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Vulnerability Annotations
     * @name GetVulnerabilityAnnotation
     * @summary Get Vulnerability Annotation
     * @request GET:/apps/{app_id}/versions/{version_id}/vulnerability-annotations/{vulnerability_annotation_id}
     * @response `200` `GetVulnerabilityAnnotationData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getVulnerabilityAnnotation: (
      {
        appId,
        versionId,
        vulnerabilityAnnotationId,
      }: GetVulnerabilityAnnotationParams,
      params: RequestParams = {},
    ) =>
      this.request<GetVulnerabilityAnnotationData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/vulnerability-annotations/${vulnerabilityAnnotationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Vulnerability Annotations
     * @name UpdateVulnerabilityAnnotation
     * @summary Update Vulnerability Annotation
     * @request PATCH:/apps/{app_id}/versions/{version_id}/vulnerability-annotations/{vulnerability_annotation_id}
     * @response `200` `UpdateVulnerabilityAnnotationData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateVulnerabilityAnnotation: (
      {
        appId,
        versionId,
        vulnerabilityAnnotationId,
      }: UpdateVulnerabilityAnnotationParams,
      data: VulnerabilityAnnotationUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UpdateVulnerabilityAnnotationData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/versions/${versionId}/vulnerability-annotations/${vulnerabilityAnnotationId}`,
        method: 'PATCH',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags App Version Vulnerability Annotations
     * @name DeleteVulnerabilityAnnotation
     * @summary Delete Vulnerability Annotation
     * @request DELETE:/apps/{app_id}/versions/{version_id}/vulnerability-annotations/{vulnerability_annotation_id}
     * @response `204` `DeleteVulnerabilityAnnotationData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteVulnerabilityAnnotation: (
      {
        appId,
        versionId,
        vulnerabilityAnnotationId,
      }: DeleteVulnerabilityAnnotationParams,
      params: RequestParams = {},
    ) =>
      this.request<
        DeleteVulnerabilityAnnotationData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/versions/${versionId}/vulnerability-annotations/${vulnerabilityAnnotationId}`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * @description Get overall policy status for an app version. Returns the pass/fail status, the evaluated policy, and summary stats.
     *
     * @tags App Version Policy
     * @name GetPolicyStatus
     * @summary Get Policy Status
     * @request GET:/apps/{app_id}/versions/{version_id}/policy/status
     * @response `200` `GetPolicyStatusData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getPolicyStatus: (
      { appId, versionId }: GetPolicyStatusParams,
      params: RequestParams = {},
    ) =>
      this.request<GetPolicyStatusData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/policy/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all policy findings for an app version without gate-specific details. Returns basic information about every finding including the action and message.
     *
     * @tags App Version Policy
     * @name ListAllFindings
     * @summary List All Findings
     * @request GET:/apps/{app_id}/versions/{version_id}/policy/findings/all
     * @response `200` `ListAllFindingsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAllFindings: (
      { appId, versionId, ...query }: ListAllFindingsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAllFindingsData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/policy/findings/all`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get vulnerability gate policy findings for an app version. Returns findings with vulnerability-specific details including severity, CVE information, and affected package details.
     *
     * @tags App Version Policy
     * @name ListVulnerabilityFindings
     * @summary List Vulnerability Findings
     * @request GET:/apps/{app_id}/versions/{version_id}/policy/findings/vulnerabilities
     * @response `200` `ListVulnerabilityFindingsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listVulnerabilityFindings: (
      { appId, versionId, ...query }: ListVulnerabilityFindingsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListVulnerabilityFindingsData, void | HTTPValidationError>({
        path: `/apps/${appId}/versions/${versionId}/policy/findings/vulnerabilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List all jobs for a specific app.
     *
     * @tags App Jobs
     * @name ListAppJobs
     * @summary List App Jobs
     * @request GET:/apps/{app_id}/jobs
     * @response `200` `ListAppJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAppJobs: (
      { appId, ...query }: ListAppJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAppJobsData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List add-sbom-asset jobs for an app, with full job spec.
     *
     * @tags App Jobs
     * @name ListAddSbomAssetJobs
     * @summary List Add SBOM Asset Jobs
     * @request GET:/apps/{app_id}/jobs/add-sbom-asset
     * @response `200` `ListAddSbomAssetJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAddSbomAssetJobs: (
      { appId, ...query }: ListAddSbomAssetJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListAddSbomAssetJobsData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/add-sbom-asset`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Upload an SBOM and create a job to process it into an asset.
     *
     * @tags App Jobs
     * @name CreateAddSbomAssetJob
     * @summary Add SBOM Asset
     * @request POST:/apps/{app_id}/jobs/add-sbom-asset
     * @response `201` `CreateAddSbomAssetJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createAddSbomAssetJob: (
      { appId }: CreateAddSbomAssetJobParams,
      data: AddSbomAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateAddSbomAssetJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/add-sbom-asset`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single add-sbom-asset job by ID.
     *
     * @tags App Jobs
     * @name GetAddSbomAssetJob
     * @summary Get Add SBOM Asset Job
     * @request GET:/apps/{app_id}/jobs/add-sbom-asset/{job_id}
     * @response `200` `GetAddSbomAssetJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddSbomAssetJob: (
      { appId, jobId }: GetAddSbomAssetJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAddSbomAssetJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/add-sbom-asset/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description List add-container-image-asset jobs for an app, with full job spec.
     *
     * @tags App Jobs
     * @name ListAddContainerImageAssetJobs
     * @summary List Add Container Image Asset Jobs
     * @request GET:/apps/{app_id}/jobs/add-container-image-asset
     * @response `200` `ListAddContainerImageAssetJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAddContainerImageAssetJobs: (
      { appId, ...query }: ListAddContainerImageAssetJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListAddContainerImageAssetJobsData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/add-container-image-asset`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to resolve a container image, scan it, and create an asset.
     *
     * @tags App Jobs
     * @name CreateAddContainerImageAssetJob
     * @summary Add Container Image Asset
     * @request POST:/apps/{app_id}/jobs/add-container-image-asset
     * @response `201` `CreateAddContainerImageAssetJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createAddContainerImageAssetJob: (
      { appId }: CreateAddContainerImageAssetJobParams,
      data: AddContainerImageAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateAddContainerImageAssetJobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/add-container-image-asset`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single add-container-image-asset job by ID.
     *
     * @tags App Jobs
     * @name GetAddContainerImageAssetJob
     * @summary Get Add Container Image Asset Job
     * @request GET:/apps/{app_id}/jobs/add-container-image-asset/{job_id}
     * @response `200` `GetAddContainerImageAssetJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddContainerImageAssetJob: (
      { appId, jobId }: GetAddContainerImageAssetJobParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetAddContainerImageAssetJobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/add-container-image-asset/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to export vulnerability data as a downloadable file.
     *
     * @tags App Jobs
     * @name CreateExportVulnerabilitiesJob
     * @summary Export Vulnerabilities
     * @request POST:/apps/{app_id}/jobs/export-vulnerabilities
     * @response `201` `CreateExportVulnerabilitiesJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportVulnerabilitiesJob: (
      { appId }: CreateExportVulnerabilitiesJobParams,
      data: ExportVulnerabilitiesRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateExportVulnerabilitiesJobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-vulnerabilities`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-vulnerabilities jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportVulnerabilitiesJobs
     * @summary List Export Vulnerabilities Jobs
     * @request GET:/apps/{app_id}/jobs/export-vulnerabilities
     * @response `200` `ListExportVulnerabilitiesJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportVulnerabilitiesJobs: (
      { appId, ...query }: ListExportVulnerabilitiesJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListExportVulnerabilitiesJobsData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-vulnerabilities`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-vulnerabilities job by ID.
     *
     * @tags App Jobs
     * @name GetExportVulnerabilitiesJob
     * @summary Get Export Vulnerabilities Job
     * @request GET:/apps/{app_id}/jobs/export-vulnerabilities/{job_id}
     * @response `200` `GetExportVulnerabilitiesJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportVulnerabilitiesJob: (
      { appId, jobId }: GetExportVulnerabilitiesJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExportVulnerabilitiesJobData, void | HTTPValidationError>(
        {
          path: `/apps/${appId}/jobs/export-vulnerabilities/${jobId}`,
          method: 'GET',
          format: 'json',
          ...params,
        },
      ),

    /**
     * @description Create a job to export the latest policy compliance findings as a downloadable file.
     *
     * @tags App Jobs
     * @name CreateExportPolicyComplianceJob
     * @summary Export Policy Compliance
     * @request POST:/apps/{app_id}/jobs/export-policy-compliance
     * @response `201` `CreateExportPolicyComplianceJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportPolicyComplianceJob: (
      { appId }: CreateExportPolicyComplianceJobParams,
      data: ExportPolicyComplianceRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateExportPolicyComplianceJobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-policy-compliance`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-policy-compliance jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportPolicyComplianceJobs
     * @summary List Export Policy Compliance Jobs
     * @request GET:/apps/{app_id}/jobs/export-policy-compliance
     * @response `200` `ListExportPolicyComplianceJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportPolicyComplianceJobs: (
      { appId, ...query }: ListExportPolicyComplianceJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListExportPolicyComplianceJobsData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-policy-compliance`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-policy-compliance job by ID.
     *
     * @tags App Jobs
     * @name GetExportPolicyComplianceJob
     * @summary Get Export Policy Compliance Job
     * @request GET:/apps/{app_id}/jobs/export-policy-compliance/{job_id}
     * @response `200` `GetExportPolicyComplianceJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportPolicyComplianceJob: (
      { appId, jobId }: GetExportPolicyComplianceJobParams,
      params: RequestParams = {},
    ) =>
      this.request<
        GetExportPolicyComplianceJobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-policy-compliance/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to export package data as a downloadable file. The export contains one row per package in the app version with name, version, type, purl, license list, vulnerability count, and affected asset count.
     *
     * @tags App Jobs
     * @name CreateExportPackagesJob
     * @summary Export Packages
     * @request POST:/apps/{app_id}/jobs/export-packages
     * @response `201` `CreateExportPackagesJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportPackagesJob: (
      { appId }: CreateExportPackagesJobParams,
      data: ExportPackagesRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateExportPackagesJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-packages`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-packages jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportPackagesJobs
     * @summary List Export Packages Jobs
     * @request GET:/apps/{app_id}/jobs/export-packages
     * @response `200` `ListExportPackagesJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportPackagesJobs: (
      { appId, ...query }: ListExportPackagesJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListExportPackagesJobsData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-packages`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-packages job by ID.
     *
     * @tags App Jobs
     * @name GetExportPackagesJob
     * @summary Get Export Packages Job
     * @request GET:/apps/{app_id}/jobs/export-packages/{job_id}
     * @response `200` `GetExportPackagesJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportPackagesJob: (
      { appId, jobId }: GetExportPackagesJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExportPackagesJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-packages/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to export an SBOM combining all packages in an app version as a CycloneDX 1.x document. Set ``format`` (default ``json``) and ``spec_version`` (default ``1.6``) in the request body. Only certain ``(format, spec_version)`` combinations are supported; unsupported pairings are rejected with 422.
     *
     * @tags App Jobs
     * @name CreateExportSbomCyclonedx1Job
     * @summary Export SBOM (CycloneDX 1.x)
     * @request POST:/apps/{app_id}/jobs/export-sbom-cyclonedx-1
     * @response `201` `CreateExportSbomCyclonedx1JobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportSbomCyclonedx1Job: (
      { appId }: CreateExportSbomCyclonedx1JobParams,
      data: ExportSbomCycloneDx1Request,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateExportSbomCyclonedx1JobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-sbom-cyclonedx-1`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-sbom-cyclonedx-1 jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportSbomCyclonedx1Jobs
     * @summary List Export SBOM Jobs (CycloneDX 1.x)
     * @request GET:/apps/{app_id}/jobs/export-sbom-cyclonedx-1
     * @response `200` `ListExportSbomCyclonedx1JobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportSbomCyclonedx1Jobs: (
      { appId, ...query }: ListExportSbomCyclonedx1JobsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListExportSbomCyclonedx1JobsData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/export-sbom-cyclonedx-1`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-sbom-cyclonedx-1 job by ID.
     *
     * @tags App Jobs
     * @name GetExportSbomCyclonedx1Job
     * @summary Get Export SBOM Job (CycloneDX 1.x)
     * @request GET:/apps/{app_id}/jobs/export-sbom-cyclonedx-1/{job_id}
     * @response `200` `GetExportSbomCyclonedx1JobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportSbomCyclonedx1Job: (
      { appId, jobId }: GetExportSbomCyclonedx1JobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExportSbomCyclonedx1JobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-sbom-cyclonedx-1/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to export an SBOM combining all packages in an app version as an SPDX 2.x document. Set ``format`` (default ``json``) and ``spec_version`` (default ``2.3``) in the request body. Only certain ``(format, spec_version)`` combinations are supported; unsupported pairings are rejected with 422.
     *
     * @tags App Jobs
     * @name CreateExportSbomSpdx2Job
     * @summary Export SBOM (SPDX 2.x)
     * @request POST:/apps/{app_id}/jobs/export-sbom-spdx-2
     * @response `201` `CreateExportSbomSpdx2JobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportSbomSpdx2Job: (
      { appId }: CreateExportSbomSpdx2JobParams,
      data: ExportSbomSpdx2Request,
      params: RequestParams = {},
    ) =>
      this.request<CreateExportSbomSpdx2JobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-sbom-spdx-2`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-sbom-spdx-2 jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportSbomSpdx2Jobs
     * @summary List Export SBOM Jobs (SPDX 2.x)
     * @request GET:/apps/{app_id}/jobs/export-sbom-spdx-2
     * @response `200` `ListExportSbomSpdx2JobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportSbomSpdx2Jobs: (
      { appId, ...query }: ListExportSbomSpdx2JobsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListExportSbomSpdx2JobsData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-sbom-spdx-2`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-sbom-spdx-2 job by ID.
     *
     * @tags App Jobs
     * @name GetExportSbomSpdx2Job
     * @summary Get Export SBOM Job (SPDX 2.x)
     * @request GET:/apps/{app_id}/jobs/export-sbom-spdx-2/{job_id}
     * @response `200` `GetExportSbomSpdx2JobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportSbomSpdx2Job: (
      { appId, jobId }: GetExportSbomSpdx2JobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExportSbomSpdx2JobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-sbom-spdx-2/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to export a CycloneDX VDR (SBOM + vulnerabilities) for an app version. When an app version has VEX annotations on its vulnerabilities, the VDR includes the corresponding ``analysis.state`` for each annotated vulnerability. Set ``include_annotation_detail=true`` to also include the annotation's narrative fields (status notes, impact, action, additional details) and the CycloneDX ``justification``.
     *
     * @tags App Jobs
     * @name CreateExportVdrJob
     * @summary Export VDR
     * @request POST:/apps/{app_id}/jobs/export-vdr
     * @response `201` `CreateExportVdrJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportVdrJob: (
      { appId }: CreateExportVdrJobParams,
      data: ExportVdrRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateExportVdrJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-vdr`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-vdr jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportVdrJobs
     * @summary List Export VDR Jobs
     * @request GET:/apps/{app_id}/jobs/export-vdr
     * @response `200` `ListExportVdrJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportVdrJobs: (
      { appId, ...query }: ListExportVdrJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListExportVdrJobsData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-vdr`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-vdr job by ID.
     *
     * @tags App Jobs
     * @name GetExportVdrJob
     * @summary Get Export VDR Job
     * @request GET:/apps/{app_id}/jobs/export-vdr/{job_id}
     * @response `200` `GetExportVdrJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportVdrJob: (
      { appId, jobId }: GetExportVdrJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExportVdrJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-vdr/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a job to export a VEX document for an app version. The default format is ``cyclonedx-json`` (a VDR-style CycloneDX 1.6 JSON document containing only vulnerabilities that have a VEX annotation, with the components array pruned to packages those vulnerabilities reference). Future VEX standards (e.g. OpenVEX) will extend the ``format`` enum.
     *
     * @tags App Jobs
     * @name CreateExportVexJob
     * @summary Export VEX
     * @request POST:/apps/{app_id}/jobs/export-vex
     * @response `201` `CreateExportVexJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createExportVexJob: (
      { appId }: CreateExportVexJobParams,
      data: ExportVexRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateExportVexJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-vex`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List export-vex jobs for an app.
     *
     * @tags App Jobs
     * @name ListExportVexJobs
     * @summary List Export VEX Jobs
     * @request GET:/apps/{app_id}/jobs/export-vex
     * @response `200` `ListExportVexJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listExportVexJobs: (
      { appId, ...query }: ListExportVexJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<ListExportVexJobsData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-vex`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single export-vex job by ID.
     *
     * @tags App Jobs
     * @name GetExportVexJob
     * @summary Get Export VEX Job
     * @request GET:/apps/{app_id}/jobs/export-vex/{job_id}
     * @response `200` `GetExportVexJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getExportVexJob: (
      { appId, jobId }: GetExportVexJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetExportVexJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/export-vex/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description List add-imported-image-asset jobs for an app, with full job spec.
     *
     * @tags App Jobs
     * @name ListAddImportedImageAssetJobs
     * @summary List Add Imported Image Asset Jobs
     * @request GET:/apps/{app_id}/jobs/add-imported-image-asset
     * @response `200` `ListAddImportedImageAssetJobsData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    listAddImportedImageAssetJobs: (
      { appId, ...query }: ListAddImportedImageAssetJobsParams,
      params: RequestParams = {},
    ) =>
      this.request<
        ListAddImportedImageAssetJobsData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/add-imported-image-asset`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Upload a pre-analyzed image (SBOM + supplementary files) and create a job to process it into an asset. Bypasses v5 analysis entirely.
     *
     * @tags App Jobs
     * @name CreateAddImportedImageAssetJob
     * @summary Add Imported Image Asset
     * @request POST:/apps/{app_id}/jobs/add-imported-image-asset
     * @response `201` `CreateAddImportedImageAssetJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    createAddImportedImageAssetJob: (
      { appId }: CreateAddImportedImageAssetJobParams,
      data: AddImportedImageAssetRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateAddImportedImageAssetJobData,
        void | HTTPValidationError
      >({
        path: `/apps/${appId}/jobs/add-imported-image-asset`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single add-imported-image-asset job by ID.
     *
     * @tags App Jobs
     * @name GetAddImportedImageAssetJob
     * @summary Get Add Imported Image Asset Job
     * @request GET:/apps/{app_id}/jobs/add-imported-image-asset/{job_id}
     * @response `200` `GetAddImportedImageAssetJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAddImportedImageAssetJob: (
      { appId, jobId }: GetAddImportedImageAssetJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetAddImportedImageAssetJobData, void | HTTPValidationError>(
        {
          path: `/apps/${appId}/jobs/add-imported-image-asset/${jobId}`,
          method: 'GET',
          format: 'json',
          ...params,
        },
      ),

    /**
     * @description Get a single job by ID.
     *
     * @tags App Jobs
     * @name GetApplicationJob
     * @summary Get Job
     * @request GET:/apps/{app_id}/jobs/by-id/{job_id}
     * @response `200` `GetApplicationJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    getApplicationJob: (
      { appId, jobId }: GetApplicationJobParams,
      params: RequestParams = {},
    ) =>
      this.request<GetApplicationJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/by-id/${jobId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancel a job. Jobs which are not running are cancelled immediately. For a running job, this requests cancellation; status will return as `cancelled` only after cancellation is effective.
     *
     * @tags App Jobs
     * @name CancelApplicationJob
     * @summary Cancel Job
     * @request DELETE:/apps/{app_id}/jobs/by-id/{job_id}
     * @response `200` `CancelApplicationJobData` Successful Response
     * @response `404` `void` Resource not found, more details will be provided in the response body.
     * @response `422` `HTTPValidationError` Validation Error
     */
    cancelApplicationJob: (
      { appId, jobId }: CancelApplicationJobParams,
      params: RequestParams = {},
    ) =>
      this.request<CancelApplicationJobData, void | HTTPValidationError>({
        path: `/apps/${appId}/jobs/by-id/${jobId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * @description Download a file produced by an export job. Returns 202 (Accepted) while the job is still processing; 200 with the file when complete.
     *
     * @tags App Downloads
     * @name DownloadExportFile
     * @summary Download Export File
     * @request GET:/apps/{app_id}/downloads/{download_id}
     * @response `200` `Blob` File download
     * @response `202` `void` Export job is still processing
     * @response `404` `void` Resource not found.
     * @response `422` `void` Validation Error
     */
    downloadExportFile: (
      { appId, downloadId }: DownloadExportFileParams,
      params: RequestParams = {},
    ) =>
      this.request<Blob, void>({
        path: `/apps/${appId}/downloads/${downloadId}`,
        method: 'GET',
        ...params,
      }),
  };
}
